import React, { useState, useEffect, useRef, useMemo } from 'react'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction'
import { connect, useSelector } from 'react-redux'
import { useParams, useHistory, useLocation } from "react-router-dom";
import HttpService from '../../services/httpService'
import moment from 'moment'
import Cookies from 'js-cookie';
import { NavLink } from 'react-router-dom';
import { makeStyles, withStyles} from '@material-ui/core/styles';
import { Accordion, AccordionSummary, AccordionDetails, FormGroup, AccordionActions, Typography, Paper, Grid, Divider, Button, Table, TableBody, TableCell, TableContainer, TableRow, DialogContentText, Box, OutlinedInput, RadioGroup, Radio , Snackbar, SnackbarContent, Avatar,Modal,
Checkbox,FormControlLabel,Card, CardContent , FormLabel,TextField,Dialog,DialogActions,DialogContent,DialogTitle,Tooltip,TableHead,InputLabel,FormControl,InputAdornment, Drawer, Chip, SvgIcon
} from '@material-ui/core';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import AttachmentIcon from '@material-ui/icons/Attachment';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import DeleteIcon from '@material-ui/icons/Delete'
import './index.css';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import { ROLENAME, designDepartment, constantDepartmentId, CURRENT_STAGE, salesDepartment, paymentMode, paymentModeType, marketingUserEmails,NarenEmail, moveToMarketingReasons, salesLostReasons, junkReasons, approvalStageMap, AI_NO_LEAD_CONVERSATION_MSG, AI_CONVERSATION_NOT_SUPPORTED_MSG, AI_PRECHECK_FAILED_MSG, maskPhoneNumbersInLogText, isMoveToMarketingBlockedByAssignmentAge, moveToMarketingAssignmentAgeMessage, requiresDsoPaymentApproval, isDsoPaymentApprovedForLead, salesVsQuotationVariancePercent, isDesignerBlockedWhileDsoPending, DSO_PENDING_DESIGNER_MOVE_BLOCK_MESSAGE } from '../../utils/index';
import { EditorState, convertToRaw } from 'draft-js';
import Editor from '@draft-js-plugins/editor';
import createMentionPlugin, { defaultSuggestionsFilter, } from '@draft-js-plugins/mention';
import '@draft-js-plugins/mention/lib/plugin.css';
import { commaSeparateAmount } from '../../components/commaSeparate';
import { PlusCircleOutlined } from '@ant-design/icons';
import { DownloadOutlined, EyeFilled,EyeOutlined, EditOutlined } from '@ant-design/icons';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; 
import {IP} from "../../utils/index"
import FlagIcon from '@material-ui/icons/Flag';
import EventIcon from "@material-ui/icons/Event";
import DescriptionIcon from "@material-ui/icons/Description";
import AssignCRMUserDialog from '../../components//AssignCRMUserDialog';
import AssignToECDialog from '../../components/AssignToECDialog';
import MoveToMarketingRunoDialog from '../../components/MoveToMarketingRunoDialog';
import BotWotChatDrawer from '../../components/BotWotChatDrawer';
import CallingDeskDialog, { useCanUseCallingDesk } from '../../components/CallingDeskDialog';
import SiteVisitPaymentRaiseModal from '../../components/siteVisitPaymentRaiseModal';
// import TableHead from '@material-ui/core/TableHead';
import {
    Http,
    Description as DocumentIcon,
    LocationOn as LocationIcon
} from '@material-ui/icons';
//import { FaBold, FaItalic, FaUnderline } from 'react-icons/fa';
import XLSX from 'xlsx';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { FaArrowRight } from "react-icons/fa";
import EditIcon from "@material-ui/icons/Edit";
import Pagination from '@material-ui/lab/Pagination';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { Download } from 'lucide-react';
import AdmCheckListPdf from './AdmCheckListPdf';
import DrawingQCLogs from './DrawingQCLogs';
import { IoMdEye } from "react-icons/io";
import MicIcon from "@material-ui/icons/Mic";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CallMadeIcon from "@material-ui/icons/CallMade";
import CallReceivedIcon from "@material-ui/icons/CallReceived";
import PersonIcon from '@material-ui/icons/Person';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import PaletteIcon from '@material-ui/icons/Palette';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import ForumIcon from '@material-ui/icons/Forum';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import BusinessIcon from '@material-ui/icons/Business';
import TimelineIcon from '@material-ui/icons/Timeline';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import ConfirmationNumberIcon from '@material-ui/icons/ConfirmationNumber';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import FolderIcon from '@material-ui/icons/Folder';
import StoreIcon from '@material-ui/icons/Store';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import VideocamIcon from '@material-ui/icons/Videocam';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ReceiptIcon from '@material-ui/icons/Receipt';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import CategoryIcon from '@material-ui/icons/Category';
import ListAltIcon from '@material-ui/icons/ListAlt';
import MapIcon from '@material-ui/icons/Map';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import LabelIcon from '@material-ui/icons/Label';
import NotesIcon from '@material-ui/icons/Notes';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import BrushIcon from '@material-ui/icons/Brush';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import WarningIcon from '@material-ui/icons/Warning';
import BlockIcon from '@material-ui/icons/Block';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import SendIcon from '@material-ui/icons/Send';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';
const BRAND_COLOR = '#f47d44';
const ACTION_BUTTON_COLOR = '#ee7a06';
const ACTION_BUTTON_HOVER_COLOR = '#c96305';

// Keep these codes in sync with the backend's TAX_INVOICE_TYPES map
// (quotation_tool_server/routes/leadLog.js).
const TAX_INVOICE_TYPES = [
    { code: 'DSO', label: 'Designs Sign off - 20% tax Invoice' },
    { code: 'DI', label: 'Dispatch invoice - 65% Tax Invoice' },
    { code: 'CI', label: 'Completion Invoice - 15% Tax Invoice' },
    { code: 'RCN', label: 'Refund- Credit Note - for all the scope Deduction' },
    { code: 'ASI', label: 'Additional Scope - Additional Scope Invoice' },
];

const PIN_ROLES = {
    Sales: [ROLENAME.SalesUser, ROLENAME.AssistantSalesManager],
    Design: [ROLENAME.DesignUser],
};
const UNPIN_ROLES = {
    Sales: [ROLENAME.SalesManager, ROLENAME.AGMSales, ROLENAME.DGM_Sales],
    Design: [ROLENAME.AGM_Design, ROLENAME.DGM_Design, ROLENAME.OperationDesignManager],
};
const PIN_OVERRIDE_ROLES = [ROLENAME.Admin, ROLENAME.CenterHead];
const MAX_PINNED_NOTES_PER_LEAD = 5;

const userHasAnyRole = (userDetails, roleNames = []) =>
    Array.isArray(userDetails?.roles) && userDetails.roles.some(role => roleNames.includes(role.name));

const PinIcon = ({ pinned, style, ...rest }) => (
    <SvgIcon
        {...rest}
        style={{ color: pinned ? BRAND_COLOR : 'rgba(0, 0, 0, 0.45)', ...style }}
    >
        <path d="M16 9V4h1V2H7v2h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H18v-2c-1.66 0-3-1.34-3-3z" />
    </SvgIcon>
);

// AI Expected Design Sign-off Date / AI Design Hold: only the LATEST conversation on the
// lead is analysed — the newer of the latest Runo call and the latest note that has an
// audio recording, whoever made the call or uploaded the note (designer, sales, manager...).
// Messages (AI_NO_LEAD_CONVERSATION_MSG etc.) are defined in utils/index.js.

// Reads GET lead/getCallRecordings. Also accepts the older response
// (recordingCount + latestRecording only) so an older server still works.
const getAiConversationPreCheck = (data) => {
    const latestConversation = data?.latestConversation || (data?.latestRecording ? { source: 'runo', ...data.latestRecording } : null);
    const hasConversation = typeof data?.hasConversation === 'boolean' ? data.hasConversation : ((data?.recordingCount || 0) > 0);
    return { hasConversation, latestConversation, noConversation: !hasConversation };
};

// True when the latest conversation could not be analysed (unsupported or
// undecodable audio, transcription failed, no speech, AI could not analyse).
const isAiConversationAnalysisFailed = (resData) => !!resData && (
    resData.analysisFailed === true
    || resData.errorCode === 'CONVERSATION_NOT_SUPPORTED'
    || (!!resData.data?.conversation_status && resData.data.conversation_status !== 'ok')
    || resData.data?.transcript_source === 'none'
);

const getAiAnalysisFailedMessage = (resData) =>
    ((resData?.analysisFailed || resData?.errorCode === 'CONVERSATION_NOT_SUPPORTED') && resData?.message)
    || resData?.data?.user_message
    || AI_CONVERSATION_NOT_SUPPORTED_MSG;

// Deal-activity label of the analysed conversation, e.g. ' [Runo call by Asha, 05 Oct 2026]'
// or ' [Note audio "rec.m4a" by Asha, 05 Oct 2026]'
const getAiConversationLabel = (conversation) => {
    if (!conversation) return '';
    const parts = [(conversation.source === 'note'
        ? `Note audio${conversation.fileName ? ` "${conversation.fileName}"` : ''}`
        : 'Runo call') + (conversation.byName ? ` by ${conversation.byName}` : '')];
    if (conversation.date && moment(conversation.date).isValid()) parts.push(moment(conversation.date).format('DD MMM YYYY'));
    return ` [${parts.join(', ')}]`;
};

// Pre-check body shared by the AI Sign-off Date and AI Design Hold dialogs:
// check failed / no conversation (blocked) / the latest conversation to be analysed.
const AiConversationPreCheckBody = ({
    state, question, infoText,
    noConversationText = AI_NO_LEAD_CONVERSATION_MSG,
    scopeText = 'Only the latest conversation on this lead is analysed (the latest Runo call, or a newer call recording uploaded in Notes), whoever made the call or uploaded the recording.',
}) => {
    if (state.preCheckError) {
        return (
            <div style={{
                padding: 15, borderRadius: 8,
                backgroundColor: '#ffebee', border: '1px solid #ef9a9a',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <ErrorOutlineIcon style={{ color: '#b71c1c', fontSize: 22 }} />
                    <Typography variant="subtitle1" style={{ color: '#b71c1c', fontWeight: 700 }}>
                        {state.preCheckError}
                    </Typography>
                </div>
            </div>
        );
    }
    if (state.noConversation || !state.hasConversation) {
        return (
            <div style={{
                padding: 15, borderRadius: 8,
                backgroundColor: '#ffebee', border: '1px solid #ef9a9a',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <BlockIcon style={{ color: '#c62828', fontSize: 22 }} />
                    <Typography variant="subtitle1" style={{ color: '#c62828', fontWeight: 700 }}>
                        No Conversation Found
                    </Typography>
                </div>
                <Typography variant="body2" style={{ marginTop: 8, fontWeight: 600 }}>
                    <PersonIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                    Designer: {state.designerName}
                </Typography>
                <Typography variant="body2" style={{ marginTop: 12, color: '#666' }}>
                    {noConversationText}
                </Typography>
                <Typography variant="caption" style={{ display: 'block', marginTop: 12, color: '#999', fontStyle: 'italic' }}>
                    <InfoIcon style={{ fontSize: 14, verticalAlign: 'middle', marginRight: 4 }} />
                    {infoText}
                </Typography>
            </div>
        );
    }
    const conversation = state.latestConversation;
    const isNote = conversation?.source === 'note';
    const durationSec = Math.round(conversation?.duration || 0);
    return (
        <div style={{
            padding: 15, borderRadius: 8,
            backgroundColor: '#f5faff', border: '1px solid #c3d5ff',
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <HeadsetMicIcon style={{ color: '#1C375D', fontSize: 22 }} />
                <Typography variant="subtitle1" style={{ color: '#1C375D', fontWeight: 700 }}>
                    Latest conversation to be analysed
                </Typography>
            </div>
            <Typography variant="body2" style={{ marginTop: 8, fontWeight: 600 }}>
                <PersonIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                Designer: {state.designerName}
            </Typography>

            {conversation && (
                <div style={{ marginTop: 14, padding: 12, backgroundColor: '#fff', borderRadius: 8, border: '1px solid #e0e0e0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                        <Chip
                            size="small"
                            icon={isNote ? <AudiotrackIcon /> : <PhoneInTalkIcon />}
                            label={isNote ? 'Note Audio' : 'Runo Call'}
                            style={{ backgroundColor: isNote ? '#fff3e0' : '#e3f2fd', fontWeight: 600 }}
                        />
                        {conversation.date && moment(conversation.date).isValid() && (
                            <Typography variant="caption" style={{ color: '#888' }}>
                                {moment(conversation.date).format('DD MMM YYYY')}
                                {!isNote && durationSec > 0 && ` • ${Math.floor(durationSec / 60)}m ${durationSec % 60}s`}
                            </Typography>
                        )}
                    </div>
                    {conversation.byName && (
                        <Typography variant="body2" style={{ marginBottom: 6 }}>
                            <PersonIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                            {isNote ? 'Uploaded by' : 'Call by'}: {conversation.byName}
                        </Typography>
                    )}
                    {isNote && conversation.fileName && (
                        <Typography variant="body2" style={{ marginBottom: 6, wordBreak: 'break-all' }}>
                            <AttachmentIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                            {conversation.fileName}
                        </Typography>
                    )}
                    {isNote && conversation.noteText && (
                        <Typography variant="body2" style={{ marginBottom: 8, color: '#555', whiteSpace: 'pre-wrap' }}>
                            {conversation.noteText.length > 200 ? conversation.noteText.substring(0, 200) + '...' : conversation.noteText}
                        </Typography>
                    )}
                    {conversation.recordingUrl && (
                        <audio
                            controls
                            preload="none"
                            style={{ width: '100%', height: 36, borderRadius: 6 }}
                            src={conversation.recordingUrl}
                        />
                    )}
                    {conversation.transcript ? (
                        <div style={{ marginTop: 10 }}>
                            <Typography variant="subtitle2" style={{ color: '#2e7d32', fontWeight: 700, marginBottom: 4, display: 'flex', alignItems: 'center', gap: 5 }}>
                                <DescriptionIcon style={{ fontSize: 16 }} />
                                Transcript
                            </Typography>
                            <div style={{
                                maxHeight: 120, overflowY: 'auto', padding: 10,
                                backgroundColor: '#f9f9f9', borderRadius: 6, border: '1px solid #eee',
                                fontSize: 12, lineHeight: 1.6, color: '#333', whiteSpace: 'pre-wrap',
                            }}>
                                {conversation.transcript.length > 600
                                    ? conversation.transcript.substring(0, 600) + '...'
                                    : conversation.transcript}
                            </div>
                        </div>
                    ) : (
                        <Typography variant="caption" style={{ display: 'block', marginTop: 8, color: '#666', fontStyle: 'italic' }}>
                            Transcript will be generated from the audio during analysis.
                        </Typography>
                    )}
                </div>
            )}

            <Typography variant="caption" style={{ display: 'block', marginTop: 10, color: '#666' }}>
                {scopeText}
            </Typography>
            <Typography variant="body2" style={{ marginTop: 12, color: '#444' }}>
                {question}
            </Typography>
            <Typography variant="caption" style={{ display: 'block', marginTop: 8, color: '#999', fontStyle: 'italic' }}>
                <InfoIcon style={{ fontSize: 14, verticalAlign: 'middle', marginRight: 4 }} />
                {infoText}
            </Typography>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    aiDialogOverlay: {
        zIndex: '1500 !important',
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightBold,
    },
    sectionHeading: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: 1,
        minWidth: 0,
        margin: 0,
    },
    /* Keeps the icon, the title and the expand chevron on one centred row */
    sectionSummary: {
        '&.MuiAccordionSummary-root': {
            minHeight: 56,
            paddingRight: 12,
        },
        '&.MuiAccordionSummary-root.Mui-expanded': {
            minHeight: 56,
        },
        '& .MuiAccordionSummary-content': {
            alignItems: 'center',
            margin: '12px 0',
            minWidth: 0,
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: '12px 0',
        },
        '& .MuiAccordionSummary-expandIcon': {
            flexShrink: 0,
            marginRight: 0,
            padding: 8,
        },
    },
    sectionIcon: {
        color: BRAND_COLOR,
        fontSize: '20px',
    },
    /* Marks a detail-table label cell regardless of how many columns the row has */
    labelCell: {
        boxSizing: 'border-box',
    },
    cellLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    cellIcon: {
        color: BRAND_COLOR,
        fontSize: '17px',
        flexShrink: 0,
    },
    /* Reference codes (lead no., project no.): letter prefix in the dark text colour, the numeric part is branded */
    refCode: {
        fontWeight: 600,
        letterSpacing: '0.3px',
    },
    refCodePrefix: {
        color: '#2c3445',
    },
    refCodeDigits: {
        color: BRAND_COLOR,
    },
    dateLabel: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
    },
    dateIcon: {
        fontSize: '14px',
    },
    /* Standalone buttons inside the detail sections (e.g. Reallocate) */
    brandButton: {
        "&.MuiButton-root": {
            backgroundColor: ACTION_BUTTON_COLOR,
            backgroundImage: "none",
            color: "#ffffff",
            fontFamily: "'Silka bold', 'Silka semiBold', sans-serif !important",
            fontWeight: "700 !important",
            letterSpacing: "0.3px",
            borderRadius: 6,
            boxShadow: "0 1px 2px rgba(16, 24, 40, 0.08)",
            transition: "background-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease",
        },
        "&.MuiButton-root:hover": {
            backgroundColor: ACTION_BUTTON_HOVER_COLOR,
            backgroundImage: "none",
            color: "#ffffff",
            transform: "translateY(-1px)",
            boxShadow: "0 4px 12px rgba(238, 122, 6, 0.32)",
        },
        "&.MuiButton-root:active": {
            backgroundColor: ACTION_BUTTON_HOVER_COLOR,
            transform: "translateY(0)",
            boxShadow: "0 1px 2px rgba(16, 24, 40, 0.12)",
        },
        "&.MuiButton-root.Mui-disabled": {
            backgroundColor: "rgba(16, 24, 40, 0.12)",
            color: "rgba(16, 24, 40, 0.34)",
            boxShadow: "none",
            transform: "none",
        },
    },
    dealActivityHeading: {
        color: BRAND_COLOR,
        '& svg': {
            color: BRAND_COLOR,
        },
    },
    dealActivityInfoIcon: {
        color: BRAND_COLOR,
        cursor: 'pointer',
    },
    runoCallButton: {
        padding: 6,
        color: '#2e7d32',
        backgroundColor: 'rgba(46, 125, 50, 0.1)',
        '&:hover': {
            backgroundColor: 'rgba(46, 125, 50, 0.18)',
        },
        '&.Mui-disabled': {
            color: 'rgba(46, 125, 50, 0.4)',
            backgroundColor: 'rgba(46, 125, 50, 0.06)',
        },
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalpaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    textFieldWidth: {
        width: "100%"
    },
    generateButton: {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    viewButton: {
        backgroundColor: 'white', color: '#14419c', borderRadius: '20px', marginLeft: '0.2em', "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    chatAccordion: {
        backgroundColor: '#f0f2f5',
        '& .MuiAccordionSummary-root': {
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        }
    },
    chatContainer: {
        backgroundColor: '#e5ddd5',
        maxHeight: '500px',
        overflowY: 'auto',
        padding: theme.spacing(2),
        margin: '-8px',
        display: 'flex',
        flexDirection: 'column',
    },
    messageContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(2),
        width: '100%',
        justifyContent: 'flex-start'
    },
    receivedMessage: {
        backgroundColor: '#fff',
        borderRadius: '0 8px 8px 8px',
        padding: theme.spacing(1),
        maxWidth: '70%',
        marginLeft: theme.spacing(1),
        boxShadow: '0 1px 1px rgba(0,0,0,0.1)',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
    },
    mediaContainer: {
        width: '300px',
        maxWidth: '100%',
        margin: '8px 0',
        borderRadius: '8px',
        overflow: 'hidden',
    },
    image: {
        width: '100%',
        height: '300px',
        objectFit: 'cover',
        cursor: 'pointer',
        borderRadius: '8px',
    },
    video: {
        width: '100%',
        height: '300px',
        objectFit: 'cover',
        cursor: 'pointer',
        borderRadius: '8px',
    },
    location: {
        width: "100%",
        height: "200px",
        borderRadius: "4px",
        cursor: "pointer",
    },
    audio: {
        width: "100%",
        borderRadius: "4px",
    },
    document: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(1),
        backgroundColor: "#f0f2f5",
        borderRadius: "4px",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "#e8e8e8",
        },
    },
    documentIcon: {
        marginRight: theme.spacing(1),
        color: "#34B7F1",
    },
    messageHeader: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: theme.spacing(0.5),
        width: '100%',
    },
    userName: {
        fontWeight: 'bold',
        color: '#075E54',
    },
    timestamp: {
        fontSize: "0.75rem",
        color: "#667781",
        alignSelf: "flex-end",
        marginTop: 'auto'
    },
    messageBody: {
        wordBreak: "break-word",
        marginBottom: theme.spacing(1)
    },
    card: {
        maxWidth: 600,
        margin: "40px auto",
        borderRadius: 12,
        boxShadow: "0 10px 25px rgba(0,0,0,0.08)"
    },
    uploadBox: {
        textAlign: "center",
        padding: 20,
        border: "2px dashed #ccc",
        borderRadius: 10,
        cursor: "pointer",
        marginBottom: 20
    },
    preview: {
        maxWidth: "100%",
        maxHeight: 250,
        borderRadius: 8,
        marginTop: 15
    },
    resultBox: {
        background: "#f9fafb",
        padding: 15,
        borderRadius: 8,
        marginTop: 15,
        whiteSpace: "pre-wrap",
        lineHeight: 1.6
    },
    uploadBtn: {
        marginTop: 15
    },
    drawerPaper: {
      width: 560,
      maxWidth: "100%"
    },
    container: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      background: "#ECE5DD",
      // Faint cross-hatch so the thread reads as a chat surface rather than a
      // flat grey panel - kept very low contrast so bubbles stay dominant.
      backgroundImage:
        "radial-gradient(rgba(0,0,0,0.045) 1px, transparent 1px), radial-gradient(rgba(0,0,0,0.045) 1px, transparent 1px)",
      backgroundSize: "22px 22px",
      backgroundPosition: "0 0, 11px 11px"
    },
    // Only the AI-Karan transcripts drawer uses this now - the BotWot chat
    // header moved into components/BotWotChatDrawer. `display: flex` is load-
    // bearing: that drawer sets flexDirection/justifyContent/alignItems inline
    // and those do nothing without it, which dropped its close button onto a
    // line of its own below the heading.
    header: {
      padding: "12px 14px",
      background: "#6c5ce7",
      color: "#fff",
      display: "flex",
      flexShrink: 0,
      boxShadow: "0 2px 10px rgba(0,0,0,0.18)",
      zIndex: 2
    },
    // AI-Karan transcripts: the call list.
    //
    // This class was referenced but never defined, so every call card rendered
    // as a bare Paper with no padding and no margin - which is why the calls
    // ran together with no gap between them.
    hoomanCallCard: {
      padding: "13px 15px",
      marginBottom: 12,
      borderRadius: 12,
      cursor: "pointer",
      border: "1px solid #e6e1fb",
      boxShadow: "0 1px 4px rgba(76,60,190,0.08)",
      transition: "transform .16s ease, box-shadow .16s ease, border-color .16s ease",
      "&:last-child": { marginBottom: 0 },
      "&:hover": {
        transform: "translateY(-2px)",
        borderColor: "#c9befa",
        boxShadow: "0 8px 20px rgba(76,60,190,0.16)",
      },
    },
    hoomanCallIconWrap: {
      width: 34,
      height: 34,
      borderRadius: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    hoomanCallSummary: {
      fontSize: 12,
      marginTop: 10,
      paddingTop: 10,
      borderTop: "1px dashed #e6e1fb",
      color: "#5c6779",
      lineHeight: 1.5,
    },
    // Nudge that a card opens the full transcript - the cards were clickable
    // with nothing saying so.
    hoomanCallCta: {
      display: "flex",
      alignItems: "center",
      gap: 3,
      marginTop: 9,
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: 0.3,
      color: "#6c5ce7",
      textTransform: "uppercase",
    },
    // Only the AI-Karan transcripts drawer uses this now; a touch more side
    // padding since it holds cards rather than chat bubbles.
    chatBody: {
      flex: 1,
      overflowY: "auto",
      padding: "16px 14px 20px",
      scrollBehavior: "smooth"
    },
    // Day marker, so a long thread reads chronologically instead of as one
    // undifferentiated run of bubbles.
    messageRow: {
      display: "flex",
      marginBottom: 10
    },
    left: {
      justifyContent: "flex-start"
    },
    right: {
      justifyContent: "flex-end"
    },
    bubble: {
      position: "relative",
      maxWidth: "78%",
      minWidth: 110,
      padding: "8px 11px 6px",
      borderRadius: 10,
      fontSize: 13,
      lineHeight: 1.45,
      boxShadow: "0 1px 1.5px rgba(0,0,0,0.13)",
      transition: "box-shadow .18s ease, transform .18s ease",
      "&:hover": { boxShadow: "0 3px 10px rgba(0,0,0,0.16)" },
      // Tail, drawn as a border triangle so it inherits nothing and can't be
      // clipped by overflow on the row.
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        width: 0,
        height: 0,
        borderStyle: "solid"
      }
    },
    leftBubble: {
      background: "#fff",
      borderTopLeftRadius: 2,
      "&::after": {
        left: -7,
        borderWidth: "0 8px 9px 0",
        borderColor: "transparent #fff transparent transparent"
      }
    },
    rightBubble: {
      background: "#DCF8C6",
      borderTopRightRadius: 2,
      "&::after": {
        right: -7,
        borderWidth: "0 0 9px 8px",
        borderColor: "transparent transparent transparent #DCF8C6"
      }
    },
    // Highlight for in-thread search matches.
    greenButton: {
      backgroundColor: "#25D366",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#1ebe5d"
      }
    },
    callingDeskButton: {
      background: "linear-gradient(135deg, #2e7d32 0%, #43a047 100%)",
      color: "#fff",
      "&:hover": {
        background: "linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)"
      }
    },
    assignToECButton: {
      background: "linear-gradient(135deg, #1C375D 0%, #2a5ea8 100%)",
      color: "#fff",
      "&:hover": {
        background: "linear-gradient(135deg, #16294a 0%, #234f8f 100%)"
      }
    },
    emptyState: {
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      color: "#666",
      textAlign: "center",
      padding: "20px"
    },
    /* Single, evenly aligned & responsive grid for all project action buttons */
    actionBar: {
        "&.MuiAccordionActions-root": {
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(132px, 1fr))",
            gridAutoRows: "1fr",
            gap: "8px",
            alignItems: "stretch",
            justifyContent: "stretch",
            padding: "14px",
            backgroundColor: "#f7f8fb",
            borderTop: "1px solid rgba(16, 24, 40, 0.07)",
        },
        "&.MuiAccordionActions-root.MuiAccordionActions-spacing > *": {
            margin: 0,
            minWidth: 0,
        },
        "&.MuiAccordionActions-root > *": {
            margin: 0,
            minWidth: 0,
        },
        "& .MuiButton-root": {
            width: "100%",
            height: "100%",
            minHeight: 34,
            margin: 0,
            padding: "5px 8px",
            fontSize: 10,
            lineHeight: 1.25,
            fontFamily: "'Silka bold', 'Silka semiBold', sans-serif !important",
            fontWeight: "700 !important",
            letterSpacing: "0.3px",
            textAlign: "center",
            borderRadius: 6,
            backgroundColor: ACTION_BUTTON_COLOR,
            backgroundImage: "none",
            color: "#ffffff",
            boxShadow: "0 1px 2px rgba(16, 24, 40, 0.08)",
            transition: "background-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease",
        },
        "& .MuiButton-root:hover": {
            backgroundColor: ACTION_BUTTON_HOVER_COLOR,
            backgroundImage: "none",
            color: "#ffffff",
            transform: "translateY(-1px)",
            boxShadow: "0 4px 12px rgba(238, 122, 6, 0.32)",
        },
        "& .MuiButton-root:active": {
            backgroundColor: ACTION_BUTTON_HOVER_COLOR,
            transform: "translateY(0)",
            boxShadow: "0 1px 2px rgba(16, 24, 40, 0.12)",
        },
        "& .MuiButton-root.Mui-disabled": {
            backgroundColor: "rgba(16, 24, 40, 0.12)",
            color: "rgba(16, 24, 40, 0.34)",
            boxShadow: "none",
            transform: "none",
        },
        "& .MuiButton-root .MuiButton-startIcon, & .MuiButton-root .MuiButton-endIcon": {
            color: "#ffffff",
        },
        "& .MuiButton-label": {
            whiteSpace: "normal",
            overflowWrap: "break-word",
        },
        [theme.breakpoints.down("sm")]: {
            "&.MuiAccordionActions-root": {
                gridTemplateColumns: "repeat(auto-fill, minmax(122px, 1fr))",
                gap: "7px",
                padding: "12px",
            },
            "& .MuiButton-root": {
                fontSize: 9.5,
                minHeight: 32,
            },
        },
        [theme.breakpoints.down("xs")]: {
            "&.MuiAccordionActions-root": {
                gridTemplateColumns: "repeat(auto-fill, minmax(108px, 1fr))",
                gap: "6px",
                padding: "10px",
            },
            "& .MuiButton-root": {
                fontSize: 9.5,
                minHeight: 32,
                padding: "4px 6px",
                letterSpacing: "0.2px",
            },
        },
    },
    /* Always-visible scrollbar shared by both scrolling columns.
       Deliberately no `scrollbarWidth` / `scrollbarColor`: those standard
       properties take precedence over the ::-webkit-scrollbar rules below
       and leave a zero-width overlay bar that auto-hides on macOS. */
    scrollbars: {
        "&::-webkit-scrollbar": {
            width: 10,
            WebkitAppearance: "none",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#eef1f6",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#b6bfd0",
            borderRadius: 5,
            border: "2px solid #eef1f6",
        },
        "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#8b96ab",
        },
    },
    /* Left column (Customer / Sales / Design details) scrolls on its own */
    scrollColumn: {
        height: "calc(100vh - 160px)",
        minWidth: 0,
        overflowY: "scroll",
        overflowX: "auto",
        [theme.breakpoints.down("sm")]: {
            height: "auto",
            overflow: "visible",
        },
    },
    /* Right column: pagination stays pinned, only the activity list scrolls */
    scrollPane: {
        height: "calc(100vh - 160px)",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        minWidth: 0,
        [theme.breakpoints.down("sm")]: {
            height: "auto",
            display: "block",
        },
    },
    /* Pagination sits under the activity list, clear of the floating chat bubble */
    paginationBar: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        paddingRight: 80,
        paddingTop: 12,
        paddingBottom: 4,
        flexShrink: 0,
        [theme.breakpoints.down("sm")]: {
            justifyContent: "center",
            paddingRight: 0,
        },
    },
    scrollArea: {
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        overflowY: "scroll",
        overflowX: "auto",
        [theme.breakpoints.down("sm")]: {
            overflow: "visible",
        },
    },
    pinnedNotesBar: {
        display: "flex",
        justifyContent: "flex-end",
        flexShrink: 0,
        paddingBottom: 8,
        paddingRight: 25,
    },
    pinnedNotesButton: {
        borderColor: BRAND_COLOR,
        color: BRAND_COLOR,
        textTransform: "none",
        fontWeight: 600,
    },
    /* Detail tables: bold labels, clear grid lines, readable values */
    table: {
        border: "1px solid rgba(16, 24, 40, 0.10)",
        "& .MuiTableCell-root": {
            borderBottom: "1px solid rgba(16, 24, 40, 0.09)",
            padding: "9px 14px",
            fontSize: 13,
            lineHeight: 1.45,
            color: "#2c3444",
            verticalAlign: "top",
        },
        /* explicitly tagged label cell — works on 2-, 3- and 4-column rows */
        "& $labelCell.MuiTableCell-root": {
            width: "42%",
            fontFamily: "'Silka bold', 'Silka semiBold', sans-serif !important",
            fontWeight: "700 !important",
            color: "#1C375D",
            backgroundColor: "#f4f6fa",
            borderRight: "1px solid rgba(16, 24, 40, 0.09)",
        },
        "& $labelCell.MuiTableCell-root ~ .MuiTableCell-root": {
            fontWeight: 600,
            overflowWrap: "break-word",
        },
        /* fallback: first cell of a two-cell row that carries no label class */
        "& .MuiTableCell-root:first-child:nth-last-child(2)": {
            width: "42%",
            fontFamily: "'Silka bold', 'Silka semiBold', sans-serif !important",
            fontWeight: "700 !important",
            color: "#1C375D",
            backgroundColor: "#f4f6fa",
            borderRight: "1px solid rgba(16, 24, 40, 0.09)",
        },
        /* the value sitting next to a label cell */
        "& .MuiTableCell-root:first-child:nth-last-child(2) + .MuiTableCell-root": {
            fontWeight: 600,
            overflowWrap: "break-word",
        },
        "& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root": {
            borderBottom: 0,
        },
        "& .MuiTableHead-root .MuiTableCell-root": {
            fontWeight: 700,
        },
        [theme.breakpoints.down("xs")]: {
            "& .MuiTableCell-root": {
                padding: "8px 10px",
                fontSize: 12,
            },
            "& .MuiTableCell-root:first-child:nth-last-child(2), & $labelCell.MuiTableCell-root": {
                width: "48%",
            },
        },
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#ccc",
        color: theme.palette.common.black,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const getCurrentTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
};

const ManageProjectLogs = (props) => {

    const modules = {
        toolbar: [
          [{ header: [1, 2, false] }],
          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'image'],
          ['clean']
        ],
      };
      
      const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet',
        'link', 'image'
      ];
    const [loading, setLoading] = React.useState(false);
    const classes = useStyles();
    const history = useHistory();
    const editorRef = useRef();
    const buttonRef = useRef(null);
    const messagesEndRef = useRef(null);
    const whatsappRepliesmessagesEndRef = useRef(null);
    const { projectId } = useParams();
    const location = useLocation();
    const { userDetails } = useSelector(state => state.user)
    const { customerDetails } = useSelector((state) => state.customer);
    const [isAccessDenied, setIsAccessDenied] = useState(false);
    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [messages, setMessages] = useState([]);
    const [whatsAppRepliesFromCustomer, setWhatsappRepliesFromCustomer] = useState([]);
    const [totalWhatsappReplies, setTotalWhatsappReplies] = useState(null);
    const [offset, setOffset] = useState(0);
    const [offsetForReplies, setOffsetForReplies] = useState(0);
    const [totalMessages, setTotalMessages] = useState(null); // Store total count
    const [loadingState, setLoadingState] = useState(false);
    const [whatsAppRepliesLoadingState, setWhatsAppRepliesLoadingState] = useState(false);
    const [projectDetails, setProjectDetails] = useState([]);
    const [projectLogs, setProjectLogs] = useState([]);
    const [pinnedNotesModalOpen, setPinnedNotesModalOpen] = useState(false);
    const [pinnedNotesList, setPinnedNotesList] = useState([]);
    const [pinnedNotesLoading, setPinnedNotesLoading] = useState(false);
    const [pinActionLoadingId, setPinActionLoadingId] = useState(null);
    const [stageInfo, setStageInfo] = useState("");
    const [stageIndex, setStageIndex] = useState(0);
    const [openNotesModal, setOpenNotesModal] = useState(false);
    const [openDesignKickOffScreenshotsModal, setOpenDesignKickOffScreenshotsModal] = useState(false);
    const createNoteFile = useRef()
    const [fileUploaded, setFileUploaded] = useState(false);
    const [openNotesInfoModal, setOpenNotesInfoModal] = useState(false);
    const [paymentDetailsModal, setPaymentDetailsModal] = useState(false)
    const [editProjectModal, setEditProjectModal] = useState(false);
    const [newErpProjectNo, setNewErpProjectNo] = useState("");
    const [quotationselected,setQuotationSelected ]  = useState(false)
    const [acadFileLink, setAcadFileLink ] = useState("");
    const [quotationStatus, setQuotationStatus] = useState(null);
    const [skpFileLink, setSkpFileLink ] = useState("");
    const [skpFile, setSkpFile] = useState(false);
    const [dwgFile, setDwgFile] = useState(false);
    const [designSignOff,setDesignSignOff]=useState("")
    const [openErpProjectNoModal, setOpenErpProjectNoModal] = useState(false);
    const [openDesignSignOff, setOpenDesignSignOffModal] = useState(false);
    const [daysfromModulardelivery, setDaysFromModularDelivery] = useState("")
    const [revisedDateModal, setRevisedDateModal] = useState(false);
    const [uploadModal, setUploadModal] = useState(false)
    const [monthlyContractFile, setMonthlyContractFile] = useState("")
    const [customerContactNo, setCustomerContactNo] = useState("")
    const [revealedContact, setRevealedContact] = useState(null)
    const [contactVisible, setContactVisible] = useState(false)
    const [contactRevealLoading, setContactRevealLoading] = useState(false)
    const [runoCallLoading, setRunoCallLoading] = useState(false)
    const [uploadPaymentProof, setUploadPaymentProof] = useState("")
    const [uploadSuccess, setUploadSuccess] = useState(false);
    // const [revisedProjectedDesignSignOffDate, setRevisedProjectedDesignSignOffDate] = useState("");
    const [daysfromContractsign, setDaysFromContractSign] = useState("");
    const [allSiteQc, setAllSiteQc] = useState([]);
    const [openAssignSiteQcModel, setOpenAssignSiteQcModel] = useState(false);
    const [openSiteVisitPaymentModal, setOpenSiteVisitPaymentModal] = useState(false);
    const [sendNoteToClient, setSendNoteToClient] = useState(false);
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [videos, setVideos] = useState([""]);
    const [showButton,setShowButton] = useState("")
    const [reRender, setReRender] = useState(false);
    const [storeVersion,setStoreVersion] = useState("")
    const [tableHeading, setTableHeading] = useState(["S.No", "Project Unique Id", "Client Name", "Payment Date", "Transaction ID", "Amount", "Payment Mode", "Department", "Requested By", "Status", "Stage", "Payment Partners", "Finance Action Status", "Finance Action Remarks"])
    const [tableData, setTableData] = useState([{ name: "test" }, { payment: "20000" }, { date: "29/12/2023" }, { status: "Completed" }])
    const [selectedSiteQcUserData, setSelectedSiteQcUserData] = useState({});
    // const [showPaymentPreview,setPaymentPreview] = useState([])
    const [customerInformation, setCustomerInformation] = useState([])
    const [checkVideoUploaded, setCheckVideoUploaded] = useState([]);
    const [showPaymentPreview, setPaymentPreview] = useState([])
    const [checkFileUploaded, setCheckFileUploaded] = useState([{ status: null }]);
    const [fileUploadeds, setFileUploadeds] = useState(false);
    const [expectedSalesclosureDate, setExpectedSalesClosureDate] = useState("")
    const [openSalesDialog, setOpenSalesDialog] = useState(false);
    const [storeSalesQuotation,setStoreSalesQuotation] = useState([])
    const [storeSalesVersion,setStoreSalesVersion] = useState("")
    const [openEnterSalesClosureDate, setOpenEnterSalesClosureDateModal] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [storeLatestQuotation,setstoreLatestQuotation] = useState([])
    const [selectedMeetingType, setSelectedMeetingType] = useState('all');
    const [filteredData, setFilteredData] = useState([]);
    const [meetingData, setMeetingData] = useState([]);
    const [openDialogForMeeting, setOpenDialogForMeeting] = useState(false);
    const [showForm, setShowForm] = useState(false)
    const [handleDataonSave,setHandleDataonSave] = useState(false)
    const [dialogOpen, setDialogOpen] = useState(false);
    const [pendingCheckedValue, setPendingCheckedValue] = useState(false);
    const [qtLength, setQtLength] = useState(0);
    const [dialogForm, setDialogForm] = useState({
        expectedSalesClosureDate: new Date(),
      });
    const [expectedSalesclosureDatenew, setExpectedSalesclosureDatenew] = useState(/* initial value */);
    const [openSelectQuotationVersion,setOpenSelectQuotationVersion] = useState(false);
    const [selectedQuotationVersion, setSelectedQuotationVersion] = useState('');
    const [quotationList, setQuotationList] = useState([])
    const [quotationPdf, setQuotationPdf] = useState();
    const [quotationCsv, setQuotationCsv] = useState();
    const [qtVersion, setQtVersion] = useState("");
    const [designUserWarningDialog, setDesignUserWarningDialog] = useState(false);
    const [openMomPage, setOpenMomPage] = useState(false);
    const [momSubmit, setMomSubmit] = useState(false);
    const [discussionNo, setDiscussionNo] = useState("");
    const [designDiscussion, setDesignDiscussion] = useState(['Discussion 1','Discussion 2', 'Discussion 3','Discussion 4']);
    const [momDiscussionsDetails, setMomDiscussionsDetails] = useState({
        time: getCurrentTime(),
        designer: userDetails.name,
        date: getCurrentDate(),
        typeOfMeeting: "",
        quotationNo: "",
        attendees : "",
        minutesBy: "",
        momNo: 0,
        venue: "",
        agenda : "",
        discussion : "",
        owners : "",
        customerRemarks : "",
        nextMeeting: "",
        remark: "",
    })
    const [clicked, setClicked] = useState(false);

    const [uploadSize, setUploadSize] = useState({
        workingDrawingFile: 0,
        threeworkingDrawingFile: 0,
        contractSignedPaymentReceviedAttachemnt: 0,
        scanQuotationFile: 0,
        scanCheckListFile: 0,
        scanProjectKickOffCheckListFile: 0,
        scanSiteQCCheckListFile: 0,
        designerPaymentAttachement: 0,
        // scanContractFile: false
        quotationCsvFile: 0,
        siteQCPhotos: [],
        paymentRecievedAttachments: []
    })
    const [totalSize, setTotalSize] = useState(0);
    const [formData, setFormData] = useState({
        notes: "",
        reminderDate: "",
        s3Location: "",
        leadId: "",
        user: "",
        stage: ""
    })

    const callTypeMap = {
        INBOUND: 'Incoming',
        OUTBOUND: 'Outgoing',
    };

    const [openPayment, setOpenPayment] = useState(false);
    const [paymentLink, setPaymentLink] = useState("");
    const [checklistResendModal, setChecklistResendModal] = useState(false)
    const [kickOffApprovalResendModal, setKickOffApprovalResendModal] = useState(false)
    const [openNew, setOpenNew] = useState(false);
    const [amount, setAmount] = useState('');
    // const [remarks, setRemarks] = useState('');
    const [isValidAmount, setIsValidAmount] = useState(false);
    const [payExtra, setPayExtra] = useState(false);
    const [checkSalesToken, setCheckSalesToken] = useState(false)
    const [currentStageIndex, setCurrentStageIndex] = useState(0);
    const [callLogsModal, setCallLogsModal] = useState(false)
    const [cdrLogs, setCDRLogs] = useState([]);
    const [cdrModal, setCDRModal] = useState(false);
    const [designHoldSelectedTypes, setDesignHoldSelectedTypes] = useState("")
    const [probableDesignSignOffDate, setProbableDesignSignOffDate] = useState("")
    const [totalAmount, setTotalAmount] = useState(0)
    const availableDesignHoldOptions = [
        { name: 'Possesion Delay' },
        { name: 'Cx not available' },
        { name: 'Cx having Financial Issue' },
        { name: 'Cx wants to put the projects on hold' },
        { name: 'Probable Loss' },
        { name: 'Others' },
    ];

    const [isFilePreviewVisible, setFilePreviewVisible] = useState(false);
    const [againDesignHoldReq, setAgainDesignHoldReq] = useState(false);
    const [page,setPage] = useState(1);
    const [paginationCount,setPaginationCount] = useState(10);
    const [type, setType] = useState('');
     // Req not collected state
    const [reqNotCollectedReasonList, setReqNotCollectedReasonList] = useState([
        'RNR from the day lead is received',
        'Connected once - Cx asked to call later, to be called',
        'Connected once - Cx asked to call later, then RNR',
        'Connected once - Cx asked to call back for requirement but RNR post that',
        'Requirement shared - Floor plan is not shared',
        'Floor plan shared - but requirement is not shared',
        'Requirement shared but out of the scope of work',
        'No requirement as of now',
        'Other'
    ]);
    const [verificationStatusList, setVerificationStatusList] = useState([
        "Yet to verify",
        "Verified real lead",
        "Verified disqualified lead"
    ])
    const [verficationStatus, setVerficationStatus] = useState('');
    const [verficationStatusOther, setVerficationStatusOther] = useState('')
    const [moveInRncReason, setMoveInRncReason] = useState('');
    const [moveInRncOtherReason, setMoveInRncOtherReason ] = useState('');
    const [reassignUser, setReassignUser] = useState(false);
    const [reqNotCollectedFromNotes, setReqNotCollectedFromNotes] = useState(false)
// Requirement Collected state - 
    const [rcScopeOfWork, setRcScopeOfWork] = useState("");
    const [designPref, setDesignPref] = useState("");
    const [estimatedBudget, setEstimateBudget] = useState("");
    const [timelineMoveHouseDate, setTimelineMoveHouseDate] = useState("")
    const [possDate, setPossDate] = useState('');
    const [floorPlanAttach, setFloorPlanAttach] = useState('')
    const [floorPlanUploaded, setFloorPlanUploaded] = useState(false);
    const [taxInvoiceModalOpen, setTaxInvoiceModalOpen] = useState(false);
    const [taxInvoiceFile, setTaxInvoiceFile] = useState(null);
    const [taxInvoiceSendVia, setTaxInvoiceSendVia] = useState({ email: true, whatsapp: true });
    const [taxInvoiceSubmitting, setTaxInvoiceSubmitting] = useState(false);
    const [taxInvoiceType, setTaxInvoiceType] = useState('');
    const [taxInvoiceRemark, setTaxInvoiceRemark] = useState('');
    const [taxInvoiceUsedTypes, setTaxInvoiceUsedTypes] = useState([]);
    const [taxInvoiceTypesLoading, setTaxInvoiceTypesLoading] = useState(false);
    const [rcOtherDetails, setRcOtherDetails] = useState("")
    const [reasonMoveRcCollect, setReasonMoveRcCollect] = useState("")
    const [reasonMoveRcCollectOther, setReasonMoveRcCollectOther] = useState("")    
    const [reasonMoveRcCollectList, setReasonMoveRcCollectList] = useState([
        "All requirements collected, ready for quotation",
        "Partial requirements collected, but sufficient for quotation",
        "Other"
    ])
    // Notes Updated for Requirement Collected state 
    const [reqCollectedChanges, setReqCollectedChanges] = useState(false);
    const [reqCollectedFromNotes, setReqCollectedFromNotes] = useState(false);
    const [qtSentNotesChanges, setQtSentNotesChanges] = useState(false);
    // Quotation Sent Handling State
    const [reasonForDealQtList, setReasonForDealQtList] = useState([
        "Quotation prepared and shared with the customer",
        "Quotation shared, awaiting customer feedback",
        "Quotation shared, customer requested revisions",
        "Quotation shared, customer asked for more time to decide",
        "Quotation shared, customer unresponsive after multiple attempts",
        "Other"
    ]);
    const [reasonToDealQt, setReasonToDealQt] = useState('');
    const [reasonToDealQtOther, setReasonToDealQtOther] = useState('');
    const [qtFittingBudget, setQtFittingBudget] = useState('');
    const [cxPlanVisitExZone, setcxPlanVisitExZone] = useState('');
    const [planVisitDate, setPlanVisitDate] = useState('');
    const [qtSentMeetingOption, setQtSentMeetingOption] = useState('Quotation sent meeting not fixed');
    const [meetingFixedDetail, setMeetingfixedDetail] = useState({
        proposeMeetingType:"",
        proposeMeetingDate: null,
        meetingParticipant:""
    })
    const [editQtSentMeetingDialog, setEditQtSentMeetingDialog] = useState(false)
    const [viewQtSentData, setViewQtSentData] = useState(false);
    const [qtSentMeetingData, setQtSentMeetingData] = useState({});
    const [cancelLinkIsModalOpen, setCancelLinkIsModalOpen] = useState(false)
    const [allPaymentLink,setAllPaymentLink] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [siteMaskingDocumentsLink, setSiteMaskingDocumentsLink] = useState([]);
    const [twoDDrawingsFileLink, setTwoDDrawingsFileLink] = useState([]);
    const [sitePhotosVideosFileLink, setSitePhotosVideosFileLink] = useState([]);
    const [appliancesChecklistFileLink, setAppliancesChecklistFileLink] = useState([]);
    const [powerPointFileLink, setPowerPointFileLink] = useState([]);
    const [quotationFileLink, setQuotationFileLink] = useState([]);
    const [siteMaskingDocuments, setSiteMaskingDocuments] = useState(false);
    const [twoDDrawingsFile, setTwoDDrawingsFile] = useState(false);
    const [sitePhotosVideosFile, setSitePhotosVideosFile] = useState(false);
    const [appliancesChecklistFile, setAppliancesChecklistFile] = useState(false);
    const [powerPointFile, setPowerPointFile] = useState(false);
    const [quotationFile, setQuotationFile] = useState(false);
    const [qcStages, setQcStages] =useState("");
    const [qcProject, setQcProject] = useState({});
    const [openDwgDialog, setOpenDwgDialog] = useState(false); 
    const [dwgRemarks, setDwgRemarks] = useState('');
    const [aDMModalOpen, setADMModalOpen] = useState(false);
    const [qcRemarks, setQCRemarks] = useState("");
    const [assignQCModel, setAssignQCModel] = useState(false);
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [designQuotationId,setDesignQuotationId] = useState("");
    const [quoPdf, setQuoPdf] = useState("");
    const [currentDepartment, setCurrentDepartment] = useState(""); 
    const [openDialogRoleChange, setOpenDialogRoleChange] = useState(false);
    const [teams, setTeams] = useState([]);
    const [selectedTeamForHierarchySet, setSelectedTeamForHierarchySet] = useState("");
    const [hierarchyOptions, setHierarchyOptions] = useState({});
    const [selectedValues, setSelectedValues] = useState({});
    const [remarks, setRemarks] = useState("");
    const [chatMessages, setChatMessages] = useState([]);
    const [chatPagination, setChatPagination] = useState({
        total: 0,
        skip: 0,
        limit: 20,
        hasMore: true,
    });
    const [loadingChats, setLoadingChats] = useState(false);
    const [decorAssistExpanded, setDecorAssistExpanded] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const [isOpenFlaggedModal , setIsOpenFlaggedModal] = useState(false)
    const [discrepanciesList , setDiscrepanciesList] = useState([])
    const [selectDiscrepancies , setSelectDiscrepancies] = useState([])
    const [discrepancyDescription, setDiscrepancyDescription] = useState("")
    const [leadFlags, setLeadFlags] = useState([]);
    const [flagLoading, setFlagLoading] = useState(false);  
    const [selectFlagAssign, setSelectFlagAssign] = useState("")
    const [drawingQtValue,setDrawingQcQtValue] = useState(0);
    const [flagAttachment, setFlagAttachment] = useState("")
    const [disableUpload, setDisableUpload] = useState(false);


    // The thread itself - messages, loading, search, scroll - now lives inside
    // BotWotChatDrawer, so this page only tracks whether the drawer is open.
    const [openChat, setOpenChat] = useState(false);
    const [callingDeskOpen, setCallingDeskOpen] = useState(false);
    const canUseCallingDesk = useCanUseCallingDesk();
    const [hoomanTranscriptsOpen, setHoomanTranscriptsOpen] = useState(false);
    const [hoomanTranscripts, setHoomanTranscripts] = useState([]);
    const [hoomanTranscriptsLoading, setHoomanTranscriptsLoading] = useState(false);
    const [selectedHoomanCall, setSelectedHoomanCall] = useState(null);

  const [cities, setCities] = useState([]);
  const [expCenters, setExpCenters] = useState([]);
  const [managerOfSalesTeam, setManagerOfSalesTeam] = useState([]);
    // ocr states.. starting here
  const [OCRState, setOCRState] = useState({
        image: null,
        preview: "",
        ocrText: "",
        s3Url: "",
        processing: false,
        OCRModalOpen: false,
        approved : false,
        approvalDate : null,
        reason :"",
        image: null,
        retryCount: 0,
        key :""
 });
  const [isEditingDate, setIsEditingDate] = useState(false);
  const [openNewNotesModal, setOpenNewNotesModal] = useState(false);
  const [assineDialogOpen, setAssineDialogOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);

  // AI Design Sign-off Date extraction state — two phases:
  // Phase 1 (preCheck): show recording count popup, let user confirm
  // Phase 2 (analysis): send for AI analysis, show result
  const [aiSignoffState, setAiSignoffState] = useState({
      loading: false,
      dialogOpen: false,
      phase: 'preCheck', // 'preCheck' | 'analysis'
      // Pre-check data
      recordingCount: 0,
      transcriptCount: 0,
      withoutTranscriptCount: 0,
      designerName: '',
      latestRecording: null, // { recordingUrl, transcript, duration, date }
      // Analysis result
      result: null, // { date_found, extracted_date, confidence, reason, source_quote }
      error: null,
      noConversation: false,
      // Only the latest conversation is analysed (latest Runo call, or a newer note audio)
      hasConversation: false,
      latestConversation: null, // { source: 'runo'|'note', id, date, recordingUrl, transcript, duration, fileName, noteText }
      analysisFailed: false, // latest conversation / audio file could not be analysed
      preCheckError: null,
  });

  // AI Design Hold verification state — same two-phase pattern
  const [designHoldPreCheck, setDesignHoldPreCheck] = useState({
      loading: false,
      dialogOpen: false,
      phase: 'preCheck', // 'preCheck' | 'analysis' | 'result'
      noConversation: false,
      recordingCount: 0,
      transcriptCount: 0,
      withoutTranscriptCount: 0,
      designerName: '',
      latestRecording: null, // { recordingUrl, transcript, duration, date }
      result: null, // { approved, reason, suggestion, confidence }
      error: null,
      hasConversation: false,
      latestConversation: null, // { source: 'runo'|'note', id, date, recordingUrl, transcript, duration, fileName, noteText }
      analysisFailed: false, // latest conversation / audio file could not be analysed
      preCheckError: null,
  });
  const [designHoldAIResult, setDesignHoldAIResult] = useState(null);

 const handleCloseOCRModal = () => {
    setOCRState({
        image: null,
        preview: "",
        ocrText: "",
        s3Url: "",
        processing: false,
        OCRModalOpen: false,
        approved : false,
        approvalDate : null,
        reason :"",
        retryCount: 0,
        key :""
    });
};

    const normalizeOcrDate = (d) => {
    if (!d) {
        return {
            ok: false,
            value: "",
            error: "The design signoff date should be in dd-mm-yyyy format only."
        };
    }
    
    const parts = d.replace(/\//g, "-").split("-");

    if (parts.length !== 3) {
        return { 
            ok: false, 
            value: d, 
            error: "The design signoff date should be in dd-mm-yyyy format only." 
        };
    }

    let day, month, year;
    let p1 = parts[0];
    let p2 = parts[1];
    let p3 = parts[2];

    //  yyyy-mm-dd formate..
    if (p1.length === 4) {
        year = p1;
        month = p2;
        day = p3;
    }
    //  dd-mm-yyyy formate..
    else if (p3.length === 4) {
        day = p1;
        month = p2;
        year = p3;
    }
    else {
        return {
            ok: false,
            value: d,
            error: "The design signoff date should be in dd-mm-yyyy format only."
        };
    }

    if (!isValidDMY(day, month, year)) {
        return { 
            ok: false, 
            value: d, 
            error: "The design signoff date should be in dd-mm-yyyy format only." 
        };
    }

    // Return ISO format for MongoDB (yyyy-mm-dd)
    const isoDate = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    
    return { 
        ok: true, 
        value: isoDate, 
        error: null
    };
};

    const isValidDMY = (d, m, y) => {
        const day = parseInt(d);
        const month = parseInt(m);
        const year = parseInt(y);

        if (isNaN(day) || isNaN(month) || isNaN(year)) return false;

        if (month < 1 || month > 12) return false;
        if (day < 1 || day > 31) return false;

        return true;
    };

const formatDateForDisplay = (dateValue) => {
    if (!dateValue) return "N/A";
    
    // If in yyyy-mm-dd format, convert to dd-mm-yyyy
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
        const [year, month, day] = dateValue.split('-');
        return `${day}-${month}-${year}`;
    }
    
    return dateValue;
};
// ocr date edit eligible role 
const canEditDate = userDetails.roles.some(
  role =>
    role.name === ROLENAME.DGM_Design ||
    role.name === ROLENAME.AGM_Design || 
    role.name  === ROLENAME.Admin
);

const canShowRunoCallIcon =
    userDetails?.departmentId === salesDepartment ||
    userDetails?.roles?.some((role) => role.name === ROLENAME.Admin);

const isSalesDepartmentUser = userDetails?.departmentId === salesDepartment;


const ALLOWED_MIME_TYPES_OCR = ["image/png", "image/jpeg", "image/jpg"];
const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!ALLOWED_MIME_TYPES_OCR.includes(file.type)) {
        props.setSnackInfo(
            "Only PNG, JPG, and JPEG images are allowed.",
            "error"
        );
        e.target.value = ""; 
        return;
    }

    setOCRState((prevState) => ({
        ...prevState,
        image: file,
        preview: URL.createObjectURL(file),
        ocrText: "",
        s3Url: "",
        approved : false,
        approvalDate : null,
        reason :"",
        reason :"",
        key : ""
    }));
};
// ocr function and states ends here..

    const clickRaiseFlagButton = ()=>{
      
     setIsOpenFlaggedModal(true)
     getAllDiscrepanciesListFun();
 
    }
 
   // reverted: removed getLeadFlagColor helper
 
    const getAllDiscrepanciesListFun = async () => {
     try {
       props.setLoading(true);
       const fetchData = await HttpService?.getAllDiscrepanciesList();
       setDiscrepanciesList(fetchData?.data|| []);
     } catch (error) {
       props.setLoading(false);
     }
   };

   const handleAttachmentImageChange = async (event) => {
    props.setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", event.target.files[0]);
      const fileUploadRes = await HttpService.uploadFile(fd);
      setFlagAttachment(fileUploadRes.data); // Make sure it's a URL or expected format
    } catch (error) {
      props.setSnackInfo("Something went wrong", "error");
    }
    props.setLoading(false);
  };

    const getLocationList = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getLocationList()
            setCities(response.data)
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    };

    const getExperienceCenterByLocation = async (e) => {
        setProjectDetailsFields({ ...projectDetailsFields, [e.target.name]: e.target.value });
        props.setLoading(true)
        try {
            const response = await HttpService.getExpericenCentersByLocation(e.target.value)
            setExpCenters(response.data)
            // getUsers();
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    };

    const getManagerBasedOnLocation = (e, city) => {
        setProjectDetailsFields({ ...projectDetailsFields, [e.target.name]: e.target.value })
        let salesManagerArr = []
        dupManagerOfSalesTeam.forEach(ele => {
            ele.experienceCenterId.forEach(ele1 => {
                if (ele1._id === e.target.value) {
                    salesManagerArr.push(ele)
                }
            })
        })
        setManagerOfSalesTeam(salesManagerArr)
    };

    const checkAssignDetail = (e) => {
        if (e.target.value) {
            let teamDetail = [];
            dupManagerOfSalesTeam.forEach(ele => {
                if (ele?._id === e.target.value) {
                    teamDetail.push(ele)
                }
            })
            setProjectDetailsFields({
                ...projectDetailsFields, [e.target.name]: e.target.value,
                'assignToName': teamDetail[0].name,
                'assignTo': teamDetail[0]._id,
                'departmentId': teamDetail[0].departmentId._id,
                'team': teamDetail[0].teamId._id,
                'status': "Lead Received",
                'currentStage': "Lead Received",
                'teamName': teamDetail[0].teamId.name,
            })
        }
    };

   // Function to create payload from lead data
 function createFlagPayload(leadData, currentUserId, formData) {
     return {
       // Required fields from lead data
       leadId: leadData._id,
       leadNo: leadData.lead_no,
       uniqueLeadNumber: leadData.uniqueLeadNumber,
       
       // From form (user selection)
       discrepancyId: formData.discrepancyId,
       description: formData.description,
       
       // Current user
       raisedBy: currentUserId,
       
       experienceCenterId: leadData.experienceCenterId || null,
       
       assignedTo: [
         leadData.designAGM,
         leadData.designManager, 
         leadData.designDGM,
         currentUserId
       ].filter(id => id) 
     };
   }

   useEffect(() => {
    async function fetchLeadFlags() {
      if (!projectDetails?._id) return;
      setFlagLoading(true);
      try {
        const response = await HttpService.getLeadFlags(projectDetails._id);
        setLeadFlags(response?.data?.data || []);
      } catch(e) {
        setLeadFlags([]);
      }
      setFlagLoading(false);
    }
    fetchLeadFlags();
  }, [projectDetails?._id]);

  function getFlagColorFromFlags(flags) {
    // Black when flag is not raised yet (no flags exist)
    if (!flags || !Array.isArray(flags) || !flags.length) return '#000000';
    
    // Check if any flag is open (flagged)
    const hasOpen = flags.some(f => String(f.status).toLowerCase() === 'open');
    if (hasOpen) return '#e53935'; // Red for open/flagged
    
    // Check if any flag is resolved
    const hasResolved = flags.some(f => String(f.status).toLowerCase() === 'resolved');
    if (hasResolved) return '#43a047'; // Green for resolved
    
    // Check if any flag is closed
    const hasClosed = flags.some(f => String(f.status).toLowerCase() === 'closed');
    if (hasClosed) return '#000000'; // Black for closed
    
    // Default to black if no flags match
    return '#000000';
  }

  const assignToForFlag = ["DGM", "AGM", "ODM","DE"]
 
 const createFlaggedproject = async (event) => {
     // event.preventDefault();
     if (selectDiscrepancies._id == "" || discrepancyDescription == "") {
         props.setSnackInfo("please fill all the fields", "warning");
         return;
     }
 
     // Form data from user input
     const formData = {
     discrepancyId: selectDiscrepancies?._id,
     description: discrepancyDescription
     };
 
     // Create payload
    //  const payload = createFlagPayload(projectDetails, userDetails?._id, formData);
    const payload = {
        leadId: projectDetails?._id,
        // discrepancyId: "68f86568c65f47d6d971030f",
        raisedBy: userDetails?._id,
        flagTo: selectFlagAssign,
        // description: "Issue with design1212",
        attachments: flagAttachment,
        discrepancyId: selectDiscrepancies?._id,
        description: discrepancyDescription,
      }
 
     props.setLoading(true);
     try {
         props.setLoading(true);
         const response = await HttpService.submitFlaggedProject(payload);
         setIsOpenFlaggedModal(false);
         setSelectDiscrepancies("");
         setDiscrepancyDescription("");
         props.setLoading(false);
         props.setSnackInfo("Sucessfully Created", "success");
     } catch (error) {
         props.setLoading(false);
         console.log("error", error)
 
         // Handle category already exists error
         if (error.response && error.response.status === 400 || error.response.status === 403) {
         props.setSnackInfo(`${error?.response?.data.message}`, "error");
         } else {
         props.setSnackInfo("Something went wrong. Please try again!", "error");
         }
     }
 };

    const closeHandle = ()=>{
        setIsOpenFlaggedModal(false)
        props.setLoading(false)
    }

    const handleChangeOwnership = async (leadId, department) => {
  try {
    setCurrentDepartment(department);
    const responseObj = await HttpService.hierarchyoptionsAccordingToUser(department);
 
    if (responseObj.status == 200) {
        const newTeams = responseObj?.data?.result?.teams || [];
        setTeams(newTeams);
        const experienceCentersListForHierarchy = responseObj?.data?.result?.experienceCenters || [];
        setHierarchyOptions({});
        handleTeamSelect(newTeams, department, experienceCentersListForHierarchy);
        setOpenDialogRoleChange(true);
        setSelectedTeamForHierarchySet("");
        setSelectedValues({});
      }else{
        props.setSnackInfo("Can Not get Hierarchy", "error");
    }
  } catch (err) {
    console.log(err);
    props.setSnackInfo("Something went wrong", "error");
  }
};

const filterUsersByManager = (managerId) => {
    const usersUnderManager = teams
      .filter(t => t.manager?._id === managerId)
      .flatMap(t => t.executive || [])
      .filter((v, i, self) => i === self.findIndex(u => u._id === v._id));
  
    // Find which key is <prefix>User
    const userKey = Object.keys(hierarchyOptions).find(k => k.endsWith("User"));
  
    setHierarchyOptions(prev => ({
      ...prev,
      [userKey]: usersUnderManager
    }));
  
    // Clear user selection if manager changed
    setSelectedValues(prev => ({
      ...prev,
      [userKey]: ""
    }));
  };

  //   customerName, email, projectId

  const resendDesignHoldButton = async () => {
    try {
      setLoadingState(true);
      props.setLoading(true);

      const fetchData = await HttpService?.resendDesignHoldButton({
        customerName :projectDetails?.customerId?.name,
        email : projectDetails?.customerId?.email,
        projectId : projectDetails?._id,
      });
      props.setSnackInfo("Successfully mail sent", "success");
      setChecklistResendModal(false);
      props.setLoading(false);
    } catch (error) {
        setLoadingState(false);
        props.setLoading(false);
    } 
  };
  

const handleTeamSelect = (teamsList = teams, department, experienceCentersListForHierarchy) => {
    const prefix = (department || currentDepartment).toLowerCase();
      

    const teamDGMList = teamsList
        .filter(t => t.teamDGM)
        .map(t => t.teamDGM)
        .filter((value, index, self) =>
            index === self.findIndex((v) => v._id === value._id)
        );


    const teamAGMList = teamsList
        .filter(t => t.teamAGM)
        .map(t => t.teamAGM)
        .filter((value, index, self) =>
            index === self.findIndex((v) => v._id === value._id)
        );


        const teamManagerList = teamsList
        .filter(t => t.manager)
        .map(t => t.manager)
        .filter((value, index, self) =>
            index === self.findIndex((v) => v._id === value._id)
        );

        const teamAssistantManagersList = teamsList
        .flatMap(t => t.assistantManagers || []) // flatten arrays
        .filter((v, i, self) => i === self.findIndex(u => u._id === v._id)); 


        // const assignToList = teamsList
        // .flatMap(t => t.executive || []) 
        // .filter((v, i, self) => i === self.findIndex(u => u._id === v._id)); 

      const teamUserList = teamsList
      .flatMap(t => t.executive || [])
      .filter((v, i, self) => i === self.findIndex(u => u._id === v._id));


      if (prefix === 'sales' ){
        setHierarchyOptions({
            [`${prefix}DGM`]: teamDGMList || [],
            [`${prefix}AGM`]:teamAGMList || [],
            [`${prefix}Manager`]: teamManagerList || [],
            [`${prefix}AssistantManager`]: teamAssistantManagersList || [],
            [`${prefix}User`]: teamUserList || [],
            [`${prefix}WonExpCtrId`]: experienceCentersListForHierarchy || [],

          //   [`assignTo`]: assignToList || [],
          });
        
          setSelectedValues({
            [`${prefix}DGM`]: "",
            [`${prefix}AGM`]: "",
            [`${prefix}Manager`]: "",
            [`${prefix}Manager`]: "",
            [`${prefix}AssistantManager`]: "",
            [`${prefix}User`]: "",
            [`${prefix}WonExpCtrId`]: "",
          //   [`$assignTo`]: "",
          });

      } else {

        setHierarchyOptions({
            [`${prefix}DGM`]: teamDGMList || [],
            [`${prefix}AGM`]:teamAGMList || [],
            [`${prefix}Manager`]: teamManagerList || [],
            [`${prefix}User`]: teamUserList || [],
            [`${prefix}WonExpCtrId`]: experienceCentersListForHierarchy || [],
          //   [`assignTo`]: assignToList || [],
          });
        
          setSelectedValues({
            [`${prefix}DGM`]: "",
            [`${prefix}AGM`]: "",
            [`${prefix}Manager`]: "",
            [`${prefix}User`]: "",
            [`${prefix}WonExpCtrId`]: "",
          //   [`$assignTo`]: "",
          });

      }

      
  
  };


const handleSaveOwnership = async () => {
  try {
    const updates = {};
    Object.entries(selectedValues).forEach(([key, value]) => {
      if (value && value._id) {
        updates[key] = {
          _id: value._id,
          name: value.name
        };
      }
    });

      const mustHaveKeys = ["designUser", "salesUser"];
      const hasRequiredKey = mustHaveKeys.some(key => updates[key]);

      if (!hasRequiredKey) {
          props.setSnackInfo("Please select Design User or Sales User", "warning");
          return;
      }
    
    if (Object.keys(updates).length === 0) {
      props.setSnackInfo("No changes to update", "warning");
      return;
    }


    if (Object.keys(updates).includes("User")) {
        props.setSnackInfo("Please Select a User", "warning");
        return;
      }

    const responseObj = await HttpService.changeHierarchyOfALead(projectDetails._id, updates);

    if (responseObj.status === 200) {
      props.setSnackInfo("Ownership updated successfully", "success");
      await getProjectLogs();
    //   await getcustomerDetails();
     setReRender(prev => !prev);
    } else {
      props.setSnackInfo("Failed to update ownership", "error");
    }
  } catch (err) {
    console.log(err);
    props.setSnackInfo("Something went wrong", "error");
  }
  setOpenDialogRoleChange(false);
};

    // getAmountReceivedForLeadForAlead 
    useEffect(() => {
        getAmountReceivedForLead();
        getLocationList();
    }, [])



    const handleOpenADMModal = () => {
        setADMModalOpen(true); 
    };
    const handleCloseADMModal = () => {
        setADMModalOpen(false);
    };

    const blockDesignerMoveIfDsoPending = () => {
        if (isDesignerBlockedWhileDsoPending(projectDetails)) {
            props.setSnackInfo(DSO_PENDING_DESIGNER_MOVE_BLOCK_MESSAGE, 'warning');
            return true;
        }
        return false;
    };

    const dwgSubStagesButton = () => {
        if (blockDesignerMoveIfDsoPending()) {
            return;
        }
        getDepartments();
        setOpenAnotherDialog(true);
        setSelectedStage("Drawing QC")
        getAllQuotationsForProject();
        handleClickOpen()
    };

    const renderMessage = (message) => {
        const formatMessageTime = (timestamp) => {
          const messageDate = moment(timestamp);
          const today = moment().startOf("day");
          const yesterday = moment().subtract(1, "days").startOf("day");
          if (messageDate.isSame(today, "day")) {
            return `Today at ${messageDate.format("hh:mm A")}`;
          } else if (messageDate.isSame(yesterday, "day")) {
            return `Yesterday at ${messageDate.format("hh:mm A")}`;
          } else {
            return messageDate.format("DD/MM/YYYY hh:mm A");
          }
        };
        const renderMediaContent = () => {
            switch (message.type) {
                case "text":
                    return <Typography>{message.body}</Typography>;
                case "image":
                    return (
                        <img
                        src={message?.mediaDetails?.url}
                        alt="Shared image"
                        className={classes.image}
                        onClick={() => window.open(message?.mediaDetails?.url, "_blank")}
                        />
                    );
                case "video":
                    return (
                        <div className={classes.mediaContainer}>
                        <video
                            className={classes.video}
                            controls
                            onClick={(e) => e.stopPropagation()}
                        >
                            <source
                            src={message?.mediaDetails?.url}
                            type={message?.mediaDetails?.mimeType}
                            />
                            Your browser does not support the video element.
                        </video>
                        </div>
                    );
                case "audio":
                    return (
                        <div className={classes.audio}>
                        <audio
                            className={classes.audio}
                            controls
                            onClick={(e) => e.stopPropagation()}
                        >
                            <source
                            src={message?.mediaDetails?.url}
                            type={message?.mediaDetails?.mimeType}
                            />
                            Your browser does not support the audio element.
                        </audio>
                        </div>
                    );
                case "document":
                    return (
                        <div 
                        className={classes.document}
                        onClick={() => window.open(message?.mediaDetails?.url, "_blank")}
                        >
                        <DocumentIcon className={classes.documentIcon} />
                        <Typography>{message?.mediaDetails?.filename || "Document"}</Typography>
                        </div>
                    );
                case "location":
                    const { latitude, longitude } = message.mediaDetails;
                    const mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
                    return (
                        <div 
                        className={classes.location}
                        onClick={() => window.open(mapUrl, "_blank")}
                        >
                        <div className={classes.location}>
                            <LocationIcon className={classes.documentIcon} />
                            <Typography>Location: {latitude}, {longitude}</Typography>
                        </div>
                        <img
                            src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=15&size=600x300&markers=color:red%7C${latitude},${longitude}&key=YOUR_GOOGLE_MAPS_API_KEY`}
                            alt="Location"
                            className={classes.location}
                        />
                        </div>
                    );
                default:
                    return (
                        <Typography>Unsupported message type: {message.type}</Typography>
                    );
            }
        };
        return (
          <div key={message._id} className={classes.messageContainer}>
            <Avatar>{message.userName[0]}</Avatar>
            <div className={classes.receivedMessage}>
                <div className={classes.messageHeader}>
                    <Typography variant="subtitle2" className={classes.userName}>
                    {message.userName}
                    <Typography
                        component="span"
                        variant="caption"
                        style={{ marginLeft: "8px", color: "#667781" }}
                    >
                        ({message.waId})
                    </Typography>
                    </Typography>
                </div>
                <div className={classes.messageBody}>
                    {renderMediaContent()}
                </div>
                <Typography variant="caption" className={classes.timestamp}>
                    {formatMessageTime(message.timestamp)}
                </Typography>
            </div>
          </div>
        );
      };


    const handleViewFile = () => {
        setFilePreviewVisible(!isFilePreviewVisible);
    };

    const handleGeneratePaymentLink = async () => {
        props.setLoading(true)
        let amountWithCharges
        if(payExtra === true){
            amountWithCharges = +amount * 0.0236;
            //  amountWithCharges = +amount * 0.016;
            amountWithCharges = (+amountWithCharges + +amount).toFixed(0);
        }else{
            amountWithCharges = amount;
        }
        const Details = {
            customer_details: {
                customer_email: projectDetails?.customerId?.email,
                customer_name: projectDetails?.customerId?.name,
                customer_phone: projectDetails?.customerId?.contact_no,
                customerAddress: projectDetails?.customerId?.address
            },
            link_amount: amountWithCharges,
            link_purpose: `${projectDetails?.customerId?.name}`,
            Stage: projectDetails.currentStage,
            departmentId: projectDetails.departmentId._id,
            uniqueLeadNumber: projectDetails.uniqueLeadNumber

        };
        try {
            // const response = await HttpService.cashFreePaymentUpload(projectDetails._id, Details)
            const response = await HttpService.phopePePaymentUpload(projectDetails._id, Details)
            // setProjectLogs(response.data)
            setPaymentLink(response.data.link_url);
            handleClick()
            setOpenPayment(true);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)

    };


    useEffect(() => {
        const storedTime = localStorage.getItem('buttonDisabledUntil');
        if (storedTime && new Date(storedTime) > new Date()) {
          setDisabled(true);
        }
      }, []);
    
      useEffect(() => {
        if (disabled) {
          const interval = setInterval(() => {
            const storedTime = localStorage.getItem('buttonDisabledUntil');
            if (!storedTime || new Date(storedTime) <= new Date()) {
              setDisabled(false);
              localStorage.removeItem('buttonDisabledUntil');
              clearInterval(interval);
            }
          }, 1000);
          return () => clearInterval(interval);
        }
      }, [disabled]);

      useEffect(() => {
        if (teams.length > 0) {
          handleTeamSelect();
        }
      }, [teams]);
      
    
      const handleClick = () => {
        // Then disable the button for 10 minutes
        const disableUntil = new Date(Date.now() + 10 * 60 * 1000);
        localStorage.setItem('buttonDisabledUntil', disableUntil.toISOString());
        setDisabled(true);
      };


    const handleClose = () => {
        setOpenPayment(false);
        setOpenDialogForMeeting(false);
    };

    const handleAddMeeting = () => {
        setShowForm(true);
        getDepartments();
    };

    const handleOpenDialog = () => {
        setOpenDialogForMeeting(true);  // Set dialog open state
    };

     const handleOpenDwgDialog = () => {
        setOpenDwgDialog(true);
    };

    const fetchUsersData = async () => {
        let obj = {
            role: "Quality Control",
        }
        try {
            let response = await HttpService.allQCUsers(obj);
            setUsersData(response.data)
        } catch (error) {
            console.log(error,"error")
        }
    };

    const assignQcPerson = async () => {
        setAssignQCModel(false);
        try {
            const obj = {
                data: projectDetails,
                assignedUser: selectedUsers,
            }
            let response = await HttpService.assignQcPerson(obj);
            if(response.status == 200) {
                props.setSnackInfo(`This project assigned to ${selectedUsers.name}`, "success");
            }
        } catch (error) {
            console.log(error,"error")
        }
    };

    const handleOpenAssign = () => {
        fetchUsersData();
        setAssignQCModel(true);
    };

    const handleCloseAssign = () => {
        setUsersData([]);
        setSelectedUsers([]);
        setAssignQCModel(false);
    };
    const handleCloseDwgDialog = () => {
        setQcStages("");
        setSiteMaskingDocumentsLink([]);
        setTwoDDrawingsFileLink([]);
        setSitePhotosVideosFileLink([]);
        setAppliancesChecklistFileLink([]);
        setPowerPointFileLink([]);
        setQuotationFileLink([]);
        setDwgRemarks("");
        setOpenDwgDialog(false);
        setQCRemarks("");
    };
    const approvalOrRejctDrawingQc = async (e, name) => {
        setOpenDwgDialog(false); 
        props.setLoading(true)
        try {
            const obj = {
                type: qcStages,
                data: projectDetails,
                dwgRemarks: dwgRemarks,
                siteMaskingDocumentsLink: siteMaskingDocumentsLink,
                twoDDrawingsFileLink: twoDDrawingsFileLink,
                sitePhotosVideosFileLink: sitePhotosVideosFileLink,
                appliancesChecklistFileLink: appliancesChecklistFileLink,
                powerPointFileLink: powerPointFileLink,
                quotationFileLink: quotationFileLink,
            }
            const response = await HttpService.drawingQCApprovelForDQCStages(obj);
            if (response.status == 200) {
                props.setSnackInfo(`Drawing has been moved to stage: ${qcStages}`, 'success');
            }
        } catch (error) {
        console.error(error)
        props.setSnackInfo("Something went wrong", 'error');
        }
        props.setLoading(false);
    }


    const handleSubmit = async () => {
        try {
            props.setLoading(true);
            const dealData = {
                stage,
                meetingType,
                meetingDate,
                projectId, // Ensure projectId is correctly assigned
                projectExpId: projectDetails?.experienceCenterId
            };
            const response = await HttpService.updateMeetingLogs(dealData);
            setHandleDataonSave(true)
            props.setSnackInfo("Meeting Updated Successfully", "success");
            if (response.success) {
                setShowForm(false);
                props.refreshData();
            }
            setOpenDialogForMeeting(false);
            setShowForm(false);
            setMeetingType("");
            setMeetingDate("");
        } catch (error) {
            props.setSnackInfo("Error saving meeting details:", error);

        } finally {
            props.setLoading(false);

        };
    }

    const fetchMeetingData = async () => {
        try {
            const response = await HttpService.getDataForMeetingTracket(projectId)
            const data = response.data
            if (data.success) {
                setMeetingData(data.meetingLogs);
                setFilteredData(data.meetingLogs);
            }
        } catch (error) {
            props.setSnackInfo("Something went wrong", "error");
        }
    };

    const handleFilterChange = (event) => {
        const filterValue = event.target.value;
        setSelectedMeetingType(filterValue);

        if (filterValue === 'all') {
            setFilteredData(meetingData);
        } else {
            const filtered = meetingData.filter(log => {
                if (filterValue === 'office') {
                    return log.meetingTypes.officeMeets.length > 0;
                } else if (filterValue === 'residence') {
                    return log.meetingTypes.residenceMeets.length > 0;
                }
                return false;
            });
            setFilteredData(filtered);
        }
    };

    const handleClickOpenNew = () => {
        setOpenNew(true);
    };

    const handleCloseNew = () => {
        setOpenNew(false);
    };

    const handleSave = () => {
        handleGeneratePaymentLink()
        handleCloseNew();

    };

    const handleAmountChange = (e) => {
        const value = e.target.value;
        setAmount(value);
        setIsValidAmount(value !== '' && parseFloat(value) > 0);
        let token;
        if (projectDetails?.departmentId?._id === salesDepartment) {
            token = +(((value / projectDetails?.grandTotal) * 100).toFixed(2));
        } else { 
            token = +(((value / projectDetails?.staticSalesWonAmount) * 100).toFixed(2));
        }
        let knowToken = projectDetails?.paymentPercent + token
        setCheckSalesToken(projectDetails?.paymentPercent + token <= 10 ? false : true)
    };

    const getGroupChatMessages = async (loadMore = false) => {
        if (loadingState) return;
        setLoadingState(true);
        try {
            const userId = userDetails._id || props.customerDetails?._id
            const response = await HttpService.leadMessages(projectId, loadMore ? offset : 0);
            if (loadMore) {
                setMessages((prev) => [...response.data.messages, ...prev]); // Append old messages at the top
            } else {
                setMessages(response.data.messages);
            }

            setOffset((prev) => prev + response.data.messages.length);
            if (totalMessages === null) {
                setTotalMessages(response.data['totalMessagesCount'] || 0);        }
            console.log('getGroupChatMessages response: ', response.data)
        } catch(error) {
            console.error('Error fetching messages:', error);
        }
        setLoadingState(false);  // ✅ Ensure loading is reset after API call
      };

      const isValidUrl = (string) => {
        try {
          const url = new URL(string);
          return url.protocol === "http:" || url.protocol === "https:";
        } catch (err) {
          return false;
        }
      };

      const get_customer_whatsapp_replies = async (loadMoreReplies = false) => {
        setWhatsAppRepliesLoadingState(true);
        try {
            const response = await HttpService.whatsAppRepliesFromCustomer(
                projectId,
                loadMoreReplies ? offsetForReplies : 0
            );
            if (loadMoreReplies) {
                setWhatsappRepliesFromCustomer((prev) => [...response?.data?.messages, ...prev]); // Append old messages at the top
            } else {
                setWhatsappRepliesFromCustomer(response?.data?.messages);
            }
            setOffsetForReplies((prev) => prev + response?.data?.messages.length);
            if (totalWhatsappReplies === null) {
                setTotalWhatsappReplies(response.data['totalMessagesCount'] || 0);
            }
        } catch (error) {
            console.log('Error fetching messages:', error.message);
            console.error('Error fetching messages:', error);
        }
        setWhatsAppRepliesLoadingState(false);
    }
    


    useEffect(() => {
        const fetchData = async () => {
            try {
              const res = await getcustomerDetails();
              if(res) {
        
                // Fire subsequent API calls
                getProjectLogs();
                getChmUsersList();
                getProjectLogCount();
                getGroupChatMessages();
                get_customer_whatsapp_replies();
                fetchHoomanTranscripts();
                fetchPinnedNotes();
                // Conditional API call
                if (userDetails.roles.find(role => role.name === ROLENAME.SeniorOperationManager)) {
                  getAllSiteQc();
                }
              }
            } catch (error) {
              console.error("Error fetching customer details:", error);
            }finally {
              setIsCheckingAccess(false);
            }
          };
        
          fetchData();

    }, [reRender])

   const handleCalled = () =>{
    getAllQuotationsForProject();
   }

    useEffect(()=>{
        calculateTotalSize();
    }, [uploadSize])

    useEffect(() => {
        if (openDialogForMeeting && projectId) {
            fetchMeetingData();
        }
    }, [openDialogForMeeting, projectId]);

    const handleQuotationStatusChange = (data) => {
        if(data.length > 0){
            setQuotationStatus(1)
        }else{
            setQuotationStatus(0);
        }
    };


    const getAmountReceivedForLead = async () => {
        try {
            let obj = {}
            obj.leadId = projectId
            const result = await HttpService.getApprovedPaymentTransactionsForLead(obj);
    
            const totalAmountReceived = result.data
                .filter(obj => obj.Status === 'Payment Received' && obj.hasOwnProperty('Amount_Received'))
                .reduce((sum, obj) => sum + obj['Amount_Received'], 0);
            setTotalAmount(totalAmountReceived)
        } catch (error) {
            console.log(error, "err");
        }
    };

    const getAllQuotationsForProject = async () => {
        props.setLoading(true)
        try {
          const response = await HttpService.getAllQuotationsForProject(projectId)
          if (response?.data?.length) {
             setQtLength(response?.data?.length)
          }
          setstoreLatestQuotation(response.data)
          setQuotationList(response.data)
          setStoreSalesQuotation(response.data)
          handleQuotationStatusChange(response.data)
        } catch (error) {
          console.error(error)
          props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        props.setLoading(false)
      }

          
    const handleCheckboxChange = (event, quotation) => {
        if (event.target.checked) {
            setShowButton(true)
          setSelectedQuotation(quotation);
          updateSelectedQuotation(quotation)
          setOpenDialog(false)
        } else {
          setSelectedQuotation(null);
          setOpenDialog(false)
          setShowButton(true)
        }
      };

      const updateSelectedQuotation = async(quotation) =>{
        try{
            let obj ={
                latestQuotationShared: quotation.s3Location,
                leadId: quotation.leadId._id,
                designVersion:quotation.version,
                grandTotal: quotation.grandTotal
            }
         let res = await HttpService.updateDesignQuotation(obj)
         getAllQuotationsForProject();
         getcustomerDetailsWithVersion()
         if(res.status == 200){
            setQuotationSelected(true)
         }
        }catch(error){
            console.log(error)
        }
      }
    

    const getAllSiteQc = async () =>
    {
        props.setLoading(true)

        try {
            const response = await HttpService.getAllSiteQcDetails()

            setAllSiteQc(response.data)
        }
        catch (error) {
            console.log("error: ", error.message)

            console.error(error)
        }

        props.setLoading(false)
    }

    const handleAssignSiteQc = async () => {
        props.setLoading(true)
        try {
            let data =
            {
                leadId: projectId,
                siteQcUserId: selectedSiteQcUserData._id,
                siteQcUserTeamId: selectedSiteQcUserData.teamId._id,
                siteQcUserTeamName: selectedSiteQcUserData.teamId.name,
                siteQcUserDepttId: selectedSiteQcUserData.departmentId,
                siteQcUserName: selectedSiteQcUserData.name,
                siteQcUserEmail: selectedSiteQcUserData.email
            }
            const response = await HttpService.assignSiteQC_Manually(data)
            setOpenAssignSiteQcModel(false)
            props.setSnackInfo(`You assigned ${selectedSiteQcUserData.name}  as a Site QC for this project`)
            setSelectedSiteQcUserData({})
            setReRender(true)
            setReRender(false)
        }
        catch (error) {
            console.log("error", error.message)
            console.error(error)
        }
        props.setLoading(false)
    }

    const handleClickSalesOpenDialog = () => {
        setOpenSalesDialog(true);
    };
    const handleSalesCloseDialog = () => {
        setOpenSalesDialog(false);
    };

    const handleCheckboxChangeSales = (event, quotation) => {
        if (event.target.checked) {
            const required4Percent = quotation?.grandTotal * 0.05;
            //  blocking here / stoping to choose a quotation ( if  grandtotal < 5% of payment received..)
            if (totalAmount < required4Percent) {
                props.setSnackInfo(
                    "Payment received is less than 5% of the quote value. Please collect the minimum 5% payment to proceed.",
                    "error"
                );
                return;
            }
            setSelectedQuotation(quotation);
            updateSalesSelectedQuotation(quotation)
            setOpenSalesDialog(false)
        } else {
            setSelectedQuotation(null)
            setOpenSalesDialog(false)
        }
    };

    const updateSalesSelectedQuotation = async (quotation) => {
        try {
            let obj = {
                grandTotal: quotation.grandTotal,
                discountPercent: quotation.discountPercent,
                salesQuotation: quotation.s3Location,
                leadId: quotation.leadId._id,
                version: quotation.version
            }
            let res = await HttpService.updateSalesQuotation(obj)
            getcustomerDetails();
            if (res.status == 200) {
                setQuotationSelected(true)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getProjectLogs = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getProjectLog(projectId,page)
            setProjectLogs(response.data)
        } catch (error) {
            console.log("No logs found")
        }
        props.setLoading(false)
    }

    const getProjectLogCount = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getProjectLogCount(projectId)
            // set total number of pages
            setPaginationCount(Math.ceil(response.data/10))
        } catch (error) {
            console.error("No logs found")
        }
        props.setLoading(false)
    }

    const getNoteDepartment = (note) => note?.createdBy?.departmentId?.name;

    const canPinNote = (note) =>
        userHasAnyRole(userDetails, PIN_OVERRIDE_ROLES) ||
        userHasAnyRole(userDetails, PIN_ROLES[getNoteDepartment(note)] || []);

    const canUnpinNote = (note) =>
        userHasAnyRole(userDetails, PIN_OVERRIDE_ROLES) ||
        userHasAnyRole(userDetails, UNPIN_ROLES[getNoteDepartment(note)] || []);

    const buildPinnedByTooltip = (note) => {
        const name = note?.pinnedBy?.name;
        if (!name) return 'Pinned';
        const roles = Array.isArray(note?.pinnedBy?.roles) ? note.pinnedBy.roles.map(role => role.name).join(', ') : '';
        return roles ? `Pinned by ${name} (${roles})` : `Pinned by ${name}`;
    }

    const buildUnpinRolesMessage = (note) => {
        const noteDepartment = getNoteDepartment(note);
        const allowedRoles = UNPIN_ROLES[noteDepartment] || [];
        const roleList = allowedRoles.length ? allowedRoles.join(', ') : 'the authorized team';
        return `Only ${roleList}${noteDepartment ? ` (${noteDepartment})` : ''} can unpin this note.`;
    }

    const handlePinNote = async (note) => {
        if (pinActionLoadingId) return;
        if (pinnedNotesList.length >= MAX_PINNED_NOTES_PER_LEAD) {
            props.setSnackInfo(`A maximum of ${MAX_PINNED_NOTES_PER_LEAD} notes can be pinned for this lead. Please unpin a note first.`, "warning");
            return;
        }
        setPinActionLoadingId(note._id);
        try {
            await HttpService.pinNote(note._id);
            props.setSnackInfo("Note pinned successfully.", "success");
            await Promise.all([getProjectLogs(), fetchPinnedNotes()]);
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong while pinning the note.", "error");
        }
        setPinActionLoadingId(null);
    }

    const attemptUnpin = (note) => {
        if (!canUnpinNote(note)) {
            props.setSnackInfo(buildUnpinRolesMessage(note), "warning");
            return;
        }
        handleUnpinNote(note);
    }

    const handleUnpinNote = async (note) => {
        if (pinActionLoadingId) return;
        setPinActionLoadingId(note._id);
        try {
            await HttpService.unpinNote(note._id);
            props.setSnackInfo("Note unpinned successfully.", "success");
            await Promise.all([getProjectLogs(), fetchPinnedNotes()]);
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong while unpinning the note.", "error");
        }
        setPinActionLoadingId(null);
    }

    const fetchPinnedNotes = async () => {
        setPinnedNotesLoading(true);
        try {
            const response = await HttpService.getPinnedNotes(projectId);
            setPinnedNotesList(response.data || []);
        } catch (error) {
            props.setSnackInfo("Failed to fetch pinned notes.", "error");
        }
        setPinnedNotesLoading(false);
    }

    const openPinnedNotesModal = async () => {
        setPinnedNotesModalOpen(true);
        await fetchPinnedNotes();
    }

    const renderPinAction = (note, stopClickPropagation) => {
        const wrapClick = (handler) => (e) => {
            if (stopClickPropagation) e.stopPropagation();
            handler(note);
        };
        if (note.isPinned) {
            return (
                <Tooltip title={buildPinnedByTooltip(note)}>
                    <span>
                        <IconButton
                            size="small"
                            disabled={pinActionLoadingId === note._id}
                            onClick={wrapClick(attemptUnpin)}
                        >
                            <PinIcon pinned fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
            );
        }
        if (!canPinNote(note)) return null;
        return (
            <Tooltip title="Pin this note">
                <span>
                    <IconButton
                        size="small"
                        disabled={pinActionLoadingId === note._id}
                        onClick={wrapClick(handlePinNote)}
                    >
                        <PinIcon fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        );
    }

      const cloneSelectedVersion = async () =>{
        let lastVersion = quotationList[quotationList.length - 1];
        let obj = {
          versionId: selectedQuotationVersion,
          leadId: projectId,
         lastVersionNo: lastVersion.version,
        }
        props.setLoading(true)
        try {
            uploadWDFileDocument(quotationCsv,"quotationcsv");
          const response = await HttpService.cloneSelectedQuotation(obj)
          getAllQuotationsForProject();
          setOpenSelectQuotationVersion(false)
          props.setSnackInfo("File Uploaded Successfully", "success")

        } catch (error) {
          props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false);
      }
      const updateDesignQuotation = async () => {
        try {
            if (qtVersion && qtVersionGrandTotal && quotationCsv ) {
            setQuotationFile(true);
            setQuotationFileLink(quotationPdf);
            setOpenSelectQuotationVersion(false)
            setCheckIsUpload((prev) => ({
                ...prev,
                quotationCsvFile: true,
                scanQuotationFile: true,
            }));
            props.setSnackInfo("Quotation version updated.", "success");
            } else {
            props.setSnackInfo("Please select a quotation version before updating.", "warning");
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error");
        }
    };
      const generateQuotationExcel = async (quotationId) => {
        props.setLoading(true)
        try {
          const response = await HttpService.generateQuotationExcel(quotationId)

          let results = response?.data?.components || [];
          var data = [];
    
          for (let i = 0; i < results.length; i++) {
            const products = results[i]['products'] || [];
            for (let j = 0; j < products.length; j++) {
              let obj = {};
              obj['categoryname'] = results[i]['categoryId']?.['name'];
              obj['code'] = results[i]['products'][j]['product']?.['code'];
              obj['productname'] = results[i]['products'][j]['product']?.['name'];
              obj['description'] = results[i]['products'][j]['product']?.['description'];
              if (results[i]['products'][j]['subUnitType'] === 'Area') {
                obj['plyType'] = results[i]['plyType']?.['name'];
                obj['finishType'] = results[i]['products'][j]['finishType']?.['name'];
                obj['Qty'] = String(1);
              } else {
                obj['plyType'] = 'NA';
                obj['finishType'] = 'NA'
                obj['Qty'] = results[i]['products'][j]['area']
              }
    
              if (results[i]['products'][j]['subUnitType'] === 'Qty') {
                obj['area'] = String(0);
              } else {
                if (results[i]['products'][j]['productCustomArea'] !== 0) {
                  obj['area'] = results[i]['products'][j]['productCustomArea']
                } else {
                  obj['area'] = results[i]['products'][j]['area']
                }
              }
    
              obj['length'] = results[i]['products'][j]['length'];
              obj['width'] = results[i]['products'][j]['width'];
              obj['unittype'] = results[i]['products'][j]['unitType'] !== null ? results[i]['products'][j]['unitType']?.['name'] : 'null';
              obj['cost'] = results[i]['products'][j]['productCustomPrice'] === 0 ? results[i]['products'][j]['totalPricePerUnit'] : results[i]['products'][j]['productCustomPrice'];
              obj['itemTotal'] = results[i]['products'][j]['productPrice'];
              obj['scope'] = results[i]['products'][j]['product']?.['scopeId']?.['name'] ?? '';
    
              if (i === 0 && j === 0) {
                if (projectDetails.discountOnAllScopes === true) {
                  obj['quotationValue'] = response?.data?.['totalAmount'];
                  obj['discountPercent'] = response?.data?.['discountPercent'];
                  obj['discount'] = response?.data?.['discountAmount'] ? response?.data?.['discountAmount'] : 0;
                  obj['subTotal'] = response?.data?.['tempSt'] ? response?.data?.['tempSt'] : 0;
                  //obj['customerToProc'] = response?.data?.['customerToBeProcured'] ? response?.data?.['customerToBeProcured'] : 0;
                  //obj['customerToProcPercent'] = response?.data?.['materialProcured'] ? response?.data?.['materialProcured'] : 0;
                  //obj['decorpotScope'] = response?.data?.['decorpotScope'] ? response?.data?.['decorpotScope'] : 0;
                  obj['gst'] = response?.data?.['gstValue'] ? response?.data?.['gstValue'] : 0;
                  obj['miscellaneous'] = response?.data?.['miscTotal'] ? response?.data?.['miscTotal'] : 0;
                  obj['total'] = response?.data?.['mainTotal'] ? response?.data?.['mainTotal'] : 0;
                  obj['customerTotalOutflow'] = response?.data?.['totalCustomerOutflow'] ? response?.data?.['totalCustomerOutflow'] : 0;
                } else {
                  obj['discountPercent'] = response?.data?.['discountPercent'];
                  obj['discount'] = response?.data?.['discountAmount'] ? response?.data?.['discountAmount'] : 0;
                  if (response?.data?.['discItemsSubTotal' && response?.data?.['totalNonDiscPrAmnt']]) {
                    obj['quotationValue'] = response?.data?.['totalDiscPrAmnt'] + response?.data?.['totalNonDiscPrAmnt'];
                    obj['subTotal'] = response?.data?.['discItemsSubTotal'] ? response?.data?.['discItemsSubTotal'] + response?.data?.['totalNonDiscPrAmnt'] : 0 + response?.data?.['totalNonDiscPrAmnt'];
                  } else {
                    obj['quotationValue'] = response?.data?.['totalAmount'];
                    obj['subTotal'] = response?.data?.['tempSt'] ? response?.data?.['tempSt'] : 0;
                  }
                  obj['gst'] = response?.data?.['gstValue'] ? response?.data?.['gstValue'] : 0;
                  obj['miscellaneous'] = response?.data?.['miscTotal'] ? response?.data?.['miscTotal'] : 0;
                  obj['total'] = response?.data?.['mainTotal'] ? response?.data?.['mainTotal'] : 0;
                  obj['customerTotalOutflow'] = response?.data?.['totalCustomerOutflow'] ? response?.data?.['totalCustomerOutflow'] : 0;
                }
              }
              data.push(obj);
            }
          }
    
          if (response.data.hasOwnProperty('miscellaneousComponent')) {
            (response.data['miscellaneousComponent']['products'] || []).forEach((misc) => {
              let obj = {}
              obj['categoryname'] = response.data['miscellaneousComponent']['projectComponent']?.['name'];
              obj['code'] = misc['product']?.['code'];
              obj['productname'] = misc['product']?.['name'];
              obj['description'] = misc['product']?.['description'];
              if (misc['subUnitType'] === 'Area') {
                obj['plyType'] = response.data['miscellaneousComponent']?.['name'];
                obj['finishType'] = misc['finishType']?.['name'];
                obj['Qty'] = String(1);
              } else {
                obj['plyType'] = 'NA';
                obj['finishType'] = 'NA'
                obj['Qty'] = misc['area']
              }
              if (misc['subUnitType'] === 'Qty') {
                obj['area'] = String(0);
              } else {
                if (misc['productCustomArea'] !== 0) {
                  obj['area'] = misc['productCustomArea']
                } else {
                  obj['area'] = misc['area']
                }
              }
              obj['length'] = misc['length'];
              obj['width'] = misc['width'];
              obj['unittype'] = misc['unitType']?.['name'] ?? 'null';
              obj['cost'] = misc['productPricePerUnit'];
              obj['itemTotal'] = misc['productPrice'];
              obj['scope'] = misc['product']?.['scopeId']?.['name'] ?? '';
              data.push(obj);
            })
          }

          // Convert the data to a worksheet
          const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(data);
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

            // Convert the worksheet to a CSV string
            const csvData = XLSX.utils.sheet_to_csv(worksheet);

            // Convert the CSV string to a Blob
            const csvBlob = new Blob([csvData], { type: 'text/csv' });

            // Create a FormData object and append the CSV Blob
            const fd = new FormData();
            fd.append('file', csvBlob, 'filename.csv'); // 'filename.csv' is the name you want to give to the file
            fd.append('customerName', projectDetails.lead_no);

            // Upload the CSV file
            const fileUploadRes = await HttpService.uploadFile(fd);
            setQuotationCsv(fileUploadRes.data);
            setContractSignStageForm((prev) => ({
                ...prev,
                quotationCsvFile: fileUploadRes.data,
            }));
            setCheckIsUpload((prev) => ({
                ...prev,
                quotationCsvFile: true,
            }));
            // uploadWDFileDocument(fileUploadRes.data, 'quotationcsv');
            return data;

        } catch (error) {
          console.error(error)
          try {
            const fallbackWorkbook = XLSX.utils.book_new();
            const fallbackSheet = XLSX.utils.json_to_sheet([{
              quotationValue: qtVersionGrandTotal || '',
              version: qtVersion || '',
            }]);
            XLSX.utils.book_append_sheet(fallbackWorkbook, fallbackSheet, 'Sheet1');
            const fallbackCsv = XLSX.utils.sheet_to_csv(fallbackSheet);
            const fallbackBlob = new Blob([fallbackCsv], { type: 'text/csv' });
            const fallbackFd = new FormData();
            fallbackFd.append('file', fallbackBlob, 'filename.csv');
            fallbackFd.append('customerName', projectDetails.lead_no);
            const fallbackUpload = await HttpService.uploadFile(fallbackFd);
            setQuotationCsv(fallbackUpload.data);
          } catch (fallbackError) {
            console.error(fallbackError);
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
          }
        }
        props.setLoading(false)
      }

      const getcustomerDetailsWithVersion = async () => {
        props.setLoading(true)
        const cacheKey = `projectDetails_${projectId}`; // Using projectId specific key

        try {
             // Clear cache before fetching fresh data
            Cookies.remove(cacheKey);
            localStorage.removeItem(cacheKey);
            
            const response = await HttpService.getProjectLeadDetails(projectId)
            // console.log('getProjectLeadDetails', response)
            console.log(response.data[0].designVersion,"this is design called")
            setStoreVersion(response.data[0].designVersion)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const getcustomerDetails = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getProjectLeadDetails(projectId)
            setQcProject(response.data[0])
            // console.log('getProjectLeadDetails', response)
            setProjectDetails(response.data[0])
            setLeadDesignHoldReason(response.data[0].designHoldReason)
            finalDesignQuotationHandle(response?.data[0]?.designQuotationVersionId?._id)
            // setRevisedProjectedDesignSignOffDate(
            //     response.data[0].projectedDesignSignOffDate?.before10th
            //     ? response.data[0]?.projectedDesignSignOffDate?.before10th
            //     : response.data[0]?.projectedDesignSignOffDate?.committedDate
            // );
            // setProposedDesignStartDate(response.data[0].proposedDesignStartDate)
            if (userDetails?.roles?.find(role => role.name === ROLENAME.DesignHead || role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
                setSelectedStage(response.data[0]['designStages']);
                setSelectedDesignStatus(response.data[0]['designStatus'])
            } else {
                setSelectedStage(response.data[0]['salesStage']);
                if (response.data[0]['status'] === 'Lead Received') {
                    setCheckStageStatus(true)
                } else {
                    setCheckStageStatus(false)
                }
                setLeadStageStatus(response.data[0]['status'])
            }
            let date = new Date()
            if (response.data[0].designSignOffDate) {
                let str = moment(response.data[0]?.designSignOffDate).valueOf()
                let time_difference = date.getTime() - str
                let result = time_difference / (1000 * 60 * 60 * 24);
                setDaysFromContractSign(result);
            }
            if (response.data[0]?.materialDispatchedDate) {
                let materialdispatch = moment(response.data[0]?.materialDispatchedDate).valueOf()
                let materialDiff = date.getTime() - materialdispatch
                let materialResult = materialDiff / (1000 * 60 * 60 * 24);
                setDaysFromModularDelivery(materialResult)
            }
            return response.data
        } catch (error) {
            props.setLoading(false)
            if (error?.response?.status === 403) {
                setIsAccessDenied(true)
            }
            props.setSnackInfo(error?.response?.data?.message ?? error?.response?.data ?? "Something went wrong", "error")
            return error
        }
        props.setLoading(false)
    }

    useEffect(() => {
        setRevealedContact(null);
        setContactVisible(false);
    }, [projectId]);

    const handleToggleContactVisibility = async () => {
        if (contactVisible) {
            setContactVisible(false);
            return;
        }

        const customerId = projectDetails?.customerId?._id;
        if (!customerId) {
            props.setSnackInfo('Customer contact not found', 'error');
            return;
        }

        if (revealedContact) {
            setContactVisible(true);
            return;
        }

        setContactRevealLoading(true);
        try {
            const response = await HttpService.viewCustomerContact(customerId, projectDetails?._id);
            if (response?.data?.success) {
                setRevealedContact(response.data.phone);
                setContactVisible(true);
                getProjectLogs();
            } else {
                props.setSnackInfo(response?.data?.message || 'Failed to reveal contact number', 'error');
            }
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message || 'Failed to reveal contact number', 'error');
        } finally {
            setContactRevealLoading(false);
        }
    };

    // Runo Call handler kept ready — Call button UI is commented below
    const handleRunoClickToCall = async () => {
        const customerId = projectDetails?.customerId?._id;
        if (!customerId) {
            props.setSnackInfo('Customer contact not found', 'error');
            return;
        }

        const callerPhone = userDetails?.mobile;
        if (!callerPhone) {
            props.setSnackInfo('Your mobile number is not set in ERP profile. Update your profile to use Runo call.', 'error');
            return;
        }

        setRunoCallLoading(true);
        try {
            const contactResponse = await HttpService.viewCustomerContact(customerId, projectDetails?._id);
            const plainPhone = contactResponse?.data?.phone;

            if (!contactResponse?.data?.success || !plainPhone) {
                props.setSnackInfo(contactResponse?.data?.message || 'Could not fetch contact number for call', 'error');
                return;
            }

            const response = await HttpService.runoClickToCall({
                customerId,
                leadId: projectDetails?._id,
                customerPhone: plainPhone,
                callerPhone,
            });
            if (response?.data?.success) {
                props.setSnackInfo(response?.data?.message || 'Call initiated via Runo', 'success');
                getProjectLogs();
            } else {
                props.setSnackInfo(response?.data?.message || 'Failed to initiate call', 'error');
            }
        } catch (error) {
            const errData = error?.response?.data;
            const msg = [errData?.message, errData?.hint].filter(Boolean).join(' — ');
            props.setSnackInfo(msg || 'Failed to initiate Runo call', 'error');
        } finally {
            setRunoCallLoading(false);
        }
    };

    const openCreateNotesModal = () => {
        getAllUsers();
        setOpenNotesModal(true);
        setFormData({
            ...formData,
            user: projectDetails?.assignTo?._id,
            stage: userDetails?.roles?.find(role => role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.AGMSales) ? projectDetails?.salesStage : projectDetails?.designStages,
            leadId: projectId
        })
        setEditorState(() => EditorState.createEmpty());
    }

    const openNotesNewModal = () => {
        getAllUsers();
        setOpenNewNotesModal(true);
        setFormData({
            ...formData,
            user: projectDetails?.assignTo?._id,
            stage: userDetails?.roles?.find(role => role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesManager || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.AGMSales) ? projectDetails?.salesStage : projectDetails?.designStages,
            leadId: projectId
        })
        setEditorState(() => EditorState.createEmpty());
    }

    const handleDesignKickOffScreenshots = () => {
        try {
            setOpenDesignKickOffScreenshotsModal(true)
        }
        catch (error) {
            console.log('error', error)
            console.error(error)
        }

    }

    const [allUsersList, setAllUsersList] = useState([]);
    const getAllUsers = async () => {
        // console.log('called')
        props.setLoading(true)
        try {
            const response = await HttpService.getAllUsers()
            let userData = [];
            response.data.forEach((ele) => {
                userData.push({
                    name: ele.name,
                    userId: ele._id
                })
            })
            setAllUsersList(userData)

        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );
    const [mentionOpen, setMentionOpen] = useState(false);
    const [suggestions, setSuggestions] = useState(allUsersList);

    const { MentionSuggestions, plugins } = useMemo(() => {
        const mentionPlugin = createMentionPlugin();
        // eslint-disable-next-line no-shadow
        const { MentionSuggestions } = mentionPlugin;
        // eslint-disable-next-line no-shadow
        const plugins = [mentionPlugin];
        return { plugins, MentionSuggestions };
    }, []);

    const setEditorStateData = (editorState) => {
        setEditorState(editorState);
        setFormData({ ...formData, 'notes': editorRef.current?.editor?.editor?.innerText })
    };

    const onOpenChange = (mentionOpen) => {
        if (mentionOpen === false) {
            setMentionOpen(false)
        } else {
            setMentionOpen(true)
        }
    };

    const onSearchChange = ({ value }) => {
        setSuggestions(defaultSuggestionsFilter(value, allUsersList));
    };

    const onAddMention = (mention) => {
        setMentionOpen(false)
    }

    const [openStatusModal, setOpenStatusModal] = useState(false);

    /** Design Hold only after customer approves DKO (Customer) checklist; not if CHM/customer rejected. */
    const canSelectDesignHold = () => {
        if (projectDetails?.designKickOffCustomerActionFromChm === 'Rejected') {
            return false;
        }
        const customerApproval = projectDetails?.customerApproved?.[0];
        if (customerApproval?.status === 'Rejected') {
            return false;
        }
        if (projectDetails?.isDesignKickOffCustomerApprovedFromChm) {
            return customerApproval?.status === 'Approved' || customerApproval?.isApproved === true;
        }
        return true;
    };

    const openStatusUpdateModal = () => {
        const marketingApprovalStatus = projectDetails?.moveToMarketingFromSmApproval;

        if (approvalStageMap[marketingApprovalStatus]) {
            return props.setSnackInfo(
                `You can't proceed as the lead is currently pending with ${approvalStageMap[marketingApprovalStatus]} for Move to Marketing approval.`,
                "warning"
            );
        }
        if (
            (selectedDesignStatus === 'Design-Hold' || projectDetails?.designStatus === 'Design-Hold') &&
            !canSelectDesignHold()
        ) {
            setSelectedDesignStatus('Design');
            setDesignStageStatus('Design');
        }
        setOpenStatusModal(true);
        getSalesManagerList();
    }

    const [leadStageStatus, setLeadStageStatus] = useState('');
    const [checkStageStatus, setCheckStageStatus] = useState(false)
    const [junkHold, setJunkHold] = useState(false);
    const [junkReasonOptions, setJunkReasonOptions] = useState(junkReasons);
    const [junkReason, setJunkReason] = useState("");
    const [selectedDesignStatus, setSelectedDesignStatus] = useState('');
    const [leadDesignHoldReason, setLeadDesignHoldReason] = useState('');
    const [proposedDesignStartDate, setProposedDesignStartDate] = useState('');

    const designStageStatusChange = (e) => {
        setDesignStageStatus(e.target.value)
        setSelectedDesignStatus(e.target.value)
    }

    const leadStageStatusChange = (e) => {
        if (e.target.value === 'Lead Received') {
            setCheckStageStatus(true)
            getSalesManagerList();
        } else {
            setJunkHold(true)
            setCheckStageStatus(false)
        }
        setLeadStageStatus(e.target.value)
    }
    const [designStageStatus, setDesignStageStatus] = useState('Design');
    const updateLeadStatus = async (options) => {
        let currentDate = moment().toISOString(new Date());
        if (checkStageStatus === true) {
            selectedSalesManager.status = leadStageStatus;
            selectedSalesManager.leadType = leadStageStatus === 'Lead Received' ? 'Real' : 'To Be Called';
            selectedSalesManager.stage = leadStageStatus === 'Lead Received' ? 'Lead Received' : stage;
            selectedSalesManager.stageDepartment = 'marketing'
            props.setLoading(true)
            try {
                await HttpService.assignProject(selectedSalesManager)
                props.setSnackInfo("Sales Manager Assigned Successfully", "success")
                setOpenStatusModal(false)
                getcustomerDetails();
                getProjectLogs();
            } catch (error) {
                props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
            }
            props.setLoading(false)
        } else {
            // let obj = {}
            let obj = {
                designHoldStatusApproval: {}
            }
            if (userDetails.departmentId === designDepartment) {

                if (
                    new Date(proposedDesignStartDate) > new Date(probableDesignSignOffDate)
                ) {
                    return props.setSnackInfo("Design Start Date cannot be after Design SignOff Date date ", "error")
                }

                // ── AI Design Hold verification ──
                // A normal "Update Status" click always opens the AI pre-check popup and stops.
                // Only the popup's Proceed button (shown when the AI approved) re-enters with
                // { skipDesignHoldPreCheck: true }. The button's onClick passes a click event,
                // so the strict === true check can never be satisfied by a plain click.
                if (designStageStatus === 'Design-Hold' && !canSelectDesignHold()) {
                    return props.setSnackInfo(
                        'Design Hold is available only after the customer approves Design Kick-Off (Customer).',
                        'error'
                    );
                }

                if (designStageStatus === 'Design-Hold' && options?.skipDesignHoldPreCheck !== true) {
                    handleDesignHoldPreCheck();
                    return;
                }

                // obj.designStatus = designStageStatus;
                // obj.designHoldReason = designStageStatus === 'Design-Hold' ? leadDesignHoldReason : 'NA';
                // if (designStageStatus === 'Design-Hold' || designStageStatus === 'Design Hold - Possession more than 3 months') {
                //     obj.proposedDesignStartDate = proposedDesignStartDate;
                // }
                obj.designStatus = designStageStatus;  //design status
                obj.designHoldSelectedTypes = designStageStatus === 'Design-Hold' ? designHoldSelectedTypes : 'NA'  //design Hold Types
                obj.designHoldReason = designStageStatus === 'Design-Hold' ? leadDesignHoldReason : 'NA';   //remark
                obj.proposedDesignStartDate = designStageStatus === 'Design-Hold' ? proposedDesignStartDate : currentDate;  //design probable date restarting 
                obj.freezeDate =  designStageStatus === 'Design-Hold' ? probableDesignSignOffDate : currentDate; // probable design sign-off date
                // The server sends an AI-verified hold straight to the customer instead
                // (odmApproval 'Approved', customerApproval 'Sent for Approval')
                obj.designHoldStatusApproval.odmApproval =  selectedDesignStatus === 'Design-Hold' ? 'Sent for Approval' : '';
                // obj.designHoldStatusApproval.odmApproval =  selectedDesignStatus === 'Design-Hold' ? 'Not Initiated' : '';
                obj.designHoldStatusApproval.customerApproval =  selectedDesignStatus === 'Design-Hold' ? 'Not Initiated' : '';
                if(againDesignHoldReq){
                    obj.againDesignHoldReq = againDesignHoldReq;
                }
            } else {
                obj.leadStatus = 'Open';
                obj.currentStage = leadStageStatus;
                obj.status = leadStageStatus;
                obj.leadType = leadStageStatus === 'Lead Received' ? 'Real' : leadStageStatus === 'Junk' ? 'Junk' : leadStageStatus === 'Hold' ? 'Hold' : 'To Be Called';
                obj.stage = leadStageStatus === 'Lead Received' ? 'Lead Received' : stage;
                obj.junkReason = junkReason !== "" ? junkReason : "";
                obj.handoverDate = handoverDate ? handoverDate : null;
            }
            // console.log(obj, 'Obj')
            props.setLoading(true)
            try {
                // const response = await HttpService.updateLeadStageStatus(obj, projectId)
                let response;
                if (againDesignHoldReq) {
                    response = await HttpService.updateAgainDesignHold(obj, projectId)
                } else {
                   response = await HttpService.updateLeadStageStatus(obj, projectId)
                }
                props.setSnackInfo(response?.data ?? "Something went wrong", "success")
                setOpenStatusModal(false);
                setJunkHold(false);
                setJunkReason("");
                setHandoverDate("");
                getcustomerDetails();
                getProjectLogs();
            } catch (error) {
                props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
            }
            props.setLoading(false)
        }
    }

    const saveNotes = async () => {
         if (reasonToDealMissing) {
            props.setSnackInfo('Please enter a valid reason for Quotation Sent','warning');
            return;
        } 
        else if (isVisitDateMissing && isScopeMissing){
            props.setSnackInfo('Please select a valid date to visit the Experience Zone','warning');
            return;
        } else if(isOtherResMissing){
            props.setSnackInfo('Please select a valid reason for Requirements Collected','warning');
            return;
        } else if (reqCollectedChanges && (isScopeMissing || isBudgetMissing || isSalesCallDate || isTimelineMissing || isPossessionDateMissing || isReasonMissing )) {
            props.setSnackInfo('Please make sure all mandatory fields are filled', 'warning');
            return;
        } else if(isOtherReasonMissing){
            props.setSnackInfo('Please enter a valid reason for Requirements Not Collected','warning');
            return;
        } else if(isVerifiedDisqualifiedMissing){
            props.setSnackInfo('Please enter a valid reason for lead verification status','warning');
            return;
        }
        // set reminder and assigntask should not send notes via whatapp
        const isDesignDept = projectDetails?.departmentId?._id === designDepartment;
        const finalSendToClient = (type === 'setReminder' || type === 'assignTask')
            ? false
            : isDesignDept ? true : sendNoteToClient;

        // showing confirmation dialog here
        if (finalSendToClient) {
            setDialogOpen(true);
            return;
        }

        // Otherwise save directly
        proceedSaveNotes(finalSendToClient);
    };
    const proceedSaveNotes = async (finalSendToClient) => {
        const contentState = editorState.getCurrentContent();
        const raw = convertToRaw(contentState);
        let mentionedUsers = [];
        for (let key in raw.entityMap) {
            const ent = raw.entityMap[key];
            if (ent.type === "mention") {
                mentionedUsers.push(ent.data.mention);
            }
        }
        let taggedUser = [];
        mentionedUsers.forEach((ele, i) => {
            taggedUser.push(ele.userId);
        })

        let obj = {
            ...formData,
            taggedUser: taggedUser,
            'innerHTML': editorRef.current?.editor?.editor?.innerHTML,
            // req not collected Date
            reqNotCollectedFromNotes : reqNotCollectedFromNotes,
            moveInRncReason: moveInRncReason,
            moveInRncOtherReason: moveInRncOtherReason,
            verficationStatus: verficationStatus,
            verficationStatusOther: verficationStatusOther,
            // req collected
            rcScopeOfWork: rcScopeOfWork,
            designPref: designPref,
            estimatedBudget: estimatedBudget,
            timelineMoveHouseDate: timelineMoveHouseDate,
            possDate: possDate,
            floorPlanAttach: floorPlanAttach,
            rcOtherDetails: rcOtherDetails,
            reasonMoveRcCollect: reasonMoveRcCollect,
            reasonMoveRcCollectOther: reasonMoveRcCollectOther,
            reqCollectedFromNotes: reqCollectedFromNotes,
            reminderData: {
                isReminderClose: false,  // Default value
                reminderCreatedBy: userDetails._id,  
                reminderTaggedUser: taggedUser,  
                lastReminderCreatedDate: new Date(),
                reminderDate: formData.reminderDate // current Date value
            },
            // Quotation Sent
            reasonToDealQt: reasonToDealQt,
            reasonToDealQtOther: reasonToDealQtOther,
            qtFittingBudget: qtFittingBudget,
            cxPlanVisitExZone: cxPlanVisitExZone,
            planVisitDate: planVisitDate,
            qtSentNotesChanges: qtSentNotesChanges,
            sendNoteToClient: finalSendToClient,
        }
        // obj.sendNoteToClient = sendNoteToClient

        let ticketTitle = '';
        let ticketDescription = '';
        if (formData.notes) {
            const matchedUser = allUsersList.find(user => formData.notes.includes(user.name));
            if (matchedUser) {
                const nameIndex = formData.notes.split(matchedUser.name)
                const titleIndex = nameIndex[1].trim().split(' ').slice(0,3).join(' ');
                ticketTitle = titleIndex 
                ticketDescription = nameIndex[1].trim(); 
            }
        }

        let internalObj = {
            ticketTitle: ticketTitle,
            ticketDescription: ticketDescription,
            ticketETAdate: formData.reminderDate,
            uploadedFiles: [formData.s3Location],
            assignedTo: taggedUser[0],
            createTicketFromNotes: true,
            leadId:projectId,
            lead_no:projectDetails?.lead_no,
            customerId: projectDetails?.customerId?._id,
            reqNotCollectedFromNotes : reqNotCollectedFromNotes,
            moveInRncReason: moveInRncReason,
            moveInRncOtherReason: moveInRncOtherReason,
            verficationStatus: verficationStatus,
            verficationStatusOther: verficationStatusOther,
            // req collected
            rcScopeOfWork: rcScopeOfWork,
            designPref: designPref,
            estimatedBudget: estimatedBudget,
            timelineMoveHouseDate: timelineMoveHouseDate,
            possDate: possDate,
            floorPlanAttach: floorPlanAttach,
            rcOtherDetails: rcOtherDetails,
            reasonMoveRcCollect: reasonMoveRcCollect,
            reasonMoveRcCollectOther: reasonMoveRcCollectOther,
            reqCollectedFromNotes: reqCollectedFromNotes,
            // Quotation Sent
            reasonToDealQt: reasonToDealQt,
            reasonToDealQtOther: reasonToDealQtOther,
            qtFittingBudget: qtFittingBudget,
            cxPlanVisitExZone: cxPlanVisitExZone,
            planVisitDate: planVisitDate,
            qtSentNotesChanges: qtSentNotesChanges,
            sendNoteToClient : false
        }

        props.setLoading(true);
        try {
            let addNoteResponse;
            if(type === 'assignTask'){
                addNoteResponse =  await HttpService.createTask(internalObj);
             }
             else {
                addNoteResponse = await HttpService.addNotes(obj);
             }
            if (addNoteResponse.status === 200) {
                setOpenNotesModal(false);
                setOpenNewNotesModal(false);
                getProjectLogs();
                getcustomerDetails();
                setFormData({
                    notes: "",
                    reminderDate: "",
                    s3Location: "",
                    leadId: "",
                    user: "",
                    stage: ""
                })
                setEditorState(() => EditorState.createEmpty());
                setFileUploaded(false);
                setType('')
                updateState();
                props.setSnackInfo("Notes Added Successfully", "success")
            }
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false);
    }

    const handleType = (e)=> {
        let typeName = e?.target?.value;
        if (typeName === 'setReminder' || typeName === 'assignTask') {
        setSendNoteToClient(false);
    }
        setType(typeName);
    }

    const uploadCreateNoteImg = async (e) => {
        props.setLoading(true)
        const fd = new FormData()
        fd.append('file', e.target.files[0])
        fd.append('customerName', projectDetails.lead_no + '_' + projectDetails.customerId.name)
        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            setFormData({
                ...formData,
                s3Location: fileUploadRes.data
            })
            setFileUploaded(true);
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const [openActivity, setOpenActivity] = useState('')
    const [paymentLogsData, setPaymentLogsData] = useState(
        [
            // { date: '2023-09-25', value: 100 },
            // { date: '2023-09-26', value: 150 },
            // { date: '2023-09-27', value: 200 }
        ]);
    const [showPaymentLogs, setShowPaymentLogs] = useState(false)
    const showInfo = (i, status) => {
        setStageIndex(i);
        setOpenNotesInfoModal(true);
        setStageInfo(projectLogs[i]['stage'])
        setOpenActivity(status)
    }

    const downloadNotesFile = (data) => {
        // Create a temporary anchor element
        const link = document.createElement('a'); 
        // Set the href to the file URL
        link.href = data;
        // Extract filename from URL
        const filename = data.substring(data.lastIndexOf('/') + 1);
        // Set download attribute with the filename
        link.setAttribute('download', filename);
        // Hide the element (optional)
        link.style.display = 'none';
        // Append to the document
        document.body.appendChild(link);
        // Trigger click programmatically
        link.click();
        // Clean up - remove the element after use
        setTimeout(() => {
            document.body.removeChild(link);
        }, 100);
    };

    const handleViewLogsClick = async (data) => {
        props.setLoading(true)
        try {
            //   console.log('handleViewLogsClick called')
            //   console.log('data', data)
            const response = await HttpService.getPaymentLogsOfLead({ leadId: data.leadId })
            //   console.log('paymentLogs response', response.data)
            setPaymentLogsData(response.data)
            setShowPaymentLogs(true)
        }
        catch (error) {
            console.log('error', error.message)
            console.error(error)
        }
        props.setLoading(false)
    }

    const viewQuotationPage = () => {
        getAllQuotationsForProject();
        props.history.push(`/manageQuotations/${projectId}`);
    }
    const [projectDetailsFields, setProjectDetailsFields] = useState({
        name: "",
        email: "",
        emails: [],
        address: "",
        contact_no: "",
        projectType: "",
        propertyType: "",
        scopeOfWork: "",
        threeLakhsSuits: "",
        startProjectBy: "",
        description: "",
        floorPlan: "",
        isRegistered: "",
        area: "",
        leadType: "",
        alternativeContactNo: "",
        discountOnAllScopes: "",
        assignTo: "",
        leadId: "",
        assignToManager: "",
        city: "",
        experienceCenterId: "",
    });

    const scopeArray = ["Full House Interiors", "Kitchen Wardrobe & Woodwork", "Only Civil Work", "Only Decor Items"];

    const { name, email, contact_no, projectType, propertyType, alternativeContactNo, scopeOfWork, threeLakhsSuits, startProjectBy, address, description, floorPlan, isRegistered, area, leadType, emails, discountOnAllScopes, leadId, assignTo, assignToManager } = projectDetailsFields

    const openEditProjectModal = () => {
        setEditProjectModal(true);
        getSalesManagerList();
        setProjectDetailsFields({
            // plyType: projectDetails.plyType._id,
            name: projectDetails?.customerId?.name,
            email: projectDetails?.customerId?.email.trim(),
            emails : projectDetails?.customerId?.emails,
            contact_no: projectDetails?.customerId?.contact_no,
            alternativeContactNo: projectDetails?.customerId?.alternativeContactNo,
            projectType: projectDetails?.projectType,
            propertyType: projectDetails?.propertyType,
            scopeOfWork: projectDetails?.scopeOfWork,
            description: projectDetails?.remark,
            floorPlan: projectDetails?.floorPlan,
            floorPlanAttachment: projectDetails?.floorPlanAttachment,
            isRegistered: projectDetails?.isRegistered,
            leadType: projectDetails?.leadType,
            assignTo: projectDetails.assignTo?._id,
            area: projectDetails?.area,
            address: projectDetails?.customerId?.address,
            discountOnAllScopes: projectDetails?.discountOnAllScopes
        })
    }
    const handlePayment = () => {
        getPaymentPreview()
        setPaymentDetailsModal(true)
        getAmountReceivedForLead();
    }

    // const getPaymentPreview = async() =>{
    //     try {
    //         const user = await HttpService.getPaymentPreview(projectId);
    //         let paymentDetails = []
    //         user.data.forEach((el,i)=>{
    //             console.log(el.customerName,"this is name")
    //             let obj={
    //              customerName : el.customerName ? el.customerName : 'NA',
    //              uniqueLeadId : el?.paymentLogsId?.TransactionNumber ? el?.paymentLogsId?.TransactionNumber : 'NA',
    //              createdAt: el.createdAt ? moment(el?.createdAt).format('DD-MM-YYYY') : "-",
    //              Amount : el.Amount ? el.Amount : 0,
    //              Status : el.Status ? el.Status : 'NA',
    //              Stage : el.Stage ? el.Stage : "NA",
    //              createdBy : el.createdBy.name ? el.createdBy.name : "NA",
    //              departmentId : el.departmentId.name ? el.departmentId.name : "NA",
    //              paymentMode: el.TransactionData.map((transaction, i) =>
    //              transaction.Tag === 'PaymentMode' ? transaction.Value : null
    //          ).filter(payment => payment !== null)
    //             }
    //             console.log(obj,"this is obj")
    //             paymentDetails.push(obj)
    //         })
    //         console.log(paymentDetails,"detaus is called")
    //         setPaymentPreview(paymentDetails)
    //     }
    //     catch(error) {
    //         console.log(error)
    //     }
    // }

    // const getPaymentPreview = async() =>{
    //     try {
    //         const user = await HttpService.getPaymentPreview(projectId);
    //         let paymentDetails = []
    //         console.log('user', user)
    //         user?.data?.paymentTransactions?.forEach((el, i) =>
    //         {
    //         let obj =
    //         {
    //             _id: el._id,
    //             leadId: el.leadId,
    //             customerName: el?.customerName ? el.customerName : "NA",
    //             newUniqueId: el?.leadId?.newUniqueLeadId ? el?.leadId?.newUniqueLeadId : "NA",
    //             uniqueLeadNumber: el?.leadId?.uniqueLeadNumber ? el?.leadId?.uniqueLeadNumber : "NA",
    //             transactionNumber: el?.cashTransactionNumber ? el.cashTransactionNumber : el?.paymentLogsId?.TransactionNumber ? el?.paymentLogsId?.TransactionNumber : "NA",
    //             createdAt: el?.createdAt ? moment(el?.createdAt).format("DD-MM-YYYY") : "-",
    //             Amount: el?.Amount ? el.Amount : 0,
    //             Status: el?.Status ? el.Status : "NA",
    //             Stage: el?.Stage ? el?.Stage : "NA",
    //             createdByUser: el?.createdBy.name ? el?.createdBy.name : "NA",
    //             createdBy: el?.createdBy?._id ? el?.createdBy?._id : "NA",
    //             departmentName: el?.departmentId?.name ? el?.departmentId.name : "NA",
    //             departmentId: el?.departmentId?._id ? el?.departmentId?._id : "NA",
    //             paymentMode: el?.selectedPaymentMode ? el?.selectedPaymentMode : el?.TransactionData?.map((transaction, i) => transaction.Tag === "PaymentMode" ? transaction.Value : null ).filter((payment) => payment !== null),
    //             slip_no: el.slip_no ? el.slip_no : 'NA',
    //             trxId: el.trxId ? el.trxId : 'NA',
    //             cheQueNo: el.cheQueNo ? el.cheQueNo : 'NA',
    //             paymentPartnerName: el?.paymentPatnerId?.name ? el?.paymentPatnerId?.name : "NA",
    //             financeAction: el.financeAction ? el.financeAction : 'NA',
    //             financeActionStatus: el.financeActionStatus,
    //             financeActionRemarks: el.financeActionRemarks,
    //             financeEditRemarks: el.financeEditRemarks,
    //             paymentLogs : el.paymentLogs ? el.paymentLogs : []
    //         };
    //         console.log('obj', obj)
    //         paymentDetails.push(obj);

    //         });

    //         console.log('paymentDetails', paymentDetails)

    //         // setPaymentInfo(paymentDetails);
    //         setPaymentPreview(paymentDetails)
    //     }
    //     catch(error) {
    //         console.log(error)
    //     }
    // }



    // Function to open dialog
    const openAssignDialog = (lead) => {
        setSelectedLead(lead);
        setAssineDialogOpen(true);
    };

    // Function called after successful assignment
    const handleAssignSuccess = () => {
        props.setSnackInfo("CRM User assigned successfully", "success");
    };

    const [assignToECDialogOpen, setAssignToECDialogOpen] = useState(false);

    const handleAssignToECSuccess = () => {
        props.setSnackInfo("Lead assigned to Experience Center successfully", "success");
        getcustomerDetails();
        getProjectLogs();
    };

    // New, standalone "Move to Marketing" button gated on Runo call data -
    // additive only, doesn't touch the existing "Move to Marketing" option
    // still reachable via "Move Deal" -> stage dropdown, or any other flow.
    const [moveToMarketingRunoDialogOpen, setMoveToMarketingRunoDialogOpen] = useState(false);
    const [runoEligibility, setRunoEligibility] = useState({
        isEligible: false,
        alreadyUsed: false,
        phoneInvalid: false,
        phoneInvalidReason: "",
        unansweredCount: 0,
        transcribedCallCount: 0,
        latestCall: null,
        latestTranscribedCall: null,
        calls: [],
        loading: false,
    });

    // Re-checked whenever the lead (or its department) changes - only
    // fetched for leads still owned by Sales, same scope as the button
    // itself, to avoid firing this for leads it will never show on.
    useEffect(() => {
        if (!projectId || projectDetails?.departmentId?._id !== salesDepartment) return;
        let isCancelled = false;
        setRunoEligibility((prev) => ({ ...prev, loading: true }));
        HttpService.getMoveToMarketingRunoEligibility(projectId)
            .then((res) => {
                if (isCancelled) return;
                const data = res?.data?.data || {};
                setRunoEligibility({
                    isEligible: Boolean(data.isEligible),
                    // Backend enforces one-time-use per lead (see
                    // routes/runo.js: /moveToMarketingEligibility) - already
                    // baked into isEligible, kept separately too so the UI
                    // can show a distinct "already used" message instead of
                    // the generic "not eligible yet" one.
                    alreadyUsed: Boolean(data.alreadyUsed),
                    // Third eligibility path: the number can't be dialled, so
                    // this lead will never accumulate Runo calls of any kind
                    // and the two call-based conditions can never be met.
                    phoneInvalid: Boolean(data.phoneInvalid),
                    phoneInvalidReason: data.phoneInvalidReason || "",
                    unansweredCount: data.unansweredCount || 0,
                    transcribedCallCount: data.transcribedCallCount || 0,
                    latestCall: data.latestCall || null,
                    latestTranscribedCall: data.latestTranscribedCall || null,
                    calls: Array.isArray(data.calls) ? data.calls : [],
                    loading: false,
                });
            })
            .catch((err) => {
                if (isCancelled) return;
                console.error("Error fetching Runo eligibility for Move to Marketing:", err);
                setRunoEligibility((prev) => ({ ...prev, loading: false }));
            });
        return () => { isCancelled = true; };
    }, [projectId, projectDetails?.departmentId?._id]);

    const moveToMarketingBlockedByAssignmentAge =
        isMoveToMarketingBlockedByAssignmentAge(projectDetails?.leadAssignedDate);

    const isMoveToMarketingRunoDisabled =
        runoEligibility.loading
        || !runoEligibility.isEligible
        || moveToMarketingBlockedByAssignmentAge;

    // The rule itself lives on the server (routes/runo.js UNANSWERED_THRESHOLD).
    // Mirrored here only so the tooltip can say "3 of 5" - if it ever moves
    // there, this has to move with it.
    const RUNO_UNANSWERED_THRESHOLD = 5;

    // The backend decides the actual outcome (Junk vs. reverted) based on
    // the outside classifier's verdict - reflect whichever one really
    // happened instead of always saying "moved to marketing".
    const handleMoveToMarketingRunoSuccess = (result) => {
        // `isJunk` alone can't distinguish all 3 backend outcomes: it's
        // `true` for Junk, `false` for reverted-to-previous-stage, but
        // completely absent (undefined) for the "No Response" reason, which
        // skips the classifier entirely and re-triggers an AI Bot call
        // instead - `result?.isJunk` being falsy for BOTH "reverted" and
        // "no response" was exactly why "no response" incorrectly showed
        // the "reverted to its previous stage" message. Use the backend's
        // own `message` (which already describes the real outcome) as the
        // source of truth, and only fall back to a generic reconstruction
        // if it's ever missing.
        let message = result?.message;
        let severity = "info";
        if (result?.isJunk === true) {
            severity = "success";
            message = message || "Lead was marked as Junk based on Runo call review";
        } else if (result?.isJunk === false) {
            severity = "info";
            message = message || "Runo call review did not confirm Junk - lead was reverted to its previous stage";
        } else {
            severity = "success";
            message = message || "Lead moved to Marketing - an AI Bot call has been re-triggered to reach the customer";
        }
        props.setSnackInfo(message, severity);
        // Disable the button immediately rather than waiting on the next
        // eligibility fetch - the backend now marks this lead as used
        // regardless of outcome (see moveToMarketingRunoUsedAt), but that
        // won't be reflected client-side until re-fetched.
        setRunoEligibility((prev) => ({ ...prev, isEligible: false, alreadyUsed: true }));
        getcustomerDetails();
        getProjectLogs();
    };

    // Handle button click - show calendar
    const handlePaymentDate = () => {
    setShowCalendar(true);
    setSelectedDate(''); // Reset selected date
    };

    // Handle date selection
    const handleDateSelect = (e) => {
    setSelectedDate(e.target.value);
    };

    // Handle update button click - call API
    const handleUpdateDate = async () => {
        if (!selectedDate) {
            alert('Please select a date first');
            return;
        }
        
        setIsUpdating(true);
        
        try {
            const data = {
                leadId: projectId, 
                newPaymentDate: selectedDate,
            }
            
            const response = await HttpService.updatePaymentDate(data);
            // Check different possible response structures
            if (response.success === true || response.data?.success === true || response.status === 200) {
                setShowCalendar(false); 
                setSelectedDate('');
                
                // Make sure props.setSnackInfo exists
                if (props.setSnackInfo) {
                    props.setSnackInfo("Payment date updated successfully", "success");
                } else {
                    alert("Payment date updated successfully");
                }
            } else {
                // Handle failure
                const errorMsg = response.message || response.data?.message || "Failed to update payment date";
                if (props.setSnackInfo) {
                    props.setSnackInfo(errorMsg, "error");
                } else {
                    alert(errorMsg);
                }
            }
        } catch (error) {
            console.error('Error:', error);
            if (props.setSnackInfo) {
                props.setSnackInfo("Error updating payment date", "error");
            } else {
                alert('Error updating payment date');
            }
        } finally {
            setIsUpdating(false);
        }
    };

    // Close calendar without updating
    const handleCancel = () => {
    setShowCalendar(false);
    setSelectedDate('');
    };
    
    const getPaymentPreview = async () => {
        try {
            // const user = await HttpService.getPaymentPreview(projectId);
            let payload = {}
            payload.leadId = projectId
            // console.log('getPaymentPreview function called, payload', payload)
            let result = await HttpService.getApprovedPaymentTransactionsForLead(payload)
            let paymentDetails = []
            // console.log('result', result)
            let data = result.data
            let cust_id_data = {}
            let temp_data = []

            for (let i = 0; i < data.length; i++) {
                let obj = {}

                if (!cust_id_data[`${data[i].leadId.uniqueLeadNumber}`]) {
                    cust_id_data[`${data[i].leadId.uniqueLeadNumber}`] = {}
                }

                cust_id_data[`${data[i].leadId.uniqueLeadNumber}`].leadId = data[i].leadId._id
                if(data[i].selectedPaymentModeType === paymentModeType.manual && (data[i].Status === "Sent For Finance Approval" || data[i].Status === "Payment Received")){
                    cust_id_data[`${data[i].leadId.uniqueLeadNumber}`].amount_requested_manual = (cust_id_data[`${data[i].leadId.uniqueLeadNumber}`].amount_requested_manual + data[i].Amount_Requested || data[i].Amount_Requested)
                }
                if(data[i].selectedPaymentModeType === paymentModeType.automatic && data[i].Status === "Payment Requested"){
                    cust_id_data[`${data[i].leadId.uniqueLeadNumber}`].amount_requested_automatic = (cust_id_data[`${data[i].leadId.uniqueLeadNumber}`].amount_requested_automatic + data[i].Amount_Requested || data[i].Amount_Requested)
                }
                if (data[i].selectedPaymentModeType === paymentModeType.automatic && data[i].Status === "Payment Received") 
                {
                    cust_id_data[`${data[i].leadId.uniqueLeadNumber}`].amount_received_auto_ping = (cust_id_data[`${data[i].leadId.uniqueLeadNumber}`].amount_received_auto_ping + data[i].Amount_Received || data[i].Amount_Received)
                }
                else if(data[i].selectedPaymentModeType === paymentModeType.manual && data[i].Status === "Payment Received") 
                {
                    cust_id_data[`${data[i].leadId.uniqueLeadNumber}`].amount_received_manual_ping = (cust_id_data[`${data[i].leadId.uniqueLeadNumber}`].amount_received_manual_ping + data[i].Amount_Received || data[i].Amount_Received)
                }


            }

            // console.log('cust_id_data', cust_id_data)

            let keys = Object.keys(cust_id_data)

            // console.log('keys', keys)

            for (let val of keys) {
                // console.log('val', val)
                // console.log('data', cust_id_data[`${val}`])

                let obj = {}
                obj.leadId = cust_id_data[`${val}`][`leadId`]
                obj.account_number = val
                obj['amount_requested_automatic'] = cust_id_data[`${val}`][`amount_requested_automatic`] || 0
                obj['amount_requested_manual'] = cust_id_data[`${val}`][`amount_requested_manual`] || 0
                obj['amount_received_auto_ping'] = cust_id_data[`${val}`][`amount_received_auto_ping`] || 0
                obj['amount_received_manual_ping'] = cust_id_data[`${val}`][`amount_received_manual_ping`] || 0

                temp_data.push(obj)
            }
            // console.log('temp_data', temp_data)
            setCustomerInformation(temp_data)
            // result?.data?.paymentTransactions?.forEach((el, i) =>
            // {
            // let obj =
            // {
            //     _id: el._id,
            //     leadId: el.leadId,
            //     customerName: el?.customerName ? el.customerName : "NA",
            //     newUniqueId: el?.leadId?.newUniqueLeadId ? el?.leadId?.newUniqueLeadId : "NA",
            //     uniqueLeadNumber: el?.leadId?.uniqueLeadNumber ? el?.leadId?.uniqueLeadNumber : "NA",
            //     transactionNumber: el?.cashTransactionNumber ? el.cashTransactionNumber : el?.paymentLogsId?.TransactionNumber ? el?.paymentLogsId?.TransactionNumber : "NA",
            //     createdAt: el?.createdAt ? moment(el?.createdAt).format("DD-MM-YYYY") : "-",
            //     Amount: el?.Amount ? el.Amount : 0,
            //     Status: el?.Status ? el.Status : "NA",
            //     Stage: el?.Stage ? el?.Stage : "NA",
            //     createdByUser: el?.createdBy.name ? el?.createdBy.name : "NA",
            //     createdBy: el?.createdBy?._id ? el?.createdBy?._id : "NA",
            //     departmentName: el?.departmentId?.name ? el?.departmentId.name : "NA",
            //     departmentId: el?.departmentId?._id ? el?.departmentId?._id : "NA",
            //     paymentMode: el?.selectedPaymentMode ? el?.selectedPaymentMode : el?.TransactionData?.map((transaction, i) => transaction.Tag === "PaymentMode" ? transaction.Value : null ).filter((payment) => payment !== null),
            //     slip_no: el.slip_no ? el.slip_no : 'NA',
            //     trxId: el.trxId ? el.trxId : 'NA',
            //     cheQueNo: el.cheQueNo ? el.cheQueNo : 'NA',
            //     paymentPartnerName: el?.paymentPatnerId?.name ? el?.paymentPatnerId?.name : "NA",
            //     financeAction: el.financeAction ? el.financeAction : 'NA',
            //     financeActionStatus: el.financeActionStatus,
            //     financeActionRemarks: el.financeActionRemarks,
            //     financeEditRemarks: el.financeEditRemarks,
            //     paymentLogs : el.paymentLogs ? el.paymentLogs : []
            // };
            // console.log('obj', obj)
            // paymentDetails.push(obj);

            // });

            // console.log('paymentDetails', paymentDetails)

            // // setPaymentInfo(paymentDetails);
            // setPaymentPreview(paymentDetails)
        }
        catch (error) {
            console.log(error)
        }
    }


    const changeHandler = (e) => {
        setProjectDetailsFields(e.target.value);
        if (e.target.value === 'Real') {
            getSalesManagerList()
            setProjectDetailsFields({ ...projectDetailsFields, [e.target.name]: e.target.value })
        } else if (e.target.name === 'assignToManager') {
            let teamDetail = [];
            dupManagerOfSalesTeam.forEach(ele => {
                if (ele?._id === e.target.value) {
                    teamDetail.push(ele)
                }
            })
            setProjectDetailsFields({
                ...projectDetailsFields, [e.target.name]: e.target.value,
                'assignTo': teamDetail[0]._id,
                'department': teamDetail[0].departmentId._id,
                'team': teamDetail[0].teamId._id
            })
        } else {
            setProjectDetailsFields({ ...projectDetailsFields, [e.target.name]: e.target.value })
        }
    }

    // function to handle input of customer name
    const customerNameInputHandler = (event) => {
        try {
            const value = event.target.value;
            // Regex pattern to check for the presence of only letters (uppercase & lowercase) and spaces and excluding special characters and numeric value
            const specialCharacters = /^[a-zA-Z\s]*$/;
            const containsSpecialCharacters = !specialCharacters.test(value);
            // If special characters is present display alert
            if (containsSpecialCharacters) {
                props.setSnackInfo("Letters and spaces only. No special characters.", "warning");
            } else {
                setProjectDetailsFields({ ...projectDetailsFields, [event.target.name]: event.target.value });
            }
        } catch (error) {
            console.log("Error -> ", error);
        }
    }
    // function to handle the input of sqft area
    const sqFtAreaInputHandler = (event) => {
        // regex to except only number in input field
        let area = event.target.value.replace(/[^0-9]/g, "");
        setProjectDetailsFields({ ...projectDetailsFields, [event.target.name]: area })
    }

    const setAdress = (event) => {
        const { name, value } = event.target;
        setProjectDetailsFields({ ...projectDetailsFields, [name]: value })
    }


    // function to handle input of phone number
    const phoneNumberInputHandler = async (event) => {
        // Allow only numbers
        let mobileNo = event.target.value.replace(/[^0-9]/g, "");

        setProjectDetailsFields({ ...projectDetailsFields, [event.target.name]: mobileNo })
    
        // Prevent more than 10 digits
        if (mobileNo.length > 10) {
            props.setSnackInfo(
                "Mobile number cannot exceed 10 digits",
                "error"
            );
            return;
        }
        
    
        // Check only when length is exactly 10
        if (mobileNo.length === 10) {
            props.setLoading(true);
    
            try {
                const response = await HttpService.checkCustomerContact(mobileNo);
    
                if (response.data.exists === true) {
                    props.setSnackInfo(response?.data?.status ?? "Something went wrong", "error")
                    setIsSubmitDisabled(true)

                } else {
                    props.setSnackInfo( "Customer Not Found", "success")
                    setIsSubmitDisabled(false)

                }
    
            } catch (error) {
                props.setSnackInfo(error?.response?.data?.error ?? "Something went wrong", "error")
            } finally {
                props.setLoading(false);
            }
        }
    };

    const [designKickOffCustomerForm, setDesignKickOffCustomerForm] = useState({
        salesOwnerMeetingDate: '',
        floorPlanReceived: '',
        quotationDiscussed: '',
        requirementDiscussed: '',
        dateOfKickOffMeeting: '',
        timeOfKickOffMeeting: ''
    });
    const [initialMeasurementForm, setInitialMeasurementForm] = useState({
        intial_measurement_date: '',
        intial_measurement_time: ''
    });
    const [finalizationOfMaterialForm, setFinalizationOfMaterialForm] = useState({
        materialSelectionDate: '',
        materialSelectionTime: ''
    });
    const [siteQcDateForm, setSiteQcDateForm] = useState({
        siteQcDate: '',
        siteQcTime: ''
    });

    const captureDesignKickOffCustomerDetails = (e, v) => {
        setDesignKickOffCustomerForm(
            {
                ...designKickOffCustomerForm,
                [e.target.name]: e.target.value
            })
    }

    const captureInitialMeasurementFormDetails = (e, v) => {
        setInitialMeasurementForm(
            {
                ...initialMeasurementForm,
                [e.target.name]: e.target.value
            })
    }
    const captureFinalizationOfMaterialsFormDetails = (e, v) => {
        setFinalizationOfMaterialForm(
            {
                ...finalizationOfMaterialForm,
                [e.target.name]: e.target.value
            })
    }
    const captureSiteQcDateFormDetails = (e, v) => {
        setSiteQcDateForm(
            {
                ...siteQcDateForm,
                [e.target.name]: e.target.value
            })
    }

    const saveProjectDetailForAsm = async () => {
        // If validation passes, proceed to save project details
        props.setLoading(true);
        try {
            const response = await HttpService.saveProjectEditAddress(projectId, projectDetailsFields);
            setEditProjectModal(false);
            getProjectLogs();
            getcustomerDetails();
            
            props.setSnackInfo(response.data, "success");
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error");
        }
        props.setLoading(false);
    };
    

    const saveProjectDetail = async () => {
        // Safely access and trim the primary email
        const primaryEmail = projectDetailsFields?.email?.trim?.();
    
        // Safely access, trim, and filter out any empty or falsy emails from the secondary emails array
        const secondaryEmails = projectDetailsFields?.emails
            ?.map(email => email?.trim?.())  // Use optional chaining for each email
            ?.filter(email => email);        // Filter out falsy values (null, undefined, empty strings)
    
        // Skip validation if no secondary emails are provided
        if (Array.isArray(secondaryEmails) && secondaryEmails.length > 0) {
    
            // Check if primary email is the same as any secondary email
            if (secondaryEmails?.includes(primaryEmail)) {
                props?.setSnackInfo?.("Primary email cannot be the same as secondary email.", "error");
                return; // Stop execution if validation fails
            }
    
            // Check for duplicates within secondary emails
            const uniqueSecondaryEmails = [...new Set(secondaryEmails)];
            const duplicateEmails = secondaryEmails?.filter(email => {
                return uniqueSecondaryEmails?.indexOf?.(email) !== uniqueSecondaryEmails?.lastIndexOf?.(email);
            });
    
            if (duplicateEmails?.length > 0) {
                props?.setSnackInfo?.("Duplicate secondary emails found: " + duplicateEmails?.join?.(", "), "error");
                return; // Stop execution if validation fails
            }
    
            // Check if there are any duplicates within the emails array
            const emailCount = secondaryEmails?.reduce?.((acc, email) => {
                acc[email] = (acc[email] || 0) + 1;
                return acc;
            }, {});
    
            // Ensure emailCount is a valid object before calling Object.keys
            if (emailCount && Object.keys?.(emailCount)?.length > 0) {
                const duplicatesInArray = Object.keys(emailCount)?.filter(email => emailCount[email] > 1);
                if (duplicatesInArray?.length > 0) {
                    props?.setSnackInfo?.("Duplicate emails found in the list: " + duplicatesInArray?.join?.(", "), "error");
                    return; // Stop execution if validation fails
                }
            }
        }
    
        // If validation passes or no secondary emails are provided, proceed to save project details
        props?.setLoading?.(true);
        try {
            // Add junkReason only if it has a value
            if (junkReason && junkReason.trim() !== "") {
                projectDetailsFields.junkReason = junkReason.trim();
                projectDetailsFields.currentStage = "Junk"
            }

            // Add handoverDate only if it has a value
            if (handoverDate) {
                projectDetailsFields.handoverDate = handoverDate;
                projectDetailsFields.currentStage = "Hold"
            }

            const response = await HttpService?.saveProjectDetails?.(projectId, projectDetailsFields);
            setEditProjectModal?.(false);
            getProjectLogs?.();
            getcustomerDetails?.();
            
            props?.setSnackInfo?.(response?.data, "success");
        } catch (error) {
            props?.setSnackInfo?.(error?.response?.data ?? "Something went wrong", "error");
        }
        props?.setLoading?.(false);
    };    
    
    
    
    // const saveProjectDetail = async () => {
    //     // Safely access and trim the primary email
    //     const primaryEmail = projectDetailsFields?.email?.trim?.();
    
    //     // Safely access, trim, and filter out any empty or falsy emails from the secondary emails array
    //     const secondaryEmails = projectDetailsFields?.emails
    //         ?.map(email => email?.trim?.())  // Use optional chaining for each email
    //         ?.filter(email => email);        // Filter out falsy values (null, undefined, empty strings)
    
    //     // Ensure secondaryEmails is an array before proceeding
    //     if (!Array.isArray(secondaryEmails) || secondaryEmails.length === 0) {
    //         props?.setSnackInfo?.("No secondary emails provided.", "error");
    //         return; // Stop execution if there are no valid emails
    //     }
    
    //     // Check if primary email is the same as any secondary email
    //     if (secondaryEmails?.includes(primaryEmail)) {
    //         props?.setSnackInfo?.("Primary email cannot be the same as secondary email.", "error");
    //         return; // Stop execution if validation fails
    //     }
    
    //     // Check for duplicates within secondary emails
    //     const uniqueSecondaryEmails = [...new Set(secondaryEmails)];
    //     const duplicateEmails = secondaryEmails?.filter(email => {
    //         return uniqueSecondaryEmails?.indexOf?.(email) !== uniqueSecondaryEmails?.lastIndexOf?.(email);
    //     });
    
    //     if (duplicateEmails?.length > 0) {
    //         props?.setSnackInfo?.("Duplicate secondary emails found: " + duplicateEmails?.join?.(", "), "error");
    //         return; // Stop execution if validation fails
    //     }
    
    //     // Check if there are any duplicates within the emails array
    //     const emailCount = secondaryEmails?.reduce?.((acc, email) => {
    //         acc[email] = (acc[email] || 0) + 1;
    //         return acc;
    //     }, {});
    
    //     // Ensure emailCount is a valid object before calling Object.keys
    //     if (emailCount && Object.keys?.(emailCount)?.length > 0) {
    //         const duplicatesInArray = Object.keys(emailCount)?.filter(email => emailCount[email] > 1);
    //         if (duplicatesInArray?.length > 0) {
    //             props?.setSnackInfo?.("Duplicate emails found in the list: " + duplicatesInArray?.join?.(", "), "error");
    //             return; // Stop execution if validation fails
    //         }
    //     }
    
    //     // If validation passes, proceed to save project details
    //     props?.setLoading?.(true);
    //     try {
    //         const response = await HttpService?.saveProjectDetails?.(projectId, projectDetailsFields);
    //         setEditProjectModal?.(false);
    //         getProjectLogs?.();
    //         getcustomerDetails?.();
            
    //         props?.setSnackInfo?.(response?.data, "success");
    //     } catch (error) {
    //         props?.setSnackInfo?.(error?.response?.data ?? "Something went wrong", "error");
    //     }
    //     props?.setLoading?.(false);
    // };
    

    const [open, setOpen] = useState(false);
    const [anotherDialog, setOpenAnotherDialog] = useState(false);
    const [reasonOptions, setReasonOptions] = useState(moveToMarketingReasons);
    const [moveToMarketingReason, setMoveToMarketingReason] = useState("");
    const [salesLostReasonOptions, setSalesLostReasonOptions] = useState(salesLostReasons);
    const [salesLostReason, setSalesLostReason] = useState("");
    const [handoverDate, setHandoverDate] = useState("");
    const [otherReason, setOtherReason] = useState("");
    const [departmentLists, setDepartmentsList] = useState([]);
    const [departmentStage, setDepartmentsStage] = useState([]);
    const [stage, setSelectedStage] = useState("");
    const [department, setSelectedDepartment] = useState("");
    const [team, setSelectedTeam] = useState("");
    const [dealOwner, setSelectedDealOwner] = useState("");
    // const [wdFile, setWDFileLink] = useState("");
    const [requirements, setRequirements] = useState("");
    const [salesCallComment, setSalesCallComment] = useState("");
    const [momQuotationStage, setMomQuotationStage] = useState("");
    const [momMeetingStage, setMomMeetingStage] = useState("");
    const [momSiteVisitStage, setMomSiteVisitStage] = useState("");
    const [momNegotiationStage, setMomNegotiationStage] = useState("");
    const [remark, setRemark] = useState("");
    const [preSalesCallDate, setHandlepreSalesCallDate] = useState("");
    const [nextFollowUpDate, setHandleNextFollowUpDate] = useState("");
    const [salesCallDate, setHandleSalesCallDate] = useState(getCurrentDate());
    const [quotationSentDate, setQuotationSentDate] = useState("");
    const [siteVisitDate, setSiteVisitDate] = useState("");
    const [negotiationDate, setNegotiationDate] = useState("");
    const [closureDate, setClosureDate] = useState(new Date("2018-01-01T00:00:00.000Z"));
    const [clientMoveinDate, setClientMoveinDate] = useState(new Date("2018-01-01T00:00:00.000Z"));
    // const [contractSignedDate, setContractSignedDate] = useState(new Date("2018-01-01T00:00:00.000Z"));
    // const [projectCompletionDate, setProjectCompletionDate] = useState(new Date("2018-01-01T00:00:00.000Z"));
    const [teamLists, setTeamList] = useState([]);
    const [dealOwnerLists, setDealOwnersList] = useState([]);
    // const [openSalesManagerModal, setOpenSalesManagerModal] = useState(false);
    const [selectedSalesManager, setSelectedSalesManager] = useState({});
    const [salesManagerList, setSalesManagerList] = useState([]);
    // const [salesData, setsalesData] = useState([]);
    const [dupManagerOfSalesTeam, setDupManagerOfSalesTeam] = useState([]);
    const [meetingDone, setMeetingDone] = useState("")
    const [meetingType, setMeetingType] = useState("")
    const [meetingDate, setMeetingDate] = useState(null);
    const [newPaymentSlip, setNewPaymentSlip] = useState("")
    const [amountPaid, setAmountPaid] = useState(0)
    const [checkForSales, setCheckForSales] = useState(false)
    const [checkForFloor, setCheckForFloor] = useState(false)
    const [floorType, setFloorType] = useState("");
    const [chmList, setChmList] = useState([]);
    const [chmUser, setSelectedChmUser] = useState('');
    const [openChmUser, setOpenChmUser] = useState(false);
    const [erpProjectExists, setErpProjectExists] = useState(false);
    const [openErpExistsDialog, setOpenErpExistsDialog] = useState(false);
    const [openWhatsAppNotificationContentDialog, setOpenWhatsAppNotificationContentDialog] = useState(false);
    const [whatsAppNotificationContent, setWhatsAppNotificationContent] = useState('');
    const [showRefundConfirmDialog, setShowRefundConfirmDialog] = useState(false);
    const [selectedLeadLogViewDetails, setSelectedLeadLogViewDetails] = useState({noteUserName: '', noteUserContact: '', noteUserEmail: '', note: '', assistantManagerName: '', assistantManagerMobile: '', assistantManagerEmail: '', attachment: '',client_name :'',amount : '',referal_policy_link :'',referee:'',client_name_two:'',bank_form_link:'',client_name_client :'', form_link:'', referralFormLink: '', cx_email:'' , cx_password:'' });
    const [managerOrHeadId, setManagerOrHeadId] = useState('');
    const [qtVersionGrandTotal, setQtVersionGrandTotal]  = useState(0)
    const [contractSignStageForm, setContractSignStageForm] = useState({
        grandTotal: 0,
        qtVersionGrandTotal:0,
        contractSignedValue: 0,
        tokenPercent: 0,
        daysAsPerContractSign: 0,
        designSignOffDate: null,
        projectCompletionDate: null,
        designSignOffRevokeDate: null,
        // internalDesignSignOffDate: null
    })
    const [files, setFiles] = useState([""]);
    const [callLogs, setCallLogs] = useState([])
    const [audioUploaded, setAudioUploaded] = useState(false);
    const [audioUploadData, setAudioUploadData] = useState('');

    const [hotDealModel, setHotDealModel] = useState(false);
    const [cxMoveInTime, setCxMoveInTime] = useState([
        'Within 2 months',
        'More than 2 months and less than 3 months',
        'More than 3 months',
        'Not sure'
    ])
    const [possessionStatus, setPossessionDate] = useState([
        "Ready to move in",
        "Same month as of Lead generated month",
        "Lead generated Month + 1",
        "Lead generated Month + 2",
        "Lead generated Month + 3",
        "More than Lead generated Month + 3",
        "Not Sure"
    ]);
    const [registrationStatus, setRegistrationStatus] = useState([
        "Already Done",
        "Same month as of Lead generated month",
        "Lead generated Month + 1",
        "Lead generated Month + 2",
        "Lead generated Month + 3",
        "More than Lead generated Month + 3",
        "Not Sure"
    ])
    const [decisionMaker, setDecisionMaker] = useState([
        "One Decision maker, In discussion with the decision maker",
        "Multiple Decision maker, not connected with everyone",
        "Multiple Decision maker, connected with everyone",
        "Not Sure"
    ]);
    const [financialReadiness, setFinancialReadiness] = useState([
        "Ready to pay/Self finance",
        "Need more time to arrange funds/ Salary dependency",
        "Exploring financing options/ Loan dependency",
        "Not Sure"
    ]);
    const [competitorInvolvement, setCompetitorInvolvement] = useState([
        'Livspace',
        'Homelane',
        'Designcafe',
        'Bonito Design',
        'Other'
    ]);
    const [budgetVsQuotation, setBudgetVsQuotation] = useState([
        "Customer is ok with the quotation",
        "Quotation is out of budget, Cx wants to discuss",
        "Quotation is out of budget, requirements cannot change"
    ])
    const [cxMoveInTimelineValue, setCxMoveInTimelineValue] = useState('');
    const [possesionStatusValue, setPossesionStatusValue] = useState('');
    const [regStatusValue, setRegStatusValue] = useState('');
    const [decisionMakerValue, setDecisionMakerValue] = useState('');
    const [financialReadinessValue, setFinancialReadinessValue] = useState('');
    const [budgetQtValue, setBudgetQtValue] = useState('');
    const [competitorValue, setCompetitorValue] = useState([]);
    const [hotDealSalesWonDate, setHotDealSalesWonDate] = useState('');
    const [otherCompetitorValue, setOtherCompetitorValue] = useState('');
    const [assignProjectChecklistCheck, setAssignProjectChecklistCheck] = useState(false);
    const [naraciQuotationList, setNaraciQuotationList] = useState([])
  
        
    const MessageComponent = ({ name, message }) => {
        const ipAddress  = process.env.UI_IP || 'https://erp.decorpot.com/'
        const salesChecklistLinkPath = `${ipAddress}customer-check-lists-item/${projectDetails._id}`
        const salesChecklistLink = salesChecklistLinkPath
        ? `<a href="${salesChecklistLinkPath}" target="_blank">${salesChecklistLinkPath}</a>`
        : 'NA';
        const attachmentInfo = selectedLeadLogViewDetails.attachment
        ? `Attachment: <a href="${selectedLeadLogViewDetails.attachment}" target="_blank">${selectedLeadLogViewDetails.attachment}</a>`
        : 'Attachment: NA';
        const notesContentWithAttachment = `<br /><p>${selectedLeadLogViewDetails.note}</p><br />${attachmentInfo}`;
        let formattedMessage = message.replace('{{name}}', `<strong>${name}</strong>`)
        .replaceAll('{{leadOwnerName}}', `<i>${selectedLeadLogViewDetails.noteUserName}</i>`)
        .replace('{{customer}}', `<strong>${name}</strong>`)
        .replace('{{leadOwnerContact}}', `<i>${selectedLeadLogViewDetails.noteUserContact}</i>`)
        .replace('{{leadOwnerManagerName}}', `<i>${selectedLeadLogViewDetails.assistantManagerName}</i>`)
        .replace('{{design_quotation_link}}', projectDetails?.designQuotationVersionId?.s3Location)
        // .replace('{{latest_quotation_link}}', selectedLeadLogViewDetails?.quotationSentS3LocationforView)
        .replace('{{latest_quotation_link}}', `<a href="${selectedLeadLogViewDetails?.quotationSentS3LocationforView}" target="_blank">${selectedLeadLogViewDetails?.quotationSentS3LocationforView}</a>`)
        .replace('{{leadOwnerManagerContact}}', `<i>${selectedLeadLogViewDetails.assistantManagerMobile}</i>`)
        .replace('{{leadOwnerEmail}}', `<i>${selectedLeadLogViewDetails.noteUserEmail}</i>`)
        .replace('{{date}}', `<i>${moment(projectDetails?.materialDispatchedDate).format('DD-MM-YYYY')}</i>`)
        .replace('{{materialSelectionDate}}', `<i>${moment(projectDetails?.materialSelectionDate).format('DD-MM-YYYY')}</i>`)
        .replace('{{materialSelectionTime}}', `<i>${projectDetails.materialSelectionTime ?  moment(projectDetails.materialSelectionTime, "HH:mm").format("hh:mm A") : 'NA'}</i>`)
        .replace('{{intial_measurement_date}}', `<i>${moment(projectDetails?.intial_measurement_date).format('DD-MM-YYYY')}</i>`)
        .replace('{{intial_measurement_time}}', `<i>${projectDetails.intial_measurement_time ?  moment(projectDetails.intial_measurement_time, "HH:mm").format("hh:mm A") : 'NA'}</i>`)
        .replace('{{dateOfKickOffMeeting}}', `<i>${moment(projectDetails?.dateOfKickOffMeeting).format('DD-MM-YYYY')}</i>`)
        .replace('{{timeOfKickOffMeeting}}', `<i>${projectDetails.timeOfKickOffMeeting ?  moment(projectDetails.timeOfKickOffMeeting, "HH:mm").format("hh:mm A") : 'NA'}</i>`)
        .replace('{{siteQcDate}}', `<i>${moment(projectDetails?.siteQcDate).format('DD-MM-YYYY')}</i>`)
        .replace('{{siteQcTime}}', `<i>${projectDetails.siteQcTime ?  moment(projectDetails.siteQcTime, "HH:mm").format("hh:mm A") : 'NA'}</i>`)
        .replace('{{pocName}}', `<i>${selectedLeadLogViewDetails.noteUserName}</i>`)
        .replace('{{managerName}}', `<i>${selectedLeadLogViewDetails.assistantManagerName || 'NA'}</i>`)
        .replace('{{pocContact}}', `<i>${selectedLeadLogViewDetails.noteUserContact}</i>`)
        .replace('{{managerContact}}', `<i>${selectedLeadLogViewDetails.assistantManagerMobile || 'NA'}</i>`)
        // .replace('{{notesContent}}', `<br /><p>${selectedLeadLogViewDetails.note}</p><br />`)
        .replace('{{notesContent}}', notesContentWithAttachment)
        .replace('{{salesChecklistLink}}', `<br /><p>${salesChecklistLink || 'NA'}</p><br />`)
        .replace('{{client_name}}', `<br /><b>${selectedLeadLogViewDetails?.client_name || 'NA'}</b><br />`)
        .replace('{{amount}}', `<b>${selectedLeadLogViewDetails?.amount || 'NA'}</b> `) 
        .replace('{{referal_policy_link}}',selectedLeadLogViewDetails?.referal_policy_link|| 'NA')
        .replace('{{form_link}}',`<a href="${selectedLeadLogViewDetails?.bank_form_link}" target="_blank">${selectedLeadLogViewDetails?.bank_form_link}</a>` || 'NA')
        .replace('{{referralFormLink}}',`:<b> <a href="${selectedLeadLogViewDetails.form_link}" target="_blank">${selectedLeadLogViewDetails.form_link}</a></b>`)
        .replace('{{referee}}', `<br /><b>${selectedLeadLogViewDetails?.client_name || 'NA'}</b><br />`)
        .replace('{{client_name_two}}', `<b>${selectedLeadLogViewDetails?.client_name_two || 'NA'}</b>`)
        .replace('{{client_name_client}}', `<b>${selectedLeadLogViewDetails?.client_name_client || 'NA'}</b><br />`)
        .replace('{{form_link_2}}', `<b>${selectedLeadLogViewDetails?.form_link || 'NA'}</b><br />`)
        .replace('{{cx_password}}', `<b>${selectedLeadLogViewDetails?.cx_password || 'NA'}</b><br />`)
        .replace('{{cx_email}}', `<b>${selectedLeadLogViewDetails?.cx_email || 'NA'}</b><br />`)
    
        const bubbleStyle = {
          backgroundColor: '#dcf8c6',
          padding: '10px 15px',
          borderRadius: '15px',
          marginBottom: '10px',
          maxWidth: '300px',
          position: 'relative',
          fontFamily: 'Arial, sans-serif',
          fontSize: '14px',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
          margin: '20px auto',
          wordWrap: 'break-word',
          overflowWrap: 'break-word'
        };
      
        const tailStyle = {
          position: 'absolute',
          bottom: '0',
          left: '-10px',
          width: '0',
          height: '0',
          borderTop: '10px solid transparent',
          borderBottom: '10px solid transparent',
          borderRight: '10px solid #dcf8c6',
        };
      
        return (
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <div style={bubbleStyle}>
              {formattedMessage.split('\n').map((line, index) => (
              <p key={index} dangerouslySetInnerHTML={{ __html: line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }}></p>
            ))}
              <div style={tailStyle}></div>
            </div>
          </div>
        );
      };

    const handleViewClick = (input) => {
        if(input.user.name && input.user.mobile && input.user.email) {
            setSelectedLeadLogViewDetails(
                {
                    ...selectedLeadLogViewDetails,
                    noteUserName: input.user.name,
                    noteUserContact: input.user.mobile,
                    noteUserEmail: input.user.email,
                    note: input.notes,
                    quotationSentS3LocationforView: input?.latest_quotation_link,
                    attachment : input.s3Location[0] || 'NA',
                    assistantManagerName: input.user?.assistantManagerId?.name || 'NA',
                    assistantManagerMobile: input.user?.assistantManagerId?.mobile || 'NA',
                    assistantManagerEmail: input.user?.assistantManagerId?.email || 'NA',
                    client_name:input?.client_name || "Customer",
                    amount :input?.amount || "0000",
                    referal_policy_link:input?.referal_policy_link || "NA",
                    referee:input?.client_name || "Customer",
                    client_name_two:input?.client_name_two || "Customer",
                    client_name_client:input?.client_name_client || "Customer",
                    form_link:input?.form_link || "Customer",
                    referralFormLink: input?.form_link || 'NA',
                    bank_form_link:input?.bank_form_link || "NA",
                    cx_email:input?.cx_email,
                    cx_password:input?.cx_password,
                }
            )
        }
        setOpenWhatsAppNotificationContentDialog(true)
        setWhatsAppNotificationContent(input.whatsAppTemplateId.template_content)
    }


    const hasAttachments = files.every(file => file !== "");
    const onImageChangeCheck = async (e, index) => {
        const newFiles = [...files];
        const newFileUploaded = [...checkFileUploaded];

        props.setLoading(true);
        const fd = new FormData();
        fd.append("file", e.target.files[0]);
        fd.append('customerName', projectDetails.lead_no);

        const file = e.target.files[0]
        const fileSize = file.size;
        let newPaymentRecievedAttachments = uploadSize.paymentRecievedAttachments;
        newPaymentRecievedAttachments[index] = fileSize
        // console.log('newPaymentRecievedAttachments is ',newPaymentRecievedAttachments)
        setUploadSize({
            ...uploadSize,
            paymentRecievedAttachments: newPaymentRecievedAttachments
        })
        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            newFiles[index] = fileUploadRes.data;
            setContractSignStageForm({
                ...contractSignStageForm,
                contractSignedPaymentReceviedAttachemnts: newFiles,
            });
            setFiles(newFiles);
            setCheckFileUploaded(newFileUploaded);
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
        }
        props.setLoading(false);
    }

    const isDisabledToken = (projectDetails?.departmentId?._id === salesDepartment ||  projectDetails?.departmentId?._id === designDepartment)&& checkSalesToken === false;
    const [pics, setPics] = useState([""]);
    const hasPhotos = pics.every(pic => pic !== '');
    const hasVideos = videos.every(video => video !== '');
    const onImageChange = async (event, index) => {
        try {
            const newFiles = [...pics];
            const newFileUploaded = [...checkFileUploaded];

            props.setLoading(true);
            const fd = new FormData();
            fd.append("file", event.target.files[0]);
            fd.append('customerName', projectDetails.lead_no);

            const file = event.target.files[0]
            const fileSize = file.size;
            let newSiteQCPhotos = uploadSize.siteQCPhotos;
            newSiteQCPhotos[index] = fileSize
            // console.log('newSiteQCPhotos is ',newSiteQCPhotos)
            setUploadSize({
                ...uploadSize,
                siteQCPhotos: newSiteQCPhotos
            })
            const fileUploadRes = await HttpService.uploadFile(fd);
            newFiles[index] = fileUploadRes.data;
            setContractSignStageForm({
                ...contractSignStageForm,
                scanSiteQCPhotos: newFiles,
            });
            setPics(newFiles)
            setCheckIsUpload({ ...checkIsUpload, siteQCPhotos: true });
            props.setSnackInfo("SiteQC Photo Upload Success", "success");
        } catch (err) {
            console.log('photos upload error',err)
          props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
          props.setLoading(false);
        }
    };
    const handleAddFilesInput = () => {
        let newFiles = [...pics];
        newFiles.push("");
        setPics(newFiles);
        setContractSignStageForm({
            ...contractSignStageForm,
            scanSiteQCPhotos: newFiles,
        });
    };
    const handleRemoveFilesInput = (index) => {
        const newFiles = [...pics];
        newFiles.splice(index, 1);
        setPics(newFiles);

        let newSiteQCPhotos = uploadSize.siteQCPhotos;
        newSiteQCPhotos.splice(index, 1);
        // console.log('newSiteQCPhotos is ',newSiteQCPhotos)
        setUploadSize({
            ...uploadSize,
            siteQCPhotos: newSiteQCPhotos
        })
    }
    // const assignSalesManager = () => {
    //     setOpenSalesManagerModal(true);
    //     getSalesManagerList();
    // }

    const [lostReason, setLostReason] = useState('')
    const [refundRequired, setRefundRequired] = useState('')
    const [refundAmount, setRefundAmount] = useState('')
    const handlelostReason = (e) => {
        setLostReason(e.target.value)
    }
     // Unified Lost + Refund state (for Move Deal -> Lost)
    const [unifiedWantsRefund, setUnifiedWantsRefund] = useState(null); // 'yes' | 'no' | null
    const [unifiedRefundAmount, setUnifiedRefundAmount] = useState(0);
    const [unifiedLostRemarks, setUnifiedLostRemarks] = useState('');

    // Floor Button_1 Function
    const [fBtnShow, setfBtnShow] = useState(false)
    const floorPlanButton = () => {
        setfBtnShow(true);
    }

     const TAX_INVOICE_MAX_SIZE = 5 * 1024 * 1024; // 5MB

    const resetTaxInvoiceForm = () => {
        setTaxInvoiceFile(null);
        setTaxInvoiceSendVia({ email: true, whatsapp: true });
        setTaxInvoiceType('');
        setTaxInvoiceRemark('');
    }

    const openTaxInvoiceModal = async () => {
        resetTaxInvoiceForm();
        setTaxInvoiceModalOpen(true);
        try {
            setTaxInvoiceTypesLoading(true);
            const result = await HttpService.getTaxInvoiceTypes(projectId);
            setTaxInvoiceUsedTypes(result?.data?.usedTypes || []);
        } catch (error) {
            setTaxInvoiceUsedTypes([]);
        } finally {
            setTaxInvoiceTypesLoading(false);
        }
    }

    const closeTaxInvoiceModal = () => {
        if (taxInvoiceSubmitting) return;
        setTaxInvoiceModalOpen(false);
        resetTaxInvoiceForm();
    }

    const handleTaxInvoiceTypeChange = (e) => {
        setTaxInvoiceType(e.target.value);
        setTaxInvoiceFile(null); // uploaded PDF must match the newly selected type
    }

    const handleTaxInvoiceFileChange = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = ''; // allow re-selecting the same file after an error
        if (!file) return;
        if (file.type !== 'application/pdf' || !/\.pdf$/i.test(file.name)) {
            props.setSnackInfo('Only PDF files up to 5 MB are allowed.', 'error');
            return;
        }
        if (file.size > TAX_INVOICE_MAX_SIZE) {
            props.setSnackInfo('Only PDF files up to 5 MB are allowed.', 'error');
            return;
        }
        try {
            const headerBuffer = await file.slice(0, 5).arrayBuffer();
            const headerText = String.fromCharCode(...new Uint8Array(headerBuffer));
            if (headerText !== '%PDF-') {
                props.setSnackInfo('This file is not a valid PDF (failed content check). Only genuine PDF files are allowed.', 'error');
                return;
            }
        } catch (err) {
            props.setSnackInfo('Could not read the selected file. Please try again.', 'error');
            return;
        }
        setTaxInvoiceFile(file);
    }

    const handleTaxInvoiceSendViaChange = (channel) => (e) => {
        const nextChecked = e.target.checked;
        const otherChannel = channel === 'email' ? 'whatsapp' : 'email';
        if (!nextChecked && !taxInvoiceSendVia[otherChannel]) {
            props.setSnackInfo('At least one channel (Email or WhatsApp) must stay selected.', 'error');
            return;
        }
        setTaxInvoiceSendVia({ ...taxInvoiceSendVia, [channel]: nextChecked });
    }

    const submitTaxInvoice = async () => {
        if (!taxInvoiceType) {
            props.setSnackInfo('Please select the Tax Invoice type.', 'error');
            return;
        }
        if (!taxInvoiceFile) {
            props.setSnackInfo('Please attach the Tax Invoice PDF.', 'error');
            return;
        }
        if (!taxInvoiceSendVia.email && !taxInvoiceSendVia.whatsapp) {
            props.setSnackInfo('Please select at least one communication channel (Email or WhatsApp).', 'error');
            return;
        }
        if (taxInvoiceRemark.length > 500) {
            props.setSnackInfo('Remark must be 500 characters or fewer.', 'error');
            return;
        }
        try {
            setTaxInvoiceSubmitting(true);
            const uniqueLeadNumber = projectDetails?.uniqueLeadNumber || projectId;
            const generatedFileName = `DPTAXInvoice_${taxInvoiceType}_${uniqueLeadNumber}_${moment().format('YYYYMMDDHHmmss')}.pdf`;
            const renamedFile = new File([taxInvoiceFile], generatedFileName, { type: 'application/pdf' });

            const uploadFormData = new FormData();
            uploadFormData.append('file', renamedFile);
            uploadFormData.append('customerName', uniqueLeadNumber);
            const uploadResult = await HttpService.uploadFile(uploadFormData);
            const fileUrl = uploadResult?.data;
            if (!fileUrl) {
                throw new Error('Tax Invoice PDF upload failed.');
            }
            const sendVia = Object.keys(taxInvoiceSendVia).filter(key => taxInvoiceSendVia[key]);
            const result = await HttpService.uploadTaxInvoice(projectId, {
                fileUrl,
                originalFileName: generatedFileName,
                type: taxInvoiceType,
                remark: taxInvoiceRemark,
                sendVia
            });
            props.setSnackInfo(result?.data?.message || 'Tax Invoice uploaded successfully.', 'success');
            setTaxInvoiceModalOpen(false);
            resetTaxInvoiceForm();
            getProjectLogs();
            setTimeout(() => getProjectLogs(), 6000);
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message || error?.message || 'Failed to upload Tax Invoice.', 'error');
        } finally {
            setTaxInvoiceSubmitting(false);
        }
    }


    const getSalesManagerList = async () => {
        props.setLoading(true)
        try {
            const result = await HttpService.getUsers()
            let salesArr = [];
            let salesManagerArr = [];
            let activeTeamUser = result.data.filter(ele => ele.isActive === true);
            activeTeamUser.forEach(ele => {
                if (ele.roles?.find(role => role.name === ROLENAME.AssistantSalesManager) && ele?.teamId?.isActive === true ) {
                    salesArr.push(ele);
                } else if (ele.roles?.find(role => role.name === ROLENAME.SalesManager) && ele?.teamId?.assistantManagers?.length === 0 && ele?.teamId?.isActive === true ) {
                    salesArr.push(ele);
                }
            })
            dupManagerOfSalesTeam.forEach(ele => {
                ele.experienceCenterId.forEach(ele1 => {
                    if (ele1._id === projectDetails.experienceCenterId._id) {
                        salesManagerArr.push(ele)
                    }
                })
            })
            setSalesManagerList(salesManagerArr)
            setDupManagerOfSalesTeam(salesArr);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }
    const getSelectedSalesManagerDetail = (e) => {
        let teamDetail = [];
        dupManagerOfSalesTeam.forEach(ele => {
            if (ele?.teamId?._id === e.target.value) {
                teamDetail.push(ele)
            }
        })
        setSelectedSalesManager({
            department: teamDetail[0]?.departmentId._id,
            team: teamDetail[0]?.teamId._id,
            id: teamDetail[0]?._id,
            status: 'Lead Received',
            stage: 'Lead Received',
            leadId: projectId
        })
    }

    const onFileUpload = async (e)=>{
        try {
            props.setLoading(true)
            const formData = new FormData()
            formData.append('file', e.target.files[0])
            formData.append('customerName', projectDetails.lead_no + '_' + projectDetails.customerId.name)
            const result = await HttpService.uploadFile(formData);
            setAudioUploadData(result.data)
            setAudioUploaded(true);
            props.setSnackInfo("Audio/Image File Upload Success", "success")
        } catch (error) {
            console.log(error)
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false)
    }
    const sentForMoveToMarketingApproval = async ()=>{
        if (isMoveToMarketingBlockedByAssignmentAge(projectDetails?.leadAssignedDate)) {
            return props.setSnackInfo(moveToMarketingAssignmentAgeMessage(), 'warning');
        }
        try{
            // console.log('projectId is ',projectId)
            // console.log('projectDetails is ',projectDetails)
            let obj = {
                leadId: projectId,
                moveToMarketingReason: moveToMarketingReason,
                audioFileLink : audioUploadData,
                handoverDate : handoverDate,
                otherReason: otherReason
            }
            const result = await HttpService.moveToMarketingFromSmApproval(obj);
            props.setSnackInfo("Sent for Move To Marketing Approval", "success")
            setReRender(!reRender)
            setOpenAnotherDialog(false)
        }
        catch(err){
            console.log(err)
        }
    }


    // const assignLeadToSalesManager = async () => {
    //     console.log(selectedSalesManager);
    //     props.setLoading(true)
    //     try {
    //         await HttpService.assignProject(selectedSalesManager)
    //         props.setSnackInfo("Sales Manager Assigned Successfully", "success")
    //         setOpenSalesManagerModal(false)
    //         getProjectLogs();
    //         getcustomerDetails();
    //     } catch (error) {
    //         props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
    //     }
    //     props.setLoading(false)
    // }

    const sentForDsoPaymentApproval = async () => {
        if (!qtVersionGrandTotal) {
            return props.setSnackInfo('Select a quotation version first', 'warning');
        }
        if (!requiresDsoPaymentApproval(projectDetails?.staticSalesWonAmount, qtVersionGrandTotal)) {
            return props.setSnackInfo(
                'DGM approval is only required when design amount is more than 30% below sales won',
                'info'
            );
        }
        try {
            props.setLoading(true);
            await HttpService.sendDsoPaymentApproval({
                leadId: projectId,
                designSignOffAmount: qtVersionGrandTotal,
            });
            props.setSnackInfo('Sent for DGM Approval', 'success');
            setOpenAnotherDialog(false);
            setOpen(false);
            getProjectLogs();
            getcustomerDetails();
        } catch (err) {
            console.error(err);
            props.setSnackInfo(err?.response?.data?.message || 'Something went wrong', 'error');
        }
        props.setLoading(false);
    };

    const handleClickOpen = () => {
        if (blockDesignerMoveIfDsoPending()) {
            return;
        }
        // if (projectDetails.currentStage === 'Finalization of Materials' && projectDetails.finalizationOfMaterialStageStatus !== "Approved" && (projectDetails.acadSkpFileStatus !== "Rejected") ){
        //     return props.setSnackInfo("Materials Checklist Not Approved" , "error")
        // }
        if (projectDetails.designStatus === 'Design-Hold' || projectDetails.designStatus === 'Design-Hold Pending Approval' ){
            return props.setSnackInfo("Design Status is Design-Hold" , "error")
        }
        else if (projectDetails.designKickOffInternalApprovalStatus === "Pending") {
            return props.setSnackInfo("Design Kick-Off Internal is not Approved/Rejected" , "error")
        }
        else if (projectDetails?.currentStage === "Design Kick-Off : Customer"
            && !projectDetails?.isDesignKickOffCustomerApprovedFromDesign) {
            return props.setSnackInfo(
                "Design Kick-Off Customer is not complete. Designer must upload customer kick-off from Design Kick-off (SEND FOR APPROVAL), not Move Deal.",
                "error"
            )
        }
        if (projectDetails.acadSkpFileStatus === "Sent for Approval" ) {
            return props.setSnackInfo("SKP/ACAD File is Pending Approval/Rejection", "error")
        }

        const marketingApprovalStatus = projectDetails?.moveToMarketingFromSmApproval;

        if (approvalStageMap[marketingApprovalStatus]) {
            return props.setSnackInfo(
                `You can't proceed as the lead is currently pending with ${approvalStageMap[marketingApprovalStatus]} for Move to Marketing approval.`,
                "warning"
            );
        }
        setOpen(true);
        getAllQuotationsForProject();
        getPaymentPreview()
        getAmountReceivedForLead()
        getDepartments();
        getAllNaraciQuotationsForProject(projectDetails);
        setEditQtSentMeetingDialog(false);
    };
    const openChmUserDialog = () => {
        setOpenChmUser(true);
        getChmUsersList();
    }
    const [marketingUser, setMarketingUser] = useState([]);
    const openAnotherDialog = () => {
        if (blockDesignerMoveIfDsoPending()) {
            return;
        }
        if (stage === 'Move to Marketing' && isMoveToMarketingBlockedByAssignmentAge(projectDetails?.leadAssignedDate)) {
            return props.setSnackInfo(moveToMarketingAssignmentAgeMessage(), 'warning');
        }
        if(stage === 'Quotation Sent'){
            getAllQuotationsForProject();
            if(qtLength === 0){
                props.setSnackInfo('You must finalize at least one quotation before moving to Quotation Sent stage', 'warning');
                return;
            }
        }
        if (projectDetails.salesStage !== "Won" && stage != "Lost" && projectDetails.departmentId === designDepartment ) {
            return props.setSnackInfo("Kickoff not Completed" , "error")
        }
        projectDetails.previouslyAssignedTo.forEach((ele, i) => {
            if (ele.departmentId === constantDepartmentId.marketing || ele.departmentId === callCenterId) {
                setMarketingUser(ele)
            }
        })
        if (stage === 'Assign to Designer' && !projectDetails?.erpProjectNo && projectDetails?.uniqueLeadNumber) {
            setNewErpProjectNo(String(projectDetails.uniqueLeadNumber).trim().toUpperCase());
            setErpProjectExists(false);
        }
        setOpen(false);
        setOpenAnotherDialog(open);
        getDepartments();
    }

    const openDesignKickOffCustomerDialog = () => {
        // if (projectDetails.salesStage === "Won Deals Pending Designer Assignment"){
        //     return props.setSnackInfo("Client has not approved the checklist2", 'error')
        // }
        getDepartments();
        setDesignKickOffCustomerDialog(true)
        setOpen(false);
    }

    const handleSelectReason = (event) => {
        setMoveToMarketingReason(event.target.value);
    }

    const handleSelectSalesLostReason = (event) => {
        setSalesLostReason(event.target.value);
    };

    const handleSelectJunkReason = (event) => {
        setJunkReason(event.target.value);
    };

    const handleSelectedDepartmentChange = (event) => {
        setSelectedDepartment(event.target.value);
        getTeamsList(event.target.value)
    }
    const handleSelectedTeamChange = (event) => {
        setSelectedTeam(event.target.value);
        getUserList(event.target.value)
    }
    const handleSelectedUserChange = (event) => {
        setSelectedDealOwner(event.target.value);
    }

    const handleChmUserChange = (event) => {
        setSelectedChmUser(event.target.value);
    }

    const handleSelectedQCStages = (event) => {
        setQcStages(event.target.value);
    }

    const updateChmUser = async () => {
        let obj = {
            projectId: projectId,
            chmUser: chmUser
        }
        props.setLoading(true)
        try {
            const response = await HttpService.updateChmUser(obj)
            props.setSnackInfo(response?.data ?? "User Changed successfully", "success")
            setOpenChmUser(false);
            getProjectLogs();
            getcustomerDetails();
            getChmUsersList();
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false)
    }

    const [callCenterId,setCallCenterId] = useState();
    const getDepartments = async () => {
        try {
            const department = await HttpService.getDepartments();
            if (userDetails?.roles?.find(role => role.name !== 'Admin')) {
                if (userDetails?.roles?.find(role => role.name === ROLENAME.MarketingUser || role.name === ROLENAME.MarketingManager || role.name === ROLENAME.TeleCallerManager || role.name === ROLENAME.TeleCallerUser)) {
                    setDepartmentsList(department.data.filter(ele => ele.name === 'Sales'));
                } else {
                    setDepartmentsList(department.data.filter(ele => ele._id === userDetails.departmentId))
                }
            }
            let callCenterData = department.data?.find(name => name.name === 'Call Center');
            setCallCenterId(callCenterData._id)
            getDepartmentStages(department.data);
        } catch (error) {
            console.log(error, "get department error")
        }
    }
    const getChmUsersList = async () => {
        try {
            const chmusers = await HttpService.getDepartments();
            const chmStage = chmusers.data.find(item => item.name === "CHM")
            if (chmStage) {
                const chmUsers = chmStage.users
                setChmList(chmUsers);
            }
        }
        catch (error) {
            console.log(error, "getchmuserlist");
        }
    }

    const getTeamsList = async (deptid) => {
        let teams = [];
        teams = departmentLists.filter(ele => ele._id === deptid)
        const centerTeams = [];
        if (userDetails.roles.find(role => role.name === ROLENAME.DesignHead || role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager)) {
            teams[0]['teams'].forEach(ele => {
                centerTeams.push(ele)
            })
        } else {
            teams[0]['teams'].forEach(ele => {
                ele.experienceCenterId.forEach(centerId => {
                    if (userDetails.experienceCenterId.includes(centerId)) {
                        centerTeams.push(ele)
                    }
                })
            })
        }
        const activeTeamList = centerTeams.filter(ele => ele.isActive === true)
        setTeamList(activeTeamList)
    }

    const getUserList = async (teamid) => {
        if (userDetails?.roles?.find(role => ROLENAME.MarketingUser || role.name === ROLENAME.MarketingManager)) {
            try {
                const users = await HttpService.getQTTeamUsers(teamid);
                let activeUsers = users.data.users.filter(ele => ele.isActive === true)
                let finalUsers = []
                if (userDetails.roles.find(role => role.name === ROLENAME.DesignHead || role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager)) {
                    for (let j = 0; j < activeUsers.length; j++) {
                        finalUsers.push(activeUsers[j])
                    }
                } else {
                    for (let i = 0; i < activeUsers.length; i++) {
                        for (let j = 0; j < activeUsers[i]['experienceCenterId'].length; j++) {
                            if (userDetails.experienceCenterId.includes(activeUsers[i]['experienceCenterId'][j]['_id'])) {
                                finalUsers.push(activeUsers[i])
                            }
                        }
                    }
                }
                setDealOwnersList(finalUsers)
                setManagerOrHeadId(users.data.manager._id);
            } catch (error) {
                console.log(error, "Error");
            }
        } else if (teamid === userDetails.teamId._id) {
            try {
                const users = await HttpService.getQTTeamUsers(teamid);
                let activeUsers = users.data.users.filter(ele => ele.isActive === true)
                setDealOwnersList(activeUsers)
                setManagerOrHeadId(users.data.manager._id);
            } catch (error) {
                console.log(error, "Error");
            }
        } else {
            try {
                const teamUsers = await HttpService.getQtTeamManager(teamid);
                let teamManager = [];
                let obj = {
                    _id: teamUsers.data.manager._id,
                    name: teamUsers.data.manager.name
                }
                teamManager.push(obj);
                setDealOwnersList(teamManager)
            } catch (error) {
                console.log(error, "Error");
            }
        }
    }

    const onVideoChangeCheck = async (e, index) => {
        const newVideos = [...videos];
        const newVideoUploaded = [...checkVideoUploaded];
    
        props.setLoading(true);
        const fd = new FormData();
        fd.append("file", e.target.files[0]);
        fd.append('customerName', projectDetails.lead_no);
    
        try {
            const fileUploadRes = await HttpService.uploadFile(fd);
            newVideos[index] = fileUploadRes.data;
            setContractSignStageForm({
                ...contractSignStageForm,
                siteQcVideo: newVideos,
            });
            setVideos(newVideos);
            setCheckVideoUploaded(newVideoUploaded);
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
        }
        props.setLoading(false);
    };


const handleAddVideoInput = (index) => {
  const newVideos = [...videos, ""];
  setVideos(newVideos);
};

const handleRemoveVideoInput = (index) => {
  const newVideos = videos.filter((_, i) => i !== index);
  setVideos(newVideos);
};


    const getDepartmentStages = async (data) => {
        let stages = []
        if (userDetails.roles.find(role => role.name === ROLENAME.MarketingUser || role.name === ROLENAME.MarketingManager || role.name === ROLENAME.TeleCallerManager || role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.ChannelPartner)) {
            data.forEach((element) => {
                if (element['name'] === 'Sales') {
                    stages.push(element['stages']);
                };
            });
        } else if (userDetails.roles.find(role => role.name === ROLENAME.DesignHead || role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser)) {
            data.forEach((element) => {
                if (element['name'] === 'Design') {
                    // element['stages'] = [];
                    // Check if the user is not a DesignUser and this logic for disbale and enable of design stage option mapping only for user
                 
                    const designStages = [
                        "Assign to Designer",
                        "Internal Kick-Off",
                        "Design Kick-Off : Customer",
                        "Initial Measurement",
                        "Design Discussion",
                        "Finalization of Design",
                        "Finalization of Materials",
                        "Renders",
                        "Final Quote and Design",
                        "Site QC/Project Kick-Off",
                        "Drawing QC",
                        "Internal Design Sign-Off",
                        "Design Sign-off HOLD",
                        "Design Sign-off",
                        "Lost"
                    ]
                    const newStage = [];

                    for(let i = 0; i < designStages.length; i++){
                        if(element['stages'].includes(designStages[i])){
                            newStage.push(designStages[i]);
                        }
                    }

                    const index = newStage.indexOf(projectDetails.currentStage);
                    if (projectDetails.currentStage === 'Design Kick-Off : Internal' && !projectDetails.designKickOffInternalApprovalStatus || projectDetails.designKickOffInternalApprovalStatus === "Rejected"
                    ) {
                        setCurrentStageIndex(1);
                    } else if (projectDetails.currentStage === 'Design Kick-Off : Internal') {
                        setCurrentStageIndex(2);
                    }
                    else if (projectDetails.currentStage === 'Designer Assigned') {
                        setCurrentStageIndex(3);
                    } else if(projectDetails.acadSkpFileStatus === 'Rejected'){
                        setCurrentStageIndex(index);
                    } else {
                        setCurrentStageIndex(index + 1);
                    }
                    stages.push(newStage);
                    // stages.push(element['stages']);

                };
            });
        } else {
            data.forEach((element) => {
                if (element['_id'] === userDetails.departmentId) {
                    // element['stages'].push('Move to Marketing');
                    stages.push(element['stages']);
                };
            });
        }
        setDepartmentsStage(stages[0]);
    }

    const handleCreateInternalTicket = (event) => {
        event.preventDefault();
        window.open("/CHM-Ticket-Creation", "_blank", "noopener,noreferrer");
      };
      
    const handleSelectedStageChange = (event) => {
        const selectedStage = event.target.value;
        
        // If Lost is selected, open the unified Lost details dialog directly
        if (selectedStage === 'Lost') {
            setSelectedStage(selectedStage);
            setShowRefundConfirmDialog(false);
            setOpen(false);
            setOpenAnotherDialog(true);
        } else {
            setSelectedStage(selectedStage);
        }
    }

    const handleRefundConfirmYes = () => {
        setRefundRequired('Yes');
        setShowRefundConfirmDialog(false);
        setOpen(false); // Close the stage selection dialog
        setOpenAnotherDialog(true); // Open the Lost details dialog
    }

    const handleRefundConfirmNo = () => {
        setRefundRequired('No');
        setRefundAmount('');
        setShowRefundConfirmDialog(false);
        setOpen(false); // Close the stage selection dialog
        setOpenAnotherDialog(true); // Open the Lost details dialog
    }

    const handleRefundConfirmCancel = () => {
        setShowRefundConfirmDialog(false);
        setSelectedStage(''); // Reset stage selection
    }

    const [checkIsUpload, setCheckIsUpload] = useState({
        workingDrawingFile: false,
        threeworkingDrawingFile: false,
        contractSignedPaymentReceviedAttachemnt: false,
        scanQuotationFile: false,
        scanCheckListFile: false,
        scanProjectKickOffCheckListFile: false,
        siteQCPhotos: false,
        scanSiteQCCheckListFile: false,
        designerPaymentAttachement: false,
        // scanContractFile: false
        quotationCsvFile: false
    })

    function calculateTotalSize() {
        const totalSize = Object.values(uploadSize).reduce((acc, el) => {
            if (Array.isArray(el)) {
                return acc + el.reduce((arraySum, arrayItem) => arraySum + arrayItem, 0);
            } else {
                return acc + (typeof el === 'number' ? el : 0);
            }
        }, 0);

        const totalSizeMB = totalSize / (1024 * 1024);
        setTotalSize(totalSizeMB);
        if (totalSizeMB >= 25) {
            props.setSnackInfo('Size exceeds 25MB limit, please try again', 'Error')
        }
        // console.log('total size in MB: ', totalSizeMB)
        // console.log('upload size: ', uploadSize)
    };
    const uploadWDFileDocument = async (e, optionType) => {
        try {
            if (optionType !== "quotationFile" && optionType !== "quotationcsv") {
                // console.log("Option -> ", optionType);
                const { name, value } = e.target.value
                props.setLoading(true)
                const formData = new FormData()
                formData.append('file', e.target.files[0])
                const file = e.target.files[0]
                const fileSize = file.size;
                const fileSizeInKB = file.size / 1024; // Convert bytes to kilobytes
                const fileSizeInMB = fileSizeInKB / 1024; // Convert kilobytes to megabytes
                // console.log('Current File Size is:', fileSizeInMB);

                formData.append('customerName', projectDetails.lead_no + '_' + projectDetails.customerId.name)
                const result = await HttpService.wdFileUpload(formData)
                if (result.status === 200 && optionType === 'wdfile') { //done
                    console.log('wdfile')
                    setContractSignStageForm({ ...contractSignStageForm, 'workingDrawingFile': result.data })
                    setCheckIsUpload({ ...checkIsUpload, workingDrawingFile: true })
                    setUploadSize({ ...uploadSize, workingDrawingFile: fileSize })
                    props.setSnackInfo("Working Drawing Upload Success", "success")
                } else if (result.status === 200 && optionType === '3wdfile') { //done
                    console.log('3dwdfile')
                    setContractSignStageForm({ ...contractSignStageForm, 'ThreeDworkingDrawingFile': result.data })
                    setCheckIsUpload({ ...checkIsUpload, threeworkingDrawingFile: true })
                    setUploadSize({ ...uploadSize, threeworkingDrawingFile: fileSize })
                    props.setSnackInfo("Working Drawing Upload Success", "success")
                }
                // else if (result.status === 200 && optionType === 'quotationFile') { //done
                //     console.log('quotationFile')
                //     setContractSignStageForm({ ...contractSignStageForm, 'scanQuotationFile': e})
                //     setCheckIsUpload({ ...checkIsUpload, scanQuotationFile: true })
                //     setUploadSize({ ...uploadSize, scanQuotationFile: fileSize })
                //     props.setSnackInfo("Quotation File Upload Success", "success")
                // } 

                else if (result.status === 200 && optionType === 'CheckList') { //done
                    console.log('CheckList')
                    setContractSignStageForm({ ...contractSignStageForm, 'scanCheckListFile': result.data })
                    setCheckIsUpload({ ...checkIsUpload, scanCheckListFile: true })
                    setUploadSize({ ...uploadSize, scanCheckListFile: fileSize })
                    props.setSnackInfo("Check List File Upload Success", "success")
                } else if (result.status === 200 && optionType === 'ProjectKickOffCheckList') { //done
                    console.log('Project Kick Off CheckList')
                    setContractSignStageForm({ ...contractSignStageForm, 'scanProjectKickOffCheckListFile': result.data })
                    setCheckIsUpload({ ...checkIsUpload, scanProjectKickOffCheckListFile: true })
                    setUploadSize({ ...uploadSize, scanProjectKickOffCheckListFile: fileSize })
                    props.setSnackInfo("Project Kick Off CheckList File Upload Success", "success")
                } else if (result.status === 200 && optionType === 'siteqcchecklist') { //done
                    console.log('SiteQC CheckList')
                    setContractSignStageForm({ ...contractSignStageForm, 'scanSiteQCCheckListFile': result.data })
                    setCheckIsUpload({ ...checkIsUpload, scanSiteQCCheckListFile: true })
                    setUploadSize({ ...uploadSize, scanSiteQCCheckListFile: fileSize })
                    props.setSnackInfo("SiteQC Check List File Upload Success", "success")
                } else if (result.status === 200 && optionType === 'designerPayment') {
                    setPaymentUpdateForm({ ...paymentUpdateForm, 'paymentAttachement': result.data })
                    setCheckIsUpload({ ...checkIsUpload, designerPaymentAttachement: true })
                    setUploadSize({ ...uploadSize, designerPaymentAttachement: fileSize })
                    props.setSnackInfo("Check List File Upload Success", "success")
                }
                // else if (result.status === 200 && optionType === 'contractpdf') {
                //     console.log('contractpdf')
                //     setContractSignStageForm({ ...contractSignStageForm, 'scanContractFile': result.data })
                //     setCheckIsUpload({ ...checkIsUpload, scanContractFile: true })
                //     props.setSnackInfo("Contract Signed File Upload Success", "success")
                // } else if (result.status === 200 && optionType === 'quotationcsv') { //done
                //     setContractSignStageForm({ ...contractSignStageForm, 'quotationCsvFile': e })
                //     setCheckIsUpload({ ...checkIsUpload, quotationCsvFile: true })
                //     setUploadSize({ ...uploadSize, quotationCsvFile: fileSize })
                //     props.setSnackInfo("Quotation Csv File Upload Success", "success")
                // }
                else if (result.status === 200 && optionType === 'salesPaymentSlip') {
                    setNewPaymentSlip(result.data)
                    setCheckForSales(true)
                    // setUploadSize({ ...uploadSize, scanQuotationFile: fileSize })
                    props.setSnackInfo("Sales Payment Slip Upload Success", "success")
                }
                // else if (result.status === 200 && optionType === 'salesPaymentSlip'){
                //     setNewPaymentSlip(result.data)
                //     setCheckForSales(true)
                //     props.setSnackInfo("Sales Payment Slip Upload Success", "success")
                // }
                else if (result.status === 200) {
                    setFloorType(result.data);
                    setCheckForFloor(true);
                    setFloorPlanAttach(result.data);
                    setFloorPlanUploaded(true);
                    // setUploadSize({ ...uploadSize, scanQuotationFile: fileSize })
                    props.setSnackInfo("Floor Plan Upload Success", "success")
                }
            } else {
                props.setLoading(true);
                const fileSize = e.size;
                const fileSizeInKB = e.size / 1024; // 
                if (optionType === 'quotationFile') { //done
                    // console.log('quotationFile')
                    setContractSignStageForm({ ...contractSignStageForm, 'scanQuotationFile': e })
                    setCheckIsUpload({ ...checkIsUpload, scanQuotationFile: true })
                    setUploadSize({ ...uploadSize, scanQuotationFile: fileSize })
                    props.setSnackInfo("Quotation File Upload Success", "success")
                } else if (optionType === 'quotationcsv') { //done
                    setContractSignStageForm({ ...contractSignStageForm, 'quotationCsvFile': e })
                    setCheckIsUpload({ ...checkIsUpload, quotationCsvFile: true })
                     setUploadSize({ ...uploadSize, quotationCsvFile: fileSize })
                    props.setSnackInfo("Quotation Csv File Upload Success", "success")
                }
                props.setLoading(false);
            }
        } catch (error) {
            console.log(error)
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false)
    }

    const assignToMarketingUser = async () => {
        let dealData = {
            status: "Lead Returned By Sales",
            stage: 'Move to Marketing',
            department: marketingUser.departmentId,
            team: marketingUser.teamId,
            id: marketingUser._id,
            leadId: projectId
        }
        try {
            props.setLoading(true)
            const assignProject = await HttpService.assignProject(dealData);
            if (assignProject.status === 200) {
                setOpenAnotherDialog(false);
                getProjectLogs();
                getcustomerDetails();
                history.push('/qtProjects');
                props.setSnackInfo("Project assigned Successful", "success")
            }
        } catch (error) {
            console.log(error, "assign project error");
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }

    const checkProceedToD2E = async () => {
        if (projectDetails.currentStage === "Design Sign-off HOLD" && !contractSignStageForm.designSignOffRevokeDate ){
            return props.setSnackInfo("Please enter date of design sign-off revoke", "error")
        }
        if ( projectDetails.acadSkpFileStatus && projectDetails.acadSkpFileStatus !== "Approved") {
            return props.setSnackInfo("SKP/ACAD file is not approved", "error")
        }
    const tokenPercentage = parseInt(qtVersionGrandTotal) !== 0 ? ((totalAmount / parseInt(qtVersionGrandTotal)) * 100).toFixed(2) : "0.00";
        if (tokenPercentage < 59) {
            setDesignUserWarningDialog(true)
        } else sendRequestToFinanceAndDesignManager ()
    }

    const sendRequestToFinanceAndDesignManager = async () => {
        if (projectDetails?.designKickOffCustomerActionFromChm !== "Approved") {
            return props.setSnackInfo( "Design Kick-off is not Approved by ADM/ODM", "error")
        }      
        setDesignUserWarningDialog(false)
        contractSignStageForm.grandTotal = projectDetails.grandTotal;
        contractSignStageForm.qtVersionGrandTotal = qtVersionGrandTotal;
        // contractSignStageForm.tokenPercent = ((projectDetails.paymentDone / projectDetails.grandTotal) * 100).toFixed(2);
        const tokenPercentValue = parseInt(qtVersionGrandTotal) !== 0 ? ((totalAmount / parseInt(qtVersionGrandTotal)) * 100).toFixed(2) : "0.00";
        contractSignStageForm.tokenPercent = tokenPercentValue;
        contractSignStageForm.designToExecutionLogsStatus = "Sent For Approval";
        contractSignStageForm.stage = stage;
        contractSignStageForm.designSignOffUser = projectDetails.assignTo._id;
        contractSignStageForm.designSignOffUserName = userDetails.name;
        contractSignStageForm.designQuotationVersion = selectedQuotationVersion;
        contractSignStageForm.qtVersion = qtVersion;
        contractSignStageForm.designWonExpCtrId = projectDetails?.experienceCenterId;
        contractSignStageForm.designUser = userDetails?._id;
        contractSignStageForm.designAssistantManager = userDetails?.assistantManagerId;
        contractSignStageForm.designManager = userDetails?.teamId?.manager?._id;
        contractSignStageForm.designDGM = userDetails?.teamId?.teamDGM?._id;
        // console.log(contractSignStageForm, 'contractSignStageForm')
        contractSignStageForm.selectedQuotationForPayment = selectedQuotationVersion
        contractSignStageForm.quotationCsvFile = quotationCsv
        contractSignStageForm.scanQuotationFile = quotationPdf
        try {
            props.setLoading(true)
            const assignProject = await HttpService.sendRequrestToFinanceAndDesgin(projectId, contractSignStageForm);
            if (assignProject.status === 200) {
                setOpenAnotherDialog(false);
                setSelectedStage('');
                setSelectedDepartment('');
                setSelectedTeam('');
                setSelectedDealOwner('');
                getProjectLogs();
                getcustomerDetails();
                props.setSnackInfo("Request has been sent successfully.", "success")
            }
        } catch (error) {
            console.log(error, "assign project error");
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false)
    }

    const assignProject = async () => {
        if (blockDesignerMoveIfDsoPending()) {
            return;
        }
        if (projectDetails.salesStage === "Won Deals Pending Designer Assignment" && stage === "Initial Measurement" ) {
            return props.setSnackInfo("Design Kick-off: Customer is not approved by client", "error")
        }
        if (projectDetails.currentStage === "Design Kick-Off : Customer" && stage != "Lost") {
            return props.setSnackInfo("Design Kick-off is not Approved by ADM/ODM", "error")
        }

        if (projectDetails.currentStage === 'Lost' && stage === 'Lost' ){
            return props.setSnackInfo("Lost request already raised" , "error")
        }

        if (projectDetails.currentStage === "Finalization of Materials" && projectDetails.finalizationOfMaterialStageStatus !== "Approved" && stage != "Lost")  {
            return props.setSnackInfo("Please complete EDC process", "error")
        }
        if (
            stage === 'Internal Design Sign-Off' &&
            requiresDsoPaymentApproval(projectDetails?.staticSalesWonAmount, qtVersionGrandTotal) &&
            !checkIsUpload.scanQuotationFile
        ) {
            return props.setSnackInfo(
                'Upload quotation documents before moving. If variation is ≥ 30%, this will be assigned to Naren.',
                'error'
            );
        }
        setDesignKickOffCustomerDialog(false)
        let dealData = {
            stage: stage,
            team: userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser) ? userDetails.teamId._id : team,
            id: userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser) ? userDetails._id : dealOwner,
            leadId: projectId,
            TeamManagerOrHeadId: managerOrHeadId,
        };

        let isDesignUserFound = userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser);
        let isTeleCallerorMarketingUser = userDetails?.roles?.find(role => role.name === ROLENAME.MarketingManager || role.name === ROLENAME.MarketingUser || role.name === ROLENAME.TeleCallerManager || role.name === ROLENAME.TeleCallerUser);

        if (isDesignUserFound) {
            dealData.department = userDetails.departmentId;
        } else {
            dealData['department'] = department
        }
        if (userDetails.departmentId === constantDepartmentId.design) {
            dealData.stageDepartment = 'design'
        } else if (userDetails.departmentId === constantDepartmentId.sales) {
            dealData.stageDepartment = 'sales'
        }  else if (userDetails.departmentId === constantDepartmentId.marketing) {
            dealData.stageDepartment = 'marketing'
        } else if (userDetails.departmentId === constantDepartmentId.factory) {
            dealData.stageDepartment = 'factory'
        }

        if(isTeleCallerorMarketingUser){
            dealData = {
                stage: stage,
                leadId: projectId,
                leadType : 'Real',
                status : 'Lead Received',
                stage: stage,
                leadStatus: 'Open'
            };
        }

        // if (stage === 'Requirements Not Collected') {
        //     if (dealOwner) {
        //         dealData['preSalesCallDate'] = preSalesCallDate
        //         dealData['nextFollowUpDate'] = nextFollowUpDate
        //         dealData['leadStatus'] = 'Open'
        //     } else {
        //         dealData = {
        //             stage: stage,
        //             leadId: projectId,
        //             nextFollowUpDate: nextFollowUpDate,
        //             preSalesCallDate: preSalesCallDate,
        //             leadStatus: 'Open'
        //         };
        //     }
        // } else if (stage === 'Requirements Collected') {
        //     if (dealOwner) {
        //         dealData['salesCallDate'] = salesCallDate;
        //         dealData['requirements'] = requirements;
        //         dealData['estimatedBudget'] = estimatedBudget;
        //         dealData['nextFollowUpDate'] = nextFollowUpDate;
        //         dealData['salesCallComment'] = salesCallComment;
        //         dealData['leadStatus'] = 'Open'
        //     } else {
        //         dealData = {
        //             stage: stage,
        //             leadId: projectId,
        //             salesCallDate: salesCallDate,
        //             requirements: requirements,
        //             estimatedBudget: estimatedBudget,
        //             nextFollowUpDate: nextFollowUpDate,
        //             salesCallComment: salesCallComment,
        //             leadStatus: 'Open'
        //         };
        //     }

        // } else if (stage === 'Quotation Sent') {
        //     if (dealOwner) {
        //         dealData['quotationSentDate'] = quotationSentDate;
        //         dealData['nextFollowUpDate'] = nextFollowUpDate;
        //         dealData['momQuotationStage'] = momQuotationStage;
        //         dealData['leadStatus'] = 'Open'
        //     } else {
        //         dealData = {
        //             stage: stage,
        //             leadId: projectId,
        //             nextFollowUpDate: nextFollowUpDate,
        //             quotationSentDate: quotationSentDate,
        //             momQuotationStage: momQuotationStage,
        //             leadStatus: 'Open'
        //         };
        //     }

        // }
        if (stage === 'Site/Office visit') {
            if (dealOwner) {
                dealData['siteVisitDate'] = siteVisitDate;
                dealData['momMeetingStage'] = momMeetingStage;
                dealData['momSiteVisitStage'] = momSiteVisitStage;
                dealData['nextFollowUpDate'] = nextFollowUpDate;
                dealData['leadStatus'] = 'Open'
                dealData['meetingDone'] = meetingDone;
                dealData['meetingType'] = meetingType;
                dealData['meetingDate'] = meetingDate;
                dealData['meetingDoneStage'] = stage;

            } else {
                dealData = {
                    stage: stage,
                    leadId: projectId,
                    siteVisitDate: siteVisitDate,
                    momMeetingStage: momMeetingStage,
                    momSiteVisitStage: momSiteVisitStage,
                    nextFollowUpDate: nextFollowUpDate,
                    leadStatus: 'Open',
                    meetingDone: meetingDone,
                    meetingType: meetingDone === "Yes" ? meetingType : "",
                    meetingDate: meetingDone === "Yes" ? meetingDate : "",
                    meetingDoneStage: meetingDone === "Yes" ? "Won Deals Pending Designer Assignment" : "",
                };
            }

        } else if (stage === 'Negotiation') {
            if (dealOwner) {
                dealData['negotiationDate'] = negotiationDate;
                dealData['momNegotitationStage'] = momNegotiationStage;
                dealData['nextFollowUpDate'] = nextFollowUpDate;
                dealData['leadStatus'] = 'Open'
                dealData['meetingDone'] = meetingDone;
                dealData['meetingType'] = meetingType;
                dealData['meetingDate'] = meetingDate;
                dealData['meetingDoneStage'] = stage;

            } else {
                dealData = {
                    stage: stage,
                    leadId: projectId,
                    negotiationDate: negotiationDate,
                    momNegotitationStage: momNegotiationStage,
                    nextFollowUpDate: nextFollowUpDate,
                    leadStatus: 'Open',
                    meetingDone: meetingDone,
                    meetingType: meetingDone === "Yes" ? meetingType : "",
                    meetingDate: meetingDone === "Yes" ? meetingDate : "",
                    meetingDoneStage: meetingDone === "Yes" ? stage : "",
                };
            }
        } else if (stage === 'Won') {
            if (dealOwner) {
                dealData['closureDate'] = closureDate;
                dealData['remark'] = '';
                dealData['finalQuoteAttached'] = '';
                dealData['clientMoveinDate'] = clientMoveinDate;
                dealData['meetingDone'] = meetingDone;
                dealData['meetingType'] = meetingType;
                dealData['meetingDate'] = meetingDate;
                dealData['meetingDoneStage'] = stage;

            } else {
                dealData = {
                    stage: stage,
                    leadId: projectId,
                    closureDate: closureDate,
                    remark: '',
                    finalQuoteAttached: '',
                    clientMoveinDate: clientMoveinDate,
                    meetingDone: meetingDone,
                    meetingType: meetingDone === "Yes" ? meetingType : "",
                    meetingDate: meetingDone === "Yes" ? meetingDate : "",
                    meetingDoneStage: meetingDone === "Yes" ? stage : "",
                };
            }
        } else if (stage === 'Design Sign-off') {
            dealData['designSignOffDate'] = contractSignStageForm.designSignOffDate;
            dealData['workingDrawingFile'] = contractSignStageForm.wdFile;
            dealData['projectCompletionDate'] = contractSignStageForm.projectCompletionDate;
            dealData['leadStatus'] = 'Open'
        } else if (stage === 'Lost') {
            dealData = {
                ...dealData,
                stage: stage,
                department: department,
                team: team,
                id: dealOwner,
                leadId: projectId,
                leadStatus: 'Lost',
                reasonForLost: lostReason,
                reasonForSalesLost: salesLostReason,
                lostRaiseUser: userDetails?.name || 'NA',
                meetingDone: meetingDone,
                meetingType: meetingDone === "Yes" ? meetingType : "",
                meetingDate: meetingDone === "Yes" ? meetingDate : "",
                meetingDoneStage: meetingDone === "Yes" ? stage : "",
                isLostPostQuotationSend : quotationStatus
            }
            // } else if (stage === 'Final Quotation Approval') {
            //     dealData['quotation_no'] = selectedQuote;
        }
        else if (stage === 'Assign to Designer') {
            // console.log('dealOwner', dealOwner, dealOwnerLists)
            // const user = dealOwnerLists.filter(el => el._id.toString() == dealOwner.toString())
            // console.log('user', user)

            dealData['stage'] = 'Design Kick-Off : Internal'
            dealData['dealOwner'] = dealOwner
            dealData['department'] = department
            if (!projectDetails.erpProjectNo) {
                try {
                    // Project No. is auto-filled from the Unique Lead Number; if it already exists, assignment is blocked
                    const response = await HttpService.changeErpProjectNo(projectDetails?.erpProjectNo, projectDetails?.uniqueLeadNumber, projectDetails?._id, true)
                    if (response.status == 204) {
                        setErpProjectExists(true)
                        setOpenErpExistsDialog(true)
                        props.setSnackInfo("The project no already exist please connect with the tech team", "error")
                        return
                    }
                    else {
                        setErpProjectExists(false)
                    }
                } catch (error) {
                    console.log("error", error)
                }
            }
        }
        else if (stage === 'Design Kick-Off : Customer') {
            dealData['designerAndSalesOwnerMeetingDate'] = designKickOffCustomerForm.salesOwnerMeetingDate;
            dealData['floorPlanReceivedToDesigner'] = designKickOffCustomerForm.floorPlanReceived;
            dealData['designerDiscussedQuotationWithClient'] = designKickOffCustomerForm.quotationDiscussed;
            dealData['designerDiscussedRequirementWithClient'] = designKickOffCustomerForm.requirementDiscussed;
            dealData['dateOfKickOffMeeting'] = designKickOffCustomerForm.dateOfKickOffMeeting;
            dealData['timeOfKickOffMeeting'] = designKickOffCustomerForm.timeOfKickOffMeeting;
        }
        else if (stage === 'Initial Measurement') {
            dealData['intial_measurement_date'] = initialMeasurementForm.intial_measurement_date;
            dealData['intial_measurement_time'] = initialMeasurementForm.intial_measurement_time;
            dealData['dealOwner'] = dealOwner;
        }
        else if (stage === "Finalization of Materials") {
            dealData['materialSelectionDate'] = finalizationOfMaterialForm.materialSelectionDate;
            dealData['materialSelectionTime'] = finalizationOfMaterialForm.materialSelectionTime;
            dealData['acadFileLinkForDesignStages'] = acadFileLink;
            dealData ['skpFileLinkForDesignStages'] = skpFileLink;
            dealData['dealOwner'] = dealOwner;
        }
        else if (stage === "Site QC/Project Kick-Off") {
            dealData['siteQcDate'] = siteQcDateForm.siteQcDate;
            dealData['siteQcTime'] = siteQcDateForm.siteQcTime;
            dealData['acadFileLinkForDesignStages'] = acadFileLink;
            dealData ['skpFileLinkForDesignStages'] = skpFileLink;
            dealData['dealOwner'] = dealOwner;
        }
        else if (stage === "Internal Design Sign-Off") {
            const tokenPercentValue = parseInt(qtVersionGrandTotal) !== 0 ? ((totalAmount / parseInt(qtVersionGrandTotal)) * 100).toFixed(2) : 0;
            dealData['tokenPercent'] = tokenPercentValue;
            dealData['monthlyContractFile'] = monthlyContractFile
            dealData['qtVersion'] = qtVersion
            dealData['designQuotationVersion'] = selectedQuotationVersion
            dealData['qtVersionGrandTotal'] = qtVersionGrandTotal
            dealData['scanQuotationFile'] = contractSignStageForm.scanQuotationFile || quotationPdf
            dealData['quotationCsvFile'] = contractSignStageForm.quotationCsvFile || quotationCsv
            dealData['dealOwner'] = dealOwner;
        }
        else if (stage === "Drawing QC") {
            dealData['dealOwner'] = dealOwner;
            dealData['siteMaskingDocumentsLink'] = siteMaskingDocumentsLink;
            dealData['twoDDrawingsFileLink'] = twoDDrawingsFileLink;
            dealData['sitePhotosVideosFileLink'] = sitePhotosVideosFileLink;
            dealData['appliancesChecklistFileLink'] = appliancesChecklistFileLink;
            dealData['powerPointFileLink'] = powerPointFileLink;
            dealData['quotationFileLink'] = quotationFileLink;
            dealData['qcStages'] = qcStages;
            dealData['qcRemarks'] = qcRemarks;
            dealData['drawingQtValue'] = drawingQtValue;
        }   
        else if (userDetails.roles.find(role => role.name === ROLENAME.DesignUser || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DGM_Design )) {
            dealData = {
                ...dealData,
                department: userDetails.departmentId,
                department: department,
                team: team,
                dealOwner: dealOwner,
                acadFileLinkForDesignStages: acadFileLink,
                skpFileLinkForDesignStages: skpFileLink
            }
        } else {
            // console.log(dealOwnerLists, "dealOwnerLists")
            dealData = {
                ...dealData,
                stage: stage,
                department: department,
                team: team,
                dealOwner: dealOwner,
                leadId: projectId,
                leadStatus: projectDetails.leadStatus === 'Won' ? 'Won' : 'Open'
            }
        }

        for (let b = 0; b < dealOwnerLists.length; b++) {
            if (dealOwnerLists[b]._id === dealOwner) {
                if (userDetails.roles.find(role => role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager)) {
                    dealData = {
                        ...dealData,
                        department: userDetails.departmentId,
                        // city: dealOwnerLists[b].locationId[0]._id,
                        // experienceCenterId: dealOwnerLists[b].experienceCenterId[0]._id,
                    }
                    break;
                } else {
                    dealData = {
                        ...dealData,
                        id: dealOwner
                        // city: dealOwnerLists[b].locationId[0]._id,
                        // experienceCenterId: dealOwnerLists[b].experienceCenterId[0]._id,
                    }
                }
            }
        }
        if (
            (userDetails.roles.find(
                role =>
                    role.name === ROLENAME.DesignUser ||
                    role.name === ROLENAME.OperationDesignManager ||
                    role.name === ROLENAME.AssistantDesignManager ||
                    role.name === ROLENAME.DGM_Design
            ) &&
            (dealData.skpFileLinkForDesignStages === "" || dealData.acadFileLinkForDesignStages === "")  &&
            !(stage === "Assign to Designer" || stage === "Initial Measurement"))
        ) {
            props.setLoading(false)
            return props.setSnackInfo("Please upload ACAD/SKP file", "error");
        }
        if (
            (userDetails.roles.find(
                role =>
                    role.name === ROLENAME.DesignUser ||
                    role.name === ROLENAME.OperationDesignManager ||
                    role.name === ROLENAME.AssistantDesignManager ||
                    role.name === ROLENAME.DGM_Design
            ) &&
                !(stage === "Assign to Designer" || stage === "Initial Measurement")) &&
                (
                    projectDetails.acadSkpFileStatus &&
                    projectDetails.acadSkpFileStatus !== "Approved" &&
                    projectDetails.acadSkpFileStatus !== "Rejected"
            )
        ) {
            props.setLoading(false)
            return props.setSnackInfo("Previous Stage ACAD/SKP not approved yet", "error");
        }
        if (projectDetails.acadSkpFileStatus === "Rejected" && (projectDetails.currentStage !== stage)) {
            props.setLoading(false)
            return props.setSnackInfo("Previous Stage ACAD/SKP not approved yet", "error");
        }
        try {
            if (stage === 'Lost') {
                props.setLoading(true)
                const lostPayload = {
                    remark: lostReason || salesLostReason,
                    reasonForSalesLost: salesLostReason,
                    status: "Lost",
                    salesToken: projectDetails?.salesToken || 0,
                    raiseRefundLostUser: userDetails?._id,
                    meetingNotDone: meetingDone === "No",
                    meetingStage: projectDetails?.currentStage || stage,
                    meetingDate: meetingDone === "Yes" ? meetingDate : null,
                    meetingType: meetingDone === "Yes" ? meetingType : "",
                    refundRequired: refundRequired === "Yes",
                    refundAmount: refundRequired === "Yes" ? Number(refundAmount) : 0
                };
                await HttpService.moveRefundLeadLost(lostPayload, projectId);
                setOpenAnotherDialog(false);
                setOpen(false)
                setSelectedStage('');
                setSelectedDepartment('');
                setSelectedTeam('');
                setSelectedDealOwner('');
                setLostReason('');
                setSalesLostReason('');
                setRefundRequired('');
                setRefundAmount('');
                setMeetingType('');
                setMeetingDate(null);
                setMeetingDone('');
                getProjectLogs();
                getcustomerDetails();
                props.setSnackInfo("Sent for Lost Approval", "success");
                props.setLoading(false)
                return;
            }
            props.setLoading(true)
            const assignProject = await HttpService.assignProject(dealData);
            if (assignProject.status === 200 && dealData.stage !== 'Lost') {
                setOpenAnotherDialog(false);
                setOpen(false)
                setSelectedStage('');
                setSelectedDepartment('');
                setHandleNextFollowUpDate('')
                setSelectedTeam('');
                setSelectedDealOwner('');
                getProjectLogs();
                getcustomerDetails();
                setAcadFileLink('');
                setSkpFileLink('');
                setSkpFile(false);
                setDwgFile(false);
                setSelectedQuotationVersion("");
                setQtVersion("");
                setQtVersionGrandTotal(0);
                setCheckIsUpload({
                    scanQuotationFile: false,
                    quotationCsvFile: false
                });
                setSiteMaskingDocumentsLink([]);
                setTwoDDrawingsFileLink([]);
                setSitePhotosVideosFileLink([]);
                setAppliancesChecklistFileLink([]);
                setPowerPointFileLink([]);
                setQuotationFileLink([]);
                
                setSiteMaskingDocuments(false);
                setTwoDDrawingsFile(false);
                setSitePhotosVideosFile(false);
                setAppliancesChecklistFile(false);
                setPowerPointFile(false);
                setQuotationFile(false);
                // getCustomerProjectDetail(projectId);
                props.setSnackInfo(
                    assignProject?.data?.pendingDsoApproval
                        ? (assignProject.data.message || 'Assigned to Naren for 30% variation approval')
                        : 'Project assigned Successful',
                    'success'
                )
            } 
            else{
                setAcadFileLink('');
                setSkpFileLink('');
                setSkpFile(false);
                setDwgFile(false);
                setOpenAnotherDialog(false);
                setOpen(false)
                setSelectedStage('');
                setSelectedDepartment('');
                setHandleNextFollowUpDate('')
                setSelectedTeam('');
                setSelectedDealOwner('');
                getProjectLogs();
                getcustomerDetails();
                setSelectedQuotationVersion("");
                setQtVersion("");
                setQtVersionGrandTotal(0);
                setCheckIsUpload({
                    scanQuotationFile: false,
                    quotationCsvFile: false
                });
                setSiteMaskingDocumentsLink([]);
                setTwoDDrawingsFileLink([]);
                setSitePhotosVideosFileLink([]);
                setAppliancesChecklistFileLink([]);
                setPowerPointFileLink([]);
                setQuotationFileLink([]);
                
                setSiteMaskingDocuments(false);
                setTwoDDrawingsFile(false);
                setSitePhotosVideosFile(false);
                setAppliancesChecklistFile(false);
                setPowerPointFile(false);
                setQuotationFile(false);
                props.setSnackInfo("Sent for Lost Approval", "success")
            }
        } catch (error) {
            const errData = error?.response?.data;
            props.setSnackInfo(
                typeof errData === 'string'
                    ? errData
                    : (errData?.message || errData?.error || error?.message || 'Something Went Wrong'),
                'error'
            )
        }
        // window.location.reload(true);
        setReRender(!reRender)
        props.setLoading(false)
    }

    // Unified Lost + Refund submission (Move Deal -> Lost)
    const handleUnifiedLostFromMoveDeal = async () => {
        props.setLoading(true);
        try {
               // If refund is required, submit bank details first
            // if (unifiedWantsRefund === 'yes') {
            //     // Wait a bit to ensure everything is ready
            //     await new Promise(resolve => setTimeout(resolve, 100));
                
            //     // Check if form is valid
            //     if (!bankDetailsValid) {
            //         props.setSnackInfo("Please fill all bank details correctly", "warning");
            //         props.setLoading(false);
            //         return;
            //     }
                
            //     // Check if ref exists
            //     if (!bankDetailsRef) {
            //         props.setSnackInfo("Bank details form not loaded. Please try again.", "error");
            //         props.setLoading(false);
            //         return;
            //     }
                
            //     // Check if submitBankDetails method exists
            //     if (typeof bankDetailsRef.submitBankDetails !== 'function') {
            //         props.setSnackInfo("Bank details form methods not available. Please refresh and try again.", "error");
            //         props.setLoading(false);
            //         return;
            //     }
                
            //     const bankResult = await bankDetailsRef.submitBankDetails();
              
            //     if (!bankResult?.success) {
            //         props.setSnackInfo(bankResult?.message || "Failed to submit bank details", "error");
            //         props.setLoading(false);
            //         return;
            //     }
                
            //     props.setSnackInfo("Bank details submitted successfully", "success");
            // }
            const isSalesDept = userDetails?.departmentId === constantDepartmentId.sales;
            const obj = {
                needsRefund: unifiedWantsRefund === 'yes',
                refundAmount: unifiedWantsRefund === 'yes' ? parseFloat(unifiedRefundAmount) : 0,
                reasonForLost: isSalesDept ? salesLostReason : lostReason,
                reasonForSalesLost: salesLostReason,
                remarks: unifiedLostRemarks,
                department: isSalesDept ? 'Sales' : 'Design',
                salesToken: projectDetails?.salesToken || 0
            };

            if (obj.department === 'Sales') {
                obj.meetingDetails = {
                    meetingNotDone: meetingDone === 'No',
                    meetingType: meetingType,
                    meetingDate: meetingDate,
                    meetingStage: stage
                };
            }

            await HttpService.moveLeadToLostUnified(projectId, obj);

            props.setSnackInfo(
                obj.needsRefund
                    ? 'Lead moved to Lost with refund request sent for approval'
                    : 'Lead moved to Lost sent for approval',
                'success'
            );

            // Reset and refresh
            setOpenAnotherDialog(false);
            setOpen(false);
            setUnifiedWantsRefund(null);
            setUnifiedRefundAmount(0);
            setUnifiedLostRemarks('');
            getProjectLogs();
            getcustomerDetails();
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.error || 'Something Went Wrong', 'error');
        }
        props.setLoading(false);
    };

    const [openNoDialog, setOpenNoDialog] = useState(false);
    const [newsalesWonDate, setNewsalesWonDate] = useState("");

      const resendKickOffApprovalEmail = async () => {
    try {
      setLoadingState(true);
      props.setLoading(true);

      await HttpService?.resendKickOffApprovalEmail({
        projectId: projectDetails?._id,
        salesUserEmail: projectDetails?.salesUser?.email,
      });
      props.setSnackInfo("Successfully mail sent", "success");
      setKickOffApprovalResendModal(false);
      props.setLoading(false);
    } catch (error) {
        setLoadingState(false);
        props.setLoading(false);
    }
  };


    const setSalesWonDate = async () => {
        setClicked(true); 
        try {

            let salesWonManager = "";


            if (userDetails.roles.find(role => role.name == "Sales Manager" || role.name === 'Assistant Sales Manager')) {
                salesWonManager = userDetails._id
            }
            else {
                salesWonManager = userDetails.teamId.manager ? userDetails.teamId.manager : userDetails.assistantManagerId
            }

            let obj = {
                salesStage: 'Won Deals Pending Designer Assignment',
                currentStage: 'Won Deals Pending Designer Assignment',
                leadWonDate: newsalesWonDate,
                salesWonUser: userDetails._id,
                salesWonManager: salesWonManager,
                salesPaymentProofAtachement: newPaymentSlip,
                paymentDone: totalAmount,
                finanaceManagerApproved: [{
                    isApproved: false,
                    status: 'Send for Approval',
                }],
                reinitiateProcess: "Send for Approval",
                salesWonExpCtrId: projectDetails?.experienceCenterId?._id
            }
            if (userDetails.roles.find(role => role.name === "Sales User")) {
                obj = {
                    ...obj,
                    salesUser: userDetails?._id,
                    salesAssistantManager: userDetails?.assistantManagerId,
                    salesManager: userDetails?.teamId?.manager?._id,
                    salesAGM: userDetails?.teamId?.teamAGM?._id,
                    salesDGM: userDetails?.teamId?.teamDGM?._id
                }
            } else if (userDetails.roles.find(role => role.name === "Assistant Sales Manager")) {
                obj = {
                    ...obj,
                    salesUser: null,
                    salesAssistantManager: userDetails?._id,
                    salesManager: userDetails?.teamId?.manager?._id,
                    salesAGM: userDetails?.teamId?.teamAGM?._id,
                    salesDGM: userDetails?.teamId?.teamDGM?._id
                }
            } else if (userDetails.roles.find(role => role.name === "Sales Manager")) {
                obj = {
                    ...obj,
                    salesUser: null,
                    salesAssistantManager: null,
                    salesManager: userDetails?._id,
                    salesAGM: userDetails?.teamId?.teamAGM?._id,
                    salesDGM: userDetails?.teamId?.teamDGM?._id
                }
            }
            const response = await HttpService.leadWonRejection(projectId, obj)
            props.setSnackInfo(response?.data ?? "Something went wrong", "success")
            setOpenNoDialog(false)
            getcustomerDetails();
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }

    }

    const updateClosureStatus = async (statusAct) => {
        if (statusAct === 'Yes') {
            let dealData = {}
            if (meetingDone === "Yes") {
                dealData = {
                    leadId: projectId,
                    meetingDone: meetingDone,
                    meetingType: meetingDone === "Yes" ? meetingType : "",
                    meetingDate: meetingDone === "Yes" ? meetingDate : "",
                    meetingDoneStage: meetingDone === "Yes" ? stage : "",
                }
                try {
                    await HttpService.leadUpdateMeeting(dealData);
                } catch (error) {
                    props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
                }
            }
            setOpenAnotherDialog(false)
            history.push({
                pathname: '/check-lists',
                state: {
                    actionCheck: statusAct,
                    leadId: projectId
                }
            })
        } else if (statusAct === 'No') {
            let dealData = {}
            if (meetingDone === "Yes") {
                dealData = {
                    leadId: projectId,
                    meetingDone: meetingDone,
                    meetingType: meetingDone === "Yes" ? meetingType : "",
                    meetingDate: meetingDone === "Yes" ? meetingDate : "",
                    meetingDoneStage: meetingDone === "Yes" ? "Won Deals Pending Designer Assignment" : "",
                }
                try {
                    await HttpService.leadUpdateMeeting(dealData);
                } catch (error) {
                    props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
                }
            }
            setOpenAnotherDialog(false)
            props.setLoading(true)
            try {
                setOpenStatusModal(false);
                setOpenNoDialog(true)
            } catch (error) {

            }
            props.setLoading(false)
        }
    }

    const navigateToVerifyPage = () => {
        props.history.push(`/verify-documents/${projectId}`);
    }

    const viewCheckList = () => {
        props.history.push(`/view-customer-checklist/${projectId}`);
    }
    const [openClientModel, setOpenClientModel] = useState(false);
    const [clientDelay, setClientDelay] = useState(0);
    const [openDesignerAssignmentDate, setOpenDesignerAssignmentDate] = useState(false)
    const [designManagerData, setDesignManager] = useState([]);
    // const [openGenerateLinkPopUp, setOpenGenerateLinkPopUp] = useState(false);
    const getDesignUsers = async () => {
        props.setLoading(true)
        try {
            const response = await HttpService.getDesignUserByTeam(userDetails.teamId._id)
            let designUser = [];
            let designManager = [];
            for (let i = 0; i < response.data.length; i++) {
                for (let j = 0; j < response.data[i].roles.length; j++) {
                    if (response.data[i].roles[j].name === ROLENAME.OperationDesignManager) {
                        designManager.push({
                            name: response.data[i].name,
                            email: response.data[i].email,
                            mobile: response.data[i].mobile,
                            _id: response.data[i]._id
                        })
                    }
                }
            }
            setDesignManager(designManager)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const [designerAssignmentDate, setDesignerAssignmentDate] = useState(new Date());
    const updateDesignerAssignmentDate = async () => {
        // Setting the obj to set the design user, design manager and design assignment date
        let obj = {
            designManager: {
                name: designManagerData[0].name,
                email: designManagerData[0].email,
                mobile: designManagerData[0].mobile,
            },
            designerAssignmentDate: designerAssignmentDate,
            customerEmailId: projectDetails?.customerId?.email,
            customerName: projectDetails?.customerId?.name
        }

        props.setLoading(true)
        try {
            const response = await HttpService.updateDesignerAssignementDetail(projectId, obj)
            props.setSnackInfo(response?.data ?? "Mail send to customer successfully", "success")
            setOpenDesignerAssignmentDate(false);
            getProjectLogs();
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const [openUpdatePaymentModel, setOpenUpdatePaymentModel] = useState(false)
    const [paymentUpdateForm, setPaymentUpdateForm] = useState({
        paymentAmount: '',
        paymentAttachement: '',
        note: ''
    });
    const updateCustomerPayment = async () => {
        let obj = {
            amount: paymentUpdateForm.paymentAmount,
            paymentAttachement: paymentUpdateForm.paymentAttachement,
            note: paymentUpdateForm.note,
            lead_no: projectDetails.lead_no,
        }
        props.setLoading(true)
        try {
            const response = await HttpService.updateCustomerPaymentAndSendToFinance(projectId, obj)
            props.setSnackInfo(response?.data ?? "Payment updated successfully", "success")
            setOpenUpdatePaymentModel(false);
            getProjectLogs();
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const handleChangeProjectNo = async (v) => {
        props.setLoading(true)
        try {
            const response = await HttpService.changeErpProjectNo(projectDetails?.erpProjectNo, newErpProjectNo, projectDetails?._id)

            if (response.status == 204) {
                setOpenErpProjectNoModal(false)
                props.setLoading(false)
                props.setSnackInfo("This Number is already being used for ERP Project.", "error")
            }
            else {
                setOpenErpProjectNoModal(false)
                props.setLoading(false)
                props.setSnackInfo("Current Project No. is Updated Now!", "success")
                // window.location.reload()
                setReRender(!reRender)
            }
        } catch (error) {
            console.log("error", error)
        }
        props.setLoading(false)
    }

     // ocr extraction function..
    const handleUploadAndExtract = async () => {
        if (!OCRState.image) {
            props.setSnackInfo("Please upload an image(Only .png, .jpg, .jpeg are accepted)", "warning");
            return;
        }
        const formData = new FormData();
        formData.append("file", OCRState.image);

        try {
            setOCRState((prevState) => ({ ...prevState, processing: true }));
            setLoading(true);

            // Upload to S3....
            const s3Res = await HttpService.uploadFile(formData);
            const s3Url = s3Res?.data ||  s3Res?.data?.url  ;

            //  Send only the URL to GPT OCR API
            const ocrRes = await HttpService.OcrUploaderToOpenAI({
                imageUrl: s3Url,
                canEditDate 
            });
            const data = ocrRes.data?.data || {};

            const approved = data?.approved === "YES";
            const reason = data?.reason || "Something Went Wrong";
            const approvalDate = data.date || null;
            const key = data?.key || "null"

            const parsed = normalizeOcrDate(approvalDate);

            if (!parsed.ok) {
                // props.setSnackInfo(parsed.error, "error");
                setDesignSignOff(""); 
            } else if (approved) {
                // Success case 
                setDesignSignOff(parsed.value); 
                props.setSnackInfo("OCR processing successfully completed", "success");
            } else {
                // Not approved
                props.setSnackInfo(reason, "error");
                setDesignSignOff("");
            }

            setOCRState((prev) => ({
                ...prev,
                s3Url,
                ocrText: JSON.stringify(data, null, 2),
                processing: false,
                approved,
                approvalDate: parsed.ok ? parsed.value : approvalDate,
                reason,
                key
            }));

        } catch (err) {
            console.error(err);
            props.setSnackInfo(err?.message || "OCR failed", "error");
            setOCRState((prev) => ({ ...prev, processing: false }));
        } finally {
            setLoading(false);
        }
    };
    // Retry OCR with the same image URL
    const handleRetryOCR = async () => {
        if (OCRState.retryCount >= 3) {
        props.setSnackInfo("Retry limit reached (max 3 times)", "warning");
        return;
    }
        if (!OCRState?.s3Url) {
            props.setSnackInfo("No image available to retry OCR", "warning");
            return;
        }

        try {
            setOCRState((prev) => ({ ...prev, processing: true , retryCount: prev.retryCount + 1 }));
            setLoading(true);

            const ocrRes = await HttpService.OcrUploaderToOpenAI({
                imageUrl: OCRState.s3Url,
                canEditDate
            });

            const data = ocrRes.data?.data || {};

            const approved = data?.approved === "YES";
            const reason = data?.reason || "Something Went Wrong";
            const approvalDate = data?.date || null;
            const key = data?.data || "ok"

            const parsed = normalizeOcrDate(approvalDate);

            if (!parsed.ok) {
                setDesignSignOff("");
            } else if (approved) {
                setDesignSignOff(parsed.value);
                props.setSnackInfo("OCR processing successfully completed", "success");
            } else {
                props.setSnackInfo(reason, "error");
                setDesignSignOff("");
            }

            setOCRState((prev) => ({
                ...prev,
                ocrText: JSON.stringify(data, null, 2),
                processing: false,
                approved,
                approvalDate: parsed.ok ? parsed.value : approvalDate,
                reason,
                key
                
            }));

        } catch (err) {
            console.error(err);
            props.setSnackInfo(err?.message || "OCR retry failed", "error");
            setOCRState((prev) => ({ ...prev, processing: false }));
        } finally {
            setLoading(false);
        }
    };
     const handleDesignSignOffDate = async (v) => {
        setOpenDesignSignOffModal(false)
        props.setLoading(true)
        let obj = {
            // freezeDate: designSignOff,
            freezeDate: OCRState.approvalDate,
            remarks: remarks,
            // don't remove this as decorassit has a single instance so commented flow from test
            signOffProofUrl: OCRState?.s3Url || "" ,
            key : OCRState.key || "",
            isEditingDate: isEditingDate,
        }
        try {
            const response = await HttpService.updateExpectedDesignSignOffDate(obj, projectId)
            setOpenDesignSignOffModal(false)
            props.setLoading(false)
            if (response.status === 200) {
                props.setSnackInfo(response.data.message)
            }
            // window.location.reload()
            setReRender(!reRender)
            setDesignSignOff("");
            setRemarks("");
        }
        catch (error) {
            console.log("error", error)
            props.setLoading(false);
            props.setSnackInfo(
            error.response?.data?.message || "Failed to update  expected design sign-off date", 
            "error");
        }
        finally{
            props.setLoading(false);
        }
    }

    // AI-based design sign-off date extraction — replaces OCR image upload.
    // The backend picks the LATEST conversation on the lead, whoever made it (latest Runo
    // call, or a newer note with an audio recording) and forwards only that one
    // to the transcript AI service for date extraction.
    // Shows AI_NO_LEAD_CONVERSATION_MSG if there is neither.
    // Phase 1: Find the latest conversation (Runo call, or a newer note audio) and show pre-analysis popup
    const handleAIDesignSignoffDate = async () => {
        setIsEditingDate(false);
        setAiSignoffState({
            loading: true, dialogOpen: true, phase: 'preCheck',
            recordingCount: 0, transcriptCount: 0, withoutTranscriptCount: 0,
            designerName: '', latestRecording: null, result: null, error: null, noConversation: false,
            hasConversation: false, latestConversation: null, analysisFailed: false, preCheckError: null,
        });
        try {
            const response = await HttpService.getCallRecordings(projectId, 'lead');
            const data = response?.data;
            const conversation = getAiConversationPreCheck(data);
            setAiSignoffState({
                loading: false, dialogOpen: true, phase: 'preCheck',
                recordingCount: data?.recordingCount || 0,
                transcriptCount: data?.transcriptCount || 0,
                withoutTranscriptCount: data?.withoutTranscriptCount || 0,
                designerName: data?.designerName || 'Unknown Designer',
                latestRecording: data?.latestRecording || null,
                result: null, error: null,
                noConversation: conversation.noConversation,
                hasConversation: conversation.hasConversation,
                latestConversation: conversation.latestConversation,
                analysisFailed: false, preCheckError: null,
            });
        } catch (err) {
            console.error('Failed to check conversations for sign-off date:', err);
            setAiSignoffState(prev => ({
                ...prev, loading: false, noConversation: false, hasConversation: false, preCheckError: AI_PRECHECK_FAILED_MSG,
            }));
        }
    };

    // Phase 2: Send the latest conversation for AI analysis (after user confirms in popup)
    const handleConfirmSignoffAnalysis = async () => {
        setAiSignoffState(prev => ({ ...prev, loading: true, phase: 'analysis', result: null, error: null, analysisFailed: false }));
        try {
            const response = await HttpService.extractDesignSignoffDate(projectId);
            const resData = response?.data;

            if (resData?.noConversation) {
                setAiSignoffState(prev => ({
                    ...prev, loading: false, result: null, error: null,
                    noConversation: true, hasConversation: false, designerName: resData.designerName || 'Unknown Designer',
                }));
                return;
            }

            const conversationLabel = getAiConversationLabel(resData?.analysedConversation || aiSignoffState.latestConversation);
            if (isAiConversationAnalysisFailed(resData)) {
                // Fail closed: no date, no Proceed, no fallback to an older conversation
                setAiSignoffState(prev => ({
                    ...prev, loading: false, result: null, analysisFailed: true,
                    error: getAiAnalysisFailedMessage(resData),
                }));
                try {
                    await HttpService.addAiDealActivity(
                        projectId,
                        `AI Sign-off Date Analysis${conversationLabel}: FAILED — latest conversation / audio file not supported`
                    );
                    getProjectLogs();
                } catch (logErr) {
                    console.error('Failed to log AI signoff failure:', logErr);
                }
                return;
            }

            const data = resData?.data;
            if (data) {
                setAiSignoffState(prev => ({
                    ...prev, loading: false, result: data, error: null,
                    noConversation: false, designerName: resData.designerName || '',
                }));
                if (data.date_found && data.extracted_date) {
                    setOCRState((prev) => ({
                        ...prev,
                        approvalDate: data.extracted_date,
                        approved: true,
                        s3Url: '',
                        key: '',
                    }));
                }
                // Log to deal activity
                try {
                    await HttpService.addAiDealActivity(
                        projectId,
                        `AI Sign-off Date Analysis${conversationLabel}: ${data.date_found ? 'Date Found (' + data.extracted_date + ')' : 'No Date Found'} — ${data.reason || ''}`
                    );
                    getProjectLogs();
                } catch (logErr) {
                    console.error('Failed to log AI signoff analysis:', logErr);
                }
            } else {
                setAiSignoffState(prev => ({
                    ...prev, loading: false, result: null,
                    error: 'No response from AI service',
                }));
            }
        } catch (err) {
            console.error('AI design sign-off date extraction failed:', err);
            const errData = err?.response?.data;
            if (errData?.noConversation || errData?.errorCode === 'NO_CONVERSATION') {
                setAiSignoffState(prev => ({
                    ...prev, loading: false, result: null, error: null,
                    noConversation: true, hasConversation: false, designerName: errData.designerName || prev.designerName,
                }));
                return;
            }
            const analysisFailed = isAiConversationAnalysisFailed(errData);
            const errMsg = analysisFailed
                ? getAiAnalysisFailedMessage(errData)
                : (errData?.message || 'AI service unavailable. Please try again.');
            setAiSignoffState(prev => ({
                ...prev, loading: false, result: null, analysisFailed,
                error: errMsg,
            }));
            // Log failure to deal activity
            try {
                await HttpService.addAiDealActivity(
                    projectId,
                    `AI Sign-off Date Analysis${getAiConversationLabel(errData?.analysedConversation || aiSignoffState.latestConversation)}: FAILED — ${analysisFailed ? 'latest conversation / audio file not supported' : errMsg}`
                );
                getProjectLogs();
            } catch (logErr) {
                console.error('Failed to log AI signoff failure:', logErr);
            }
        }
    };

    // Design Hold: Phase 1 — Find the latest conversation on the lead, whoever made it
    // (Runo call, or a newer note audio) before submitting hold
    const handleDesignHoldPreCheck = async () => {
        setDesignHoldPreCheck({
            loading: true, dialogOpen: true, phase: 'preCheck', noConversation: false,
            recordingCount: 0, transcriptCount: 0, withoutTranscriptCount: 0, designerName: '',
            latestRecording: null, result: null, error: null,
            hasConversation: false, latestConversation: null, analysisFailed: false, preCheckError: null,
        });
        try {
            const response = await HttpService.getCallRecordings(projectId, 'lead');
            const data = response?.data;
            const recCount = data?.recordingCount || 0;
            const conversation = getAiConversationPreCheck(data);
            setDesignHoldPreCheck({
                loading: false, dialogOpen: true, phase: 'preCheck',
                noConversation: conversation.noConversation,
                recordingCount: recCount,
                transcriptCount: data?.transcriptCount || 0,
                withoutTranscriptCount: data?.withoutTranscriptCount || 0,
                designerName: data?.designerName || 'Unknown Designer',
                latestRecording: data?.latestRecording || null,
                result: null, error: null,
                hasConversation: conversation.hasConversation,
                latestConversation: conversation.latestConversation,
                analysisFailed: false, preCheckError: null,
            });
        } catch (err) {
            console.error('Failed to check conversations for design hold:', err);
            setDesignHoldPreCheck(prev => ({
                ...prev, loading: false, phase: 'preCheck', noConversation: false, hasConversation: false, preCheckError: AI_PRECHECK_FAILED_MSG,
            }));
        }
    };

    // Design Hold: Phase 2 — Run AI verification of the latest conversation within dialog
    const handleDesignHoldConfirmAndSubmit = async () => {
        setDesignHoldPreCheck(prev => ({ ...prev, loading: true, phase: 'analysis', result: null, error: null, analysisFailed: false }));
        try {
            const verifyResponse = await HttpService.verifyDesignHold({
                holdReason: designHoldSelectedTypes,
                remarks: leadDesignHoldReason,
                proposedRestartDate: proposedDesignStartDate,
                tentativeClosureDate: probableDesignSignOffDate,
            }, projectId);
            const resData = verifyResponse?.data;
            const conversationLabel = getAiConversationLabel(resData?.analysedConversation || designHoldPreCheck.latestConversation);
            if (isAiConversationAnalysisFailed(resData)) {
                // Fail closed: hold is not approvable, no fallback to an older conversation
                setDesignHoldAIResult(null);
                try {
                    await HttpService.addAiDealActivity(
                        projectId,
                        `AI Design Hold Analysis${conversationLabel}: FAILED — latest conversation / audio file not supported`
                    );
                    getProjectLogs();
                } catch (logErr) {
                    console.error('Failed to log AI design hold failure:', logErr);
                }
                setDesignHoldPreCheck(prev => ({
                    ...prev, loading: false, phase: 'result', result: null, analysisFailed: true,
                    error: getAiAnalysisFailedMessage(resData),
                }));
                return;
            }
            const aiResult = resData?.data;
            setDesignHoldAIResult(aiResult);

            // Log to deal activity
            try {
                await HttpService.addAiDealActivity(
                    projectId,
                    `AI Design Hold Analysis${conversationLabel}: ${aiResult?.approved ? 'APPROVED ✓' : 'REJECTED ✗'} — ${aiResult?.reason || 'No reason provided'}${aiResult?.suggestion ? ' | Suggestion: ' + aiResult.suggestion : ''}`
                );
                getProjectLogs();
            } catch (logErr) {
                console.error('Failed to log AI design hold analysis:', logErr);
            }

            setDesignHoldPreCheck(prev => ({
                ...prev,
                loading: false,
                phase: 'result',
                result: aiResult,
                error: null,
            }));
        } catch (verifyErr) {
            console.error('Design hold verification failed:', verifyErr);
            const errData = verifyErr?.response?.data;
            setDesignHoldAIResult(null);
            if (errData?.noConversation || errData?.errorCode === 'NO_CONVERSATION') {
                // No Runo call / note audio on the lead — back to the blocked pre-check view
                setDesignHoldPreCheck(prev => ({
                    ...prev, loading: false, phase: 'preCheck', result: null, error: null,
                    noConversation: true, hasConversation: false, latestConversation: null,
                    designerName: errData.designerName || prev.designerName,
                }));
                return;
            }
            const analysisFailed = isAiConversationAnalysisFailed(errData);
            const errMsg = analysisFailed
                ? getAiAnalysisFailedMessage(errData)
                : (errData?.message || 'Design hold verification failed. Please try again.');

            // Log failure to deal activity
            try {
                await HttpService.addAiDealActivity(
                    projectId,
                    `AI Design Hold Analysis${getAiConversationLabel(errData?.analysedConversation || designHoldPreCheck.latestConversation)}: FAILED — ${analysisFailed ? 'latest conversation / audio file not supported' : errMsg}`
                );
                getProjectLogs();
            } catch (logErr) {
                console.error('Failed to log AI design hold failure:', logErr);
            }

            setDesignHoldPreCheck(prev => ({
                ...prev,
                loading: false,
                phase: 'result',
                result: null,
                analysisFailed,
                error: errMsg,
            }));
        }
    };

    // Design Hold: Phase 3 — User clicks Proceed after AI approval
    // Calls the submit directly, same as the sign-off Proceed: this render's
    // updateLeadStatus already holds the reason, remarks and dates the AI verified,
    // so the server sends the hold straight to the customer for approval (no ODM step).
    const handleDesignHoldProceedAfterApproval = () => {
        // Ignore a second click while the popup is fading out
        if (!designHoldPreCheck.dialogOpen || !designHoldPreCheck.result?.approved) return;
        setDesignHoldPreCheck(prev => ({ ...prev, dialogOpen: false }));
        updateLeadStatus({ skipDesignHoldPreCheck: true });
    };

    // Design Hold: Close pre-check popup without proceeding
    const handleDesignHoldPreCheckClose = () => {
        setDesignHoldPreCheck(prev => ({ ...prev, dialogOpen: false, phase: 'preCheck', result: null, error: null }));
    };

    // const handleRevisedProjectedDesignSignOffDate = async (v) => {
    //     props.setLoading(true)
    //     let obj = {
    //         revisedProjectedDesignSignOffDate: revisedProjectedDesignSignOffDate
    //     }
    //     try {
    //         const response = await HttpService.updateRevisedProjectedDesignSignOffDate(obj, projectId)
    //         setRevisedDateModal(false)
    //         props.setLoading(false)
    //         props.setSnackInfo("Date is updated")
    //     }
    //     catch (error) {
    //         console.log("error", error)
    //     }
    //     props.setLoading(false)
    // }

    const handleFileSelection = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setMonthlyContractFile(file);
            setUploadSuccess(true);
            props.setLoading(true);

            const fd = new FormData();
            fd.append('file', file);
            fd.append('customerName', `${projectDetails?.lead_no}_${projectDetails?.customerId.name}`);

            try {
                const fileUploadRes = await HttpService.uploadFile(fd);
                setMonthlyContractFile(fileUploadRes.data)
                props.setSnackInfo("File Uploaded Successfully", "success");
                props.setLoading(false)
            } catch (error) {
                console.error("File upload failed:", error);
                props.setSnackInfo("File Upload Failed", "error");
            }
        } else {
            console.error("No file selected.");
        }
    };

    // const handlePaymentAttachment = async (file) => {
    //     if (file) {
    //         props.setLoading(true);

    //         const fd = new FormData();
    //         fd.append('file', file);
    //         fd.append('customerName', `${projectDetails?.lead_no}_${projectDetails?.customerId.name}`);

    //         try {
    //             const fileUploadRes = await HttpService.uploadFile(fd);

    //             setUploadPaymentProof(file);
    //             // setUploadSuccess(true);
    //             let obj = {
    //                 paymentAttachment: fileUploadRes.data
    //             };

    //             const response = await HttpService.uploadPaymentAttachment(obj, projectId);
    //             props.setSnackInfo("File Uploaded Successfully", "success");
    //             props.setLoading(false)
    //             setUploadModal(false)
    //         } catch (error) {
    //             console.error("File upload failed:", error);
    //             props.setSnackInfo("File Upload Failed", "error");
    //         }
    //     } else {
    //         console.error("No file selected.");
    //     }
    // };

    const salesClosureDateHandler = (e) => {
        setExpectedSalesClosureDate(e.target.value);
    }
    const handleEnterSalesClosureDate = async () => {
        props.setLoading(true);

        let obj = {
            expectedSalesclosureDate: expectedSalesclosureDate,
        };

        try {
            const response = await HttpService.updateExpectedSalesClosureDate(obj, projectId);
            setOpenEnterSalesClosureDateModal(false);
            props.setSnackInfo("Date is updated");
            // Instead of directly reloading, you might want to update your state or perform a more controlled navigation.
            // window.location.reload();
        } catch (error) {
            console.error("Error updating date:", error);
            props.setSnackInfo("Failed to update date. Please try again.");
        } finally {
            props.setLoading(false);
        }
        getProjectLogs();
        getcustomerDetails();
    };

    const clientExtraDays = () => {
        setOpenClientModel(true)
    }

    const clientDelayfunc = async () => {
        try {
            const response = await HttpService.extraDaysDuetoClientDependency(projectId, clientDelay)
            props.setSnackInfo("Updated Successfully", "success")
            setOpenClientModel(false)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }
    const [newModals, setNewModal] = useState(false);
    const [paymentProof, setpaymentProof] = useState([])

    const paymentData = async () => {
        try {
            setNewModal(true)
            const response = await HttpService.finalPaymentApprovedByFm(projectId)
            setpaymentProof(response.data)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const [alertShown, setAlertShown] = useState(false);

    const [designKickOffCustomerDialog, setDesignKickOffCustomerDialog] = useState(false)

    const isDisabled = contractSignStageForm.designSignOffDate > contractSignStageForm.projectCompletionDate;

    if (isDisabled && !alertShown) {
        setContractSignStageForm(prevState => ({
            ...prevState,
            designSignOffDate: contractSignStageForm.designSignOffDate === null,
            projectCompletionDate: contractSignStageForm.projectCompletionDate === null,
        }));
        props.setSnackInfo("Design Sign-Off date cannot be earlier than the Expected Completion Date!", "error")
    }

    //floor plan attachment

    const floorPlanFunc = async () => {
        try {
            const response = await HttpService.floorPlanUpdate(projectId, floorType)
            props.setSnackInfo("Updated Successfully", "success")
            setOpenClientModel(false)
            setfBtnShow(false);
            getcustomerDetails();
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
        }
    }

    const handleAddFileInput = () => {
        let newFiles = [...files];
        newFiles.push("");
        setFiles(newFiles);
        setContractSignStageForm({
            ...contractSignStageForm,
            contractSignedPaymentReceviedAttachemnts: newFiles,
        });
    };

    const handleRemoveFileInput = (index) => {
        const newFiles = files.filter((file, id) => id !== index);
        setFiles([...newFiles]);
        setContractSignStageForm({ ...contractSignStageForm, contractSignedPaymentReceviedAttachemnts: newFiles })
        let newPaymentRecievedAttachments = uploadSize.paymentRecievedAttachments;
        newPaymentRecievedAttachments.splice(index, 1);
        // console.log('newPaymentRecievedAttachments is ',newPaymentRecievedAttachments)
        setUploadSize({
            ...uploadSize,
            paymentRecievedAttachments: newPaymentRecievedAttachments
        })
    }
    const handleClickOpenDialog = () => {
        setOpenDialog(true);
      };
      const handleCloseDialog = () => {
        setOpenDialog(false);
      };

      const sendToImosAndSiteBOM = async () =>{
        props.setLoading(true)
        try {
            await HttpService.uploadAndSendToImosAndSiteBOM(projectDetails._id);
            // props.setSnackInfo("Project Created Successfully", "success")
            // history.push(`/lead-design-to-execution/${moment().subtract(1, 'months').format('YYYY-MM-DD')}/${moment().add(1, 'days').format('YYYY-MM-DD')}`);
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }
    const uploadProductDocument = async () => {
        try {
            props.setLoading(true)
            let divisionOfProject = ""
            if (projectDetails?.grandTotal < 1000000) {
                divisionOfProject = '<10L'
            } else if (projectDetails?.grandTotal > 2500000) {
                divisionOfProject = '25L+'
            } else {
                divisionOfProject = "10-25L"
            }
            let obj = {}
            obj.code = projectDetails.erpProjectNo
            obj.clientName = projectDetails.customerId.name
            obj.apartmentName = projectDetails.customerId.address
            obj.clientAddress = projectDetails.customerId.address
            obj.contactNumber = projectDetails.customerId.contact_no
            obj.status = "Site QC"
            obj.locationId = projectDetails.city
            obj.experienceCenterId = projectDetails.experienceCenterId
            obj.leadOwner = projectDetails.assignTo._id
            obj.contractCustomerApproved = projectDetails.contractCustomerApproved
            obj.leadId = projectDetails._id
            obj.stage = projectDetails.currentStage
            obj.leadOwner = projectDetails.assignTo._id
            obj.contractCustomerApproved = projectDetails.contractCustomerApproved
            obj.financeStage = projectDetails.contractFinanceApproved
            obj.divisionOfProject = divisionOfProject
            obj.existingProject = false
            obj.documentFiles = [
                {
                    documentType: 'CheckList',
                    documentLink: projectDetails?.scanCheckListFile,
                    status: 'InSiteQC'
                },
                {
                    documentType: 'ContractSignaturePDF',
                    documentLink: projectDetails?.customerAgreementPdf || projectDetails?.termsAndConditionsPdf,
                    status: 'InSiteQC'
                },
                {
                    documentType: 'WorkingDrawingPDF',
                    documentLink: projectDetails?.workingDrawingFile,
                    status: 'InSiteQC'
                }
            ]
            const result = await HttpService.getProductDocAndCreateProject(obj)
            if (result.status === 200) {
                await sendToImosAndSiteBOM();
                getProjectLogs();
                getcustomerDetails();    
            }
        } catch (error) {
            props.setLoading(false)
            console.log(error)
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
    }


    // const handleRequestLink =  async() => {
    //     props.setLoading(true)
    //     try{
    //         const response = await HttpService.sendRequestForLink(projectId)
    //         props.setSnackInfo("Request Submitted Successfully", "success")
    //         setOpenGenerateLinkPopUp(false)
    //     }catch(err){
    //         props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
    //     }
    //     props.setLoading(false)
    // }
    const [copied, setCopied] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleCopyLink = () => {
        navigator?.clipboard?.writeText(paymentLink)
            .then(() => {
                setCopied(true);
                setSnackbarOpen(true);
            })
            .catch(error => {
                setSnackbarOpen(true);
            });
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const addDwgSkpFile = async (e) => {
        const { name, value } = e.target
        props.setLoading(true)
        setLoading(true)
        const fd = new FormData()
        fd.append('file', e.target.files[0])
        fd.append('customerName', "floor" + '_' + "plan")
        try {
            const acadSKpFileUpload = await HttpService.uploadFile(fd);
            if ([name][0] === "skpFile") {
                setSkpFileLink(acadSKpFileUpload.data)
                setSkpFile(true);
            }
            if ([name][0] === "dwgFile") {
                setAcadFileLink(acadSKpFileUpload.data)
                setDwgFile(true);
            }

        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error")
        }
        props.setLoading(false)
        setLoading(false)
    }

    const addDwgSkpMultipleFile = async (e) => {
    const { name } = e.target;
    props.setLoading(true);
    setLoading(true);
    
    try {
        // Convert FileList to Array to handle multiple files
        const filesArray = Array.from(e.target.files);
        
        // Process each file one by one
        for (const file of filesArray) {
            const fd = new FormData();
            fd.append('file', file);
            fd.append('customerName', "floor" + '_' + "plan");
            
            const acadSKpFileUpload = await HttpService.uploadFile(fd);
            
            // Update the appropriate state array based on the input name
            if ([name][0] === "siteMasking") {
                setSiteMaskingDocumentsLink(prev => [...prev, acadSKpFileUpload.data]);
                setSiteMaskingDocuments(true);
            }
            if ([name][0] === "2dDrawings") {
                setTwoDDrawingsFileLink(prev => [...prev, acadSKpFileUpload.data]);
                setTwoDDrawingsFile(true);
            }
            if ([name][0] === "sitePhotosVideos") {
                setSitePhotosVideosFileLink(prev => [...prev, acadSKpFileUpload.data]);
                setSitePhotosVideosFile(true);
            }
            if ([name][0] === "appliancesChecklist") {
                setAppliancesChecklistFileLink(prev => [...prev, acadSKpFileUpload.data]);
                setAppliancesChecklistFile(true);
            }
            if ([name][0] === "3dPPT") {
                setPowerPointFileLink(prev => [...prev, acadSKpFileUpload.data]);
                setPowerPointFile(true);
            }
            if ([name][0] === "Quotation") {
                setQuotationFileLink(prev => [...prev, acadSKpFileUpload.data]);
                setQuotationFile(true);
            }
        }
        } catch (err) {
            props.setSnackInfo(err?.response?.data ?? "Something went wrong", "error");
        } finally {
            props.setLoading(false);
            setLoading(false);
        }
    };



    // move deal design discussion stage
    const handleDiscussionButton = async()=>{
        if (acadFileLink && acadFileLink.trim() === "" || skpFileLink && skpFileLink.trim()  === ""  ) {
            return props.setSnackInfo("Please upload SKP/ACAD file", "error");
        }
        if (( acadFileLink.trim() === "" || skpFileLink.trim()  === "" ) ){
            return props.setSnackInfo("Please upload SKP/ACAD file", "error");
        }
        setOpenAnotherDialog(false)
        props.setLoading(true)
        let obj={
            momDiscussionsDetails : momDiscussionsDetails,
            discussionNo : discussionNo,
            leadId: projectId,
            stage : stage,
            acadFileLinkForDesignStages : acadFileLink,
            skpFileLinkForDesignStages : skpFileLink
        }
        try{
             let res = await HttpService.discussionNotesData(obj);
             setOpen(false);
             getProjectLogs();
             setDiscussionNo("");
            setMomDiscussionsDetails({
                time: getCurrentTime(),
                designer: userDetails.name,
                date: getCurrentDate()
            })
            setSkpFileLink("");
            setAcadFileLink("");
            setSkpFile(false);
            setDwgFile(false);
            setMomSubmit(false);
            getcustomerDetails();
            getAllQuotationsForProject();
            setSiteMaskingDocuments(false);


        }
        catch(err){
            props.setSnackInfo("Something went wrong", "error")
        }
        props.setLoading(false)
    }

    const handleMomFormDetail = (e) => {
        setMomDiscussionsDetails({
            ...momDiscussionsDetails,
            [e.target.name]: e.target.value,
        });
    };
    const handleDiscussionDetailsSubmit = ()=>{
        setMomSubmit(true);
        setOpenMomPage(false);
    }

    const areAllFieldsFilled = () => {
        for (const key in momDiscussionsDetails) {
            if (momDiscussionsDetails.hasOwnProperty(key) && momDiscussionsDetails[key] === "") {
                return false;
            }
        }
        return true;
    };

    const openCHMticketPage = ()=>{
        try{
            let newLocalObj = JSON.parse(JSON.stringify(projectDetails));
            newLocalObj.departmentId = projectDetails.departmentId._id;
            // console.log('projectDetails.departmentId is ',projectDetails.departmentId);
            // console.log('newLocalObj.departmentId is ', newLocalObj.departmentId);
            localStorage.setItem('CHMTicketLeadDetails', JSON.stringify(newLocalObj))
            // console.log('projectDetails are',projectDetails)
            window.open("/CHM-Ticket-Creation", "_blank", "noopener,noreferrer");
        }
        catch(err){
            console.log('err ',err)
        }
    }

    // getting all the call logs for a particular lead
    const handleCallLogs = async () => {
        props.setLoading(true)
        try {
            let payload = {}
            payload.customer_contact_no = projectDetails?.customerId?.contact_no
            const response = await HttpService.getCallLogsForLead(payload)
            setCallLogs(response.data.result)
            setCallLogsModal(true)
        } catch(error) {
            console.log('error: ', error)
        }
        props.setLoading(false)
    }

    // const handleCallDetailRecordings = async () => {
    //     try {
    //         let queryData = {}
    //         queryData.leadId = projectDetails?._id
    //         const response = await HttpService.getCDRForLead(queryData)
    //         setCDRLogs(response.data)
    //         setCDRModal(true)
    //     } catch (error) {
    //         console.error("CDR Error ->", error)
    //     }
    // }

    const handleCallDetailRecordings = () => {
        const leadId = projectDetails?._id;
        if (leadId) {
            window.open(`/call-detail-recordings/${leadId}`, '_blank');
        } else {
            console.error("Lead ID is missing");
        }
    };

    const handleDownloadExcel = () => {
        if (!cdrLogs || cdrLogs.length === 0) {
            console.warn("No data available to download.");
            return;
        }

        const data = cdrLogs.map((row, i) => ({
            "Sl. No.": i + 1,
            "Lead No": row?.leadId?.lead_no || "N/A",
            "ERP User": row?.user?.name || "N/A",
            "Role": row?.rolesData[0].name || "N/A",
            "Call Type": callTypeMap[row?.callType] || "N/A",
            "Caller Number": row?.callerNumber || "N/A",
            // "Destination Number": row?.destinationNumber || "N/A",
            "Call Duration (sec)": row?.conversationDuration || "NaN",
            "Overall Call Status": row?.overallCallStatus || "N/A",
            "Recordings": row.recordingURL ? row.recordingURL : "No Recording",
            "Date": row.createdAt ? moment(row.createdAt).format("DD-MM-YYYY") : "N/A",
        }));

        const ws = XLSX.utils.json_to_sheet(data);

        const callRecordingCol = "J";
        cdrLogs.forEach((row, i) => {
            if (row.recordingURL) {
                const cellRef = `${callRecordingCol}${i + 2}`;
                ws[cellRef] = {
                    t: "s",
                    v: "Download",
                    l: { Target: row.recordingURL }, // Hyperlink target
                };
            }
        });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "CDR Logs");

        XLSX.writeFile(wb, `CDR_Logs_${moment().format("YYYYMMDD_HHmmss")}.xlsx`);
    };

    const [designKickOffInternalDialog, setDesignKickOffInternalDialog] = useState(false)
    const [designerMomChecklistData, setDesignerMomChecklistData] = useState("")
    const openDesignKickOffInternalDialog = () => {
        getDepartments();
        setDesignerMomChecklistData((current) => {
            const base = current && typeof current === 'object' ? current : {};
            return {
                ...base,
                dateOfInternalKickOffMeeting: base.dateOfInternalKickOffMeeting || toDateInputValue(projectDetails?.dateOfInternalKickOffMeeting),
                dateOfKickOffMeeting: base.dateOfKickOffMeeting || toDateInputValue(projectDetails?.dateOfKickOffMeeting),
            };
        });
        setDesignKickOffInternalDialog(true)
        setOpen(false);
    }

    const canRaiseInternalDkoChecklist = () => {
        return projectDetails?.currentStage === 'Design Kick-Off : Internal'
            && projectDetails?.designKickOffInternalApprovalStatus !== 'Pending'
            && projectDetails?.designKickOffInternalApprovalStatus !== 'Approved'
            && userDetails?.roles?.some(role =>
                role.name === ROLENAME.DesignUser ||
                role.name === ROLENAME.AssistantDesignManager
            );
    }

    const isSalesWonOwner = () => {
        const salesWonId = projectDetails?.salesWonUser?._id || projectDetails?.salesWonUser;
        return String(salesWonId || '') === String(userDetails?._id || '');
    }

    const canDesignerRaiseCustomerDko = () => {
        return projectDetails?.currentStage === 'Design Kick-Off : Customer'
            && projectDetails?.designKickOffInternalApprovalStatus === 'Approved'
            && !projectDetails?.isDesignKickOffCustomerApprovedFromDesign
            && userDetails?.roles?.some(role =>
                role.name === ROLENAME.DesignUser ||
                role.name === ROLENAME.AssistantDesignManager
            );
    }

    useEffect(() => {
        const params = new URLSearchParams(location.search || '');
        if (params.get('raiseInternalDko') === '1' && projectDetails?._id && canRaiseInternalDkoChecklist()) {
            openDesignKickOffInternalDialog();
        }
    }, [location.search, projectDetails?._id, projectDetails?.currentStage, projectDetails?.designKickOffInternalMomLink, projectDetails?.designKickOffInternalApprovalStatus])
    const toDateInputValue = (value) => {
        if (!value) return '';
        const parsed = moment(value);
        return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
    };

    const checklistDateValue = (field, fallback) => {
        if (designerMomChecklistData && typeof designerMomChecklistData === 'object' && designerMomChecklistData[field] != null && designerMomChecklistData[field] !== '') {
            return designerMomChecklistData[field];
        }
        return toDateInputValue(fallback);
    };

    const handleDesignerMomChanges = e => {
        const current = designerMomChecklistData && typeof designerMomChecklistData === 'object' ? designerMomChecklistData : {};
        setDesignerMomChecklistData({ ...current, [e.target.name]: e.target.value });
    };
    const handleDesignKickOffInternalDesignMomSubmit = async (e) => {
        try {
            let obj = {
                clientName: designerMomChecklistData.clientName || projectDetails?.customerId?.name,
                apartmentName: designerMomChecklistData.apartmentName || projectDetails?.customerId?.address,
                designerName: projectDetails?.designUser?.name,
                salesUserName: projectDetails?.salesWonUserName,
                erpAssignmentDate: projectDetails?.designerAssignedDate,
                possessionDate: projectDetails?.possessionDate,
                tentativeMoveInDate: projectDetails?.clientMoveinDate,
                checkListRemarks: projectDetails?.checkListRemarkBySalesUser,
                discountAgreed: projectDetails?.discountPercent,
                leadId: projectDetails?._id
            }
             if (
                !designerMomChecklistData.floorPlanShared ||
                !designerMomChecklistData.approvalInfo ||
                // !designerMomChecklistData.budgetInfo ||
                !designerMomChecklistData.cashApprovalInfo ||
                !designerMomChecklistData.complimentaryBoolean ||
                !designerMomChecklistData.dateOfInternalKickOffMeeting  ||
                !designerMomChecklistData.dateOfKickOffMeeting ||
                !designerMomChecklistData.designapprovalInfo ||
                !designerMomChecklistData.floorPlanShared ||
                !designerMomChecklistData.furnitureboolean ||
                !designerMomChecklistData.informedClient ||
                !designerMomChecklistData.mailApprovalInfo ||
                !designerMomChecklistData.paymentScreenshot ||
                !designerMomChecklistData.refImg ||
                !designerMomChecklistData.requirementSpecification   ||
                !designerMomChecklistData.servicesApproval ||
                !designerMomChecklistData.siteVisitInfo ||
                !designerMomChecklistData.specification ||
                !designerMomChecklistData.stdHandles ||
                !designerMomChecklistData.stdOfferingInfo ||
                !designerMomChecklistData.timelineBoolean ||
                !designerMomChecklistData.timelineDays ||
                !designerMomChecklistData.vendorinfo ||
                // !designerMomChecklistData.internalKickOffRemarks ||
                !designerMomChecklistData.familyDetails ||
                !designerMomChecklistData.clientInformationsRemarks ||
                !designerMomChecklistData.specificationRemarks ||
                !designerMomChecklistData.requirementSpecificRemarks ||
                // !designerMomChecklistData.internalKickOffRemarks ||
                !designerMomChecklistData.notesClientInformation ||
                !designerMomChecklistData.vendorRemarks ||
                !designerMomChecklistData.approvalRemarks ||
                !designerMomChecklistData.designApprovalRemarks ||
                !designerMomChecklistData.mailApprovalRemarks ||
                !designerMomChecklistData.standardOfferingsNotes ||
                !designerMomChecklistData.salesTeamInfoNotes

            )
            return props.setSnackInfo('Please Enter All fields', "error")
            let details = {...designerMomChecklistData, ...obj }
            props.setLoading(true)
            const response = await HttpService.raiseDesignKickOffInternal(details)
            props.setLoading(false)
            setDesignKickOffInternalDialog(false)
            getProjectLogs();
            getcustomerDetails();
            setDesignKickOffInternalDialog(false)

        }
        catch (error) {
            console.log('error', error)
        }
    }



   const [errors, setErrors] = useState({
    emailError: '',
    emailsErrors: [],
});

// Email validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

 // State to track errors for both primary and additional emails
 const [emailError, setEmailError] = useState(false); // For primary email
 const [emailErrorsArray, setEmailErrorsArray] = useState([]); // For additional emails

 // State to track whether the submit button should be disabled
 const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

 // Handler for primary email change and validation
 const handleEmailChange = async (e) => {
    const value = e.target.value;

    setProjectDetailsFields((prev) => ({
        ...prev,
        email: value,
    }));
    

    // Validate email
    const isValid = emailRegex.test(value);

    setErrors((prev) => ({
        ...prev,
        emailError: !isValid ? "Invalid Email" : "",
    }));

    // Check only if valid email
    if (isValid) {
        props.setLoading(true);

        try {
            const response = await HttpService.checkCustomerEmail(value);

            if (response.data.exists === true) {
                props.setSnackInfo(response?.data?.status ?? "Something went wrong", "error")
                setIsSubmitDisabled(true)
            } else {
                props.setSnackInfo( response?.data?.status ?? "success")

                setIsSubmitDisabled(false)

            }

        } catch (error) {
            props.setSnackInfo(error?.response?.data?.error ?? "Something went wrong", "error")
        } finally {
            props.setLoading(false);
        }
    }
};

 // Handler for additional emails change and validation
 const handleEmailsChange = async (index, e) => {
    const value = e.target.value;

    // Update emails array
    const newEmails = [...projectDetailsFields.emails];
    newEmails[index] = value;

    setProjectDetailsFields({
        ...projectDetailsFields,
        emails: newEmails,
    });

    // Validate current email
    const isValid = emailRegex.test(value);

    const newErrors = [...emailErrorsArray];
    newErrors[index] = !isValid;

    setEmailErrorsArray(newErrors);

    // Stop if invalid
    if (!isValid) {
        return;
    }

    props.setLoading(true);

    try {
        const response = await HttpService.checkCustomerEmail(value);

        if (response.data.exists === true) {
            props.setSnackInfo(response?.data?.status ?? "Something went wrong", "error")

            setIsSubmitDisabled(true);

        } else {
            props.setSnackInfo( response?.data?.status ?? "success")
            setIsSubmitDisabled(false);
        }

    } catch (error) {
        props.setSnackInfo(
            error?.response?.data ?? "Something went wrong",
            "error"
        );
    } finally {
        props.setLoading(false);
    }
};

 // Function to add a new email field
 const addEmailField = () => {
    setProjectDetailsFields({
        ...projectDetailsFields,
        emails: [...(projectDetailsFields?.emails || []), ''], // Ensure emails is an array
    });
     // Add a corresponding error entry
     setEmailErrorsArray([...emailErrorsArray, false]);
 };

 // Function to remove an email field
 const removeEmailField = (index) => {
     const newEmails = projectDetailsFields?.emails.filter((_, i) => i !== index);
     const newErrors = emailErrorsArray.filter((_, i) => i !== index);
     setProjectDetailsFields({
         ...projectDetailsFields,
         emails: newEmails,
     });
     setEmailErrorsArray(newErrors);
 };

 // Check if the submit button should be disabled
 useEffect(() => {
     const hasErrors = emailError || emailErrorsArray.some((error) => error);
     const primaryEmailEmpty = !projectDetailsFields.email;
     setIsSubmitDisabled(hasErrors || primaryEmailEmpty);
 }, [emailError, emailErrorsArray, projectDetailsFields.email]);


 useEffect(() => {
        const hotDealData = projectDetails?.hotDealChecklistData;
        if (hotDealData) {
            const {
                cxMoveTimeline,
                possessionStatus,
                registrationStatus,
                decisionMaker,
                financialReadiness,
                budgetQuotation,
                competitorInvolvement,
                otherCompetitorValue,
                expectedSalesWonDate
            } = hotDealData;

            if (cxMoveTimeline) setCxMoveInTimelineValue(cxMoveTimeline);
            if (possessionStatus) setPossesionStatusValue(possessionStatus);
            if (registrationStatus) setRegStatusValue(registrationStatus);
            if (decisionMaker) setDecisionMakerValue(decisionMaker);
            if (financialReadiness) setFinancialReadinessValue(financialReadiness);
            if (budgetQuotation) setBudgetQtValue(budgetQuotation);
            if (competitorInvolvement) setCompetitorValue(competitorInvolvement);
            if (otherCompetitorValue) setOtherCompetitorValue(otherCompetitorValue);
            if (expectedSalesWonDate) {
                const formattedDate = new Date(expectedSalesWonDate).toISOString().split("T")[0];
                setHotDealSalesWonDate(formattedDate);
            }
        }
    }, [projectDetails]);

    const handleSiteVisitNegotiation = () => {
        props.setLoading(true);
        if (!projectDetails.hotDealChecklistData || !projectDetails.hotDealChecklistData.isHotDealFilled) {
            props.setSnackInfo('Kindly fill the Hotdeal Checklist using the Hotdeal Checklist button.', 'warning')
            return;
        } else {
            setHotDealModel(true);
            setAssignProjectChecklistCheck(true);
        }
        props.setLoading(false);
    }

    // Function to handle the change in audio file
	const handleAudioFileChange = async (event, projectDetails) => {
		props.setLoading(true);
		const fd = new FormData();
		fd.append("file", event.target.files[0]);
		fd.append("customerName", projectDetails.uniqueLeadNumber);
		try {
			const fileUploadRes = await HttpService.uploadFile(fd);
			let payload = {
				leadId: projectDetails._id,
				fileType: "recordingFile",
				fileLink: fileUploadRes.data,
			};
			const response = await HttpService.updateAttachmentsForLead(
				payload
			);
			props.setSnackInfo("Recording File saved successfully.", "success");
			getcustomerDetails();
		} catch (err) {
			props.setSnackInfo(
				err?.response?.data ?? "Error Uploading File",
				"error"
			);
			console.error("Error -> ", err);
		}
		props.setLoading(false);
	};
	// Function to handle the change in floor plan attachment file
	const handleFloorPlanAttachmentChange = async (event, projectDetails) => {
		props.setLoading(true);
		const fd = new FormData();
		fd.append("file", event.target.files[0]);
		fd.append("customerName", projectDetails.uniqueLeadNumber);
		try {
			const fileUploadRes = await HttpService.uploadFile(fd);
			let payload = {
				leadId: projectDetails._id,
				fileType: "floorPlanAttachment",
				fileLink: fileUploadRes.data,
			};
			const response = await HttpService.updateAttachmentsForLead(
				payload
			);
			props.setSnackInfo(
				"Floor Plan Attachment saved successfully.",
				"success"
			);
			getcustomerDetails();
		} catch (err) {
			props.setSnackInfo(
				err?.response?.data ?? "Error Uploading File",
				"error"
			);
			console.error("Error -> ", err);
		}
		props.setLoading(false);
	};

    const handlePageChange = async (e,v)=>{
        setPage(v);
        const response = await HttpService.getProjectLog(projectId,v)
        setProjectLogs(response.data)
    }

    const navigateToMatCheckList = () => {
        history.push(`/materials-checklist/${projectDetails._id}`);
      };

     // Click button to send Again Design-Hold Staus 
     const handleAgainDesignHoldReq = () => {
        setOpenStatusModal(true);
        setAgainDesignHoldReq(true);
        setDesignStageStatus('Design-Hold');
        setSelectedDesignStatus('Design-Hold');
    }

    const handleDownloadAllImages = (urls = []) => {
        if (urls.length === 0) return alert("No files to download.");
        urls.forEach((url) => {
            window.open(url, "_blank");
        });
    };

    const handleReassign = (e)=>{
        setReassignUser((prev) => !prev);
        setSelectedDepartment(constantDepartmentId.sales);
        getTeamsList(constantDepartmentId.sales)
    }

    //  handle requirement not collected function cancel
    const handleRncCancelButton = ()=> {
       setOpenAnotherDialog(false);
       setMoveInRncReason('');
       setMoveInRncOtherReason('');
       setVerficationStatus('');
       setVerficationStatusOther('');
       setReassignUser(false);
       setSelectedDepartment('');
       setSelectedTeam('');
       setSelectedDealOwner('')
    }

    // requirement collected handle cancel function
    const handleRcCancelButton = () =>{
        setHandleSalesCallDate(getCurrentDate());
        setOpenAnotherDialog(false);
        setRcScopeOfWork('');
        setDesignPref('');
        setEstimateBudget('');
        setTimelineMoveHouseDate('');
        setPossDate('');
        setFloorPlanAttach('');
        setFloorPlanUploaded(false);
        setRcOtherDetails('');
        setReasonMoveRcCollect('');
        setReasonMoveRcCollectOther('');
        setReassignUser(false);
        setSelectedDepartment('');
        setSelectedTeam('');
        setSelectedDealOwner('')
    }

    // quotation sent cancel button
    const handleQtCancelButton = ()=>{
        setOpenAnotherDialog(false);
        setReassignUser(false);
        setSelectedDepartment('');
        setSelectedTeam('');
        setSelectedDealOwner('');
        setReasonToDealQt('');
        setReasonToDealQtOther('');
        setQtFittingBudget('')
        setcxPlanVisitExZone('');
        setPlanVisitDate('');
        setQtSentMeetingOption('Quotation sent meeting not fixed');
        setMeetingfixedDetail({
            proposeMeetingType: "",
            proposeMeetingDate: null,
            meetingParticipant: ""
        });
    }

      // requirement not collected handle submit
        const handleRncSubmitButton = async ()=>{
            props.setLoading(true);
            try {
                    const obj = {
                        stage: stage,
                        team: userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser) ? userDetails.teamId._id : team,
                        id: userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser) ? userDetails._id : dealOwner,
                        leadId: projectId,
                        department: department,
                        stageDepartment: 'sales',
                        dealOwner: dealOwner,
                        leadStatus: 'Open',
                        moveInRncReason: moveInRncReason,
                        moveInRncOtherReason: moveInRncOtherReason,
                        verficationStatus: verficationStatus,
                        verficationStatusOther: verficationStatusOther,
                        reassignUser : reassignUser,
                    }
                const res = await HttpService.updateRequirementsNotCollected(obj);
                if(res.status === 200){
                    props.setSnackInfo("Updated successfully");
                    setOpenAnotherDialog(false);
                    setMoveInRncReason('');
                    setMoveInRncOtherReason('');
                    setVerficationStatus('');
                    setVerficationStatusOther('');
                    setReassignUser(false);
                    setSelectedDepartment('');
                    setSelectedTeam('');
                    setSelectedDealOwner('');
                    getcustomerDetails();
                    getProjectLogs();
                }
            }
            catch(err){
                props.setSnackInfo('Something went wrong','error')
            }
            props.setLoading(false);
        }
    
        // requirement collected handle submit
        const handleRcSubmitButton = async ()=>{
            try {
                const obj = {
                    stage: stage,
                    team: userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser) ? userDetails.teamId._id : team,
                    id: userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser) ? userDetails._id : dealOwner,
                    leadId: projectId,
                    department: department,
                    stageDepartment: 'sales',
                    dealOwner: dealOwner,
                    leadStatus: 'Open',
                    reqCollectionDate: salesCallDate,
                    rcScopeOfWork: rcScopeOfWork,
                    designPref: designPref,
                    estimatedBudget:estimatedBudget,
                    timelineMoveHouseDate: timelineMoveHouseDate,
                    possDate: possDate,
                    floorPlanAttach:floorPlanAttach,
                    rcOtherDetails: rcOtherDetails,
                    reasonMoveRcCollect: reasonMoveRcCollect,
                    reasonMoveRcCollectOther: reasonMoveRcCollectOther,
                    reassignUser : reassignUser,
                }
                const response = await HttpService.updateRequirementsCollected(obj);
                if(response.status === 200){
                    setOpenAnotherDialog(false);
                    getcustomerDetails();
                    getProjectLogs();
                    setHandleSalesCallDate(getCurrentDate());
                    setOpenAnotherDialog(false);
                    setRcScopeOfWork('');
                    setDesignPref('');
                    setEstimateBudget('');
                    setTimelineMoveHouseDate('');
                    setPossDate('');
                    setFloorPlanAttach('');
                    setFloorPlanUploaded(false);
                    setRcOtherDetails('');
                    setReasonMoveRcCollect('');
                    setReasonMoveRcCollectOther('');
                    setReassignUser(false);
                    setSelectedDepartment('');
                    setSelectedTeam('');
                    setSelectedDealOwner('')
                    props.setSnackInfo("Updated successfully");
                }
            }
            catch(err){
                console.error(err);
                props.setSnackInfo('Something went wrong', 'error')
            }
        }
    
        //handle Quotation sent submit Button 
        const handleQtSubmitButton = async() => {
            try {
                const obj = {
                    stage: stage,
                    team: userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser) ? userDetails.teamId._id : team,
                    id: userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser) ? userDetails._id : dealOwner,
                    leadId: projectId,
                    department: department,
                    stageDepartment: 'sales',
                    dealOwner: dealOwner,
                    leadStatus: 'Open',
                    reasonToDealQt: reasonToDealQt,
                    reasonToDealQtOther: reasonToDealQtOther,
                    qtFittingBudget: qtFittingBudget,
                    cxPlanVisitExZone: cxPlanVisitExZone,
                    planVisitDate: planVisitDate,
                    reassignUser : reassignUser,
                    qtSentMeetingOption,
                    meetingFixedDetail,
                }
                const res = await HttpService.updateQuotationSentStage(obj);
                if(res.status === 200){
                    props.setSnackInfo("Updated successfully");
                    setOpenAnotherDialog(false);
                    setReassignUser(false);
                    setSelectedDepartment('');
                    setSelectedTeam('');
                    setSelectedDealOwner('');
                    setReasonToDealQt('');
                    setReasonToDealQtOther('');
                    setQtFittingBudget('')
                    setcxPlanVisitExZone('');
                    setPlanVisitDate('');
                    getcustomerDetails();
                    getProjectLogs();
                }
            }
            catch (err) {
                console.log(err);
                props.setSnackInfo('Something wents wrong', 'error')
            }   
        }
    
        const handleMoveInRncReason = (e)=> {
            setMoveInRncReason(e.target.value);
            setReqNotCollectedFromNotes(true);
        }
    
        const handleMoveInRcCollected = (e)=>{
            setReasonMoveRcCollect(e.target.value);
            setReqCollectedFromNotes(true);
    
        } 
    
        const handleNotesCancel = ()=>{
           setOpenNotesModal(false);
           updateState();
        }

        const handleNotesNewCancel = ()=>{
            setOpenNewNotesModal(false);
            updateState();
        }
    
        const updateState = () =>{
            setMoveInRncReason('');   // req not collected
            setMoveInRncOtherReason('');
            setVerficationStatus('');
            setVerficationStatusOther('');
            setRcScopeOfWork('');   //req collected
            setDesignPref('');
            setEstimateBudget('');
            setTimelineMoveHouseDate('');
            setPossDate('');
            setFloorPlanAttach('');
            setFloorPlanUploaded(false);
            setRcOtherDetails('');
            setReasonMoveRcCollect('');
            setReasonMoveRcCollectOther('');
            setReqCollectedChanges(false);
            setReqCollectedFromNotes(false);
            setReasonToDealQt('');      //quotation sent
            setReasonToDealQtOther('');
            setQtFittingBudget('')
            setcxPlanVisitExZone('');
            setPlanVisitDate('');
            setQtSentNotesChanges(false);
            setType('');
            setSendNoteToClient(false);
        }
    
        const handleQtSentReason = (e)=>{
           setReasonToDealQt(e.target.value);
           setQtSentNotesChanges(true);
        }
    
        // RNC Handle Is submitted disable functionality
        const isMoveReasonMissing = moveInRncReason === '';
        const isVerificationStatusMissing = verficationStatus === '';
        const isOtherReasonMissing = moveInRncReason === 'Other' && moveInRncOtherReason === '';
        const isVerifiedDisqualifiedMissing = verficationStatus === 'Verified disqualified lead' && verficationStatusOther === '';
        const isReassignIncomplete = reassignUser && (team === '' || dealOwner === '');
    
        const isRncSubmitDisabled =
            isMoveReasonMissing ||
            isVerificationStatusMissing ||
            isOtherReasonMissing ||
            isVerifiedDisqualifiedMissing ||
            isReassignIncomplete;
    
        // RC Handle Is submitted disable functionality
        const isScopeMissing = rcScopeOfWork === '';
        const isBudgetMissing = estimatedBudget === '';
        const isSalesCallDate = salesCallDate === '';
        const isTimelineMissing = timelineMoveHouseDate === '';
        const isPossessionDateMissing = possDate === '';
        const isReasonMissing = reasonMoveRcCollect === '';
        const isOtherResMissing = reasonMoveRcCollect === 'Other' && reasonMoveRcCollectOther === '';
    
        const isRcSubmitDisabled =
            isScopeMissing ||
            isBudgetMissing ||
            isSalesCallDate ||
            isTimelineMissing ||
            isPossessionDateMissing ||
            isReasonMissing ||
            isOtherResMissing ||
            isReassignIncomplete;
    
        // QT handle submit button
        const isQtReasonMissing = reasonToDealQt === '';
        const reasonToDealMissing = reasonToDealQt === 'Other' && reasonToDealQtOther === '';
        const qtFittingMissing = qtFittingBudget === '';
        const isVisitStatusMissing = cxPlanVisitExZone === '';
        const isVisitDateMissing = cxPlanVisitExZone === 'Yes' && planVisitDate === '';
        const proposeMeetingType = meetingFixedDetail.proposeMeetingType === "";
        const proposeMeetingDate = meetingFixedDetail.proposeMeetingDate === null;
        const meetingParticipant = meetingFixedDetail.meetingParticipant === "";
        const isQtSentMeeting = qtSentMeetingOption === "";  
            const isQtSentMeetingFixed = qtSentMeetingOption === "Quotation sent meeting fixed"; 
            const qtMeetingFieldsMissing =
            isQtSentMeetingFixed && (
                proposeMeetingType ||
                proposeMeetingDate ||
                meetingParticipant
            );
    
        const isQtSubmitDisabled =
            isQtReasonMissing ||
            reasonToDealMissing ||
            qtFittingMissing ||
            isVisitStatusMissing ||
            isReassignIncomplete ||
            isVisitDateMissing ||
            isQtSentMeeting ||
            qtMeetingFieldsMissing

    

    
    // Make deal Activitiy some text bold which is wrap up **...**
    // The customer's own Name and Email, masked for DISPLAY.
    //
    // Automation-created leads are named after the number ("AI Bot Lead
    // 7013184040") and emailed at it ("7013184040@leads.decorpot.com"), so the
    // Contact row can be correctly masked while the two rows above it hand the
    // number over in full.
    //
    // Derived once here rather than inline at each site, so the Customer Name
    // row, the Email row and the WhatsApp preview can never disagree.
    //
    // Display only - every payload, filename and API call on this page still
    // uses projectDetails.customerId.* untouched.
    const maskedCustomerName = maskPhoneNumbersInLogText(
        projectDetails?.customerId?.name,
        projectDetails?.customerId?.contact_no
    );
    const maskedCustomerEmail = maskPhoneNumbersInLogText(
        projectDetails?.customerId?.email,
        projectDetails?.customerId?.contact_no
    );

    function renderWithBold(text) {
        if (!text) return null;

        // Masked here rather than at each call site, because this one function
        // renders Deal Activity, Notes and the notes list - so every place a log
        // entry reaches the screen is covered by this single line.
        //
        // Automation-created leads carry the customer's mobile inside the Name
        // and Email fields ("AI Bot Lead 7013184040",
        // "7013184040@leads.decorpot.com"), which leaked the full number right
        // next to the correctly-masked "Phone Number: XXXXXXXX40" line.
        //
        // Masks this lead's customer number, and any other bare 10-digit run as
        // a safety net. The hyphen boundaries keep the Unique Lead Number UUID
        // intact.
        //
        // Display only - the stored text is untouched, so exports and the API
        // are unaffected.
        const maskedText = maskPhoneNumbersInLogText(text, projectDetails?.customerId?.contact_no);
      
        // Discount request entries (sent / approved / rejected / revoked): colour the outcome and the %.
        if (/discount request of \d/i.test(maskedText)) {
            const tone = /\brejected\b/i.test(maskedText)
                ? { color: '#c0392b', background: '#fdecea' }
                : /\bapproved\b/i.test(maskedText)
                    ? { color: '#1e8449', background: '#eafaf1' }
                    : /\brevoked\b/i.test(maskedText)
                        ? { color: '#546e7a', background: '#eceff1' }
                        : { color: '#c1531f', background: '#fff1ea' };
            const pieces = maskedText.split(/(\b(?:approved|rejected|revoked)\b|\d+(?:\.\d+)?%)/gi);
            return (
                <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', margin: 0, maxWidth: '600px', width: '100%' }}>
                    {pieces.map((piece, index) => {
                        const isOutcome = /^(approved|rejected|revoked)$/i.test(piece);
                        const isPercent = /^\d+(?:\.\d+)?%$/.test(piece);
                        if (!isOutcome && !isPercent) return <span key={index}>{piece}</span>;
                        const outcomeTone = /^approved$/i.test(piece)
                            ? { color: '#1e8449', background: '#eafaf1' }
                            : /^rejected$/i.test(piece)
                                ? { color: '#c0392b', background: '#fdecea' }
                                : { color: '#546e7a', background: '#eceff1' };
                        const style = isOutcome ? outcomeTone : tone;
                        return (
                            <strong key={index} style={{ ...style, padding: '1px 7px', borderRadius: 6, textTransform: isOutcome ? 'uppercase' : 'none', fontSize: isOutcome ? '0.92em' : undefined }}>
                                {piece}
                            </strong>
                        );
                    })}
                </div>
            );
        }
        const bulletSections = maskedText.split(/(?=#)/g); // Keeps "#" in each chunk

        return (
            // <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', margin: 0 }}>
                 <div
                style={{
                    whiteSpace: 'pre-wrap',
                    wordWrap: 'break-word',
                    margin: 0,
                    maxWidth: '600px', // adjust as needed
                    width: '100%',     // responsive within parent
                }}
            >
                {bulletSections.map((section, i) => {
                    const isBullet = section.trim().startsWith('#');

                    // Remove '#' from start of bullet section
                    const cleanedText = isBullet ? section.trim().replace(/^#\s*/, '') : section;

                    // Handle bold inside the cleaned text
                    const parts = cleanedText.split(/(\*\*[^*]+?\*\*)/g);

                    const content = parts.map((part, index) =>
                        part.startsWith('**') && part.endsWith('**') ? (
                            <strong key={index}>{part.slice(2, -2)}</strong>
                        ) : (
                            <span key={index}>{part}</span>
                        )
                    );

                    return isBullet ? (
                        <li key={i}>{content}</li>
                    ) : (
                        <p key={i}>{content}</p>
                    );
                })}
            </div>
        );
    }

      const handleCheckboxClick = (e) => {
        // if (!sendNoteToClient) {
        //     setPendingCheckedValue(e.target.checked);
        //     setDialogOpen(true);
        // }
        // setSendNoteToClient(false)
        // Don't change the state yet, just store the intent
        if (projectDetails?.departmentId?._id !== designDepartment) {
        setSendNoteToClient(e.target.checked);
    }

    };

     const handleDialogConfirm = () => {
        // setSendNoteToClient(pendingCheckedValue);
        setDialogOpen(false);
        // Now proceed with the actual save
        proceedSaveNotes(true);
        
    };

    const handleDialogCancel = () => {
        setDialogOpen(false);
        updateState();
    };

    const allPaymentLinkHandle = async () => {
        try {
            props.setLoading(true);
            const fetchData = await HttpService.allPaymentLink(projectDetails?._id);
            setAllPaymentLink(fetchData?.data)
            props.setLoading(false);
        } catch (error) {
            props.setLoading(false);
            console.log("error");
        }
    };

    const cancelPaymentLinkHandle = async (linkId,link,merchantOrderId) => {
        let obj = {
            linkId,
            link,
            merchantOrderId,
            name : userDetails?.name,
            leadId: projectDetails?._id
        }
        try {
            props.setLoading(true);
            const fetchData = await HttpService.paymentCancelLink(obj);
            // props.setSnackInfo(fetchData?.data?.data?.link_status,"success")
             props.setSnackInfo(fetchData?.data?.phonePeResponse,"success")
            props.setLoading(false);
        } catch (error) {
            props.setLoading(false);
            props.setSnackInfo(error?.response?.data?.message,"warning")
            console.log("error",error);
        }
    };

      // Handle hot deal checklist
    const handleHotDealChecklist = () => {
        try {
            setHotDealModel(true);
        }
        catch (err) {
            props.setSnackInfo('Something wents wrong');
            console.log(err);
        }
    }

    // competitor involvement
    const handleCompetitorInvolvement = (e, value)=>{
       if(value === 'Other'){
           setOtherCompetitorValue('')
       }
         if (e.target.checked) {
            setCompetitorValue((prev) => [...prev, value]);
        } else {
            setCompetitorValue((prev) => prev.filter((item) => item !== value));
        }
    }


    const handleHotDealSubmit = async() => {
        props.setLoading(true);
        try {
            setOpenAnotherDialog(false);
            setHotDealModel(false);
            const obj = {
                cxMoveInTimelineValue: cxMoveInTimelineValue,
                possesionStatusValue: possesionStatusValue,
                regStatusValue: regStatusValue,
                decisionMakerValue: decisionMakerValue,
                financialReadinessValue: financialReadinessValue,
                budgetQtValue: budgetQtValue,
                competitorValue: competitorValue,
                otherCompetitorValue: otherCompetitorValue,
                hotDealSalesWonDate: hotDealSalesWonDate
            }
           const res = await HttpService.submitHotDealChecklistData(obj,projectId);
           if(res.status === 200){
                props.setSnackInfo('Hot Deal Checklist Updated');
                getProjectLogs();
                getcustomerDetails();
                 if(assignProjectChecklistCheck){
                    assignProject();
                    setAssignProjectChecklistCheck(false);
                }
           } 
        }
        catch (err) {
            console.error(err);
            props.setSnackInfo('Something wents wrong', 'error');
        }
        props.setLoading(false);
    }

    const finalDesignQuotationHandle = async (quotationId) => {
        try {
            props.setLoading(true);
            const fetchData = await HttpService.getVersionOfQuotationById(quotationId);
            setDesignQuotationId(fetchData?.data?.version)
            props.setLoading(false);
        } catch (error) {
            props.setLoading(false);
            console.log("error");
        }
    };
        
    const designQuotationLink = async (version) => {
        const encoded = btoa(`${projectDetails._id}/${projectDetails?.version}`);
        window.open(`${IP.prodUrl}webQuotation/erpUser/${encoded}`)
    }  

    const webQuotationRoute = async (version,leadId) => {
        const encoded = btoa(`${leadId}/${version}`);
        window.open(`${IP.prodUrl}webQuotation/erpUser/${encoded}`)
      }
          // This is Naraci Quotation details.
    const getAllNaraciQuotationsForProject = async (projectDetails) => {
        props.setLoading(true)
        try {
          const response = await HttpService.getNaraciDesignQuotations(projectDetails?._id)
          // console.log('getAllQuotationsForProject data', response.data)
          setNaraciQuotationList(response?.data?.quotationVersions)
        } catch (error) {
          console.error(error)
        //   props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    // handle meeting fixed and not fixed radio
    const handleQtSentMeetingOption = (e) => {
        setQtSentMeetingOption(e.target.value);
        setMeetingfixedDetail({
            proposeMeetingType: "",
            proposeMeetingDate: null,
            meetingParticipant: ""
        });
        updateState();
    }

    const editQtSentMeetingDetails = ()=> {
        getLeadMeetingFixedDetail()
        setEditQtSentMeetingDialog(true);
        setMeetingfixedDetail({
            proposeMeetingType: "",
            proposeMeetingDate: null,
            meetingParticipant: ""
        });
        setQtSentMeetingOption('Quotation sent meeting not fixed');
    }

    const handleQtSentMeetingCancel = ()=>{
        setEditQtSentMeetingDialog(false);
        setMeetingfixedDetail({
            proposeMeetingType: "",
            proposeMeetingDate: null,
            meetingParticipant: ""
        });
        setQtSentMeetingOption('Quotation sent meeting not fixed');
    }

    const handleQtSentMeetingSubmit = async()=>{
        props.setLoading(true);
        try{
            const obj = {
                meetingFixedDetail,
                projectId,
                previousMeetingData: qtSentMeetingData?.meeting

            }
            const res = await HttpService.editQtSentMeetingDetail(obj);
            if(res.status === 200){
                handleQtSentMeetingCancel();
                getProjectLogs();
            }
        } catch(err){
            console.error(err);
        }
        props.setLoading(false);
    }

    const getLeadMeetingFixedDetail = async()=>{
        try{
            let res = await HttpService.getLeadMeetingFixedDetail(projectId);
            setQtSentMeetingData(res?.data?.qtSentMeetingDetail);
        }
        catch(err){
            console.error(err);
            props.setSnackInfo('Something went wrong', 'error')
        }
    }

    const handleViewQtSentMeetingDetail = ()=>{
        setViewQtSentData(true);
        getLeadMeetingFixedDetail()
    }

    const isProjectTimeline = moveToMarketingReason === "project_timeline";
    const isOtherReason = moveToMarketingReason === "others";

    // Determine if the form is valid
    const isFormValid = audioUploaded &&
        (!isProjectTimeline || (isProjectTimeline && handoverDate !== "")) &&
        (!isOtherReason || (isOtherReason && otherReason !== ""));
        
    const getMinDate = () => {
        return new Date().toISOString().split("T")[0];
    };

    // Maximum = last day of the third month from now
    const getMaxDate = () => {
        const today = new Date();
        const maxDate = new Date(today.getFullYear(), today.getMonth() + 4, 0); // 4 because we include the current month
        return maxDate.toISOString().split("T")[0];
    };

    const leadAssignedDate = new Date(projectDetails?.leadAssignedDate);
    const today = new Date();

    // Calculate difference in days
    const diffInDays = (today - leadAssignedDate) / (1000 * 60 * 60 * 24);

    const hasTopLevelDesign = userDetails?.canAccess?.some(
        (item) => item.label === "Design"
      );

    const hasDesignInStatistics = userDetails?.canAccess?.some(
    (menu) =>
        menu.label === "Statistics" &&
        menu.subMenu?.some((sub) => sub.label === "Design")
    );

    const hasTopLevelDesign1 = userDetails?.canAccess[0]?.canAccess?.some(
        (item) => item.label === "Design"
      );

    const hasDesignInStatistics1 = userDetails?.canAccess[0]?.canAccess?.some(
    (menu) =>
        menu.label === "Statistics" &&
        menu.subMenu?.some((sub) => sub.label === "Design")
    );

    // BotWotChatDrawer fetches the thread itself from the leadId it is given,
    // so opening it is all this needs to do.
    const handleBotWotChat = () => setOpenChat(true);

    const fetchHoomanTranscripts = async () => {
        try {
            const res = await HttpService.getTranscriptsForLead(projectId);
            setHoomanTranscripts(res.data.data || []);
        } catch (error) {
            console.error("Error fetching HoomanLabs transcripts", error);
        }
    };

    const handleHoomanLabsTranscripts = async () => {
        setHoomanTranscriptsOpen(true);
        setSelectedHoomanCall(null);
        setHoomanTranscriptsLoading(true);
        await fetchHoomanTranscripts();
        setHoomanTranscriptsLoading(false);
    };

    // Merge Deal Activity log entries (current page) with calls that happened
    // in between them, so the timeline reads as one chronological feed.
    const parseRunoTranscript = (text) => {
        if (!text) return [];
        const lines = String(text).split(/\n+/).map((line) => line.trim()).filter(Boolean);
        const messages = [];
        lines.forEach((line) => {
            const agentMatch = line.match(/^(Agent|AI Bot|Bot)\s*:\s*(.*)$/i);
            const customerMatch = line.match(/^(Customer|Client|User)\s*:\s*(.*)$/i);
            if (agentMatch) {
                messages.push({ role: 'assistant', content: agentMatch[2], label: 'Agent' });
            } else if (customerMatch) {
                messages.push({ role: 'user', content: customerMatch[2], label: 'Customer' });
            } else if (messages.length) {
                messages[messages.length - 1].content += `\n${line}`;
            } else {
                messages.push({ role: 'assistant', content: line, label: 'Agent' });
            }
        });
        return messages;
    };

    const extractRunoCallSummary = (dealActivity) => {
        if (!dealActivity) return '';
        const text = String(dealActivity);
        const summaryMatch = text.match(/Summary:\s*([\s\S]+)$/i);
        if (summaryMatch?.[1]) return summaryMatch[1].trim();
        return text.replace(/^Runo call transcript received[^.]*\.\s*/i, '').trim() || text;
    };

    const timelineItems = useMemo(() => {
        const activityItems = (projectLogs || []).map((log) => ({
            type: 'activity',
            timestamp: log.createdAt,
            data: log,
        }));

        if (!activityItems.length) return activityItems;

        const pageTimestamps = activityItems.map((item) => moment(item.timestamp).valueOf());
        const minTs = Math.min(...pageTimestamps);
        const maxTs = Math.max(...pageTimestamps);

        // Deal Activity logs are fetched newest-first, page 1 = most recent.
        // A call that happened more recently than the newest log we have (no
        // stage-change logged yet for it) or further back than the oldest
        // log (before any activity was ever logged) will never fall inside
        // any page's [minTs, maxTs] window - only the first page can be
        // "newer than everything" and only the last page can be "older than
        // everything", so widen the window on those two edges instead of
        // silently dropping such calls off the timeline entirely.
        const isFirstPage = page === 1;
        const isLastPage = page >= paginationCount;

        const callItems = (hoomanTranscripts || [])
            // hoomanTranscripts is fetched once for the whole lead (not
            // paginated), while activityItems is just the current page of
            // Deal Activity logs - without this filter, every call gets
            // re-merged into every page, so the same transcripts appeared
            // duplicated on each page. Scope calls to the time window this
            // page's activity entries actually span (widened at the first/
            // last page edges, per the note above).
            .filter((call) => {
                const ts = moment(call.beginTimestamp || call.createdAt).valueOf();
                if (ts >= minTs && ts <= maxTs) return true;
                if (isFirstPage && ts > maxTs) return true;
                if (isLastPage && ts < minTs) return true;
                return false;
            })
            .map((call) => ({
                type: 'call',
                timestamp: call.beginTimestamp || call.createdAt,
                data: call,
            }));

        return [...activityItems, ...callItems].sort(
            (a, b) => moment(b.timestamp).valueOf() - moment(a.timestamp).valueOf()
        );
    }, [projectLogs, hoomanTranscripts, page, paginationCount]);

    const isPrivilegedUser = userDetails?.roles?.some(
        role =>
            role.name === ROLENAME.Admin ||
            role.name === ROLENAME.NaraciTechManager ||
            role.name === ROLENAME.NaraciTechUser
    );

    const canEditLead = userDetails?.roles?.some(
        role =>
            role.name === ROLENAME.Admin ||
            role.name === ROLENAME.NaraciTechManager ||
            role.name === ROLENAME.NaraciTechUser ||
            (role.name === 'DGM Sales' && !projectDetails?.customerApproved?.[0]?.isApproved) ||
            (role.name === 'AGM Sales' && !projectDetails?.customerApproved?.[0]?.isApproved) ||
            (role.name === 'DGM Design' && projectDetails?.departmentId?.name === 'Design') ||
            (role.name === 'AGM Design' && projectDetails?.departmentId?.name === 'Design') ||
            role.name === 'Marketing Manager' ||
            role.name === 'Marketing User' ||
            role.name === 'TeleCaller'
    );

    if (isCheckingAccess) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                <CircularProgress />
            </div>
        );
    }

    if (isAccessDenied) {
        return (
            <div style={{ padding: '60px 24px', textAlign: 'center' }}>
                <Typography variant="h5" gutterBottom>Access Denied</Typography>
                <Typography variant="body1">
                    You are not authorized to view this project's logs. Only the assigned employee and their reporting managers can access this page.
                </Typography>
            </div>
        );
    }
    
    return (
        <div>
            <div className={classes.root}>
                <Grid container spacing={3}>
                    {/* Details */}
                    <Grid item lg={6} md={6} sm={12} className={`${classes.scrollColumn} ${classes.scrollbars}`}>
                        <Paper className={classes.paper}>
                        {
                        // HARD FAIL: if user has DesignUser role → do NOT show anything
                        !userDetails?.roles?.some(role => role.name === ROLENAME.DesignUser) &&

                        (
                            (
                            // 1. Allowed roles (without DesignUser)
                            userDetails?.roles?.some(role =>
                                role.name === ROLENAME.OperationDesignManager ||
                                role.name === ROLENAME.DesignManager ||
                                role.name === ROLENAME.DesignHead ||
                                role.name === ROLENAME.AGM_Design ||
                                role.name === ROLENAME.DGM_Design ||
                                role.name === ROLENAME.Admin
                            )
                            ||
                            // 2. Design menu conditions
                            (hasTopLevelDesign ||
                            hasDesignInStatistics ||
                            hasTopLevelDesign1 ||
                            hasDesignInStatistics1)
                            )
                            &&
                            // // 3. Must match department
                            projectDetails?.departmentId?._id === designDepartment
                        ) &&
                        
                        (
                            <Button
                            variant="contained"
                            onClick={clickRaiseFlagButton}
                            style={{
                                backgroundColor: "#F47E46",
                                color: "white",
                                fontWeight: "bold",
                                textTransform: "none",
                                borderRadius:"12px",
                                padding: "6px 14px",
                            }}
                            startIcon={
                                !flagLoading && getFlagColorFromFlags(leadFlags) ? (
                                <FlagIcon style={{ color: getFlagColorFromFlags(leadFlags) }} />
                                ) : null
                            }
                            >
                            Click here to raise flag
                            </Button>
    
                              
                            )
                        }


                            {/* Customer Details */}
                            <Accordion defaultExpanded>
                                <AccordionSummary
                                    className={classes.sectionSummary}
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                <Typography className={`${classes.heading} ${classes.sectionHeading}`}><PersonIcon className={classes.sectionIcon} />Customer Details</Typography>
                                </AccordionSummary>

                                <Divider />

                                <AccordionDetails style={{ padding: '8px 0px 16px' }}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="customized table">
                                            <TableBody>
                                                <TableRow key='1'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Customer Name</span></TableCell>
                                                    <TableCell>{maskedCustomerName}</TableCell>
                                                </TableRow>
                                                <TableRow key='2'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PhoneIcon className={classes.cellIcon} />Contact</span></TableCell>
                                                    <TableCell>
                                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                                            {contactVisible && revealedContact
                                                                ? revealedContact
                                                                : projectDetails?.customerId?.contact_no}
                                                            {!isSalesDepartmentUser && (
                                                            <Tooltip title={contactVisible ? 'Hide number' : 'View contact number'}>
                                                                <span>
                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={handleToggleContactVisibility}
                                                                        disabled={contactRevealLoading}
                                                                        style={{ padding: 4 }}
                                                                    >
                                                                        {contactVisible ? <EyeFilled /> : <EyeOutlined />}
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                            )}
                                                            {canShowRunoCallIcon && (
                                                            <Tooltip title={runoCallLoading ? 'Initiating call...' : 'Call customer via Runo'}>
                                                                <span>
                                                                    <IconButton
                                                                        size="small"
                                                                        className={classes.runoCallButton}
                                                                        onClick={handleRunoClickToCall}
                                                                        disabled={runoCallLoading}
                                                                    >
                                                                        <PhoneIcon style={{ fontSize: 17 }} />
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                            )}
                                                        </span>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='3'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EmailIcon className={classes.cellIcon} />Email</span></TableCell>
                                                    <TableCell>{maskedCustomerEmail}</TableCell>
                                                </TableRow>
                                                <TableRow key='4'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><LocationOnIcon className={classes.cellIcon} />Address</span></TableCell>
                                                    <TableCell>{projectDetails?.customerId?.address}</TableCell>
                                                </TableRow>
                                                <TableRow key='5'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><BusinessIcon className={classes.cellIcon} />Department</span></TableCell>
                                                    <TableCell>{projectDetails?.departmentId?.name}</TableCell>
                                                </TableRow>
                                                <TableRow key='6'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><TimelineIcon className={classes.cellIcon} />Current Stage</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails.currentStage}
                                                        {projectDetails.currentStage === "Quotation Sent" &&
                                                            <>
                                                                <Button variant="contained" size="small" onClick={editQtSentMeetingDetails} style={{ marginLeft: '20px', cursor: 'pointer', background: 'green', color:'white', fontSize: '10px', borderRadius:'30px' }} > 
                                                                    Update Meeting Details
                                                                </Button>
                                                                <EyeOutlined style={{ marginLeft: '15px', cursor: 'pointer' }} onClick={handleViewQtSentMeetingDetail} />
                                                            </>                                                        }                                                    
                                                    </TableCell>
                                                </TableRow>
                                                {(projectDetails.closureDate) && (
                                                    <TableRow key='14'>
                                                        <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Tentative Design Closure</span></TableCell>
                                                        <TableCell>
                                                            {projectDetails?.closureDate ? moment(projectDetails?.closureDate).format('DD-MM-YYYY') : 'NA'}
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                                {(projectDetails?.designStatus === 'Design-Hold'  || projectDetails?.designStatus === 'Design-Hold Pending Approval') && (
                                                    <TableRow key='7'>
                                                        <TableCell className={classes.labelCell}><span className={classes.cellLabel}><FlagIcon className={classes.cellIcon} />Design Status</span></TableCell>
                                                        <TableCell>
                                                            {projectDetails?.designStatus || "N/A"}
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                                {(projectDetails?.designStatus === 'Design-Hold' || projectDetails?.designStatus === 'Design-Hold Pending Approval') && (
                                                    <TableRow key='8'>
                                                        <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Probable Date for Restarting the Designing</span></TableCell>
                                                        <TableCell>
                                                            {/* {moment(projectDetails?.proposedDesignStartDate).format('DD-MM-YYYY') || "N/A"} */}
                                                            {projectDetails?.proposedDesignStartDate ? moment(projectDetails?.proposedDesignStartDate).format('DD-MM-YYYY') : 'NA'}
                                                        </TableCell>
                                                    </TableRow>
                                                )}

                                                {/* {(projectDetails?.designStatus === 'Design-Hold' || projectDetails?.designStatus === 'Design-Hold Pending Approval') && (
                                                    <TableRow key='8.1'>
                                                        <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Probable Date of Design Sign-off</span></TableCell>
                                                        <TableCell>
                                                            {projectDetails?.probableDesignSignOffDate ? moment(projectDetails?.probableDesignSignOffDate).format('DD-MM-YYYY') : 'NA'}
                                                        </TableCell>
                                                    </TableRow>
                                                )} */}

                                                <TableRow key='9'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><AssignmentIndIcon className={classes.cellIcon} />Assigned To</span></TableCell>
                                                    <TableCell>{projectDetails?.assignTo?.name}</TableCell>
                                                </TableRow>
                                                <TableRow key='10'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><ConfirmationNumberIcon className={classes.cellIcon} />Lead Number</span></TableCell>
                                                    <TableCell>{projectDetails?.lead_no}</TableCell>
                                                </TableRow>
                                                <TableRow key='11'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><FingerprintIcon className={classes.cellIcon} />Unique Lead Number</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.uniqueLeadNumber ? (
                                                            <span className={classes.refCode}>
                                                                <span className={classes.refCodePrefix}>{String(projectDetails.uniqueLeadNumber).replace(/^([A-Za-z]*).*$/, '$1')}</span>
                                                                <span className={classes.refCodeDigits}>{String(projectDetails.uniqueLeadNumber).replace(/^[A-Za-z]*/, '')}</span>
                                                            </span>
                                                        ) : '-'}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='12'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><FolderIcon className={classes.cellIcon} />Project No.</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.erpProjectNo ? (
                                                            <span className={classes.refCode}>
                                                                <span className={classes.refCodePrefix}>{String(projectDetails.erpProjectNo).replace(/^([A-Za-z]*).*$/, '$1')}</span>
                                                                <span className={classes.refCodeDigits}>{String(projectDetails.erpProjectNo).replace(/^[A-Za-z]*/, '')}</span>
                                                            </span>
                                                        ) : '-'}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='13'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><StoreIcon className={classes.cellIcon} />ExperienceCenter</span></TableCell>
                                                    <TableCell>{projectDetails?.experienceCenterId?.name ? projectDetails?.experienceCenterId?.name : '-'}</TableCell>
                                                </TableRow>
                                                {projectDetails?.assignedQCPersonName && (
                                                    <TableRow key='14'>
                                                        <TableCell className={classes.labelCell}><span className={classes.cellLabel}><VerifiedUserIcon className={classes.cellIcon} />Assigned QC Person</span></TableCell>
                                                        <TableCell>{projectDetails?.assignedQCPersonName}</TableCell>
                                                    </TableRow>
                                                )}

                                                {/* <TableRow key='9a'> */}
                                                {/* <TableCell>Total Amount Paid by Customer</TableCell>
                                                    <TableCell style={{ color: "#0000ff" }}>
                                                        <span onClick={() => paymentData()}>
                                                                ₹ {projectDetails?.totalAmountPaidByCustomer ? commaSeparateAmount(projectDetails?.totalAmountPaidByCustomer) : `0`}
                                                            </span> */}
                                                {/* </TableCell>
                                                    </TableRow>
                                                    <TableRow key='9'>
                                                    <TableCell>Customer Pending Amount</TableCell>
                                                    <TableCell> ₹ {projectDetails?.pendingAmountByCustomer ? commaSeparateAmount(projectDetails?.pendingAmountByCustomer) : `0`}</TableCell>
                                                </TableRow>  */}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>

                                <Divider />

                                {/* Meeting Dialog */}
                                <Dialog open={openDialogForMeeting} onClose={handleClose} maxWidth="md" fullWidth>
                                    <DialogTitle>Meeting Tracker</DialogTitle>
                                    <DialogContent>
                                        <Box sx={{ mb: 3 }}>
                                            {/* Add Meeting Button */}
                                            {!showForm && (
                                                <Button variant="contained" color="primary" onClick={handleAddMeeting} style={{ marginBottom: 15 }}>
                                                    Add Meeting
                                                </Button>
                                            )}
                                            {/* Meeting Form */}
                                            {showForm && (
                                                <Box sx={{ mb: 2 }}>
                                                    {/* Sales Stage Selection */}
                                                    <FormControl fullWidth variant="outlined" style={{ marginBottom: 10 }}>
                                                        <InputLabel id="select-stage">Select Stage</InputLabel>
                                                        <Select
                                                            labelId="select-stage"
                                                            id="select-stage"
                                                            value={stage}
                                                            label="Select Stage"
                                                            variant="outlined"
                                                            onChange={(e) => handleSelectedStageChange(e)}
                                                        >
                                                            {departmentStage
                                                                ?.filter(row =>
                                                                    row === "Negotiation" ||
                                                                    row === "Won" ||
                                                                    row === "Site/Office visit" ||
                                                                    row === "Lost"
                                                                )
                                                                ?.map((row, i) => {
                                                                    let isActive = true;
                                                                    let mtmOption = false;
                                                                    if ((projectDetails?.currentStage === 'Design Discussion' && (row === 'Design Discussion' || row === 'Lost'))
                                                                        ||
                                                                        ((projectDetails?.currentStage === 'Internal Design Sign-Off' || projectDetails.currentStage === 'Design Sign-off HOLD' || projectDetails.currentStage === 'Design Sign-off') && (row === 'Design Sign-off' || row === 'Design Sign-off HOLD' || row === 'Lost'))
                                                                        ||
                                                                        (i === currentStageIndex || row === 'Lost')) {
                                                                        isActive = false;
                                                                    }
                                                                    if (
                                                                        row === 'Move to Marketing'
                                                                        && (
                                                                            userDetails?.roles?.find(role => role.name === ROLENAME.SalesUser)
                                                                            || isMoveToMarketingBlockedByAssignmentAge(projectDetails?.leadAssignedDate)
                                                                        )
                                                                    ) {
                                                                        mtmOption = true;
                                                                    } else {
                                                                        mtmOption = false;
                                                                    }
                                                                    const isInternalSignOffDisabled = row === 'Internal Design Sign-Off' && projectDetails?.internalDesignSignOffDate;
                                                                    const isDisabledMoveThroughNaraci = row === 'Drawing QC' || row === 'Design Sign-off';
                                                                    const isDesignerBlockedFromInternalKickOff = row === 'Internal Kick-Off';
                                                                    const menuItemLabel = isDesignerBlockedFromInternalKickOff
                                                                        ? `${row} (Assigned by ODM)`
                                                                        : (isDisabledMoveThroughNaraci ? `${row} (Naraci - Push to DQC)` : row);
                                                                    return (
                                                                        projectDetails?.departmentId?.name === 'Design' && userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser) ? (
                                                                            <MenuItem key={i + 1} value={row} disabled={isActive || isInternalSignOffDisabled || isDisabledMoveThroughNaraci || isDesignerBlockedFromInternalKickOff}>{menuItemLabel}</MenuItem>
                                                                        ) : (
                                                                            <MenuItem key={i + 1} value={row} disabled={mtmOption || isInternalSignOffDisabled || isDisabledMoveThroughNaraci}>{menuItemLabel}</MenuItem>
                                                                        )
                                                                    );
                                                                })}
                                                        </Select>
                                                    </FormControl>
                                                    {/* Meeting Type */}
                                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined">
                                                        <InputLabel>Meeting Type</InputLabel>
                                                        <Select
                                                            id="demo-simple-select"
                                                            value={meetingType}
                                                            onChange={(e) => setMeetingType(e.target.value)}
                                                            variant="outlined"
                                                            label="Meeting Type"
                                                        >
                                                            <MenuItem value="Office Meet">Office Meet</MenuItem>
                                                            <MenuItem value="Residence Meeting">Residence Meeting</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                    {/* Meeting Date */}
                                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                                        <TextField
                                                            id="meetingDoneDate"
                                                            value={meetingDate}
                                                            onChange={(e) => {
                                                                const today = new Date().toISOString().split("T")[0];
                                                                if (e.target.value > today) return;
                                                                setMeetingDate(e.target.value);
                                                            }}
                                                            label="Meeting Done Date"
                                                            type="date"
                                                            InputLabelProps={{ shrink: true }}
                                                            inputProps={{
                                                                max: new Date().toISOString().split("T")[0],
                                                            }}
                                                            variant="outlined"
                                                        />
                                                    </FormControl>
                                                    {/* Submit Button */}
                                                    <Button variant="contained" color="primary" onClick={handleSubmit} style={{ marginRight: 10 }}>
                                                        Save
                                                    </Button>
                                                    <Button variant="outlined" color="secondary" onClick={() => setShowForm(false)}>
                                                        Cancel
                                                    </Button>
                                                </Box>
                                            )}
                                            {/* Table */}
                                            <TableContainer component={Paper}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>S.No</TableCell>
                                                            <TableCell>Created Date</TableCell>
                                                            <TableCell>Stage</TableCell>
                                                            <TableCell>Meeting Date</TableCell>
                                                            <TableCell>Meeting Type</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {filteredData.map((log, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell>
                                                                    {new Date(log?.createdAt).toLocaleDateString()}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {log.meetingStage || 'Designer Assignment Pending'}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {log.meetingDate ?
                                                                        new Date(new Date(log?.meetingDate).getTime() + (5 * 60 + 30) * 60 * 1000).toLocaleDateString()
                                                                        : '-'}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {log?.meetingTypes?.officeMeets?.length > 0 ? 'Office Meet' :
                                                                        log?.meetingTypes?.residenceMeets?.length > 0 ? 'Residence Meet' : ''}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                        {filteredData.length === 0 && (
                                                            <TableRow>
                                                                <TableCell colSpan={4} align="center">
                                                                    No meetings found
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose} color="primary">
                                            Close
                                        </Button>
                                    </DialogActions>
                                </Dialog>


                                <AccordionActions className={classes.actionBar}>

                                    {/* Start - Payment Integration */}
                                    {
                                        (userDetails?.roles?.find(role => role.name === ROLENAME.Admin) || (userDetails?.roles?.find(role => role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager) || (userDetails?.roles?.find(role => role.name === ROLENAME.DesignHead)) ||  (userDetails?.roles?.find(role => role.name === ROLENAME.salesAGM)) || (userDetails?.roles?.find(role => role.name === ROLENAME.salesDGM)) || (userDetails?.roles?.find(role => role.name === ROLENAME.salesManager)))) &&
                                        <Button variant="contained" color="secondary" size="small" onClick={handlePayment}>Payment Details</Button>
                                    }
                                    
                                    {/* End - Payment Integration */}
                                    {/* Date changes of expected payment Date */}
                                    {
                                        (userDetails?.roles?.find(role => role.name === ROLENAME.Admin || 
                                            role.name === ROLENAME.DecorpotRFDExecutives || 
                                            role.name === ROLENAME.DecorpotRFDManager)) && (
                                            <>
                                            <Button 
                                                variant="contained" 
                                                color="secondary" 
                                                size="small" 
                                                onClick={handlePaymentDate}
                                            >
                                                Change Expected Payment Date
                                            </Button>

                                            {/* Calendar Popup */}
                                            {showCalendar && (
                                                <div style={{
                                                position: 'fixed',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                zIndex: 9999,
                                                }}>
                                                <div style={{
                                                    backgroundColor: 'white',
                                                    padding: '24px',
                                                    borderRadius: '8px',
                                                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                                    minWidth: '300px',
                                                }}>
                                                    <h3 style={{ margin: '0 0 16px 0' }}>Select Expected Payment Date</h3>
                                                    
                                                    {/* Calendar Input */}
                                                    <input
                                                    type="date"
                                                    value={selectedDate}
                                                    onChange={handleDateSelect}
                                                    style={{
                                                        width: '100%',
                                                        padding: '10px',
                                                        fontSize: '16px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px',
                                                        marginBottom: '20px',
                                                    }}
                                                    />
                                                    
                                                    {/* Buttons */}
                                                    <div style={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                    justifyContent: 'flex-end',
                                                    }}>
                                                    <button
                                                        onClick={handleCancel}
                                                        style={{
                                                        padding: '8px 16px',
                                                        backgroundColor: '#f5f5f5',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        onClick={handleUpdateDate}
                                                        disabled={!selectedDate || isUpdating}
                                                        style={{
                                                        padding: '8px 16px',
                                                        backgroundColor: !selectedDate || isUpdating ? '#ccc' : '#1976d2',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: !selectedDate || isUpdating ? 'not-allowed' : 'pointer',
                                                        }}
                                                    >
                                                        {isUpdating ? 'Updating...' : 'Update'}
                                                    </button>
                                                    </div>
                                                </div>
                                                </div>
                                            )}
                                            </>
                                        )
                                    }
                                    {
                                        userDetails?.roles?.find(role => role.name === ROLENAME.DocumentUploader) &&
                                        <Button variant="contained" color="primary" size="small" onClick={navigateToVerifyPage}>Verify Documents</Button>
                                    }

                                    {
                                        ((userDetails.email === projectDetails?.assignTo?.email && userDetails?.roles?.find(role => role.name === ROLENAME.MarketingUser || role.name === ROLENAME.TeleCallerUser)) || (marketingUserEmails.includes(userDetails.email)) || (userDetails?.roles?.find(role => role.name === ROLENAME.TeleCallerManager || role.name === ROLENAME.MarketingManager))) &&
                                        <Button variant="contained" color="primary" size="small" onClick={openStatusUpdateModal}>Update Status</Button>
                                    }
                                    {
                                        userDetails?.roles?.find(role => role.name === ROLENAME.Admin || role.name === ROLENAME.DGM_Design || role.name === ROLENAME.DesignHead) &&
                                        <Button variant="contained" color="secondary" size="small" onClick={() => setOpenErpProjectNoModal(true)}>Change Project No.</Button>
                                    }
                                    {
                                        userDetails?.roles?.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.DesignUser || role.name == ROLENAME.AssistantDesignManager) &&
                                        <Button variant="contained" color="primary" size="small" disabled = { projectDetails.designStatus === "Design-Hold Pending Approval"} onClick={openStatusUpdateModal}>Update Status</Button>
                                    }
                                    {
                                        userDetails?.roles?.find(role => role.name === ROLENAME.DesignHead || role.name === ROLENAME.DGM_Design || role.name === ROLENAME.AGM_Design) &&
                                        <Button variant="contained" color="primary" size="small"  onClick={openStatusUpdateModal}>Update Status</Button>
                                    }
                                    {
                                        userDetails?.roles?.find
                                            (role =>
                                                role.name === ROLENAME.SeniorOperationManager &&
                                                projectDetails.currentStage == CURRENT_STAGE[6]) &&
                                        <Button variant="contained" style={{ background: '#2c2e3e', color: 'white' }} size="small" onClick={() => setOpenAssignSiteQcModel(true)}>Assign Site QC</Button>
                                    }
                                    {/* {
                                        userDetails?.roles?.find
                                            (role => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.Admin) &&
                                        <Button variant='contained' color="primary" size="small" onClick={openChmUserDialog} disabled={projectDetails?.salesStage !== 'Won'}>Change CHM User</Button>   //button should be disable before lead won  because when lead won then lead assigning chm user using round robin 
                                    } */}
                                  {
                                        userDetails?.roles?.find
                                        (role => role.name === ROLENAME.DesignUser || role.name === ROLENAME.AssistantDesignManager|| role.name === ROLENAME.DGM_Design|| role.name === ROLENAME.DesignHead ) && (projectDetails.currentStage === "Design Sign-off HOLD" && projectDetails.contractCustomerApproved == true) &&
                                        (<Button variant='contained' color="primary" size="small" onClick={() => uploadProductDocument()}>Revoke Design Sign-off HOLD & Move to Production</Button>)
                                    }
                                    <Button variant="contained" color="primary" size="small" onClick={openCreateNotesModal}>Task & Reminder</Button>
                                    <Button variant="contained" color="primary" size="small" onClick={openNotesNewModal}>Notes</Button>
                                    {
                                        userDetails?.roles?.find(role => role.name !== ROLENAME.MarketingUser && role.name !== ROLENAME.MarketingManager && role.name !== ROLENAME.DocumentUploader && role.name !== ROLENAME.ScopeAdmin && role.name !== ROLENAME.QCManager && role.name !== ROLENAME.QualityControl ) &&
                                        <Button variant="contained" color="secondary" size="small" onClick={viewQuotationPage}>View Quotation</Button>
                                    }
                                     {
                                        userDetails?.roles?.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.Admin) &&
                                        <Button
                                            variant="contained"
                                            color="secondary" size="small"
                                            className={classes.generateButton} onClick={handleOpenDialog}
                                        >
                                            Update & View Meetings
                                        </Button>
                                    }
                                    {
                                        (userDetails?.roles?.find(role => role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User || role.name === ROLENAME.Admin || role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager)) &&
                                        <Button variant="contained" color="secondary" size="small" onClick={openCHMticketPage}>Raise Internal Ticket</Button>
                                    }
                                    {
                                         userDetails?.roles?.find(role => role.name === ROLENAME.TeleCallerManager || role.name === ROLENAME.TeleCallerUser) &&
                                         <>
                                     <Button variant="contained" color="primary" size="small">
                                        <a 
                                            href="https://decorpotprivatelimited.zohodesk.in/portal/en/newticket" 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            style={{ color: "white", textDecoration: "none" }}
                                        >
                                            Raise Service Ticket
                                        </a>
                                        </Button>
                                         </>
                                    }

                                    {!userDetails?.roles?.some(role => role.name === ROLENAME.QCManager || role.name === ROLENAME.QualityControl || role.name === ROLENAME.QC_Head) &&
                                        (userDetails?.roles?.find(role => role.name !== ROLENAME.Admin && role.name !== ROLENAME.MarketingUser && role.name !== ROLENAME.MarketingManager && role.name !== ROLENAME.ScopeAdmin && role.name !== ROLENAME.DocumentUploader && role.name !== ROLENAME.TeleCallerUser || role.name !== ROLENAME.TeleCallerManager || role.name !== ROLENAME.QCManager || role.name !== ROLENAME.QualityControl) &&
                                            (userDetails.email === projectDetails?.assignTo?.email || userDetails?.teamId?._id === projectDetails?.assignTo?.teamId?._id || userDetails.departmentId === projectDetails?.departmentId?._id)
                                            // && projectDetails?.salesStage !== 'Won Deals Pending Designer Assignment'
                                        ) &&
                                         <>
                                         <Button variant="contained" color="secondary" size="small" onClick={handleClickOpen}
                                         disabled={ 
                                         isDesignerBlockedWhileDsoPending(projectDetails) ||
                                         (
                                            (projectDetails?.currentStage === "Design Sign-off" ||  projectDetails?.currentStage === "Material Dispatched (In-transit)") &&
                                            (
                                            projectDetails?.contractQualityControlApproved || 
                                            projectDetails?.contractQCManagerApproved ||
                                            projectDetails?.contractDesignManagerApproved ||
                                            projectDetails?.contractCustomerApproved ||
                                            projectDetails?.contractFinanceApproved 
                                            )
                                            ) 
                                        }
                                         title={isDesignerBlockedWhileDsoPending(projectDetails) ? DSO_PENDING_DESIGNER_MOVE_BLOCK_MESSAGE : undefined}
                                        > Move Deal</Button>
                                        </>
                                    }
                                    {canRaiseInternalDkoChecklist() && (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                            onClick={openDesignKickOffInternalDialog}
                                        >
                                            Raise Internal Kick-Off Checklist
                                        </Button>
                                    )}
                                    {canDesignerRaiseCustomerDko() && (
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                            onClick={() => history.push('/design_kick-off')}
                                        >
                                            Send Customer Kick-Off for Approval
                                        </Button>
                                    )}
                                    {/* {!projectDetails?.drawingQcTwoApproved && userDetails?.roles?.some(
                                        role => [
                                            ROLENAME.DesignUser,
                                        ].includes(role.name)
                                    ) && 
                                    ((projectDetails?.currentStage === "Drawing QC" || projectDetails?.currentStage === "Internal Design Sign-Off")) && (
                                        <Button 
                                            variant="contained" 
                                            color="secondary" 
                                            size="small" 
                                            onClick={dwgSubStagesButton}
                                            disabled={(
                                                isDesignerBlockedWhileDsoPending(projectDetails) ||
                                                projectDetails?.drawingQCStage === "ADM In Progress" ||
                                                projectDetails?.drawingQCStage === "QC1 In Progress" ||
                                                projectDetails?.drawingQCStage === "QC2 In Progress" ||
                                                projectDetails?.drawingQCStage === "Final Signoff In Progress"
                                            )}
                                        >
                                            Update DWG Sub Stages
                                        </Button>
                                    )} */}


                                    {/* Hot Deal Checklist Button */}
                                    {
                                        (userDetails?.departmentId === constantDepartmentId.sales) &&
                                        (userDetails.email === projectDetails?.assignTo?.email || userDetails?.teamId?._id === projectDetails?.assignTo?.teamId?._id || userDetails.departmentId === projectDetails?.departmentId?._id)
                                        &&
                                        <>
                                            <Button variant="contained" color="primary" size="small" disabled={[
                                                    'Lead Received',
                                                    'Requirements Not Collected',
                                                    'Requirements Collected',
                                                    'Won Deals Pending Designer Assignment',
                                                    'Lost'
                                                ].includes(projectDetails?.currentStage)} 
                                                onClick={handleHotDealChecklist}
                                            > 
                                                Hot Deal Checklist
                                            </Button>
                                        </>
                                    }

                                    {/* Hot deal checklist Model/ Dialog */}
                                    <Dialog
                                        open={hotDealModel}
                                        onClose={() => setHotDealModel(false)}
                                        aria-labelledby="form-dialog-title"
                                        maxWidth="sm"
                                        PaperProps={{
                                            style: {
                                                width: "100%",
                                                maxHeight: "80vh",
                                            },
                                        }}
                                    >
                                        <DialogTitle id="form-dialog-title">
                                            <h4>Hot Deal Checklist</h4>
                                        </DialogTitle>
                                        <Divider />
                                        <DialogContent>
                                            {/* timeline */}
                                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                                <InputLabel id="cx-move-into-timeline">Customer Move-in timeline *</InputLabel>
                                                <Select
                                                    labelId="cx-move-into-timeline"
                                                    id="cx-move-into-timeline"
                                                    label="Customer Move-in timeline"
                                                    value={cxMoveInTimelineValue}
                                                    onChange={(e) => setCxMoveInTimelineValue(e.target.value)}
                                                    variant="outlined"
                                                >
                                                    {cxMoveInTime.map((data, i) => {
                                                        return (
                                                            <MenuItem key={i + 1} value={data}>{data}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                            {/* possession status */}
                                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                                <InputLabel id="possessionStatus">Possesion Status *</InputLabel>
                                                <Select
                                                    labelId="possessionStatus"
                                                    id="possessionStatus"
                                                    label="Possession Status"
                                                    value={possesionStatusValue}
                                                    onChange={(e) => setPossesionStatusValue(e.target.value)}
                                                    variant="outlined"
                                                >
                                                    {possessionStatus.map((data, i) => {
                                                        return (
                                                            <MenuItem key={i + 1} value={data}>{data}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                            {/* Registration Status */}
                                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                                <InputLabel id="registrationStatus"> Registration Status *</InputLabel>
                                                <Select
                                                    labelId="registrationStatus"
                                                    id="registrationStatus"
                                                    label="Registration Status"
                                                    value={regStatusValue}
                                                    onChange={(e) => setRegStatusValue(e.target.value)}
                                                    variant="outlined"
                                                >
                                                    {registrationStatus.map((data, i) => {
                                                        return (
                                                            <MenuItem key={i + 1} value={data}>{data}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                            {/* Decision Maker */}
                                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                                <InputLabel id="decisionMaker">Decision Maker *</InputLabel>
                                                <Select
                                                    labelId="decisionMaker"
                                                    id="decisionMaker"
                                                    label="Decision Maker"
                                                    value={decisionMakerValue}
                                                    onChange={(e) => setDecisionMakerValue(e.target.value)}
                                                    variant="outlined"
                                                >
                                                    {decisionMaker.map((data, i) => {
                                                        return (
                                                            <MenuItem key={i + 1} value={data}>{data}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                            {/* Financial Readiness */}
                                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                                <InputLabel id="financialReadiness">Financial Readiness *</InputLabel>
                                                <Select
                                                    labelId="financialReadiness"
                                                    id="financialReadiness"
                                                    label="Financial Readiness"
                                                    value={financialReadinessValue}
                                                    onChange={(e) => setFinancialReadinessValue(e.target.value)}
                                                    variant="outlined"
                                                >
                                                    {financialReadiness.map((data, i) => {
                                                        return (
                                                            <MenuItem key={i + 1} value={data}>{data}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                            {/* Budget vs Quotation */}
                                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                                <InputLabel id="budgetQt">Budget Vs Quotation *</InputLabel>
                                                <Select
                                                    labelId="budgetQt"
                                                    id="budgetQt"
                                                    label="Budget Vs Quotation"
                                                    value={budgetQtValue}
                                                    onChange={(e) => setBudgetQtValue(e.target.value)}
                                                    variant="outlined"
                                                >
                                                    {budgetVsQuotation.map((data, i) => {
                                                        return (
                                                            <MenuItem key={i + 1} value={data}>{data}</MenuItem>
                                                        )
                                                    })}
                                                </Select>
                                            </FormControl>
                                            {/* Competitor Involvement */}
                                            <FormControl component="fieldset" style={{ width: '100%' }}>
                                                <FormGroup>
                                                    <Typography>Competitor Involvement *</Typography>
                                                    {competitorInvolvement.map((data, i) => (
                                                        <div
                                                            key={i}
                                                            style={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                lineHeight: 1,
                                                                color: 'grey'
                                                            }}
                                                        >
                                                            <Typography style={{ width: '30px' }}>{i + 1}.</Typography>
                                                            <Typography style={{ flexGrow: 1 }}>{data} </Typography>
                                                            <Checkbox color="primary" checked={competitorValue.includes(data)} onChange={(e) => handleCompetitorInvolvement(e, data)} />
                                                        </div>
                                                    ))}
                                                </FormGroup>
                                            </FormControl>

                                            {competitorValue.includes('Other') &&
                                                <TextField
                                                    fullWidth
                                                    label="Other Competitor"
                                                    name="otherCompetitor"
                                                    id="otherCompetitor"
                                                    variant="outlined"
                                                    value={otherCompetitorValue}
                                                    onChange={(e) => setOtherCompetitorValue(e.target.value)}
                                                    required
                                                    style={{ marginBottom: '10px' }}
                                                />
                                            }

                                            {/* hot deal checklist sales won date */}
                                            <FormControl fullWidth style={{ marginBottom: "15px", marginTop: '10px' }} variant="outlined" size="small">
                                                <TextField
                                                    label=" Expected Sales Won Date"
                                                    name="salesWonDate"
                                                    id="salesWonDate"
                                                    variant="outlined"
                                                    value={hotDealSalesWonDate}
                                                    onChange={(e) => setHotDealSalesWonDate(e.target.value)}
                                                    type="date"
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                    size="small"
                                                    required
                                                />
                                            </FormControl>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={() => setHotDealModel(false)} variant="outlined">
                                                Cancel
                                            </Button>
                                            <Button
                                                onClick={handleHotDealSubmit}
                                                variant="contained"
                                                color="primary"
                                                className={classes.submitButton}
                                                disabled={!cxMoveInTimelineValue || !possesionStatusValue || !regStatusValue || !decisionMakerValue || !financialReadinessValue || !budgetQtValue || !hotDealSalesWonDate || competitorValue.length === 0 || (competitorValue.includes('Other') && !otherCompetitorValue)}
                                            >
                                                Submit
                                            </Button>
                                        </DialogActions>
                                    </Dialog>

                                    {

                                        ((projectDetails.finalizationOfMaterialStageStatus === "Client Submitted") && (userDetails.departmentId === designDepartment))
                                        &&
                                        <>
                                            <Button variant="contained" color="secondary" size="small" onClick={navigateToMatCheckList}
                                            > Fill Material Checklist</Button>
                                        </>
                                    }
                                    
                                    {/* This button of move DQC stages. */}
                                    {/* {userDetails?.roles?.find(role => role.name === ROLENAME.QualityControl || role.name === ROLENAME.QC_Head) && projectDetails?.drawingQcAdmApproved && 
                                    !projectDetails?.drawingQcTwoApproved &&
                                        <Button
                                            variant="contained"
                                            color="secondary" size="small"
                                            className={classes.generateButton} 
                                            onClick={handleOpenDwgDialog}
                                             disabled={
                                                !(
                                                    projectDetails?.drawingQCStage === "QC1 In Progress" ||
                                                    projectDetails?.drawingQCStage === "QC2 In Progress"
                                                )
                                            }
                                        >
                                            Update DWG Status  
                                        </Button>
                                    } */}
                                    {userDetails?.roles?.find(role => role.name === ROLENAME.QCManager ||  role.name === ROLENAME.QC_Head || (role.name === ROLENAME.AGM_Design && (projectDetails.currentStage === "Drawing QC" || projectDetails.currentStage === "Internal Design Sign-Off") )) &&
                                        !projectDetails?.drawingQcTwoApproved && (
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                size="small"
                                                className={classes.generateButton}
                                                onClick={handleOpenAssign}
                                            >
                                                Assign Project to QC  
                                            </Button>
                                        )
                                    }


                                {/* </AccordionActions>
                                <AccordionActions> */}
                                    {
                                        (userDetails?.roles?.find(role => role.name === ROLENAME.Admin || role.name === ROLENAME.DecorpotRFDManager)) && (
                                            <>
                                            <Button 
                                                variant="contained" 
                                                color="secondary" 
                                                size="small" 
                                                onClick={() => openAssignDialog(projectId)}
                                            >
                                                Assign CRM User
                                            </Button>
                                            <AssignCRMUserDialog
                                                open={assineDialogOpen}
                                                onClose={() => {
                                                setAssineDialogOpen(false);
                                                setSelectedLead(null);
                                                }}
                                                leadId={projectId}
                                                leadNumber={projectId}
                                                onAssignSuccess={handleAssignSuccess}
                                            />
                                            </>
                                        )
                                    }
                                    {!userDetails?.roles?.find(role => role.name === ROLENAME.QCManager|| role.name === ROLENAME.QualityControl || role.name === ROLENAME.QC_Head) && (
                                    <Button variant="contained" color="primary" size="small" onClick={handleCallDetailRecordings}>Call Detail Recordings</Button>)}
                                    <Button variant="contained" size="small" onClick={handleBotWotChat} className={classes.greenButton}>BotWot Chats</Button>
                                    <Button variant="contained" size="small" onClick={handleHoomanLabsTranscripts} className={classes.purpleButton}>AI-Karan Transcripts</Button>
                                    {canUseCallingDesk && (
                                        <Button variant="contained" size="small" onClick={() => setCallingDeskOpen(true)} className={classes.callingDeskButton}>Calling Desk</Button>
                                    )}
                                    {/* Transfer EC only makes sense while the lead is still owned by
                                        Sales - once it has moved on (e.g. to Design), the Sales team no
                                        longer owns it and this action should disappear entirely. */}
                                    {projectDetails?.departmentId?._id === salesDepartment &&
                                    userDetails?.roles?.find(role =>
                                        role.name === ROLENAME.Admin ||
                                        role.name === ROLENAME.SalesHead ||
                                        role.name === ROLENAME.DGM_Sales ||
                                        role.name === ROLENAME.AGMSales ||
                                        role.name === ROLENAME.SalesManager ||
                                        role.name === ROLENAME.AssistantSalesManager ||
                                        role.name === ROLENAME.SalesUser
                                    ) && (
                                        <>
                                            <Button
                                                variant="contained"
                                                size="small"
                                                onClick={() => setAssignToECDialogOpen(true)}
                                            >
                                                Transfer EC
                                            </Button>
                                            <AssignToECDialog
                                                open={assignToECDialogOpen}
                                                onClose={() => setAssignToECDialogOpen(false)}
                                                leadId={projectId}
                                                currentUniqueLeadNumber={projectDetails?.uniqueLeadNumber}
                                                currentExperienceCenterId={projectDetails?.experienceCenterId?._id}
                                                currentExperienceCenterName={projectDetails?.experienceCenterId?.name}
                                                currentExperienceCenterCode={projectDetails?.experienceCenterId?.code}
                                                currentLocationId={projectDetails?.experienceCenterId?.locationId?._id}
                                                onAssignSuccess={handleAssignToECSuccess}
                                            />
                                        </>
                                    )}
                                    {/* Move to Marketing (Runo-gated) - standalone button, same gating
                                        as Transfer EC. Enabled once this lead has 5+ unanswered Runo
                                        calls, OR one call carrying a recording or transcript, OR a
                                        contact number that cannot be dialled at all
                                        (see runoEligibility / isMoveToMarketingRunoDisabled).
                                        This is independent of, and doesn't alter, the existing
                                        "Move to Marketing" option still reachable via "Move Deal" ->
                                        stage dropdown. The submit API is a placeholder for now (see
                                        HttpService.submitMoveToMarketingWithRunoData) pending the real
                                        endpoint. */}
                                    {projectDetails?.departmentId?._id === salesDepartment &&
                                    userDetails?.roles?.find(role =>
                                        role.name === ROLENAME.Admin ||
                                        role.name === ROLENAME.SalesHead ||
                                        role.name === ROLENAME.DGM_Sales ||
                                        role.name === ROLENAME.AGMSales ||
                                        role.name === ROLENAME.SalesManager ||
                                        role.name === ROLENAME.AssistantSalesManager ||
                                        role.name === ROLENAME.SalesUser
                                    ) && (
                                        <>
                                            <Tooltip
                                                title={
                                                    runoEligibility.loading
                                                        ? "Checking Runo call history..."
                                                        : moveToMarketingBlockedByAssignmentAge
                                                            ? moveToMarketingAssignmentAgeMessage()
                                                            : runoEligibility.alreadyUsed
                                                            ? "This lead has already been through Runo-based Move to Marketing review - it can only be used once"
                                                            : runoEligibility.phoneInvalid
                                                                ? `This customer's number is not dialable (${runoEligibility.phoneInvalidReason || "invalid number"}), so no calls can be made - the lead can be moved without call history`
                                                                : !runoEligibility.isEligible
                                                                    ? `Needs one of: ${runoEligibility.unansweredCount} of ${RUNO_UNANSWERED_THRESHOLD} unanswered Runo calls, or ${runoEligibility.transcribedCallCount} calls with a recording or transcript (1 is enough)`
                                                                    : ""
                                                }
                                            >
                                                <span>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        disabled={isMoveToMarketingRunoDisabled}
                                                        onClick={() => setMoveToMarketingRunoDialogOpen(true)}
                                                    >
                                                        Move to Marketing
                                                    </Button>
                                                </span>
                                            </Tooltip>
                                            <MoveToMarketingRunoDialog
                                                open={moveToMarketingRunoDialogOpen}
                                                onClose={() => setMoveToMarketingRunoDialogOpen(false)}
                                                leadId={projectId}
                                                reasonOptions={moveToMarketingReasons}
                                                eligibility={runoEligibility}
                                                onSubmitSuccess={handleMoveToMarketingRunoSuccess}
                                            />
                                        </>
                                    )}
                                    {!userDetails?.roles?.find(role => role.name === ROLENAME.QCManager|| role.name === ROLENAME.QualityControl || role.name === ROLENAME.QC_Head) && (
                                    <Button variant="contained" color="secondary" size="small" onClick={handleCallLogs}>Call Logs</Button>)}

                                    {canEditLead && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            onClick={openEditProjectModal}
                                            disabled={
                                                !isPrivilegedUser &&
                                                (
                                                    projectDetails?.leadStatus === 'Lost' ||
                                                    projectDetails?.customerId?.isEdit === 'true' ||
                                                    projectDetails?.customerId?.isEdit === true
                                                )
                                            }
                                        >
                                            Edit Lead
                                        </Button>
                                    )}

                                    {
                                        userDetails?.roles?.find(role => role.name !== ROLENAME.MarketingManager || role.name !== ROLENAME.MarketingUser) &&
                                        <Button variant="contained" color="primary" size="small" onClick={() => viewCheckList()}>View Check List</Button>
                                    }
                                    {
                                    userDetails?.roles?.find(role => role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignHead || role.name === ROLENAME.DesignUser  || role.name === ROLENAME.Admin || role.name === ROLENAME.DGM_Design ||  role.name === ROLENAME.AGM_Design) &&
                                        // <Button variant="contained" color="secondary" size="small" onClick={() => setOpenDesignSignOffModal(true)}>Expected Design Sign-off Date</Button>
                                        <Button variant="contained" color="secondary" size="small"  onClick = {handleAIDesignSignoffDate}>Expected Design Sign-off Date</Button>
                                    }
                                    {/* {
                                        (userDetails?.roles?.find(role => role.name === ROLENAME.AssistantDesignManager) && projectDetails?.projectedDesignSignOffDate && !projectDetails?.monthlyContractCompleted) &&
                                        <Button variant="contained" color="secondary" size="small" onClick={() => setRevisedDateModal(true)}>Change Projected Design Sign-Off Date</Button>
                                    }
                                    {
                                        (userDetails?.roles?.find(role => role.name === ROLENAME.AssistantDesignManager) && projectDetails?.projectedDesignSignOffDate && !projectDetails?.monthlyContractCompleted) &&
                                        <Button variant="contained" color="secondary" size="small" onClick={() => setUploadModal(true)}>Update Monthly Contract</Button>
                                    } */}
                                    {
                                        projectDetails.designStages === 'Assign to Designer' && userDetails?.roles?.find(role => role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager) &&
                                        <Button variant="contained" color="primary" size="small" onClick={() => { setOpenDesignerAssignmentDate(true); getDesignUsers() }}> Set Designer Assignment Date </Button>
                                    }
                                    {
                                        userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser || role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User) &&
                                        <Button variant="contained" color="primary" size="small" onClick={() => setOpenUpdatePaymentModel(true)} > Update Payment </Button>
                                    }
                                    {
                                        userDetails?.roles?.find(role => role.name === ROLENAME.Execution_Manager || role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User || role.name === ROLENAME.SeniorOperationManager) &&
                                        <Button variant="contained" color="primary" size="small" onClick={clientExtraDays}>Extra days due to client dependency</Button>
                                    }
                                    {
                                        userDetails?.roles?.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesUser) &&
                                        <Button variant="contained" color="primary" size="small" onClick={floorPlanButton}>Floor Plan</Button>
                                    }
                                    {/* {
                                        userDetails?.roles?.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.SalesHead || role.name === ROLENAME.SalesUser || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.AGMSales) &&
                                        <Button variant="contained" color="secondary" size="small" onClick={() => setOpenEnterSalesClosureDateModal(true)}>Enter Expected Sales Closure Date</Button>
                                    } */}
                                   { !(userDetails?.roles?.find(role => role.name === ROLENAME.QC_Head)) &&
                                        ((userDetails?.departmentId === salesDepartment || userDetails?.departmentId === designDepartment || userDetails?.departmentId === constantDepartmentId.chm || (userDetails?.roles?.find(role => role.name === ROLENAME.FactoryCrmUser))) && (userDetails?.roles?.find(role => role.name !== ROLENAME.QCManager && role.name !== ROLENAME.QualityControl)))&&
                                        <Button
                                            variant="contained"
                                            color="secondary" size="small"
                                            className={classes.generateButton}
                                            onClick={handleClickOpenNew}
                                            disabled={(userDetails?.departmentId === constantDepartmentId.chm || (userDetails?.roles?.find(role => role.name === ROLENAME.FactoryCrmUser)) ? false : userDetails?.departmentId !== projectDetails?.departmentId?._id) || disabled}
                                        >
                                            Generate Payment Link
                                        </Button>
                                    }

                                    {
                                        ((userDetails?.departmentId === salesDepartment || userDetails?.departmentId === designDepartment ))&&
                                        <Button
                                            variant="contained"
                                            color="secondary" size="small"
                                            className={classes.generateButton}
                                            onClick={()=>{
                                              setCancelLinkIsModalOpen(true)
                                              allPaymentLinkHandle()
                                            }}
                                            disabled={(userDetails?.departmentId === constantDepartmentId.chm || (userDetails?.roles?.find(role => role.name === ROLENAME.FactoryCrmUser)) ? false : userDetails?.departmentId !== projectDetails?.departmentId?._id)}
                                        >
                                            Cancel Payment Link
                                        </Button>
                                    }
                                    {
                                        userDetails?.roles?.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AGM_Sales || role.name === ROLENAME.DGM_Sales) &&
                                        <Button variant="contained" color="primary" size="small" onClick={() => setOpenSiteVisitPaymentModal(true)}>Physical Site Visit</Button>
                                    }

                                    {
                                        userDetails?.roles?.some(role =>
                                            role.name === ROLENAME.FinanceManager ||
                                            role.name === ROLENAME.FinanceExecutive ||
                                            role.name === ROLENAME.FinanceUser ||
                                            role.name === ROLENAME.Admin
                                        ) &&
                                        Boolean(projectDetails?.internalDesignSignOffDate) &&
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            size="small"
                                            className={classes.generateButton}
                                            onClick={openTaxInvoiceModal}
                                        >
                                            Upload Tax Invoices
                                        </Button>
                                    }
                                    
                                    {userDetails?.roles?.find(
                                        role => role.name === ROLENAME.AssistantDesignManager ||
                                            role.name === ROLENAME.DesignHead ||
                                            role.name === ROLENAME.DGM_Design
                                    ) && projectDetails?.designHoldStatusApproval?.customerApproval === 'Approved' && (
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                size="small"
                                                onClick={handleAgainDesignHoldReq}
                                                disabled={projectDetails?.designHoldStatusApproval?.customerApproval !== 'Approved'}
                                            >
                                                Change Design-Hold Revoke Date
                                            </Button>
                                        )}

                                    {
                                        (
                                            (userDetails?.departmentId === designDepartment || 
                                            userDetails?.roles?.some(role => role.name === ROLENAME.DataAnalyst)) &&
                                            projectDetails?.designStatus === "Design-Hold Pending Approval" &&
                                            projectDetails?.designHoldStatusApproval?.odmApproval === "Approved"
                                        )
                                        &&
                                        <Button
                                            variant="contained"
                                            color="secondary" size="small"
                                            className={classes.generateButton}
                                            onClick={()=>{
                                            //   setCancelLinkIsModalOpen(true)
                                            //   allPaymentLinkHandle()
                                              setChecklistResendModal(true)
                                            }}
                                        >
                                            Resend Hold Approval Link
                                        </Button>
                                    }

                                    {
                                        userDetails?.roles?.some(
                                            (role) =>
                                                role.name === ROLENAME.OperationDesignManager ||
                                                role.name === ROLENAME.DesignHead ||
                                                role.name === ROLENAME.DGM_Design ||
                                                role.name === ROLENAME.AGM_Design
                                        ) &&
                                        projectDetails?.currentStage === "Design Kick-Off : Customer" &&
                                        projectDetails?.customerApproved?.length > 0 &&
                                        projectDetails?.customerApproved?.[0]?.status === "Send for Approval" &&
                                        <Button
                                            variant="contained"
                                            color="secondary" size="small"
                                            className={classes.generateButton}
                                            onClick={() => {
                                              setKickOffApprovalResendModal(true)
                                            }}
                                        >
                                            Resend Kick-off Approval Email
                                        </Button>
                                    }

                                    {/* {
                                        (userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser) && (projectDetails?.cashFreeLinkRequest === undefined || projectDetails?.cashFreeLinkRequest === null || projectDetails?.cashFreeLinkRequest?.isApproved === false || projectDetails?.cashFreeLinkRequest?.isRequested === false)) && 
                                        <Button
                                            variant="contained"
                                            color="secondary" size="small"
                                            className={classes.generateButton}
                                            onClick={() => setOpenGenerateLinkPopUp(true)}
                                            disabled={projectDetails?.cashFreeLinkRequest?.isRequested === true}
                                        >
                                            Request For Generate Link
                                        </Button>
                                    } */}
                                </AccordionActions>
                            </Accordion>

                            {/* Project Details  */}
                            {!userDetails?.roles?.some(role => role.name === ROLENAME.QCManager || role.name === ROLENAME.QualityControl || role.name === ROLENAME.QC_Head) && (
                            <Accordion 
                            // defaultExpanded
                            >
                                <AccordionSummary
                                    className={classes.sectionSummary}
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography className={`${classes.heading} ${classes.sectionHeading}`}><TrendingUpIcon className={classes.sectionIcon} />Sales & Marketing Details</Typography>
                                </AccordionSummary>
                                <Divider />

                                <AccordionDetails style={{ padding: '35px 0px 16px' }}>
                                    <TableContainer component={Paper}>
                                        {(userDetails?.roles?.some(
                                                role =>
                                                    role.name === ROLENAME.Admin ||
                                                    role.name === ROLENAME.FinanceExecutive ||
                                                    role.name === ROLENAME.FinanceManager ||
                                                    role.name === ROLENAME.FinanceUser ||
                                                    role.name === ROLENAME.AGM_Sales ||
                                                    role.name === ROLENAME.DGM_Sales
                                            ) || userDetails?.email ===  NarenEmail?.email // Special case
                                            ) && (
                                                    <Box display="flex" gap={1} mb={2} ml={1}>
                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            className={classes.brandButton}
                                                            onClick={() => handleChangeOwnership(projectDetails?._id, "Sales")}
                                                        >
                                                            Reallocate
                                                        </Button>
                                                    </Box>
                                                )}
                                        <Table className={classes.table} size="small" aria-label="customized table">
                                            <TableBody>

                                                {
                                                    projectDetails?.salesStage === 'Won' &&
                                                    <>
                                                       
                                                        <TableRow key='2a'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Tentative Possession</span></TableCell>
                                                            <TableCell>{moment(projectDetails?.possessionDate).format('DD-MM-YYYY')}</TableCell>
                                                        </TableRow>
                                                        <TableRow key='2b'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Tentative Design Closure</span></TableCell>
                                                            <TableCell>{moment(projectDetails?.closureDate).format('DD-MM-YYYY')}</TableCell>
                                                        </TableRow>
                                                        <TableRow key='2c'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Tentative Client Move-in Date</span></TableCell>
                                                            <TableCell>{moment(projectDetails?.clientMoveinDate).format('DD-MM-YYYY')}</TableCell>
                                                        </TableRow>
                                                        <TableRow key='2d'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Expected Sales Won Date</span></TableCell>
                                                            <TableCell>{projectDetails?.expectedTenPercent ? moment(projectDetails?.expectedTenPercent).format('DD-MM-YYYY') : `-`}</TableCell>
                                                        </TableRow>
                                                    </>
                                                }
                                                    <TableRow key='salesDGM'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Sales DGM</span></TableCell>
                                                        <TableCell>{projectDetails?.salesDGM ? projectDetails?.salesDGM?.name : `-`}</TableCell>
                                                    </TableRow>
                                                    <TableRow key='salesAGM'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Sales AGM</span></TableCell>
                                                        <TableCell>{projectDetails?.salesAGM ? projectDetails?.salesAGM?.name : `-`}</TableCell>
                                                    </TableRow>
                                                <TableRow key='1a'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Sales Manager</span></TableCell>
                                                    <TableCell>{projectDetails?.salesManager ? projectDetails?.salesManager?.name : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='1b'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Sales ASM</span></TableCell>
                                                    <TableCell>{projectDetails?.salesAssistantManager ? projectDetails?.salesAssistantManager?.name : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='1c'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Sales User</span></TableCell>
                                                    <TableCell>{projectDetails?.salesUser ? projectDetails?.salesUser?.name : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='3'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><CategoryIcon className={classes.cellIcon} />Project Type</span></TableCell>
                                                    <TableCell>{projectDetails?.projectType ? projectDetails?.projectType : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='4'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><CategoryIcon className={classes.cellIcon} />Property Type</span></TableCell>
                                                    <TableCell>{projectDetails?.propertyType ? projectDetails?.propertyType : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='5'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><ListAltIcon className={classes.cellIcon} />Scope of Work</span></TableCell>
                                                    <TableCell>{projectDetails?.scopeOfWork ? projectDetails?.scopeOfWork : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='6'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />AssignedTo</span></TableCell>
                                                    <TableCell>{projectDetails?.assignTo?.name ? projectDetails?.assignTo?.name : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='leadAssignedToSalesDate'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Lead Assigned To Sales Date</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.leadAssignedDate
                                                            ? moment(projectDetails.leadAssignedDate).format('DD-MM-YYYY')
                                                            : `-`}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='8'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><LocationOnIcon className={classes.cellIcon} />City</span></TableCell>
                                                    <TableCell>{projectDetails?.city ? projectDetails?.city?.name : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='9'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><MapIcon className={classes.cellIcon} />FloorPlan</span></TableCell>
                                                    <TableCell>{projectDetails?.floorPlanAttachment ? 'Yes' : `No`}</TableCell>
                                                </TableRow>
                                                <TableRow key='10'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><AspectRatioIcon className={classes.cellIcon} />Sq.Ft Area</span></TableCell>
                                                    <TableCell>{projectDetails?.area ? projectDetails?.area : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='22'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><ListAltIcon className={classes.cellIcon} />Project Needs</span></TableCell>
                                                    <TableCell>{projectDetails?.projectNeeds ? projectDetails?.projectNeeds : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='23'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><LabelIcon className={classes.cellIcon} />3 Lakhs Suits</span></TableCell>
                                                    <TableCell>{projectDetails?.threeLakhsSuits ? projectDetails?.threeLakhsSuits : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='24'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><LabelIcon className={classes.cellIcon} />Start Project By</span></TableCell>
                                                    <TableCell>{projectDetails?.startProjectBy ? projectDetails?.startProjectBy : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='11'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><CategoryIcon className={classes.cellIcon} />LeadType</span></TableCell>
                                                    <TableCell>{projectDetails?.leadType ? projectDetails?.leadType : `-`}</TableCell>
                                                </TableRow>

                                                <TableRow key='25'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Hold Revoke Date</span></TableCell>
                                                    <TableCell>{(projectDetails?.holdRevokeDate || projectDetails?.handoverDate) ? moment(projectDetails?.holdRevokeDate || projectDetails?.handoverDate).format('DD-MM-YYYY') : '-'}</TableCell>
                                                </TableRow>

                                                <TableRow key='11q'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><HelpOutlineIcon className={classes.cellIcon} />Reason to Move To Be Called/Hold</span></TableCell>
                                                    <TableCell>{projectDetails?.reasonForOtherLeadType ? projectDetails?.reasonForOtherLeadType : `-`}</TableCell>
                                                </TableRow>
                                                
                                                <TableRow key='26'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><HelpOutlineIcon className={classes.cellIcon} />Junk Reason</span></TableCell>
                                                    <TableCell>{projectDetails?.junkReason ? projectDetails?.junkReason : `-`}</TableCell>
                                                </TableRow>
                                                
                                                <TableRow key='29'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><HelpOutlineIcon className={classes.cellIcon} />Sales Lost Reason</span></TableCell>
                                                    <TableCell>{projectDetails?.salesLostReason ? projectDetails?.salesLostReason : `-`}</TableCell>
                                                </TableRow>

                                                <TableRow key='12'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><TimelineIcon className={classes.cellIcon} />Status</span></TableCell>
                                                    <TableCell>{projectDetails?.status ? projectDetails?.status : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='13'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><HowToRegIcon className={classes.cellIcon} />Registered</span></TableCell>
                                                    <TableCell>{projectDetails?.isRegistered ? projectDetails?.isRegistered : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='14'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><TrackChangesIcon className={classes.cellIcon} />Source</span></TableCell>
                                                    <TableCell>{projectDetails?.sourceOfLead ? projectDetails?.sourceOfLead?.name : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key="30">
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><TrackChangesIcon className={classes.cellIcon} />Secondary Sources</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.secondarySources?.length > 0 ? (
                                                            projectDetails.secondarySources.map((item, index) => {
                                                                const date = item?.date
                                                                    ? new Date(item.date)
                                                                        .toLocaleDateString("en-GB")
                                                                        .replace(/\//g, "-")
                                                                    : "";
                                                                return (
                                                                    <div key={index}>
                                                                        {item?.source?.name || "-"} {date && `(${date})`}
                                                                    </div>
                                                                );
                                                            })
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='15'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><ListAltIcon className={classes.cellIcon} />Remark(scopeOfWork)</span></TableCell>
                                                    <TableCell>{projectDetails?.remark ? projectDetails?.remark : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='16'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><MonetizationOnIcon className={classes.cellIcon} />Estimate Quotation Amount</span></TableCell>
                                                    <TableCell>₹ {projectDetails?.estimatedBudget ? commaSeparateAmount(projectDetails?.estimatedBudget) : `0`}</TableCell>
                                                </TableRow>
                                                <TableRow key='17'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><MonetizationOnIcon className={classes.cellIcon} />Quotation Amount</span></TableCell>
                                                    <TableCell>₹ {projectDetails?.grandTotal ? commaSeparateAmount(projectDetails?.grandTotal) : `0`}</TableCell>
                                                </TableRow>
                                                <TableRow key='18'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><MonetizationOnIcon className={classes.cellIcon} />Apply Discount on All Scopes:</span></TableCell>
                                                    <TableCell>{projectDetails?.discountOnAllScopes === true ? `True` : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='18a'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><MonetizationOnIcon className={classes.cellIcon} />Apply Discount Percentage</span></TableCell>
                                                    <TableCell>{projectDetails?.discountPercent ? projectDetails?.discountPercent + "%" : `0`}</TableCell>
                                                </TableRow>
                                                <TableRow key='19a'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Created At:</span></TableCell>
                                                    <TableCell>{moment(projectDetails?.createdAt).format('DD-MM-YYYY')}</TableCell>
                                                </TableRow>
                                                <TableRow key='19b'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><LabelIcon className={classes.cellIcon} />Meeting With Customer:</span></TableCell>
                                                    <TableCell>{projectDetails?.meetingWithCustomer?.meetingDate ? moment(projectDetails?.meetingWithCustomer?.meetingDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='19b1'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Expected Sales Closure Date:</span></TableCell>
                                                    <TableCell>{projectDetails?.expectedSalesclosureDate ? moment(projectDetails?.expectedSalesclosureDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='19f'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PhotoLibraryIcon className={classes.cellIcon} />Move to Marketing Audio/Image File</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.moveToMarketingFile ?
                                                            <span onClick={() => window.open(projectDetails?.moveToMarketingFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='27'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><HelpOutlineIcon className={classes.cellIcon} />Move To Marketing Reason</span></TableCell>
                                                    <TableCell>{projectDetails?.moveToMarketingReason ? projectDetails?.moveToMarketingReason : `-`}</TableCell>
                                                </TableRow>

                                                <TableRow key='28'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><HelpOutlineIcon className={classes.cellIcon} />Move To Marketing Others Reason</span></TableCell>
                                                    <TableCell>{projectDetails?.moveToMarketingOtherReason ? projectDetails?.moveToMarketingOtherReason : `-`}</TableCell>
                                                </TableRow>
                                                
                                                <TableRow key='19c'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><AudiotrackIcon className={classes.cellIcon} />Audio Recording File</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.recordingFile ?
                                                            <span onClick={() => window.open(projectDetails?.recordingFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                        {(userDetails?.roles?.find(role => role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager)) &&
                                                            <>
                                                                <input
                                                                    accept="*"
                                                                    className={classes.input}
                                                                    id="contained-button-file-for-audio"
                                                                    type="file"
                                                                    onChange={(event) => handleAudioFileChange(event, projectDetails)}
                                                                    style={{ display: 'none' }}
                                                                    name="AudioRecordingFile"
                                                                />
                                                                <label htmlFor="contained-button-file-for-audio">
                                                                    <Button 
                                                                        component="span" startIcon={<EditIcon />}
                                                                    >
                                                                    </Button>
                                                                </label>
                                                            </>
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='19d'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Floor Plan Attachment</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.floorPlanAttachment ?
                                                            <span onClick={() => window.open(projectDetails?.floorPlanAttachment)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                        {(userDetails?.roles?.find(role => role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager)) &&
                                                            <>
                                                                <input
                                                                    accept="*"
                                                                    className={classes.input}
                                                                    id="contained-button-file-for-attachment"
                                                                    type="file"
                                                                    onChange={(event) => handleFloorPlanAttachmentChange(event, projectDetails)}
                                                                    style={{ display: 'none' }}
                                                                    name="FloorPlanAttachment"
                                                                />
                                                                <label htmlFor="contained-button-file-for-attachment">
                                                                    <Button  component="span" startIcon={<EditIcon />}>
                                                                    </Button>
                                                                    
                                                                </label>
                                                            </>
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='19e'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PhotoLibraryIcon className={classes.cellIcon} />Image Uploaded During Lead Creation:</span></TableCell>
                                                    <TableCell>{projectDetails?.uploadedImage ?   <span onClick={() => window.open(projectDetails?.uploadedImage)} > <GetAppOutlinedIcon /> </span> : `NA`}</TableCell>
                                                </TableRow>
                                                {
                                                    projectDetails?.salesStage === 'Won' &&
                                                    <>
                                                        <TableRow key='2e'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><ReceiptIcon className={classes.cellIcon} />GST Required</span></TableCell>
                                                            <TableCell>{projectDetails?.customerRequriedGst === true ? `Yes` : projectDetails?.customerRequriedGst === false ? `No` : `-`}</TableCell>
                                                        </TableRow>
                                                        <TableRow key='2e'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><ReceiptIcon className={classes.cellIcon} />GST Invoice Name</span></TableCell>
                                                            <TableCell>{projectDetails?.customerGstInName ? projectDetails?.customerGstInName : `-`}</TableCell>
                                                        </TableRow>
                                                        <TableRow key='2e'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><ReceiptIcon className={classes.cellIcon} />GST Number</span></TableCell>
                                                            <TableCell>{projectDetails?.customerGstInNumber ? projectDetails?.customerGstInNumber : `-`}</TableCell>
                                                        </TableRow>
                                                        <TableRow key='2e'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><ReceiptIcon className={classes.cellIcon} />GST Shipping</span></TableCell>
                                                            <TableCell>{projectDetails?.customerGstShipping ? projectDetails?.customerGstShipping : `-`}</TableCell>
                                                        </TableRow>

                                                    </>
                                                }
                                                {/* <TableRow key='2e'>
                                                    <TableCell>CHM Executive</TableCell>
                                                    <TableCell>{projectDetails?.chmUser ? projectDetails?.chmUser?.name : '-'}</TableCell>
                                                </TableRow> */}

                                                {/* Add New Column of Expected handover date when lead is created */}
                                                <TableRow key='21a'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Expected Handover Date</span></TableCell>
                                                    <TableCell>{projectDetails?.expectedHandoverDate ? moment(projectDetails?.expectedHandoverDate).format('DD-MM-YYYY') : '-'}</TableCell>
                                                </TableRow>

                                                <TableRow key='21b'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><StoreIcon className={classes.cellIcon} />Sales Won Experience Center</span></TableCell>
                                                    <TableCell>{projectDetails?.salesWonExpCtrId?.name ? projectDetails?.salesWonExpCtrId?.name : 'NA'}</TableCell>
                                                </TableRow>

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>

                            </Accordion>)}

                            {/*design details */}
                            {!userDetails?.roles?.some(role => role.name === ROLENAME.QCManager || role.name === ROLENAME.QualityControl || role.name === ROLENAME.QC_Head) && (
                            <Accordion
                            // defaultExpanded
                            >
                                <AccordionSummary
                                    className={classes.sectionSummary}
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography className={`${classes.heading} ${classes.sectionHeading}`}><PaletteIcon className={classes.sectionIcon} />Design Details</Typography>
                                </AccordionSummary>
                                <Divider />
                                <AccordionDetails style={{ padding: '8px 0px 16px' }}>
                                    <TableContainer component={Paper}>
                                       {(userDetails?.roles?.some(
                                                role =>
                                                    role.name === ROLENAME.Admin ||
                                                    role.name === ROLENAME.FinanceExecutive ||
                                                    role.name === ROLENAME.FinanceManager ||
                                                    role.name === ROLENAME.FinanceUser ||
                                                    role.name === ROLENAME.AGM_Design ||
                                                    role.name === ROLENAME.DGM_Design
                                            ) || userDetails?.email ===  NarenEmail?.email
                                            ) && (
                                                    <Box display="flex" gap={1} mb={2} ml={1}>
                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            color="primary"
                                                            className={classes.brandButton}
                                                            onClick={() => handleChangeOwnership(projectDetails?._id, "Design")}
                                                        >
                                                            Reallocate
                                                        </Button>
                                                    </Box>
                                                )}
                                        <Table className={classes.table} size="small" aria-label="customized table">
                                            <TableBody>
                                                {/* <TableRow key='12'>
                                                    <TableCell>Revised Design Sign-off Date</TableCell>
                                                    <TableCell>{projectDetails?.projectedDesignSignOffDate?.after10th ? moment(projectDetails?.projectedDesignSignOffDate?.after10th).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='11'>
                                                    <TableCell>Projected Design Sign-off Date</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.projectedDesignSignOffDate?.before10th
                                                            ? moment(projectDetails.projectedDesignSignOffDate.before10th).format('DD-MM-YYYY')
                                                            : projectDetails?.projectedDesignSignOffDate?.committedDate
                                                                ? moment(projectDetails.projectedDesignSignOffDate.committedDate).format('DD-MM-YYYY')
                                                                : '-'}
                                                    </TableCell>
                                                </TableRow> */}
                                                <TableRow key='1a'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><StoreIcon className={classes.cellIcon} />Design Won Experience Center</span></TableCell>
                                                    <TableCell>{projectDetails?.designWonExpCtrId ? projectDetails?.designWonExpCtrId?.name  : `NA`}</TableCell>
                                                </TableRow>
                                                <TableRow key='1'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Internal Design Sign-off Date</span></TableCell>
                                                    <TableCell>{projectDetails?.internalDesignSignOffDate ? moment(projectDetails?.internalDesignSignOffDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                {/* <TableRow key='2'>
                                                    <TableCell>Expected Design Sign-off Date</TableCell>
                                                    <TableCell>{projectDetails?.expectedDesignSignOffDate ? moment(projectDetails?.expectedDesignSignOffDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow> */}
                                                {/* <TableRow key='2a'>
                                                    <TableCell>Projected DSO Committed Date</TableCell>
                                                    <TableCell>{projectDetails?.projectionDSOCommitedDate ? moment(projectDetails?.projectionDSOCommitedDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow> */}
                                                <TableRow key='3'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Days from Contract sign:</span></TableCell>
                                                    <TableCell>{daysfromContractsign !== "" ? daysfromContractsign.toFixed(0) : `-`}</TableCell>
                                                </TableRow>

                                                <TableRow key='4'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><BrushIcon className={classes.cellIcon} />Design Kick-off SKP:</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.designKickOffCustomerFileLinks?.skpFileLink ?
                                                            <span onClick={() => window.open(projectDetails?.designKickOffCustomerFileLinks?.skpFileLink)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='5'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><MonetizationOnIcon className={classes.cellIcon} />Design Kick-off Quotation link:</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.designKickOffCustomerFileLinks?.quotationFileLink ?
                                                        <a onClick={()=>{
                                                            designQuotationLink(projectDetails?.designKickOffCustomerFileLinks?.quotationVersionNo)
                                                        }} style={{cursor:"pointer"}}>Link </a>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='8a'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><MonetizationOnIcon className={classes.cellIcon} />Quotation PDF</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanQuotationFile ?
                                                            <GetAppOutlinedIcon onClick={() => window.open(projectDetails?.scanQuotationFile)} /> 
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>


                                                <TableRow key='6'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><NotesIcon className={classes.cellIcon} />Design Kick-off: Customer Designer MOM</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.designKickOffCustomerFileLinks?.momFileLink ?
                                                            <span onClick={() => window.open(projectDetails?.designKickOffCustomerFileLinks?.momFileLink)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='6.1'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><AssignmentTurnedInIcon className={classes.cellIcon} />Electrical-Domestic Checklist</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.finalizationOfMaterialCheckListPdf ?
                                                            <span onClick={() => window.open(projectDetails?.finalizationOfMaterialCheckListPdf)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='6.2'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><NotesIcon className={classes.cellIcon} />Design Kick-off: Internal Designer MOM</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.designKickOffInternalMomLink ?
                                                            <span onClick={() => window.open(projectDetails?.designKickOffInternalMomLink)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='7'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PhotoLibraryIcon className={classes.cellIcon} />Design Kick-off Screenshots:</span></TableCell>
                                                    <TableCell>
                                                        <EyeFilled style={{ fontSize: 25 }} onClick={handleDesignKickOffScreenshots} />
                                                    </TableCell>
                                                </TableRow>
                                                 <TableRow key='ocr'>
                                                        <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PhotoLibraryIcon className={classes.cellIcon} />Expected Design Sign-Off Screenshot</span></TableCell>
                                                        <TableCell>
                                                            {projectDetails?.ocrFileLinks?.length ? (
                                                                <CloudDownloadIcon
                                                                    style={{ fontSize: 25, cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        const url = projectDetails?.ocrFileLinks?.[
                                                                            projectDetails?.ocrFileLinks?.length - 1
                                                                        ]?.signOffProofUrl;

                                                                        if (url) {
                                                                            window.open(url, '_blank', 'noreferrer');
                                                                        }
                                                                    }}
                                                                />
                                                            ) : (
                                                                <Typography variant="body2" color="textSecondary">
                                                                    —
                                                                </Typography>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>  
                                                <TableRow key='8'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><TimelineIcon className={classes.cellIcon} />Design Stage</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.designStatus || "N/A"}
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='9'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Design Executive</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.designUser ? projectDetails?.designUser?.name : "-"}
                                                    </TableCell>
                                                </TableRow>

                                                {/* <TableRow key='10'>
                                                    <TableCell> Assistant Design Manager</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.designAssistantManager ? projectDetails?.designAssistantManager.name : "-"}
                                                    </TableCell>
                                                </TableRow> */}
                                                <TableRow key='designManager'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Design Manager</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.designManager ? projectDetails?.designManager.name : "-"}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='designAGM'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Design AGM</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.designAGM ? projectDetails?.designAGM.name : "-"}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='designDGM'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Design DGM</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.designDGM ? projectDetails?.designDGM.name : "-"}
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow key='11'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Project SKP File</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.projectSkpFile ?
                                                            <span onClick={() => window.open(projectDetails?.projectSkpFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `NA`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='12'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Project ACAD File</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.projectAcadFile ?
                                                            <span onClick={() => window.open(projectDetails?.projectAcadFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `NA`
                                                        }
                                                    </TableCell>
                                                </TableRow>

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>
                            </Accordion>)}


                            {/* Deals Details */}
                            {!userDetails?.roles?.some(role => role.name === ROLENAME.QCManager || role.name === ROLENAME.QualityControl || role.name === ROLENAME.QC_Head) && (
                            <Accordion 
                            // defaultExpanded
                            >
                                <AccordionSummary
                                    className={classes.sectionSummary}
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography className={`${classes.heading} ${classes.sectionHeading}`}><AssignmentTurnedInIcon className={classes.sectionIcon} />Post Design Sign-off Details</Typography>
                                </AccordionSummary>
                                <Divider />
                                <AccordionDetails style={{ padding: '8px 0px 16px' }}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="customized table">
                                            <TableBody>
                                                <TableRow key='1a'>
                                                    <TableCell>Days from Modular delivery:</TableCell>
                                                    <TableCell>{daysfromModulardelivery !== "" ? daysfromModulardelivery.toFixed(0) : `-`}</TableCell>
                                                </TableRow>

                                                    <TableRow key='2a'>
                                                        <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Senior Operation Manager</span></TableCell>
                                                        <TableCell>{ projectDetails?.seniorOperationManager ?  projectDetails?.seniorOperationManager?.name : `Not Assigned`}</TableCell>
                                                    </TableRow>
                                                     <TableRow key='2a'>
                                                        <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Execution Lead</span></TableCell>
                                                        <TableCell>{ projectDetails?.executionLead ?  projectDetails?.executionLead?.name : `Not Assigned`}</TableCell>
                                                    </TableRow>
                                                                 <TableRow key='2c'>
                                                        <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PersonIcon className={classes.cellIcon} />Project Manager</span></TableCell>
                                                        <TableCell>{ projectDetails?.projectManager ?  projectDetails?.projectManager?.name : `Not Assigned`}</TableCell>
                                                    </TableRow>
                                                <TableRow key='1b'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Days from Modular delivery:</span></TableCell>
                                                    <TableCell>{projectDetails?.imosToFactoryDate ? moment(projectDetails?.imosToFactoryDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='3'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Design Sign-off Date</span></TableCell>
                                                    {/* <TableCell>{projectDetails?.designSignOffDate ? moment(projectDetails?.designSignOffDate).format('DD-MM-YYYY') : `-`}</TableCell> */}
                                                    <TableCell>{projectDetails?.customerDesignSignOffDate ? moment(projectDetails?.customerDesignSignOffDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='3a'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><LabelIcon className={classes.cellIcon} />Extra Days Due To Client Dependency:</span></TableCell>
                                                    <TableCell>{projectDetails?.extraDaysDueToClientDependency ? projectDetails?.extraDaysDueToClientDependency : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='4'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><BrushIcon className={classes.cellIcon} />Working Drawing File</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.workingDrawingFile ?
                                                            <span onClick={() => window.open(projectDetails?.workingDrawingFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='5'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><BrushIcon className={classes.cellIcon} />3D Working Drawing File</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.ThreeDworkingDrawingFile ?
                                                            <span onClick={() => window.open(projectDetails?.ThreeDworkingDrawingFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='18'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><AssignmentTurnedInIcon className={classes.cellIcon} />Project Kick-Off Check List File</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanProjectKickOffCheckListFile ?
                                                            <span onClick={() => window.open(projectDetails?.scanProjectKickOffCheckListFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='19'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><AssignmentTurnedInIcon className={classes.cellIcon} />SiteQC Check List File</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanSiteQCCheckListFile ?
                                                            <span onClick={() => window.open(projectDetails?.scanSiteQCCheckListFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='20'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PhotoLibraryIcon className={classes.cellIcon} />SiteQC Photos</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanSiteQCPhotos && projectDetails.scanSiteQCPhotos.length > 0 ? (
                                                            projectDetails.scanSiteQCPhotos.map((photo, index) => (
                                                                <span key={index} onClick={() => window.open(photo)}>
                                                                    <GetAppOutlinedIcon />
                                                                </span>
                                                            ))
                                                        ) : (
                                                            `-`
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='20a'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><VideocamIcon className={classes.cellIcon} />SiteQC Video</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.siteQcVideo && projectDetails.siteQcVideo.length > 0 ? (
                                                            projectDetails.siteQcVideo.map((video, index) => (
                                                                <span key={index} onClick={() => window.open(video)}>
                                                                    <GetAppOutlinedIcon />
                                                                </span>
                                                            ))
                                                        ) : (
                                                            `-`
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='6'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><AssignmentTurnedInIcon className={classes.cellIcon} />Signed Check list File</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.salesChecklistPdfFile ?
                                                            <span onClick={() => window.open(projectDetails?.salesChecklistPdfFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='7'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Contract Sign File</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.customerAgreementPdf ?
                                                            <span onClick={() => window.open(projectDetails?.customerAgreementPdf)} > <GetAppOutlinedIcon /> </span>
                                                            : projectDetails?.termsAndConditionsPdf ?
                                                            <span onClick={() => window.open(projectDetails?.termsAndConditionsPdf)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='8aQ'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><MonetizationOnIcon className={classes.cellIcon} />Web Quotation</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.scanQuotationFile ?
                                                            <a onClick={()=>{
                                                                designQuotationLink(designQuotationId)
                                                            }} style={{cursor:"pointer"}}>Link </a>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='8b'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><MonetizationOnIcon className={classes.cellIcon} />Quotation CSV</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.quotationCsvFile ?
                                                            <span onClick={() => window.open(projectDetails?.quotationCsvFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                {/* <TableRow key='8bc'>
                                                    <TableCell>Final Working Drawing File</TableCell>
                                                    <TableCell>
                                                        {projectDetails?.finalWDFile ?
                                                            <span onClick={() => window.open(projectDetails?.finalWDFile)} > <GetAppOutlinedIcon /> </span>
                                                            :
                                                            `-`
                                                        }
                                                    </TableCell>
                                                </TableRow> */}
                                                {
                                                    userDetails.roles.find(role => role.name === ROLENAME.Admin || role.name === ROLENAME.CHM_Manager || role.name === ROLENAME.CHM_User) &&
                                                    <>
                                                        <TableRow key='8'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Carpentry File</span></TableCell>
                                                            <TableCell>
                                                                {projectDetails?.imosCarpentryFile ?
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosCarpentryFile)} > <GetAppOutlinedIcon /> </span>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {projectDetails?.newImosCarpentryFile ?
                                                                    <Tooltip title="New File">
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosCarpentryFile)} > <GetAppOutlinedIcon /> </span>
                                                                    </Tooltip>
                                                                    :
                                                                    `-`
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow key='9'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Custom File</span></TableCell>
                                                            <TableCell>
                                                                {projectDetails?.imosCustomFile ?
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosCustomFile)} > <GetAppOutlinedIcon /> </span>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {projectDetails?.newImosCustomFile ?
                                                                    <Tooltip title="New File">
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosCustomFile)} > <GetAppOutlinedIcon /> </span>
                                                                    </Tooltip>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow key='10'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Edge Band File</span></TableCell>
                                                            <TableCell>
                                                                {projectDetails?.imosEdgeBandingFile ?
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosEdgeBandingFile)} > <GetAppOutlinedIcon /> </span>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {projectDetails?.newImosEdgeBandingFile ?
                                                                    <Tooltip title="New File">
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosEdgeBandingFile)} > <GetAppOutlinedIcon /> </span>
                                                                    </Tooltip>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow key='11'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Hardware File</span></TableCell>
                                                            <TableCell>
                                                                {projectDetails?.imosHardwareFile ?
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosHardwareFile)} > <GetAppOutlinedIcon /> </span>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {projectDetails?.newImosHardwareFile ?
                                                                    <Tooltip title="New File">
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosHardwareFile)} > <GetAppOutlinedIcon /> </span>
                                                                    </Tooltip>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow key='12'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Pasting PDF File</span></TableCell>
                                                            <TableCell>
                                                                {projectDetails?.imosPastingListPdf ?
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosPastingListPdf)} > <GetAppOutlinedIcon /> </span>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {projectDetails?.newImosPastingListPdf ?
                                                                    <Tooltip title="New File">
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosPastingListPdf)} > <GetAppOutlinedIcon /> </span>
                                                                    </Tooltip>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow key='13'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Pasting Excel File</span></TableCell>
                                                            <TableCell>
                                                                {projectDetails?.imosPastingListExcel ?
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosPastingListExcel)} > <GetAppOutlinedIcon /> </span>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {projectDetails?.newImosPastingListExcel ?
                                                                    <Tooltip title="New File">
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosPastingListExcel)} > <GetAppOutlinedIcon /> </span>
                                                                    </Tooltip>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow key='14'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Saw File</span></TableCell>
                                                            <TableCell>
                                                                {projectDetails?.imosSawFile ?
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosSawFile)} > <GetAppOutlinedIcon /> </span>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {projectDetails?.newImosSawFile ?
                                                                    <Tooltip title="New File">
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosSawFile)} > <GetAppOutlinedIcon /> </span>
                                                                    </Tooltip>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow key='15'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />MPR File</span></TableCell>
                                                            <TableCell>
                                                                {projectDetails?.imosMprFile ?
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosMprFile)} > <GetAppOutlinedIcon /> </span>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {projectDetails?.newImosMprFile ?
                                                                    <Tooltip title="New File">
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosMprFile)} > <GetAppOutlinedIcon /> </span>
                                                                    </Tooltip>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow key='16'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Tracking File</span></TableCell>
                                                            <TableCell>
                                                                {projectDetails?.imosTrackingFile ?
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosTrackingFile)} > <GetAppOutlinedIcon /> </span>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                            <TableCell>
                                                                {projectDetails?.newImosTrackingFile ?
                                                                    <Tooltip title="New File">
                                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosTrackingFile)} > <GetAppOutlinedIcon /> </span>
                                                                    </Tooltip>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow key='17'>
                                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Updated Pasting List File</span></TableCell>
                                                            <TableCell>
                                                                {projectDetails?.updatedPastingListFile ?
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.updatedPastingListFile)} > <GetAppOutlinedIcon /> </span>
                                                                    : `-`
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableCell className={classes.labelCell}><span className={classes.cellLabel}><InsertDriveFileIcon className={classes.cellIcon} />Jali File</span></TableCell>
                                                        <TableCell>
                                                            {projectDetails?.imosJaliFile ?
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.imosJaliFile)} > <GetAppOutlinedIcon /> </span>
                                                                : `-`
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            {projectDetails?.newImosJaliFile ?
                                                                <Tooltip title="New File">
                                                                    <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails?.newImosJaliFile)} > <GetAppOutlinedIcon /> </span>
                                                                </Tooltip>
                                                                : `-`
                                                            }
                                                        </TableCell>
                                                    </>
                                                }
                                                <TableRow key='9'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Factory Ready to Dispatch Date</span></TableCell>
                                                    <TableCell>{projectDetails?.readyToDispatchDate ? moment(projectDetails?.readyToDispatchDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='10a'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Material Dispatched Date</span></TableCell>
                                                    <TableCell>{projectDetails?.materialDispatchedDate ? moment(projectDetails?.materialDispatchedDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                  <TableRow key='10d'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Material Delivery Date</span></TableCell>
                                                    <TableCell>{projectDetails?.materialDeliveryDate ? moment(projectDetails?.materialDeliveryDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='10b'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Modular Delivery Date</span></TableCell>
                                                    <TableCell>{projectDetails?.modularDeliveryDate ? moment(projectDetails?.modularDeliveryDate).format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                <TableRow key='10c'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Expected Project Completion Date</span></TableCell>
                                                    {/* <TableCell>{projectDetails?.projectCompletionDate ? moment(projectDetails?.projectCompletionDate).format('DD-MM-YYYY') : `-`}</TableCell> */}
                                                    <TableCell>{projectDetails?.customerDesignSignOffDate ? moment(projectDetails?.customerDesignSignOffDate).add(60, 'days').format('DD-MM-YYYY') : `-`}</TableCell>
                                                </TableRow>
                                                   
                                            <TableRow key='10e'>
                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><VideocamIcon className={classes.cellIcon} />Execution completion videos</span></TableCell>
                                            <TableCell>
                                                {projectDetails?.videoUrls && projectDetails.videoUrls.length > 0 ? (
                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        {projectDetails.videoUrls.map((url, index) => (
                                                            <Tooltip key={index} title={`Video ${index + 1}`}>
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(url)}>
                                                                    <GetAppOutlinedIcon />
                                                                </span>
                                                            </Tooltip>
                                                        ))}
                                                    </div>
                                                ) : `-`}
                                            </TableCell>
                                        </TableRow>

            

                                        <TableRow key='18b'>
                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PhotoLibraryIcon className={classes.cellIcon} />Execution completion Photos</span></TableCell>
                                            <TableCell>
                                                {projectDetails?.photoUrls && projectDetails.photoUrls.length > 0 ? (
                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        {projectDetails.photoUrls.map((url, index) => (
                                                            <Tooltip key={index} title={`Photo ${index + 1}`}>
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(url)}>
                                                                    <GetAppOutlinedIcon />
                                                                </span>
                                                            </Tooltip>
                                                        ))}
                                                    </div>
                                                ) : `-`}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key='18d'>
                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><VerifiedUserIcon className={classes.cellIcon} />Execution completion certificate</span></TableCell>
                                            <TableCell>
                                                {projectDetails?.completionCertificate ? (
                                                    <Tooltip title="Download Certificate">
                                                        <span style={{ cursor: "pointer" }} onClick={() => window.open(projectDetails.completionCertificate)}>
                                                            <GetAppOutlinedIcon />
                                                        </span>
                                                    </Tooltip>
                                                ) : `-`}
                                            </TableCell>
                                        </TableRow>
                                        
                                        <TableRow key='18c'>
                                            <TableCell className={classes.labelCell}><span className={classes.cellLabel}><PhotoLibraryIcon className={classes.cellIcon} />Execution Completion Whatsapp Chat Images</span></TableCell>
                                            <TableCell>
                                                {projectDetails?.whatsappUrls && projectDetails.whatsappUrls.length > 0 ? (
                                                    <div style={{ display: 'flex', gap: '8px' }}>
                                                        {projectDetails.whatsappUrls.map((url, index) => (
                                                            <Tooltip key={index} title={`WhatsApp Screenshot ${index + 1}`}>
                                                                <span style={{ cursor: "pointer" }} onClick={() => window.open(url)}>
                                                                    <GetAppOutlinedIcon />
                                                                </span>
                                                            </Tooltip>
                                                        ))}
                                                    </div>
                                                ) : `-`
                                                }
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key='19c1'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><VpnKeyIcon className={classes.cellIcon} />Possession Received</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.displayCustomerPossession?.propertyPossession || "-"}
                                                    </TableCell>
                                                    
                                                </TableRow>  
                                                <TableRow key='20c'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Expected Possession Received Date</span></TableCell>
                                                    <TableCell>   
                                                        {projectDetails?.displayCustomerPossession?.propertyPossessionDate ? moment(projectDetails?.displayCustomerPossession?.propertyPossessionDate).format('DD-MM-YYYY') : "-"}
                                                    </TableCell>
                                                    
                                                </TableRow>  
                                                               
                                                <TableRow key='21c'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><VpnKeyIcon className={classes.cellIcon} />Keys Availability Handover</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.displayCustomerPossession?.hasKeys || "-"}
                                                    </TableCell>
                                                    
                                                </TableRow>  
                                                               
                                                <TableRow key='22c'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Expected Key Handover Date</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.displayCustomerPossession?.keysReceiptDate || "-"}
                                                    </TableCell>
                                                    
                                                </TableRow>  
                                                               
                                                <TableRow key='23c'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><MonetizationOnIcon className={classes.cellIcon} />Material Delivery & Payment in 30 Days</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.displayCustomerPossession?.materialDeliveryWilling || "-"}
                                                    </TableCell>
                                                    
                                                </TableRow>  
                                                               
                                                <TableRow key='24c'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Expected Delivery & Payment Date</span></TableCell>
                                                    <TableCell>
                                                        {projectDetails?.displayCustomerPossession?.materialDeliveryDate || "-"}
                                                    </TableCell>
                                                </TableRow>  


                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>
                            </Accordion>)}
                            {/* Group Chats */}
                            {!userDetails?.roles?.some(role => role.name === ROLENAME.QCManager || role.name === ROLENAME.QualityControl || role.name === ROLENAME.QC_Head) && (
                            <Accordion>
                                <AccordionSummary
                                    className={classes.sectionSummary}
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography className={`${classes.heading} ${classes.sectionHeading}`}><ForumIcon className={classes.sectionIcon} />Group Chats</Typography>
                                </AccordionSummary>
                                <AccordionDetails
                                    style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%',
                                    height: '300px', // Adjust as needed
                                    overflow: 'hidden',
                                    }}
                                >
                                    <div
                                    style={{
                                        flex: 1,
                                        overflowY: 'auto', // Allow scrolling when needed
                                        padding: '10px',
                                        background: '#dedcd9',
                                        msOverflowStyle: 'none',
                                        scrollbarWidth: 'none',
                                    }}
                                    >
                                        {
                                            messages.length === 0 && (
                                                <Typography variant="body1" style={{ color: '#555' }}>No chats</Typography>
                                            )
                                        }
                                        {totalMessages > messages.length && messages.length > 0 && (
                                            <button
                                            onClick={() => getGroupChatMessages(true)}
                                            style={{
                                                background: '#f47e46',
                                                color: 'white',
                                                padding: '5px 10px',
                                                borderRadius: '5px',
                                                border: 'none',
                                                cursor: 'pointer',
                                                width: '30%',
                                                marginBottom: '10px',
                                            }}
                                            disabled={loadingState}
                                            >
                                            {loadingState ? 'Loading...' : 'Load More'}
                                            </button>
                                        )}
                                        {messages.map((msg, index) => {
                                            const timestamp = new Date(msg.timestamp);
                                            const now = new Date();
                                            const diffInDays = Math.floor((now - timestamp) / (1000 * 3600 * 24));
                            
                                            let formattedDate;
                            
                                            if (diffInDays === 0) {
                                              formattedDate = 'Today';
                                            } else if (diffInDays === 1) {
                                              formattedDate = 'Yesterday';
                                            } else {
                                              formattedDate = timestamp.toLocaleString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric',
                                              });
                                            }
                            
                                            const formattedTime = timestamp.toLocaleTimeString([], { 
                                              hour: '2-digit', 
                                              minute: '2-digit', 
                                              second: '2-digit', 
                                              hour12: true 
                                            });

                                            return (
                                                <div
                                                    key={index}
                                                    style={{
                                                    marginBottom: '10px',
                                                    textAlign:
                                                        msg.sender.name === (Object.keys(userDetails).length
                                                        ? userDetails.name
                                                        : customerDetails.name)
                                                        ? 'right'
                                                        : 'left',
                                                    }}
                                                >
                                                    
                                                    {/* Sender's Name and Message Content */}
                                                    <div
                                                    style={{
                                                        display: 'inline-block',
                                                        padding: '8px 12px',
                                                        borderRadius: '10px',
                                                        background:
                                                            msg.sender.name === (Object.keys(userDetails).length
                                                            ? userDetails.name
                                                            : customerDetails.name)
                                                            ? '#0084ff'
                                                            : '#3a3b3c',
                                                        color: '#fff',
                                                        textAlign: 'left',
                                                        minWidth: '40%',
                                                        maxWidth: '75%', // Prevents messages from stretching too wide
                                                        wordBreak: 'break-word', // Ensures long words wrap
                                                        whiteSpace: 'pre-wrap', // Preserves spacing while wrapping text
                                                        }}
                                                    >
                                                        {msg.sender.name !== 
                                                        (Object.keys(userDetails).length
                                                            ? userDetails.name
                                                            : customerDetails.name) && (
                                                            <span
                                                            style={{
                                                                fontWeight: 'bold',
                                                                display: 'block',
                                                                marginBottom: '4px',
                                                            }}
                                                            >
                                                                {msg.sender.name}
                                                            </span>
                                                        )}
                                                        <span>
                                                            {isValidUrl(msg.content) ? (
                                                            <a
                                                                href={msg.content}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{textDecoration: 'underline', color: 'white' }}
                                                            >
                                                                {msg.content}
                                                            </a>
                                                            ) : (
                                                                msg.content
                                                            )}
                                                        </span>
                                                        <span
                                                            style={{
                                                            fontSize: '.5em',
                                                            display: 'block',
                                                            textAlign: 'right'
                                                            }}
                                                        >
                                                            {/* {new Date(msg.timestamp).toLocaleTimeString([], {
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                second: '2-digit'
                                                            })} */}
                                                            {`${formattedDate}, ${formattedTime}`}
                                                        </span>
                                                    </div>
                                                </div>
                                            )
                                        
                                        })}
                                    <div ref={messagesEndRef} />
                                </div>
                                </AccordionDetails>
                            </Accordion>)}

                            {/* WhatsApp Replies From Customer */}
                            {!userDetails?.roles?.some(role => role.name === ROLENAME.QCManager || role.name === ROLENAME.QualityControl || role.name === ROLENAME.QC_Head) && (
                            <Accordion>
                                <AccordionSummary
                                    className={classes.sectionSummary}
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography className={`${classes.heading} ${classes.sectionHeading}`}><WhatsAppIcon className={classes.sectionIcon} />WhatsApp Replies From Customer</Typography>
                                </AccordionSummary>
                                <AccordionDetails
                                    style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%',
                                    height: '300px',
                                    overflow: 'hidden',
                                    }}
                                >
                                    <div
                                    style={{
                                        flex: 1,
                                        overflowY: 'auto',
                                        padding: '10px',
                                        background: '#dedcd9',
                                        msOverflowStyle: 'none',
                                        scrollbarWidth: 'none',
                                    }}
                                    >
                                        { whatsAppRepliesLoadingState ? (
                                            <Box display="flex" justifyContent="center" p={3}>
                                                <Typography>Loading replies...</Typography>
                                            </Box>
                                            ) : whatsAppRepliesFromCustomer.length > 0 ? (
                                                <>
                                                    { totalWhatsappReplies && totalWhatsappReplies > whatsAppRepliesFromCustomer.length && (
                                                        <button
                                                        onClick={() => get_customer_whatsapp_replies(true)}
                                                        style={{
                                                            background: '#f47e46',
                                                            color: 'white',
                                                            padding: '5px 10px',
                                                            borderRadius: '5px',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            width: '30%',
                                                            marginBottom: '10px',
                                                        }}
                                                        disabled={loadingState}
                                                        >
                                                            {whatsAppRepliesLoadingState ? "Loading..." : "Load More"}
                                                        </button>
                                                    )}
                                                    {whatsAppRepliesFromCustomer.map(renderMessage)}
                                                    <div ref={whatsappRepliesmessagesEndRef} />
                                                </>
                                            ) : (
                                                <Typography>No replies found</Typography>
                                        )}
                                    </div>
                                </AccordionDetails>
                            </Accordion>)}

                            {/* This Design Drawing Details start */}
                            <Accordion>
                                <AccordionSummary
                                    className={classes.sectionSummary}
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography className={`${classes.heading} ${classes.sectionHeading}`}><VerifiedUserIcon className={classes.sectionIcon} />Drawing QC Details</Typography>
                                </AccordionSummary>
                                <Divider />
                                <AccordionDetails style={{ padding: '8px 0px 16px' }}>
                                    <TableContainer component={Paper}>
                                        <Table className={classes.table} size="small" aria-label="customized table">
                                            <TableBody>
                                        
                                                {/* This is Drawing QC Start */}
                                                <TableRow key='22'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><EventIcon className={classes.cellIcon} />Drawing QC Assigned Date/Time</span></TableCell>
                                                    <TableCell>
                                                    {
                                                        projectDetails?.drawingQCRequestedApprovalDate
                                                            ? moment(projectDetails.drawingQCRequestedApprovalDate).format("DD-MM-YYYY hh:mm A")
                                                            : "-"
                                                    }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='22a'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><BrushIcon className={classes.cellIcon} />Drawing QC Status</span></TableCell>
                                                    <TableCell>
                                                        {
                                                            projectDetails?.drawingQCStage
                                                                ? (projectDetails.drawingQCStage === "ADM In Progress"
                                                                    ? "ADM Approval is Pending"
                                                                    : projectDetails.drawingQCStage)
                                                                : "-"
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow key='22b'>
                                                    <TableCell className={classes.labelCell}><span className={classes.cellLabel}><BrushIcon className={classes.cellIcon} />All Drawing QC Files and Remarks</span></TableCell>
                                                    <TableCell>
                                                        <IoMdEye
                                                            onClick={handleOpenADMModal} 
                                                            style={{ cursor: 'pointer', fontSize: "25px", color: "green", }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                {/* This is Drawing QC END */}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>
                            </Accordion>
                        </Paper>
                    </Grid>

                    {/* Notes Details */}
                    <Grid item lg={6} md={6} sm={12} className={classes.scrollPane}>
                        <div className={classes.pinnedNotesBar}>
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<PinIcon pinned={pinnedNotesList.length > 0} />}
                                onClick={openPinnedNotesModal}
                                className={classes.pinnedNotesButton}
                            >
                               Pinned Notes ({pinnedNotesList.length}/{MAX_PINNED_NOTES_PER_LEAD})
                            </Button>
                        </div>
                        <div className={`${classes.scrollArea} ${classes.scrollbars}`}>
                        {timelineItems?.map((item, i) => {
                            if (item.type === 'call') {
                                const call = item.data;
                                const isInbound = call.callInfo?.type === "inbound";
                                const summary = call.analysis?.results?.summary;
                                const recordingSrc = call.callInfo?.recording || call.callInfo?.recordingSrc;
                                const transcript = call.transcript || [];

                                return (
                                    <Paper className={classes.paper} key={`call-${call._id || call.beginTimestamp || call.createdAt || i}`}>
                                        <Accordion defaultExpanded>
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: 8 }}>
                                                    <Typography className={classes.heading} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                        <LocalActivityIcon fontSize="small" />
                                                        Deal Activity
                                                        {isInbound
                                                            ? <CallReceivedIcon style={{ color: '#2e7d32' }} />
                                                            : <CallMadeIcon style={{ color: '#1565c0' }} />}
                                                        <span style={{ fontWeight: 400 }}> &middot; {isInbound ? 'Inbound' : 'Outbound'} Call</span>
                                                    </Typography>
                                                    <Chip
                                                        size="small"
                                                        label={call.outcome || (call.connected ? "Connected" : "Not connected")}
                                                        style={{
                                                            background: call.connected ? "#e6f4ea" : "#fdecea",
                                                            color: call.connected ? "#1e7e34" : "#c62828",
                                                            fontWeight: 600
                                                        }}
                                                    />
                                                    <Typography style={{ marginLeft: 'auto', fontSize: 11, whiteSpace: 'nowrap' }}>
                                                        {moment(call.beginTimestamp || call.createdAt).format('lll')}
                                                    </Typography>
                                                </div>
                                            </AccordionSummary>
                                            <Divider />
                                            <AccordionDetails style={{ flexDirection: 'column' }}>
                                                {summary && (
                                                    <div className={classes.resultBox} style={{ width: '100%', marginBottom: 12 }}>
                                                        <Typography style={{ fontWeight: 600, marginBottom: 6 }}>Call Summary</Typography>
                                                        <Typography style={{ fontSize: 13 }}>{summary}</Typography>
                                                    </div>
                                                )}
                                                {recordingSrc && (
                                                    <audio controls style={{ width: '100%', marginBottom: 12 }}>
                                                        <source src={recordingSrc} />
                                                        Your browser does not support audio
                                                    </audio>
                                                )}
                                                {transcript.length === 0 ? (
                                                    <Typography style={{ fontSize: 13, opacity: 0.7 }}>No transcript available for this call</Typography>
                                                ) : (
                                                    <div style={{ width: '100%', maxHeight: '45vh', overflowY: 'auto', paddingRight: 4 }}>
                                                        {transcript.map((msg, idx) => (
                                                            <div key={idx} className={`${classes.messageRow} ${msg.role === "assistant" ? classes.right : classes.left}`}>
                                                                <div className={`${classes.bubble} ${msg.role === "assistant" ? classes.rightBubble : classes.leftBubble}`}>
                                                                    <Typography style={{ fontSize: 11, fontWeight: 600 }}>
                                                                        {msg.role === "assistant" ? "AI Bot" : "Customer"}
                                                                    </Typography>
                                                                    <Typography style={{ fontSize: 13 }}>{msg.content}</Typography>
                                                                    {msg.timestamp && (
                                                                        <Typography style={{ fontSize: 10, marginTop: 4, textAlign: 'right' }}>
                                                                            {moment(msg.timestamp).format('hh:mm A')}
                                                                        </Typography>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </AccordionDetails>
                                        </Accordion>
                                    </Paper>
                                );
                            }

                            const data = item.data;
                            const isRunoCallLog = !!(data?.cdrLog || data?.runoCallId || data?.runoTranscriptText);
                            const runoTranscriptMessages = isRunoCallLog
                                ? parseRunoTranscript(data?.runoTranscriptText || data?.notes)
                                : [];
                            const runoCallSummary = isRunoCallLog ? extractRunoCallSummary(data?.dealActivity) : '';

                            return (
                            <Paper className={classes.paper} key={`activity-${data._id || i}`}>
                                {
                                    data?.dealActivity && <Accordion defaultExpanded className="accordian">
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            {isRunoCallLog ? (
                                                <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: 8 }}>
                                                    <Typography className={classes.heading} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                        <LocalActivityIcon fontSize="small" />
                                                        Deal Activity
                                                        <CallMadeIcon style={{ color: '#1565c0' }} />
                                                        <span style={{ fontWeight: 400 }}> · Outbound Call</span>
                                                    </Typography>
                                                    <Chip
                                                        size="small"
                                                        label="Connected"
                                                        style={{
                                                            background: '#e6f4ea',
                                                            color: '#1e7e34',
                                                            fontWeight: 600,
                                                        }}
                                                    />
                                                    <Typography style={{ marginLeft: 'auto', fontSize: 11, whiteSpace: 'nowrap' }}>
                                                        {moment(data?.createdAt).format('lll')}
                                                    </Typography>
                                                </div>
                                            ) : (
                                            <Typography className={`${classes.heading} ${classes.dealActivityHeading}`}>
                                                <LocalActivityIcon />
                                                <span className="titlename">Deal Activity</span>
                                                <span className={`datedata ${classes.dateLabel}`}><EventIcon className={classes.dateIcon} />{moment(data?.createdAt).format('lll')}</span>
                                                {/* {{pl.createdAt | date}}, {{pl.createdAt | date:'shortTime' }}  */}
                                            </Typography>
                                            )}
                                        </AccordionSummary>
                                        <Divider />
                                        <AccordionDetails style={isRunoCallLog ? { flexDirection: 'column' } : undefined}>
                                            {isRunoCallLog ? (
                                                <>
                                                    {runoCallSummary && (
                                                        <div className={classes.resultBox} style={{ width: '100%', marginBottom: 12, marginTop: 0 }}>
                                                            <Typography style={{ fontWeight: 600, marginBottom: 6 }}>Call Summary</Typography>
                                                            <Typography style={{ fontSize: 13 }}>{runoCallSummary}</Typography>
                                                        </div>
                                                    )}
                                                    {data?.cdrURL && (
                                                        <audio controls style={{ width: '100%', marginBottom: 12 }}>
                                                            <source src={data.cdrURL} />
                                                            Your browser does not support audio
                                                        </audio>
                                                    )}
                                                    {runoTranscriptMessages.length === 0 ? (
                                                        <Typography style={{ fontSize: 13, opacity: 0.7 }}>
                                                            No transcript available for this call
                                                        </Typography>
                                                    ) : (
                                                        <div style={{ width: '100%', maxHeight: '45vh', overflowY: 'auto', paddingRight: 4 }}>
                                                            {runoTranscriptMessages.map((msg, idx) => (
                                                                <div
                                                                    key={idx}
                                                                    className={`${classes.messageRow} ${msg.role === 'assistant' ? classes.right : classes.left}`}
                                                                >
                                                                    <div className={`${classes.bubble} ${msg.role === 'assistant' ? classes.rightBubble : classes.leftBubble}`}>
                                                                        <Typography style={{ fontSize: 11, fontWeight: 600 }}>
                                                                            {msg.label || (msg.role === 'assistant' ? 'Agent' : 'Customer')}
                                                                        </Typography>
                                                                        <Typography style={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>{msg.content}</Typography>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                            <Typography variant="body2" gutterBottom>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    {renderWithBold(data?.dealActivity)}
                                                    {data?.isWhatsAppNotificationSent && (
                                                    <Button 
                                                        variant="contained" 
                                                        color="primary" 
                                                        onClick={() => handleViewClick(data)}
                                                        // style={{ marginLeft: '8px' }}
                                                        className={classes.viewButton}
                                                        size="small"
                                                    >
                                                        View
                                                    </Button>
                                                    )}
                                                </div>
                                                {/* design-hold pending approval sequence */}
                                                {data.isDesignHoldApprovalSent && projectDetails?.departmentId?.name === 'Design' &&
                                                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px'}}>
                                                     <h5
                                                         style={{
                                                             color: projectDetails?.designHoldStatusApproval?.admApproval === 'Sent for Approval' ? 'red' 
                                                                 : projectDetails?.designHoldStatusApproval?.admApproval === 'Approved' ? 'green' : 'inherit'
                                                         }}> ADM <FaArrowRight />
                                                     </h5>
 
                                                     <h5 style={{
                                                         color: projectDetails?.designHoldStatusApproval?.odmApproval === 'Sent for Approval' ? 'red'
                                                             : projectDetails?.designHoldStatusApproval?.odmApproval === 'Approved' ? 'green' : 'inherit'
                                                     }}> {data.dealActivity?.includes('(verified by AI)') ? 'AI Verified' : 'ODM Design'} <FaArrowRight /></h5>
 
                                                     <h5 style={{
                                                          color: projectDetails?.designHoldStatusApproval?.customerApproval === 'Sent for Approval' ? 'red'
                                                             : projectDetails?.designHoldStatusApproval?.customerApproval === 'Approved' ? 'green' : 'inherit'
                                                      }}> Customer </h5>
                                                 </div>
                                                }
                                                {data?.isADMUpdate && (
                                                    <>
                                                        <EyeFilled
                                                            style={{ cursor: 'pointer', fontSize: '20px', color: '#1890ff' }}
                                                            onClick={handleViewFile}
                                                        />
                                                        {/* Inline File Preview */}
                                                        {isFilePreviewVisible && (
                                                            <div style={{ marginTop: '20px' }}>
                                                                {data?.leadId?.monthlyContractFile?.endsWith('.pdf') ? (
                                                                    // Using Google Docs Viewer for PDF preview
                                                                    <iframe
                                                                        src={`https://docs.google.com/gview?url=${data?.leadId?.monthlyContractFile}&embedded=true`}
                                                                        style={{ width: '100%', height: '600px' }}
                                                                        title="PDF Preview"
                                                                        frameBorder="0"
                                                                        allow="fullscreen"
                                                                    />
                                                                ) : (
                                                                    // Display image inline
                                                                    <img
                                                                        src={data?.leadId?.monthlyContractFile}
                                                                        alt="Image Preview"
                                                                        style={{ width: '100%', height: 'auto' }}
                                                                    />
                                                                )}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                                {data?.cdrLog && data?.cdrURL && (
                                                    <a href={data.cdrURL} download target="_blank" rel="noopener noreferrer">
                                                        <Download className="text-blue-600 hover:text-blue-800 cursor-pointer" />
                                                    </a>
                                                )}
                                                {data?.bank_form_link && (
                                                    <>
                                                        <br />
                                                        Form -{" "}
                                                        <a
                                                            href={data.bank_form_link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            Link
                                                        </a>
                                                    </>
                                                )}
                                                {(data.isLostApprovalSent || (data?.dealActivity && data.dealActivity.toLowerCase().includes('lost') && data.dealActivity.toLowerCase().includes('approval'))) && projectDetails?.departmentId?.name === 'Design' && (
                                                     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px'}}>
                                                        <h5
                                                            style={{
                                                                color: projectDetails?.designLostApproval?.odmApproval === 'Sent for Approval' ? 'red'
                                                                    : projectDetails?.designLostApproval?.odmApproval === 'Approved' ? 'green' : 'inherit'
                                                            }}> Operation Design Manager <FaArrowRight />
                                                        </h5>

                                                        <h5 style={{
                                                            color: projectDetails?.designLostApproval?.dgmDesignApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.designLostApproval?.dgmDesignApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> DGM/AGM Design <FaArrowRight /></h5>

                                                        <h5 style={{
                                                            color: projectDetails?.designLostApproval?.adminApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.designLostApproval?.adminApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> Director </h5>
                                                    </div>
                                                )}
                                                {/* Sales Lost Approval Flow - Dynamic display based on approval status */}
                                                {(data.isLostApprovalSent || (data?.dealActivity && data.dealActivity.toLowerCase().includes('lost') && data.dealActivity.toLowerCase().includes('approval'))) && 
                                                 projectDetails?.departmentId?.name === 'Sales' && 
                                                 (() => {
                                                     const salesApproval = projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval;
                                                     const unifiedApproval = projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval;
                                                     
                                                     return true;
                                                 })() &&
                                                 ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval) || (projectDetails?.approvals?.unifiedLostRefundApproval?.sales || projectDetails?.unifiedLostRefundApproval?.sales)) && (
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px'}}>
                                                        {/* Show ASM if asmApproval has any value (Won deals) */}
                                                        {((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.asmApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.asmApproval) && (
                                                            <>
                                                                <h5 style={{
                                                                    color: ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.asmApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.asmApproval) === 'Sent for Approval' ? 'red'
                                                                        : ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.asmApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.asmApproval) === 'Approved' ? 'green' 
                                                                        : ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.asmApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.asmApproval) === 'Rejected' ? 'orange' : 'inherit'
                                                                }}> Assistant Sales Manager </h5>
                                                                {((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.smApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.smApproval || (projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.dgmSalesApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.dgmSalesApproval) && <FaArrowRight />}
                                                            </>
                                                        )}

                                                        {/* Show SM if smApproval has any value */}
                                                        {((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.smApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.smApproval) && (
                                                            <>
                                                                <h5 style={{
                                                                    color: ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.smApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.smApproval) === 'Sent for Approval' ? 'red'
                                                                        : ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.smApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.smApproval) === 'Approved' ? 'green'
                                                                        : ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.smApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.smApproval) === 'Rejected' ? 'orange' : 'inherit'
                                                                }}> Sales Manager </h5>
                                                                {((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.dgmSalesApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.dgmSalesApproval) && <FaArrowRight />}
                                                            </>
                                                        )}

                                                        {/* Show DGM Sales if dgmSalesApproval has any value */}
                                                        {((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.dgmSalesApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.dgmSalesApproval) && (
                                                            <>
                                                                <h5 style={{
                                                                    color: ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.dgmSalesApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.dgmSalesApproval) === 'Sent for Approval' ? 'red'
                                                                        : ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.dgmSalesApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.dgmSalesApproval) === 'Approved' ? 'green'
                                                                        : ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.dgmSalesApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.dgmSalesApproval) === 'Rejected' ? 'orange' : 'inherit'
                                                                }}> DGM Sales </h5>
                                                                {((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.centerHeadApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.centerHeadApproval) && <FaArrowRight />}
                                                            </>
                                                        )}

                                                        {/* Show Center Head if centerHeadApproval has any value */}
                                                        {((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.centerHeadApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.centerHeadApproval) && (
                                                            <h5 style={{
                                                                color: ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.centerHeadApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.centerHeadApproval) === 'Sent for Approval' ? 'red'
                                                                    : ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.centerHeadApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.centerHeadApproval) === 'Approved' ? 'green'
                                                                    : ((projectDetails?.approvals?.salesLostApproval || projectDetails?.salesLostApproval)?.centerHeadApproval || (projectDetails?.approvals?.unifiedLostRefundApproval || projectDetails?.unifiedLostRefundApproval)?.sales?.centerHeadApproval) === 'Rejected' ? 'orange' : 'inherit'
                                                            }}> Center Head </h5>
                                                        )}
                                                    </div>
                                                )}

                                                {data?.callRecordAttachment &&
                                                    <DownloadOutlined
                                                        onClick={() => window.open(data?.callRecordAttachment)}
                                                        style={{
                                                            color: "green",
                                                            cursor: "pointer",
                                                            fontWeight: "bold",
                                                            fontSize: '24px',
                                                        }}
                                                    />
                                                }

                                                {data?.taxInvoiceAttachment &&
                                                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                        <Tooltip title="Click here to download">
                                                            <AttachmentIcon
                                                                onClick={() => window.open(data?.taxInvoiceAttachment)}
                                                                style={{
                                                                    color: "green",
                                                                    cursor: "pointer",
                                                                    fontWeight: "bold",
                                                                    fontSize: '24px',
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                }

                                                {data.designDiscussionPdf &&
                                                    <DownloadOutlined
                                                        onClick={() => window.open(data.designDiscussionPdf)}
                                                        style={{
                                                            color: "green",
                                                            cursor: "pointer",
                                                            fontWeight: "bold",
                                                            fontSize: '24px',
                                                        }}
                                                    />}
                                                
                                                {/* hot deal message */}
                                                {data.hotdealMessage && (
                                                    <div style={{ color: 'red', marginTop: 10 }}>
                                                        <h3>{data.hotdealMessage}</h3>
                                                        <div style={{ color: 'black', marginTop: 5 }}>
                                                            <h4> 1. Statistics → Marketing → Lead Generated (Download CSV) </h4>
                                                            <h4> 2. Statistics → Sales → Stage Review → Right Pipeline Stages Review (Download CSV) </h4>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Sales refund request Approval Sequence*/}
                                                {(((data.isRefundRequestApprovalSent) || (data?.dealActivity && data.dealActivity.toLowerCase().includes('refund request sent for approval'))) && (projectDetails?.salesRefundRequestApproval?.asmApproval === 'Sent for Approval' || projectDetails?.salesRefundRequestApproval?.asmApproval === 'Approved')) &&
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                                                        <h5
                                                            style={{
                                                                color: projectDetails?.salesRefundRequestApproval?.asmApproval === 'Sent for Approval' ? 'red'
                                                                    : projectDetails?.salesRefundRequestApproval?.asmApproval === 'Approved' ? 'green' : 'inherit'
                                                            }}> ASM <FaArrowRight />
                                                        </h5>

                                                        <h5 style={{
                                                            color: projectDetails?.salesRefundRequestApproval?.smApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.salesRefundRequestApproval?.smApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> Sales Manager <FaArrowRight /></h5>

                                                        <h5 style={{
                                                            color: projectDetails?.salesRefundRequestApproval?.dgmApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.salesRefundRequestApproval?.dgmApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> DGM Sales <FaArrowRight style={{ visibility: projectDetails.refundAmount > 10000 ? "visible" : 'hidden' }} /></h5>

                                                        {projectDetails.refundAmount > 10000 &&
                                                            <h5 style={{
                                                                color: projectDetails?.salesRefundRequestApproval?.centerHeadApproval === 'Sent for Approval' ? 'red'
                                                                    : projectDetails?.salesRefundRequestApproval?.centerHeadApproval === 'Approved' ? 'green' : 'inherit'
                                                            }}> Center Head </h5>
                                                        }
                                                    </div>
                                                }

                                                {/* Design Refund Request Approval Sequence*/}
                                                {(((data.isRefundRequestApprovalSent) || (data?.dealActivity && data.dealActivity.toLowerCase().includes('refund request sent for approval'))) && (projectDetails?.designRefundRequestApproval?.admApproval === 'Sent for Approval' || projectDetails?.designRefundRequestApproval?.admApproval === 'Approved')) &&
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                                                        <h5
                                                            style={{
                                                                color: projectDetails?.designRefundRequestApproval?.admApproval === 'Sent for Approval' ? 'red'
                                                                    : projectDetails?.designRefundRequestApproval?.admApproval === 'Approved' ? 'green' : 'inherit'
                                                            }}> ADM <FaArrowRight />
                                                        </h5>

                                                        <h5 style={{
                                                            color: projectDetails?.designRefundRequestApproval?.odmApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.designRefundRequestApproval?.odmApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> ODM Design <FaArrowRight /></h5>

                                                        <h5 style={{
                                                            color: projectDetails?.designRefundRequestApproval?.dgmApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.designRefundRequestApproval?.dgmApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> DGM Design <FaArrowRight /></h5>

                                                        <h5 style={{
                                                            color: projectDetails?.designRefundRequestApproval?.adminApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.designRefundRequestApproval?.adminApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> Admin </h5>
                                                    </div>
                                                }

                                                {/* Chm Raise Refund Request */}
                                                {((data.isRefundRequestApprovalSent && projectDetails?.chmRefundRequestApproval?.dgmOpsApproval === 'Sent for Approval') || (data.isRefundRequestApprovalSent && projectDetails?.chmRefundRequestApproval?.dgmOpsApproval === 'Approved')) &&
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                                                        <h5
                                                            style={{
                                                                color: projectDetails?.chmRefundRequestApproval?.dgmOpsApproval === 'Sent for Approval' ? 'red'
                                                                    : projectDetails?.chmRefundRequestApproval?.dgmOpsApproval === 'Approved' ? 'green' : 'inherit'
                                                            }}> DGM Ops <FaArrowRight />
                                                        </h5>

                                                        <h5 style={{
                                                            color: projectDetails?.chmRefundRequestApproval?.executionHeadApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.chmRefundRequestApproval?.executionHeadApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> Execution Head</h5>
                                                    </div>
                                                }

                                                {(data.raiseRefundLostSent && projectDetails?.salesToken >= 10) &&
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                                                        <h5 style={{
                                                            color: projectDetails?.salesLostApproval?.smApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.salesLostApproval?.smApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> Sales Manager <FaArrowRight /> </h5>

                                                        <h5 style={{
                                                            color: projectDetails?.salesLostApproval?.dgmSalesApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.salesLostApproval?.dgmSalesApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> DGM Sales <FaArrowRight /> </h5>

                                                        <h5 style={{
                                                            color: projectDetails?.salesLostApproval?.centerHeadApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.salesLostApproval?.centerHeadApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> Center Head </h5>
                                                    </div>
                                                }

                                                {/* Download paid attachment which is upload by finance for refund request */}
                                                {data?.paidRefundAttachment &&
                                                    <DownloadOutlined
                                                        onClick={() => window.open(data?.paidRefundAttachment)}
                                                        style={{
                                                            color: "green",
                                                            cursor: "pointer",
                                                            fontWeight: "bold",
                                                            fontSize: '24px',
                                                        }}
                                                    />
                                                }
                                                {/* show attach floor plan attachment of req collected stage in sales */}
                                                {
                                                    data?.floorPlanAttach && 
                                                    (
                                                        <>
                                                         <b> Download Floor Plan Attachment: </b>
                                                        <DownloadOutlined
                                                            onClick={() => window.open(data?.floorPlanAttach)}
                                                            style={{
                                                                color: "green",
                                                                cursor: "pointer",
                                                                fontWeight: "bold",
                                                                fontSize: '24px',
                                                            }}
                                                        />
                                                        </>
                                                    )
                                                }
                                            </Typography>
                                            )}
                                        </AccordionDetails>

                                        {/* <Divider /> */}
                                        {
                                            (data?.leadId?.designStages === 'Design Sign-off' &&
                                                data?.leadId.contractFinanceApproved &&
                                                data?.leadId.contractCustomerApproved &&
                                                data?.quotationChangesActivity
                                            ) &&
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                {data?.QtChangesPaymentReceipt?.length > 0 && (<span style={{ fontWeight: 'bold', marginLeft: '12px' }}>Uploaded Payment Receipt:</span>)}                                               
                                                     {data?.QtChangesPaymentReceipt?.map((url, index) => (
                                                        <div key={index} style={{ marginRight: '10px' }}>
                                                            <DownloadOutlined
                                                                onClick={() => window.open(url)}
                                                                style={{
                                                                    color: "green",
                                                                    cursor: "pointer",
                                                                    fontWeight: "bold",
                                                                    fontSize: '24px',
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                                { (data.approvalSeqVisibility && !projectDetails?.isChmUser ) ?
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px' }}>
                                                    <h5
                                                        style={{
                                                            color: projectDetails?.sentForQuotationChangeApproval?.DesignManagerApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.sentForQuotationChangeApproval?.DesignManagerApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> DM/ADM <FaArrowRight />
                                                    </h5>

                                                    <h5 style={{
                                                        color: projectDetails?.sentForQuotationChangeApproval?.OpsDesignApproval === 'Sent for Approval' ? 'red'
                                                            : projectDetails?.sentForQuotationChangeApproval?.OpsDesignApproval === 'Approved' ? 'green' : 'inherit'
                                                    }}> Operation DM <FaArrowRight /></h5>

                                                    {data?.allPositiveValues !== true ?
                                                        (
                                                            <h5 style={{
                                                                color: projectDetails?.sentForQuotationChangeApproval?.DgmOpsApproval === 'Sent for Approval' ? 'red'
                                                                    : projectDetails?.sentForQuotationChangeApproval?.DgmOpsApproval === 'Approved' ? 'green' : 'inherit'
                                                            }}> DGM Ops <FaArrowRight /></h5>
                                                        ) : null}

                                                    <h5 style={{
                                                        color: projectDetails?.sentForQuotationChangeApproval?.FinanceManagerApproval === 'Sent for Approval' ? 'red'
                                                            : projectDetails?.sentForQuotationChangeApproval?.FinanceManagerApproval === 'Approved' ? 'green' : 'inherit'
                                                    }}> Finance Manager 
                                                     <FaArrowRight style={{visibility : (data?.valuesGreaterThan20k === true ||
                                                        data?.delayCategoryCheck === true)  ? "visible" :'hidden' }} />
                                                    </h5>

                                                    {data?.valuesGreaterThan20k === true ||
                                                       data?.delayCategoryCheck === true ? (
                                                        <h5 style={{
                                                            color: projectDetails?.sentForQuotationChangeApproval?.OperationHeadApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.sentForQuotationChangeApproval?.OperationHeadApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> Director Approval </h5>
                                                    ) : null}
                                                </div> 
                                                : null}

                                                {/* this is for CHM approval tracker only */}
                                                {projectDetails?.isChmUser &&
                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '5px'}}>          
                                                        <h5 style={{
                                                            color: projectDetails?.sentForQuotationChangeApproval?.DgmOpsApproval === 'Sent for Approval' ? 'red'
                                                            : projectDetails?.sentForQuotationChangeApproval?.DgmOpsApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> DGM Ops <FaArrowRight /></h5>
                                                        <h5 style={{
                                                            color: projectDetails?.sentForQuotationChangeApproval?.FinanceManagerApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.sentForQuotationChangeApproval?.FinanceManagerApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> Finance Manager <FaArrowRight />
                                                        </h5>
                                                    
                                                        <h5 style={{
                                                            color: projectDetails?.sentForQuotationChangeApproval?.OperationHeadApproval === 'Sent for Approval' ? 'red'
                                                                : projectDetails?.sentForQuotationChangeApproval?.OperationHeadApproval === 'Approved' ? 'green' : 'inherit'
                                                        }}> Director Approval </h5>
                                                    </div>
                                                }
                                                {/* this is for CHM approval tracker only */}
                                            </div>
                                        }
                                        {!isRunoCallLog && (
                                        <>
                                        <Divider />
                                        <AccordionActions style={{ display: "block" }}>
                                            <InfoIcon className={classes.dealActivityInfoIcon} onClick={() => showInfo(i, 'dealActivity')} />
                                            {
                                                Array.isArray(data.s3Location) &&
                                                data.s3Location.every(item => Array.isArray(item) ? item.length > 0 : item && item !== "") && (
                                                    <>
                                                           {data.s3Location.map((location, index) => (
                                                            location && location !== "" && !(Array.isArray(location) && location.length === 0) && (
                                                                <AttachmentIcon
                                                                    key={index}
                                                                    style={{ cursor: 'pointer' }}
                                                                       onClick={() => downloadNotesFile(location)}
                                                                   />
                                                               )
                                                           ))}
                                                    </>
                                                )
                                            }
                                        </AccordionActions>
                                        </>
                                        )}

                                    </Accordion >
                                }
                                {
                                    data?.notes && !(data?.cdrURL || data?.cdrLog || data?.runoCallId) && <Accordion defaultExpanded className="accordian">
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography className={classes.heading} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <EditTwoToneIcon />
                                                <span className="titlename" style={{ position: 'static', margin: 0 }}>Notes</span>
                                                {renderPinAction(data, true)}
                                                <span className={`datedata ${classes.dateLabel}`} style={{ position: 'static', top: 'auto', right: 'auto', marginLeft: 'auto' }}><EventIcon className={classes.dateIcon} />{moment(data?.createdAt).format('lll')}</span>
                                            </Typography>
                                        </AccordionSummary>
                                        <Divider />
                                        <AccordionDetails>
                                            <Typography variant="body2" gutterBottom>
                                                {renderWithBold(data?.notes)}
                                                <br />
                                                {
                                                    data?.floorPlanAttach &&
                                                    (
                                                        <>
                                                            <b> Download Floor Plan Attachment: </b>
                                                            <DownloadOutlined
                                                                onClick={() => window.open(data?.floorPlanAttach)}
                                                                style={{
                                                                    color: "green",
                                                                    cursor: "pointer",
                                                                    fontWeight: "bold",
                                                                    fontSize: '24px',
                                                                }}
                                                            />
                                                        </>
                                                    )
                                                }
                                                <br />
                                                <span style={{ fontSize: "12px" }}>{data?.createdBy?.name} has left a note</span>                                            </Typography>
                                        </AccordionDetails>
                                        <Divider />
                                        <AccordionActions style={{ display: "block" }}>
                                            <InfoIcon style={{ cursor: 'pointer' }} onClick={() => showInfo(i, 'notes')} />
                                            { Array.isArray(data.s3Location) &&
                                                data.s3Location.every(item => Array.isArray(item) ? item.length > 0 : item && item !== "") && (
                                                    <>
                                                           {data.s3Location.map((location, index) => (
                                                            location && location !== "" && !(Array.isArray(location) && location.length === 0) && (
                                                                <AttachmentIcon
                                                                    key={index}
                                                                    style={{ cursor: 'pointer' }}
                                                                        onClick={() => window.open(location)}
                                                                  />
                                                               )
                                                           ))}
                                                    </>
                                                )
                                            }
                                            {/* {data.s3Location.length !== 0 && <AttachmentIcon onClick={() => window.open(data.s3Location[0])} />} */}
                                            {renderPinAction(data, false)}
                                        </AccordionActions>
                                    </Accordion>
                                }

                                {data?.taskAssignNotes && <Accordion defaultExpanded className="accordian">
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography className={classes.heading}>
                                            <EditTwoToneIcon />
                                            <span className="titlename">Task</span>
                                            <span className={`datedata ${classes.dateLabel}`}><EventIcon className={classes.dateIcon} />{moment(data?.createdAt).format('lll')}</span>
                                        </Typography>
                                    </AccordionSummary>
                                    <Divider />
                                    <AccordionDetails>
                                        <Typography variant="body2" gutterBottom>
                                            {data?.taskAssignNotes} <br />
                                            <span style={{ fontSize: "12px" }}> Task has been assigned by  {data?.createdBy?.name}</span>
                                        </Typography>
                                    </AccordionDetails>
                                    <Divider />
                                    <AccordionActions style={{ display: "block" }}>
                                        <InfoIcon style={{ cursor: 'pointer' }} onClick={() => showInfo(i, 'notes')} />
                                        {Array.isArray(data.s3Location) &&
                                            data.s3Location.every(item => Array.isArray(item) ? item.length > 0 : item && item !== "") && (
                                                <>
                                                    {data.s3Location.map((location, index) => (
                                                        location && location !== "" && !(Array.isArray(location) && location.length === 0) && (
                                                            <AttachmentIcon
                                                                key={index}
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => window.open(location)}
                                                            />
                                                        )
                                                    ))}
                                                </>
                                            )
                                        }
                                    </AccordionActions>
                                </Accordion>
                                }
                            </Paper>
                            );
                        })}
                        </div>
                        <div className={classes.paginationBar}>
                            <Pagination count={paginationCount} onChange={handlePageChange} size="large" />
                        </div>
                    </Grid>
                </Grid>
            </div>

            {/* Pinned Notes Modal */}
            <Dialog open={pinnedNotesModalOpen} onClose={() => setPinnedNotesModalOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    <Box display="flex" alignItems="center">
                        <PinIcon pinned style={{ marginRight: 8 }} />
                        <Typography variant="h6">Pinned Notes ({pinnedNotesList.length}/{MAX_PINNED_NOTES_PER_LEAD})</Typography>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {pinnedNotesLoading ? (
                        <Box display="flex" justifyContent="center" py={3}>
                            <CircularProgress size={28} />
                        </Box>
                    ) : pinnedNotesList.length === 0 ? (
                        <Typography variant="body2" color="textSecondary" align="center" style={{ padding: '16px 0' }}>
                            No notes have been pinned for this lead yet.
                        </Typography>
                    ) : (
                        pinnedNotesList.map((note) => (
                            <Paper key={note._id} variant="outlined" style={{ padding: 12, marginBottom: 10 }}>
                                <Typography variant="body2" gutterBottom>{renderWithBold(note?.notes)}</Typography>
                                <Divider style={{ margin: '8px 0' }} />
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Tooltip title={buildPinnedByTooltip(note)}>
                                        <span style={{ fontSize: 12, color: 'rgba(0,0,0,0.6)', cursor: 'default' }}>
                                            Pinned by {note?.pinnedBy?.name || '-'} on {note?.pinnedAt ? moment(note.pinnedAt).format('lll') : '-'}
                                        </span>
                                    </Tooltip>
                                    <Button
                                        size="small"
                                        color="secondary"
                                        disabled={pinActionLoadingId === note._id}
                                        onClick={() => attemptUnpin(note)}
                                    >
                                        Unpin
                                    </Button>
                                </Box>
                            </Paper>
                        ))
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setPinnedNotesModalOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            
            {/* Show whatsApp Notification Content */}
            <Dialog open={openWhatsAppNotificationContentDialog} onClose={() => {setOpenWhatsAppNotificationContentDialog(false); setWhatsAppNotificationContent('')}}>
                <DialogTitle>
                    <Box display="flex" justifyContent="center">
                        <Typography variant="h6" align="center">
                            WhatsApp Notification Content
                        </Typography>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <MessageComponent name={maskedCustomerName} message={whatsAppNotificationContent} />
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Create Notes Modal */}
            <Dialog open={openNotesModal} onClose={() => setOpenNotesModal(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">Task & Reminder</DialogTitle>
                <Divider />
                <DialogContent>
                <FormControl component="fieldset">
                        <RadioGroup
                            aria-label="type"
                            name="type"
                            value={type}
                            onChange={(e) => handleType(e)}
                        >
                            <div className="modal-header-radio">
                                <FormControlLabel value="setReminder" control={<Radio />} label="Set Reminder" />
                                <FormControlLabel value="assignTask" control={<Radio />} label="Assign Task" />
                            </div>
                        </RadioGroup>
                    </FormControl>
                    <div style={{ paddingBottom: 10 }}>
                        <div className="editor">
                            <Editor
                                editorKey={'editor'}
                                editorState={editorState}
                                onChange={setEditorStateData}
                                plugins={plugins}
                                ref={editorRef}
                            />
                            <MentionSuggestions
                                open={mentionOpen}
                                onOpenChange={onOpenChange}
                                suggestions={suggestions}
                                onSearchChange={onSearchChange}
                                onAddMention={onAddMention}
                                onClose={() => { }}
                            />
                        </div>
                    </div>
                    <div style={{ paddingBottom: 15 }}>
                        <TextField
                            id="start_date"
                            label="Set Date and Time"
                            name="reminderDate"
                            onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                            type="datetime-local"
                            className={classes.textFieldWidth}
                            size="small"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div>
                    <div style={{ paddingBottom: 15 }}>
                        <input
                            accept="*"
                            ref={createNoteFile}
                            className={classes.input}
                            id="project-document"
                            onChange={uploadCreateNoteImg}
                            type="file"
                        />
                        <label htmlFor="project-document">
                            {
                                fileUploaded && <CheckCircleIcon />
                            }
                        </label>
                    </div>

                    {/* <div style={{ paddingBottom: 15 }}>
                            <>
                                <label>Send Note to Client</label>
                                <Checkbox
                                    // checked={sendNoteToClient}
                                checked={
                                    (type === 'setReminder' || type === 'assignTask')
                                        ? false
                                        : projectDetails?.departmentId?._id === designDepartment
                                            ? true
                                            : sendNoteToClient
                                }
                                    onChange={handleCheckboxClick}
                                    color="primary"
                                    disabled={projectDetails?.departmentId === designDepartment  || type === 'setReminder' || type === 'assignTask'}
                                />
                            </>

                        <Dialog
                            open={dialogOpen}
                            onClose={handleDialogCancel}
                        >
                            <DialogTitle>Confirm Action</DialogTitle>
                            <DialogContent>
                                {}
                                <DialogContentText>
                                    This note will be sent to the client via WhatsApp. Are you sure you want to proceed?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleDialogCancel} color="secondary">
                                    Cancel
                                </Button>
                                <Button onClick={handleDialogConfirm} color="primary" autoFocus>
                                    Yes
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div> */}

                    {(userDetails.roles.find(role => role.name === ROLENAME.SalesUser || role.name === ROLENAME.AssistantSalesManager ) && projectDetails.currentStage === 'Requirements Not Collected') &&
                        <>
                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                <InputLabel id="req-not-collected-reason">Reason to move to Requirements Not Collected </InputLabel>
                                <Select
                                    labelId="req-not-collected-reason"
                                    id="req-not-collected-reason"
                                    value={moveInRncReason}
                                    label="Reason to move to requirements not collected "
                                    onChange={(e) => handleMoveInRncReason(e)}
                                    variant="outlined"
                                    style={{width: '430px'}}
                                >
                                    {reqNotCollectedReasonList.map((reasonName, i) => {
                                        return (
                                            <MenuItem key={i + 1} value={reasonName}>{reasonName}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                            {moveInRncReason === 'Other' &&
                                <TextField
                                    fullWidth
                                    label="Reason"
                                    name="accountHolder"
                                    id="reasonForMove"
                                    variant="outlined"
                                    value={moveInRncOtherReason}
                                    onChange={(e) => setMoveInRncOtherReason(e.target.value)}
                                    required
                                    style={{ marginBottom: '10px', width: '430px' }}
                                />
                            }

                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                <InputLabel id="verfication-status">Lead verification status </InputLabel>
                                <Select
                                    labelId="req-not-collected-reason"
                                    id="verfication-status"
                                    value={verficationStatus}
                                    label="Lead verification status "
                                    onChange={(e) => setVerficationStatus(e.target.value)}
                                    variant="outlined"
                                    style={{width: '430px'}}

                                >
                                    {verificationStatusList.map((status, i) => {
                                        return (
                                            <MenuItem key={i + 1} value={status}>{status}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>

                            {verficationStatus === 'Verified disqualified lead' &&
                                <TextField
                                    fullWidth
                                    label="Reason"
                                    name="verifiyName"
                                    id="verifiyName"
                                    variant="outlined"
                                    value={verficationStatusOther}
                                    onChange={(e) => setVerficationStatusOther(e.target.value)}
                                    required
                                    // size="small"
                                    style={{ marginBottom: '10px', width: '430px' }}
                                />
                            }
                        </>
                    } 

                    {/* notes for Requirement Collected Changes */}
                    {(userDetails.roles.find(role => role.name === ROLENAME.SalesUser || role.name === ROLENAME.AssistantSalesManager) && projectDetails.currentStage === 'Requirements Collected') &&
                        <>
                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                <InputLabel id="req-collected-reason"> Reason to for lead to stay in Requirements Collected </InputLabel>
                                <Select
                                    labelId="req-collected-reason"
                                    id="req-collected-reason"
                                    value={reasonMoveRcCollect}
                                    label="Reason to for lead to stay in Requirements Collected"
                                    onChange={(e) => handleMoveInRcCollected(e)}
                                    variant="outlined"
                                    style={{width: '460px'}}
                                >
                                    {reasonMoveRcCollectList.map((reasonName, i) => {
                                        return (
                                            <MenuItem key={i + 1} value={reasonName}>{reasonName}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>

                            {reasonMoveRcCollect === 'Other' &&
                                <TextField
                                    fullWidth
                                    label="Reason"
                                    name="reasonCollect"
                                    id="reasonCollect"
                                    variant="outlined"
                                    value={reasonMoveRcCollectOther}
                                    onChange={(e) => setReasonMoveRcCollectOther(e.target.value)}
                                    required
                                    size="small"
                                    style={{ marginBottom: '10px', width: '460px' }}
                                />
                            }
                              <FormControl component="fieldset" className={classes.root} style={{ marginRight: 20 }}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={reqCollectedChanges}
                                        onChange={(e) => setReqCollectedChanges(e.target.checked)}
                                        name="reqCollectedChanges"
                                        color="primary"
                                    />
                                    }
                                    label="Any change in Requirement Collected"
                                />
                                </FormControl>

                                {reqCollectedChanges && 
                                    <>
                                         <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="scope_of_work"
                                                label="Scope of work in detail"
                                                multiline
                                                value={rcScopeOfWork}
                                                onChange={(e) => setRcScopeOfWork(e.target.value)}
                                                variant="outlined"
                                                size="small"
                                                required
                                            />
                                        </FormControl>
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="design_preference"
                                                label="Design Preferences"
                                                multiline
                                                value={designPref}
                                                onChange={(e) => setDesignPref(e.target.value)}
                                                variant="outlined"
                                                size="small"
                                            />
                                        </FormControl>
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="estimate_budget"
                                                label="Budget"
                                                multiline
                                                value={estimatedBudget}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*$/.test(value)) { // Only allow digits (no decimal, no letters)
                                                       setEstimateBudget(value);
                                                    }
                                                  }}
                                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}                                           
                                                variant="outlined"
                                                size="small"
                                                required
                                            />
                                        </FormControl>
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="timeLineMoveHouseDate"
                                                name={timelineMoveHouseDate}
                                                value={timelineMoveHouseDate}
                                                onChange={(e) => setTimelineMoveHouseDate(e.target.value)}
                                                label="Timeline to move into the house"
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                variant="outlined"
                                                size="small"
                                                required
                                            />
                                        </FormControl>

                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="possession_date"
                                                name={possDate}
                                                value={possDate}
                                                onChange={(e) => setPossDate(e.target.value)}
                                                label="Possession Date"
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                variant="outlined"
                                                size="small"
                                                required
                                            />
                                        </FormControl>
                                        {/* attachement floor plan  */}
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <>
                                                <input
                                                    accept=".pdf"
                                                    className={classes.input}
                                                    id="floorplan-document"
                                                    onChange={(e) => uploadWDFileDocument(e, 'FloorPlanFile')}
                                                    type="file"
                                                    style={{ display: 'none' }}
                                                />
                                                <label htmlFor="floorplan-document">
                                                    <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span">
                                                        Attach Floor Plan (if applicable)
                                                    </Button>
                                                    {floorPlanUploaded && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
                                                </label>
                                            </>
                                        </FormControl>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                id="anyother_relevant"
                                                label="Any other specific details relevant to Decorpot"
                                                multiline
                                                rows={2}
                                                value={rcOtherDetails}
                                                onChange={(e) => setRcOtherDetails(e.target.value)}
                                                variant="outlined"
                                                size="small"
                                            />
                                        </FormControl>
                                    </>
                                }
                        </>
                    } 

                    {(userDetails.roles.find(role => role.name === ROLENAME.SalesUser || role.name === ROLENAME.AssistantSalesManager) && projectDetails.currentStage === 'Quotation Sent') &&
                        <>
                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                <InputLabel id="reason-deal-QtSent">Reason for deal to be in Quotation Sent</InputLabel>
                                <Select
                                    labelId="reason-deal-QtSent"
                                    id="reason-deal-QtSent"
                                    value={reasonToDealQt}
                                    label="Reason for deal to be in Quotation Sent"
                                    onChange={(e)=>handleQtSentReason(e)}
                                    variant="outlined"
                                    size="small"
                                    required
                                >
                                    {reasonForDealQtList.map((reasonName, i) => {
                                        return (
                                            <MenuItem key={i + 1} value={reasonName}>{reasonName}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>

                            {reasonToDealQt === 'Other' &&
                                <TextField
                                    fullWidth
                                    label="Reason"
                                    name="reasonToDealOther"
                                    id="reasonToDealOther"
                                    variant="outlined"
                                    value={reasonToDealQtOther}
                                    onChange={(e) => setReasonToDealQtOther(e.target.value)}
                                    required
                                    size="small"
                                    style={{ marginBottom: '10px' }}
                                />
                            }

                            <FormControl component="fieldset">
                                <FormLabel component="legend" style={{ color: "#000" }}>
                                    1. Is quotation fitting customer budget mentioned?
                                </FormLabel>
                                <RadioGroup
                                    aria-label="type"
                                    name="type"
                                    value={qtFittingBudget}
                                    onChange={(e) => setQtFittingBudget(e.target.value)}
                                >
                                    <>
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </>
                                </RadioGroup>
                            </FormControl>

                            <FormControl component="fieldset">
                                <FormLabel component="legend" style={{ color: "#000" }}>
                                    2. Is the customer planning to visit the Experience Zone?
                                </FormLabel>
                                <RadioGroup
                                    aria-label="type"
                                    name="type"
                                    value={cxPlanVisitExZone}
                                    onChange={(e) => setcxPlanVisitExZone(e.target.value)}
                                >
                                    <>
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        {cxPlanVisitExZone === "Yes" &&
                                            <TextField
                                                fullWidth
                                                name="cxPlanDate"
                                                id="cxPlanDate"
                                                value={planVisitDate}
                                                onChange={(e) => setPlanVisitDate(e.target.value)}
                                                label="Select Plan Date Visit"
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                variant="outlined"
                                                size="small"
                                                required
                                                style={{ marginBottom: '5px' }}
                                            />
                                        }
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </>
                                </RadioGroup>
                            </FormControl>
                        </>
                    }
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={handleNotesCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={saveNotes} color="primary">
                        Save Note
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Create Notes Modal */}
            <Dialog open={openNewNotesModal} onClose={() => setOpenNewNotesModal(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">Create Note</DialogTitle>
                <Divider />
                <DialogContent>
                {/* <FormControl component="fieldset">
                        <RadioGroup
                            aria-label="type"
                            name="type"
                            value={type}
                            onChange={(e) => handleType(e)}
                        >
                            <div className="modal-header-radio">
                                <FormControlLabel value="setReminder" control={<Radio />} label="Set Reminder" />
                                <FormControlLabel value="assignTask" control={<Radio />} label="Assign Task" />
                            </div>
                        </RadioGroup>
                </FormControl> */}
                    <div style={{ paddingBottom: 10 }}>
                        <div className="editor">
                            <Editor
                                editorKey={'editor'}
                                editorState={editorState}
                                onChange={setEditorStateData}
                                plugins={plugins}
                                ref={editorRef}
                            />
                            <MentionSuggestions
                                open={mentionOpen}
                                onOpenChange={onOpenChange}
                                suggestions={suggestions}
                                onSearchChange={onSearchChange}
                                onAddMention={onAddMention}
                                onClose={() => { }}
                            />
                        </div>
                    </div>
                    {/* <div style={{ paddingBottom: 15 }}>
                        <TextField
                            id="start_date"
                            label="Set Date and Time"
                            name="reminderDate"
                            onChange={(e) => setFormData({ ...formData, [e.target.name]: e.target.value })}
                            type="datetime-local"
                            className={classes.textFieldWidth}
                            size="small"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </div> */}
                    <div style={{ paddingBottom: 15 }}>
                        <input
                            accept="*"
                            ref={createNoteFile}
                            className={classes.input}
                            id="project-document"
                            onChange={uploadCreateNoteImg}
                            type="file"
                        />
                        <label htmlFor="project-document">
                            {
                                fileUploaded && <CheckCircleIcon />
                            }
                        </label>
                    </div>

                    <div style={{ paddingBottom: 15 }}>
                            <>
                                <label>Send Note to Client</label>
                                <Checkbox
                                    // checked={sendNoteToClient}
                                checked={
                                    (type === 'setReminder' || type === 'assignTask')
                                        ? false
                                        : projectDetails?.departmentId?._id === designDepartment
                                            ? true
                                            : sendNoteToClient
                                }
                                    onChange={handleCheckboxClick}
                                    color="primary"
                                    disabled={projectDetails?.departmentId === designDepartment  || type === 'setReminder' || type === 'assignTask'}
                                />
                            </>

                        <Dialog
                            open={dialogOpen}
                            onClose={handleDialogCancel}
                        >
                            <DialogTitle>Confirm Action</DialogTitle>
                            <DialogContent>
                                {}
                                <DialogContentText>
                                    This note will be sent to the client via WhatsApp. Are you sure you want to proceed?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleDialogCancel} color="secondary">
                                    Cancel
                                </Button>
                                <Button onClick={handleDialogConfirm} color="primary" autoFocus>
                                    Yes
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>

                    {(userDetails.roles.find(role => role.name === ROLENAME.SalesUser || role.name === ROLENAME.AssistantSalesManager ) && projectDetails.currentStage === 'Requirements Not Collected') &&
                        <>
                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                <InputLabel id="req-not-collected-reason">Reason to move to Requirements Not Collected </InputLabel>
                                <Select
                                    labelId="req-not-collected-reason"
                                    id="req-not-collected-reason"
                                    value={moveInRncReason}
                                    label="Reason to move to requirements not collected "
                                    onChange={(e) => handleMoveInRncReason(e)}
                                    variant="outlined"
                                    style={{width: '430px'}}
                                >
                                    {reqNotCollectedReasonList.map((reasonName, i) => {
                                        return (
                                            <MenuItem key={i + 1} value={reasonName}>{reasonName}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                            {moveInRncReason === 'Other' &&
                                <TextField
                                    fullWidth
                                    label="Reason"
                                    name="accountHolder"
                                    id="reasonForMove"
                                    variant="outlined"
                                    value={moveInRncOtherReason}
                                    onChange={(e) => setMoveInRncOtherReason(e.target.value)}
                                    required
                                    style={{ marginBottom: '10px', width: '430px' }}
                                />
                            }

                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                <InputLabel id="verfication-status">Lead verification status </InputLabel>
                                <Select
                                    labelId="req-not-collected-reason"
                                    id="verfication-status"
                                    value={verficationStatus}
                                    label="Lead verification status "
                                    onChange={(e) => setVerficationStatus(e.target.value)}
                                    variant="outlined"
                                    style={{width: '430px'}}

                                >
                                    {verificationStatusList.map((status, i) => {
                                        return (
                                            <MenuItem key={i + 1} value={status}>{status}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>

                            {verficationStatus === 'Verified disqualified lead' &&
                                <TextField
                                    fullWidth
                                    label="Reason"
                                    name="verifiyName"
                                    id="verifiyName"
                                    variant="outlined"
                                    value={verficationStatusOther}
                                    onChange={(e) => setVerficationStatusOther(e.target.value)}
                                    required
                                    // size="small"
                                    style={{ marginBottom: '10px', width: '430px' }}
                                />
                            }
                        </>
                    } 

                    {/* notes for Requirement Collected Changes */}
                    {(userDetails.roles.find(role => role.name === ROLENAME.SalesUser || role.name === ROLENAME.AssistantSalesManager) && projectDetails.currentStage === 'Requirements Collected') &&
                        <>
                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                <InputLabel id="req-collected-reason"> Reason to for lead to stay in Requirements Collected </InputLabel>
                                <Select
                                    labelId="req-collected-reason"
                                    id="req-collected-reason"
                                    value={reasonMoveRcCollect}
                                    label="Reason to for lead to stay in Requirements Collected"
                                    onChange={(e) => handleMoveInRcCollected(e)}
                                    variant="outlined"
                                    style={{width: '460px'}}
                                >
                                    {reasonMoveRcCollectList.map((reasonName, i) => {
                                        return (
                                            <MenuItem key={i + 1} value={reasonName}>{reasonName}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>

                            {reasonMoveRcCollect === 'Other' &&
                                <TextField
                                    fullWidth
                                    label="Reason"
                                    name="reasonCollect"
                                    id="reasonCollect"
                                    variant="outlined"
                                    value={reasonMoveRcCollectOther}
                                    onChange={(e) => setReasonMoveRcCollectOther(e.target.value)}
                                    required
                                    size="small"
                                    style={{ marginBottom: '10px', width: '460px' }}
                                />
                            }
                              <FormControl component="fieldset" className={classes.root} style={{ marginRight: 20 }}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={reqCollectedChanges}
                                        onChange={(e) => setReqCollectedChanges(e.target.checked)}
                                        name="reqCollectedChanges"
                                        color="primary"
                                    />
                                    }
                                    label="Any change in Requirement Collected"
                                />
                                </FormControl>

                                {reqCollectedChanges && 
                                    <>
                                         <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="scope_of_work"
                                                label="Scope of work in detail"
                                                multiline
                                                value={rcScopeOfWork}
                                                onChange={(e) => setRcScopeOfWork(e.target.value)}
                                                variant="outlined"
                                                size="small"
                                                required
                                            />
                                        </FormControl>
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="design_preference"
                                                label="Design Preferences"
                                                multiline
                                                value={designPref}
                                                onChange={(e) => setDesignPref(e.target.value)}
                                                variant="outlined"
                                                size="small"
                                            />
                                        </FormControl>
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="estimate_budget"
                                                label="Budget"
                                                multiline
                                                value={estimatedBudget}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*$/.test(value)) { // Only allow digits (no decimal, no letters)
                                                       setEstimateBudget(value);
                                                    }
                                                  }}
                                                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}                                           
                                                variant="outlined"
                                                size="small"
                                                required
                                            />
                                        </FormControl>
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="timeLineMoveHouseDate"
                                                name={timelineMoveHouseDate}
                                                value={timelineMoveHouseDate}
                                                onChange={(e) => setTimelineMoveHouseDate(e.target.value)}
                                                label="Timeline to move into the house"
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                variant="outlined"
                                                size="small"
                                                required
                                            />
                                        </FormControl>

                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="possession_date"
                                                name={possDate}
                                                value={possDate}
                                                onChange={(e) => setPossDate(e.target.value)}
                                                label="Possession Date"
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                variant="outlined"
                                                size="small"
                                                required
                                            />
                                        </FormControl>
                                        {/* attachement floor plan  */}
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <>
                                                <input
                                                    accept=".pdf"
                                                    className={classes.input}
                                                    id="floorplan-document"
                                                    onChange={(e) => uploadWDFileDocument(e, 'FloorPlanFile')}
                                                    type="file"
                                                    style={{ display: 'none' }}
                                                />
                                                <label htmlFor="floorplan-document">
                                                    <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span">
                                                        Attach Floor Plan (if applicable)
                                                    </Button>
                                                    {floorPlanUploaded && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
                                                </label>
                                            </>
                                        </FormControl>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                id="anyother_relevant"
                                                label="Any other specific details relevant to Decorpot"
                                                multiline
                                                rows={2}
                                                value={rcOtherDetails}
                                                onChange={(e) => setRcOtherDetails(e.target.value)}
                                                variant="outlined"
                                                size="small"
                                            />
                                        </FormControl>
                                    </>
                                }
                        </>
                    } 

                    {(userDetails.roles.find(role => role.name === ROLENAME.SalesUser || role.name === ROLENAME.AssistantSalesManager) && projectDetails.currentStage === 'Quotation Sent') &&
                        <>
                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                <InputLabel id="reason-deal-QtSent">Reason for deal to be in Quotation Sent</InputLabel>
                                <Select
                                    labelId="reason-deal-QtSent"
                                    id="reason-deal-QtSent"
                                    value={reasonToDealQt}
                                    label="Reason for deal to be in Quotation Sent"
                                    onChange={(e)=>handleQtSentReason(e)}
                                    variant="outlined"
                                    size="small"
                                    required
                                >
                                    {reasonForDealQtList.map((reasonName, i) => {
                                        return (
                                            <MenuItem key={i + 1} value={reasonName}>{reasonName}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>

                            {reasonToDealQt === 'Other' &&
                                <TextField
                                    fullWidth
                                    label="Reason"
                                    name="reasonToDealOther"
                                    id="reasonToDealOther"
                                    variant="outlined"
                                    value={reasonToDealQtOther}
                                    onChange={(e) => setReasonToDealQtOther(e.target.value)}
                                    required
                                    size="small"
                                    style={{ marginBottom: '10px' }}
                                />
                            }

                            <FormControl component="fieldset">
                                <FormLabel component="legend" style={{ color: "#000" }}>
                                    1. Is quotation fitting customer budget mentioned?
                                </FormLabel>
                                <RadioGroup
                                    aria-label="type"
                                    name="type"
                                    value={qtFittingBudget}
                                    onChange={(e) => setQtFittingBudget(e.target.value)}
                                >
                                    <>
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </>
                                </RadioGroup>
                            </FormControl>

                            <FormControl component="fieldset">
                                <FormLabel component="legend" style={{ color: "#000" }}>
                                    2. Is the customer planning to visit the Experience Zone?
                                </FormLabel>
                                <RadioGroup
                                    aria-label="type"
                                    name="type"
                                    value={cxPlanVisitExZone}
                                    onChange={(e) => setcxPlanVisitExZone(e.target.value)}
                                >
                                    <>
                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                        {cxPlanVisitExZone === "Yes" &&
                                            <TextField
                                                fullWidth
                                                name="cxPlanDate"
                                                id="cxPlanDate"
                                                value={planVisitDate}
                                                onChange={(e) => setPlanVisitDate(e.target.value)}
                                                label="Select Plan Date Visit"
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                variant="outlined"
                                                size="small"
                                                required
                                                style={{ marginBottom: '5px' }}
                                            />
                                        }
                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                    </>
                                </RadioGroup>
                            </FormControl>
                        </>
                    }
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={handleNotesNewCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={saveNotes} color="primary">
                        Save Note
                    </Button>
                </DialogActions>
            </Dialog>

            {/* DesignKickOff Screenshots */}
            <Dialog open={openDesignKickOffScreenshotsModal} onClose={() => setOpenDesignKickOffScreenshotsModal(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">Click to Download</DialogTitle>
                <Divider />
                <DialogContent>

                    <Box sx={{ minWidth: 550 }}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="custom pagination table">
                                <TableBody>
                                    {
                                        projectDetails?.designKickOffCustomerFileLinks?.screenshShotsLinks.map((el, index) => {
                                            return (
                                                <TableRow>
                                                    <TableCell style={{ textAlign: 'center' }}>ScreenShot {index + 1}</TableCell>
                                                    <TableCell style={{ textAlign: 'center' }}><DownloadOutlined onClick={() => window.open(el)} /></TableCell>
                                                </TableRow>)
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenDesignKickOffScreenshotsModal(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Assign SiteQc Model */}
            <Dialog open={openAssignSiteQcModel} onClose={() => setOpenAssignSiteQcModel(false)}>
                <DialogTitle style={{ textAlign: 'center' }}>You can assign below User's for this Project</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <Autocomplete
                                value={selectedSiteQcUserData}
                                onChange={(e, v) => setSelectedSiteQcUserData(v)}
                                options={allSiteQc}
                                getOptionLabel={(option) => option.name}
                                style={{ width: 500, marginBottom: 10, marginLeft: 25 }}
                                renderInput={(params) => <TextField {...params} label="Select Site QC" fullWidth variant="outlined" />}
                            />
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions >
                    <Button onClick={() => setOpenAssignSiteQcModel(false)} variant="outlined" color="primary">Cancel</Button>

                    <Button variant="contained" color="primary" onClick={handleAssignSiteQc}>Submit</Button>
                </DialogActions>
            </Dialog>
            {/* Raise Site Visit Payment Request Modal */}
            <SiteVisitPaymentRaiseModal
                open={openSiteVisitPaymentModal}
                onClose={() => setOpenSiteVisitPaymentModal(false)}
                sourceLeadId={projectDetails?._id}
                setLoading={props.setLoading}
                setSnackInfo={props.setSnackInfo}
            />


            {/* Pop up while generating link */}
            {/* <Dialog 
                open={openGenerateLinkPopUp} 
                onClose={() => setOpenGenerateLinkPopUp(false)} 
                maxWidth="md" 
            >
            <DialogTitle style={{ textAlign: 'center' }}>Are You Sure You Want Submit ?</DialogTitle>
                <DialogContent>
            </DialogContent>
            <DialogActions >
            <Button onClick={() => setOpenGenerateLinkPopUp(false)} variant="outlined" color="primary">Cancel</Button>
            <Button variant="contained" color="primary" onClick={handleRequestLink}>Submit</Button>
            </DialogActions>
            </Dialog> */}

            {/* Project No already exists popup (Assign to Designer) */}
            <Dialog open={openErpExistsDialog} onClose={() => setOpenErpExistsDialog(false)}>
                <DialogTitle>Project No. Already Exists</DialogTitle>
                <DialogContent>
                    <p>The project no already exist please connect with the tech team</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenErpExistsDialog(false)} variant="contained" color="primary">OK</Button>
                </DialogActions>
            </Dialog>

            {/* Edit ERP Project No Model */}
            <Dialog open={openErpProjectNoModal} onClose={() => setOpenErpProjectNoModal(false)}>
                <DialogTitle>Enter Detail</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <TextField label="New ERP Project No." size="small" value={newErpProjectNo} style={{ marginBottom: 20 }} name="floorPlan" onChange={e => setNewErpProjectNo(e.target.value.toUpperCase())} variant="outlined" />
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenErpProjectNoModal(false)} variant="outlined" color="primary">Cancel</Button>

                    <Button variant="contained" color="primary" size="small" onClick={handleChangeProjectNo}>Change</Button>

                </DialogActions>
            </Dialog>

            {/* //design sign off  design signoff modal open */}
            {/* <Dialog open={openDesignSignOff} onClose={() => setOpenDesignSignOffModal(false)}>
                <DialogTitle>Enter Date</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <TextField
                                type="date"
                                size="small"
                                value={designSignOff}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                    min: getMinDate(),
                                    // max: getMaxDate(),
                                }}
                                style={{ marginBottom: 20 }}
                                name="floorPlan"
                                onChange={e => setDesignSignOff(e.target.value)}
                                variant="outlined" />
                            <TextField
                                label='Remarks'
                                fullWidth
                                multiline
                                minRows={3}
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                variant='outlined'
                            />
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDesignSignOffModal(false)} variant="outlined" color="primary">Cancel</Button>

                    <Button variant="contained" color="primary" size="medium" disabled={!designSignOff || remarks === ""} 
                    onClick={handleDesignSignOffDate}>Change</Button>
                </DialogActions>
            </Dialog> */}

            { /* Change Revised Projected Design Sign-Off Date */}
            {/* <Dialog open={revisedDateModal} onClose={() => setRevisedDateModal(false)}>
                <DialogTitle>Enter Date</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <TextField
                                type="date"
                                size="small"
                                value={revisedProjectedDesignSignOffDate ? new Date(revisedProjectedDesignSignOffDate).toISOString().substring(0, 10) : ""}
                                style={{ marginBottom: 20 }}
                                onChange={e => setRevisedProjectedDesignSignOffDate(e.target.value)}
                                variant="outlined"
                            />
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setRevisedDateModal(false)} variant="outlined" color="primary">Cancel</Button>
                    <Button variant="contained" color="primary" size="medium" onClick={handleRevisedProjectedDesignSignOffDate}>Change</Button>
                </DialogActions>
            </Dialog> */}

            {/* <Dialog open={uploadModal} onClose={() => setUploadModal(false)}>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    color="primary"
                                    style={{ marginBottom: 20, marginRight: '10px' }} // Added marginRight for spacing
                                >
                                    Upload Payment Proof
                                    <input
                                        type="file"
                                        hidden
                                        accept="image/*, application/pdf"
                                        onChange={handleFileSelection}  // Directly handle file selection
                                    />
                                </Button>
                                {uploadSuccess && <CheckCircleIcon style={{ color: 'green' }} />}
                            </Box>
                        </FormControl>

                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button disabled={!uploadSuccess} onClick={() => handlePaymentAttachment(monthlyContractFile)} variant="outlined" color="primary">
                        Submit
                    </Button>
                    <Button onClick={() => setUploadModal(false)} variant="outlined" color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog> */}

            {/* expectedSalesclosureDate dialog box */}
            <Dialog open={openEnterSalesClosureDate} onClose={() => setOpenEnterSalesClosureDateModal(false)}>
                <DialogTitle>Enter Date</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <TextField type="date" size="small" value={expectedSalesclosureDate} style={{ marginBottom: 20 }} name="expectedsalesclosuredate" onChange={salesClosureDateHandler} variant="outlined" />
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenEnterSalesClosureDateModal(false)} variant="outlined" color="primary">Cancel</Button>
                    <Button variant="contained" color="customColor" size="medium" onClick={handleEnterSalesClosureDate}>Change</Button>
                </DialogActions>
            </Dialog>

            {/* Show Notes and Deal Activity Info Modal */}
            <Dialog open={openNotesInfoModal} onClose={() => setOpenNotesInfoModal(false)} aria-labelledby="form-dialog-title" fullWidth maxWidth='sm'>
                <DialogTitle id="form-dialog-title">
                    {(stageInfo === 'Quotation Sent' && openActivity === 'dealActivity') && <>Quotation Sent</>}
                    {(stageInfo === 'Requirements Not Collected' && openActivity === 'dealActivity') && <>Requirements Not Collected</>}
                    {(stageInfo === 'Requirements Collected' && openActivity === 'dealActivity') && <>Requirements Collected</>}
                    {(stageInfo === 'Negotiation' && openActivity === 'dealActivity') && <>Negotiation</>}
                    {(stageInfo === 'Won' && openActivity === 'dealActivity') && <>Won</>}
                    {(stageInfo === 'Site/Office visit' && openActivity === 'dealActivity') && <>Site/Office visit</>}
                    {openActivity === 'notes' && <>Notes</>}
                    {(stageInfo !== 'Requirements Not Collected' && stageInfo !== 'Requirements Collected' && stageInfo !== 'Quotation Sent' && stageInfo !== 'Site/Office visit' && stageInfo !== 'Negotiation' && stageInfo !== 'Won' && openActivity === 'dealActivity') && <>Deal Activity</>}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {/* {projectLogs[stageIndex]?.stage === "Quotation Sent" &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Quotation sent Date</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['quotationSentDate'] != null ? moment(projectLogs[stageIndex]?.['quotationSentDate']).format('DD-MM-YYYY') : "NA"}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>MOM</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['momQuotationStage']}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Next Follow update</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['nextFollowUpDate'] != null ? moment(projectLogs[stageIndex]?.['nextFollowUpDate']).format('DD-MM-YYYY') : "NA"}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {projectLogs[stageIndex]?.stage === "Requirements Not Collected" &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Pre-sales Call Date</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['preSalesCallDate'] != null ? moment(projectLogs[stageIndex]?.['preSalesCallDate']).format('DD-MM-YYYY') : "NA"}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Next Follow update</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['nextFollowUpDate'] != null ? moment(projectLogs[stageIndex]?.['nextFollowUpDate']).format('DD-MM-YYYY') : "NA"}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {projectLogs[stageIndex]?.stage === "Requirements Collected" &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Requirements Collected Date</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['salesCallDate'] != null ? moment(projectLogs[stageIndex]?.['salesCallDate']).format('DD-MM-YYYY') : "NA"}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>Requirements</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['requirements']}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Estimated Budget</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['estimatedBudget']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Requirements Collected Comment</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['salesCallComment']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Next Follow update</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['nextFollowUpDate'] != null ? moment(projectLogs[stageIndex]?.['nextFollowUpDate']).format('DD-MM-YYYY') : "NA"}</TableCell>
                                    </TableRow>
                                    <TableRow key='6'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    } */}

                    {projectLogs[stageIndex]?.stage === "Negotiation" &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Negotiation Date</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['negotiationDate'] != null ? moment(projectLogs[stageIndex]?.['negotiationDate']).format('DD-MM-YYYY') : "NA"}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>MOM Negotitation Stage</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['momNegotitationStage']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Next Follow update</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['nextFollowUpDate'] != null ? moment(projectLogs[stageIndex]?.['nextFollowUpDate']).format('DD-MM-YYYY') : "NA"}</TableCell>
                                    </TableRow>
                                    <TableRow key='6'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='7'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='8'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {projectLogs[stageIndex]?.['Won'] &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Won Date</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['closureDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>Remarks</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['remark']}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Payment Plan</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['paymentPlan']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Final Quote Attached</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['finalQuoteAttached'] === true ? `Yes` : `No`}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Client Move in Date</TableCell>
                                        <TableCell>{moment(projectLogs[stageIndex]?.['clientMoveinDate']).format('DD-MM-YYYY')}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                    {projectLogs[stageIndex]?.stage === "Site/Office visit" &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Site/Visit Date</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['siteVisitDate'] != null ? moment(projectLogs[stageIndex]?.['siteVisitDate']).format('DD-MM-YYYY') : "NA"}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>MOM Meeting Stage</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['momMeetingStage']}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>MOM Site Visit Stage</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['momSiteVisitStage']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Next Follow update</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['nextFollowUpDate'] != null ? moment(projectLogs[stageIndex]?.['nextFollowUpDate']).format('DD-MM-YYYY') : "NA"}</TableCell>
                                    </TableRow>
                                    <TableRow key='6'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }

                    {
                        (
                            stageInfo !== 'Requirements Not Collected' &&
                            stageInfo !== 'Requirements Collected' &&
                            stageInfo !== 'Negotiation' &&
                            stageInfo !== 'Quotation Sent' &&
                            stageInfo !== 'Site/Office visit' &&
                            stageInfo !== 'Won' &&
                            !projectLogs[stageIndex]?.['notes']
                        )
                            ?
                            <TableContainer component={Paper}>
                                <Table className={classes.table} size="small" aria-label="customized table">
                                    <TableBody>
                                        <TableRow key='1'>
                                            <TableCell>Assigned To</TableCell>
                                            <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                        </TableRow>
                                        <TableRow key='4'>
                                            <TableCell>Department</TableCell>
                                            <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                        </TableRow>
                                        <TableRow key='5'>
                                            <TableCell>Team</TableCell>
                                            <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            :
                            <TableContainer component={Paper}>
                                <Table className={classes.table} size="small" aria-label="customized table">
                                    <TableBody>
                                        {
                                            projectLogs[stageIndex]?.['notes'] &&

                                            <TableRow key='2'>
                                                <TableCell>Notes</TableCell>
                                                <TableCell>{projectLogs[stageIndex]?.['notes']}</TableCell>
                                            </TableRow>
                                        }
                                        {
                                            projectLogs[stageIndex]?.['s3Location'].length !== 0 &&

                                            <TableRow key='3'>
                                                <TableCell>Attachments</TableCell>
                                                {projectLogs[stageIndex]?.['s3Location']?.map((data, i) => (
                                                    <TableCell key={i + 1}>{data}</TableCell>
                                                ))}
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                    }
                    {/* {
                        (
                            projectLogs[stageIndex]?.['quotationSentDate'] === null ||
                            projectLogs[stageIndex]?.['preSalesCallDate'] === null ||
                            projectLogs[stageIndex]?.['salesCallDate'] === null ||
                            projectLogs[stageIndex]?.['negotiationDate'] === null ||
                            projectLogs[stageIndex]?.['siteVisitDate'] === null
                        )
                        &&
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                                <TableBody>
                                    <TableRow key='1'>
                                        <TableCell>Assigned To</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['user']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='4'>
                                        <TableCell>Department</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['departmentId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='5'>
                                        <TableCell>Team</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['leadId']?.['teamId']?.['name']}</TableCell>
                                    </TableRow>
                                    <TableRow key='2'>
                                        <TableCell>Notes</TableCell>
                                        <TableCell>{projectLogs[stageIndex]?.['notes']}</TableCell>
                                    </TableRow>
                                    <TableRow key='3'>
                                        <TableCell>Attachments</TableCell>
                                        {projectLogs[stageIndex]?.['s3Location']?.map((data, i) => (
                                            <TableCell key={i + 1}>{data}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    } */}
                </DialogContent>
            </Dialog>

            {/*Start - customer payment information */}
            {/* <Dialog open={paymentDetailsModal} onClose={() => setPaymentDetailsModal(false)} aria-labelledby="form-dialog-title" fullWidth maxWidth='lg' style={{padding:"10rem 10rem 10rem 10rem"}}>
                <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
                    All Payments Details
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Table className={classes.table} size="small" aria-label="customized table">
                            <StyledTableRow>
                                {tableHeading.map((heading) => (
                                    <StyledTableCell key={heading} component="th" scope="row">{heading}</StyledTableCell>
                                ))}
                          </StyledTableRow>
                          <TableBody>
                            {showPaymentPreview.map((row, i) => {
                                return (
                                    <StyledTableRow key={i + 1}>
                                        <StyledTableCell>{i + 1}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.uniqueLeadNumber}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.customerName}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.createdAt}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.transactionNumber}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.Amount}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.paymentMode}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.departmentName}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.createdByUser}</StyledTableCell>
                                        <TableCell component="th" scope="row">{row?.Status === 'successful' ? 'Successful' : row?.Status ==='cancel' ? 'Cancel' :""}</TableCell>
                                        <StyledTableCell component="th" scope="row">{row?.Stage}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.paymentPartnerName}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.financeActionStatus}</StyledTableCell>
                                        <StyledTableCell component="th" scope="row">{row?.financeActionRemarks}</StyledTableCell>
                                                                                                         
                                    </StyledTableRow>
                                );
                            })}
                        </TableBody>
                        </Table>
                    </DialogContentText>
                </DialogContent>
            </Dialog> */}

            {/* Genrate Payment Model */}
            <Dialog open={openPayment} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogContent style={{ backgroundColor: "#222", color: "white", padding: '20px', minWidth: '400px', position: 'relative' }}>
                <IconButton onClick={handleClose} style={{ color: "white", position: 'absolute', top: '10px', right: '10px', zIndex: '1000' }}>
                    <CloseIcon />
                </IconButton>
                <TextField
                    value={paymentLink}
                    variant="outlined"
                    size="small"
                    fullWidth
                    InputProps={{
                        readOnly: true,
                        style: { color: "white", paddingRight: '40px' },
                        endAdornment: (
                            <IconButton onClick={handleCopyLink} style={{ color: "white", position: 'absolute', right: '5px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', zIndex: '1000' }}>
                                {copied ? <span>Copied</span> : <FileCopyIcon />}
                            </IconButton>
                        )
                    }}
                    style={{ width: 'calc(100% - 40px)', margin: '0' }}
                />
            </DialogContent>
            <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={handleSnackbarClose}
            >
            <SnackbarContent
            message={
                <span style={{ fontSize: '14px' }}>
                {copied ? "Copied!" : "Copy failed!"}
            </span>
        }
    />
</Snackbar>
        </Dialog>
            <Dialog open={paymentDetailsModal} onClose={() => setPaymentDetailsModal(false)} aria-labelledby="form-dialog-title" fullWidth maxWidth='lg' style={{ padding: "10rem 10rem 10rem 10rem" }}>
                <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
                    Payments Logs
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Table className={classes.table} size="small" aria-label="customized table">
                            {/* <StyledTableRow>
                                {tableHeading.map((heading) => (
                                    <StyledTableCell key={heading} component="th" scope="row">{heading}</StyledTableCell>
                                ))}
                            </StyledTableRow> */}
                            <StyledTableRow>
                                <TableCell style={{ fontWeight: "800", textAlign: "center" }}>S.No</TableCell>
                                <TableCell style={{ fontWeight: "800", textAlign: "center" }}>Account Number</TableCell>
                                <TableCell style={{ fontWeight: "800", textAlign: "center" }}>Amount Requested Automatic</TableCell>
                                <TableCell style={{ fontWeight: "800", textAlign: "center" }}>Amount Requested Manual</TableCell>
                                <TableCell style={{ fontWeight: "800", textAlign: "center" }}>Amount Received Automated Ping</TableCell>
                                <TableCell style={{ fontWeight: "800", textAlign: "center" }}>Amount Received Manual Approved</TableCell>
                                <TableCell style={{ fontWeight: "800", textAlign: "center" }}>Total Amount Received</TableCell>
                                <TableCell style={{ fontWeight: "800", textAlign: "center" }}>Requested amount -  Total Amount Received</TableCell>
                            </StyledTableRow>
                            <TableBody>
                                {customerInformation.map((row, i) => {
                                    return (
                                        // <StyledTableRow key={i + 1}>
                                        //     <StyledTableCell>{i + 1}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.uniqueLeadNumber}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.customerName}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.createdAt}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.transactionNumber}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.Amount}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.paymentMode}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.departmentName}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.createdByUser}</StyledTableCell>
                                        //     <TableCell component="th" scope="row">{row?.Status === 'successful' ? 'Successful' : row?.Status ==='cancel' ? 'Cancel' :""}</TableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.Stage}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.paymentPartnerName}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.financeActionStatus}</StyledTableCell>
                                        //     <StyledTableCell component="th" scope="row">{row?.financeActionRemarks}</StyledTableCell>

                                        // </StyledTableRow>
                                        <TableRow key={i + 1}>

                                            <TableCell style={{ textAlign: "center" }}>{i + 1}</TableCell>
                                            <TableCell style={{ textAlign: "center" }}>{row.account_number} <PlusCircleOutlined onClick={() => handleViewLogsClick(row)} /></TableCell>
                                            <TableCell style={{ textAlign: "center" }}>{row.amount_requested_automatic}</TableCell>
                                            <TableCell style={{ textAlign: "center" }}>{row.amount_requested_manual}</TableCell>
                                            <TableCell style={{ textAlign: "center" }}>{row.amount_received_auto_ping}</TableCell>
                                            <TableCell style={{ textAlign: "center" }}>{row.amount_received_manual_ping}</TableCell>
                                            <TableCell style={{ textAlign: "center" }}>{row.amount_received_auto_ping + row.amount_received_manual_ping}</TableCell>
                                            <TableCell style={{ textAlign: "center" }}>{(row.amount_requested_automatic + row.amount_requested_manual) - (row.amount_received_auto_ping + row.amount_received_manual_ping)}</TableCell>

                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            {/*End - customer payment information*/}

            {/* start - customer payment logs */}

            <Dialog open={showPaymentLogs} onClose={() => { setShowPaymentLogs(false); setPaymentLogsData([]) }} aria-labelledby="form-dialog-title" fullWidth maxWidth='lg' style={{ padding: "10rem 10rem 10rem 10rem" }}>
                <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
                    Payment Logs
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Table className={classes.table} size="small" aria-label="customized table">
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row">S.No.</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row">Amount Received / Requested</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row">Requested By / Received Mode</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row">Amount</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row">Date</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row">Receipts</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row">Reference ID</StyledTableCell>


                            </StyledTableRow>
                            <TableBody>
                                {paymentLogsData.map((row, i) => {
                                    return (
                                        <StyledTableRow key={i + 1}>
                                            <StyledTableCell>{i + 1}</StyledTableCell>
                                            {/* <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{Amount_Received.includes(row?.Status) ? 'Amount Received' : 'Amount Requested'}</StyledTableCell> */}
                                            <StyledTableCell style={{ textAlign: "center" }} component="td" scope="row">{row?.Status}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "center" }} component="td" scope="row">{row?.Status == 'Payment Requested' ? row?.PaymentUser?.name : row?.paymentMode}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "center" }} component="td" scope="row">{row?.amount}</StyledTableCell>
                                            {/* <StyledTableCell style={{textAlign:"center" }} component="td" scope="row">{moment(row?.createdAt).format('DD-MM-YYYY')}</StyledTableCell> */}
                                            <StyledTableCell style={{ textAlign: "center" }} component="td" scope="row">{moment(row?.paymentDate).format('DD-MM-YYYY')}</StyledTableCell>
                                            {/* <StyledTableCell component="th" scope="row" >{}<DownloadOutlined  onClick={() => window.open(row?.paymentTransactionId?.attachment[0])} /></StyledTableCell> */}
                                            <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row" >
                                                {/* <Button variant="outlined" className={classes.downloadButton} onClick={() => window.open(row?.paymentTransactionId?.attachment[0])}><DownloadOutlined /></Button> */}
                                                {/* <Button variant="outlined" className={classes.downloadButton} onClick={() => window.open(row?.paymentTransactionId?.financeReceipt)}><DownloadOutlined /></Button> */}
                                                {row?.Status == 'Payment Requested' ? 'NA' : <Button variant="outlined" className={classes.downloadButton} onClick={() => window.open(row?.paymentTransactionId?.financeReceipt)}><DownloadOutlined /></Button>}
                                            </StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "center" }} component="td" scope="row">{row?.paymentTransactionId?.trxId}</StyledTableCell>




                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            {/* end - customer payment logs */}

            {/* Edit Project Modal */}
            <Dialog open={editProjectModal} onClose={() => setEditProjectModal(false)} aria-labelledby="form-dialog-title" fullWidth maxWidth='sm'>
                <DialogTitle id="form-dialog-title">
                    Edit Project
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" style={{ display: "flex", flexDirection: "column" }}>
                        {/* <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20, marginTop: 20 }}>
                            <InputLabel id="demo-simple-select-label">Select Ply Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={plyType}
                                label="Select Ply Type"
                                onChange={changeHandler}
                                variant="outlined"
                            >
                                {plyTypeMaster.map((row, i) => {
                                    return (
                                        <MenuItem key={i + 1} value={row._id}>{row.name}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl> */}
                    { 
                        userDetails.roles[0]['name'] === "Assistant Sales Manager" &&
                            <>
                                <TextField label="Address" size="small" value={address} style={{ marginBottom: 20 }} name="address" onChange={setAdress} variant="outlined" />
                            </>
                    }
                    { 
                        userDetails.roles[0]['name'] !== "Assistant Sales Manager" &&
                        <>
                            <TextField
                                label="Customer Name"
                                size="small"
                                value={name}
                                style={{ marginBottom: 20, marginTop: 20 }}
                                name="name"
                                onChange={customerNameInputHandler}
                                variant="outlined"
                            />

                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                            <TextField
                                label="Primary Email"
                                size="small"
                                value={projectDetailsFields.email}
                                style={{ flex: 1, marginRight: 10 }}
                                name="email"
                                onChange={handleEmailChange}
                                variant="outlined"
                                error={!!errors.emailError}
                                helperText={errors.emailError}
                            />
                            {/* Show Plus Button only when there are no additional emails */}
                            {(!projectDetailsFields?.emails || projectDetailsFields?.emails?.length === 0) && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={addEmailField}
                                    style={{
                                        padding: '6px 16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginLeft: 7,
                                    }}
                                >
                                    <PlusCircleOutlined style={{ fontSize: '20px' }} />
                                </Button>
                            )}
                        </div>

                        {/* Show additional email fields */}
                        {projectDetailsFields?.emails && projectDetailsFields?.emails.length > 0 &&
                            projectDetailsFields?.emails.map((email, index) => (
                                <div key={index} style={{ marginBottom: 20, display: 'flex', alignItems: 'center' }}>
                                    <TextField
                                        label={`Email ${index + 2}`}
                                        size="small"
                                        value={email}
                                        name={`emails[${index}]`}
                                        onChange={(e) => handleEmailsChange(index, e)}
                                        variant="outlined"
                                        style={{ flex: 1, marginRight: 10 }}
                                        error={!!errors.emailsErrors[index]}
                                        helperText={errors.emailsErrors[index]}
                                    />

                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => removeEmailField(index)}
                                        style={{
                                            padding: '6px 16px',
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <DeleteIcon style={{ fontSize: '20px' }} />
                                    </Button>

                                    {/* Show Plus Button if the number of emails is less than 2 */}
                                    {index === projectDetailsFields?.emails?.length - 1 && projectDetailsFields?.emails?.length < 2 && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={addEmailField}
                                            style={{
                                                padding: '6px 16px',
                                                marginLeft: '7px',
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <PlusCircleOutlined style={{ fontSize: '20px' }} />
                                        </Button>
                                    )}
                                </div>
                            ))}

                        <TextField label="Address" size="small" value={address} style={{ marginBottom: 20 }} name="address" onChange={setAdress} variant="outlined" />
                        <TextField label="Customer Contact No." size="small" value={contact_no} style={{ marginBottom: 20 }} name="contact_no" onChange={phoneNumberInputHandler} variant="outlined" />
                        {
                            projectDetails?.alternativeContactNo ?
                                <>
                                    <TextField
                                        label="Alternate Contact No"
                                        size="small"
                                        value={alternativeContactNo}
                                        style={{ marginBottom: 20 }}
                                        name="alternativeContactNo"
                                        onChange={phoneNumberInputHandler}
                                        variant="outlined"
                                        error={alternativeContactNo?.length !== 10}
                                        helperText={alternativeContactNo?.length !== 10 ? 'Must be 10 characters' : ''}
                                    />
                                </>
                                :
                                <>
                                    <TextField
                                        label="Alternate Contact No"
                                        size="small"
                                        value={alternativeContactNo}
                                        style={{ marginBottom: 20 }}
                                        name="alternativeContactNo"
                                        onChange={phoneNumberInputHandler}
                                        variant="outlined"
                                        error={alternativeContactNo?.length !== 10}
                                        helperText={alternativeContactNo?.length !== 10 ? 'Must be 10 characters' : ''}
                                    />
                                </>
                        }
                        </>}
                        {
                            userDetails.roles.some(role =>
                                role.name === "Marketing Manager" || role.name === "Marketing User" || role.name === "TeleCaller"
                            ) && !projectDetails?.experienceCenterId && <>
                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="city"
                                        value={projectDetailsFields?.city}
                                        label="City *"
                                        onChange={getExperienceCenterByLocation}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            cities?.map((data, i) => (
                                                <MenuItem value={data._id} key={i + 1}>{data.name}</MenuItem>
                                            ))
                                        }
                                    </TextField>
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-expcenter-simple-select"
                                        name="experienceCenterId"
                                        value={projectDetailsFields?.experienceCenterId}
                                        label="Experience Center *"
                                        onChange={(e) => getManagerBasedOnLocation(e, projectDetailsFields.city)}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            expCenters?.map((data, i) => (
                                                <MenuItem value={data._id} key={i + 1}>{data.name}</MenuItem>
                                            ))
                                        }
                                    </TextField>
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-project-needs-simple-select"
                                        name="scopeOfWork"
                                        value={scopeOfWork}
                                        label="Scope of the Work *"
                                        onChange={(e) => setProjectDetailsFields({ ...projectDetailsFields, [e.target.name]: e.target.value })}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {
                                            scopeArray?.map((data, i) => (
                                                <MenuItem value={data} key={i + 1}>{data}</MenuItem>
                                            ))
                                        }
                                    </TextField>
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-budget-simple-select"
                                        name="threeLakhsSuits"
                                        value={threeLakhsSuits}
                                        label="Budget of 3 Lakhs *"
                                        onChange={(e) => setProjectDetailsFields({ ...projectDetailsFields, [e.target.name]: e.target.value })}
                                        variant="outlined"
                                        size="small"
                                    >
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                    </TextField>
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-start-project-simple-select"
                                        name="startProjectBy"
                                        value={startProjectBy}
                                        label="Start Project By *"
                                        onChange={(e) => setProjectDetailsFields({ ...projectDetailsFields, [e.target.name]: e.target.value })}
                                        variant="outlined"
                                        size="small"
                                    >
                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>
                                    </TextField>
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="leadType"
                                        value={leadType}
                                        label="Status (Do not ask)"
                                        onChange={(e) => setProjectDetailsFields({ ...projectDetailsFields, [e.target.name]: e.target.value })}
                                        variant="outlined"
                                        size="small"
                                    >
                                        <MenuItem value='Real'>Real</MenuItem>
                                        <MenuItem value='Junk'>Junk</MenuItem>
                                        <MenuItem value='Hold'>Hold</MenuItem>
                                        {/* <MenuItem value='To Be Called'>To Be Called</MenuItem> */}
                                    </TextField>
                                </FormControl>

                                {/* Show Junk Reason ONLY if stage is Junk */}
                                {leadType === "Junk" && (
                                    <FormControl
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        style={{ margingTop: 50, marginBottom: 10 }}
                                    >
                                        <InputLabel id="select-reason-label" style={{ fontSize: '0.85rem' }}>
                                            Junk Reason
                                        </InputLabel>

                                        <Select
                                            labelId="select-reason-label"
                                            id="select-junk-reason"
                                            value={junkReason}
                                            label="Junk Reason"
                                            onChange={handleSelectJunkReason}
                                            size="small"
                                            style={{ fontSize: '0.85rem' }}
                                        >
                                            {junkReasonOptions.map((row, i) => (
                                                <MenuItem key={i} value={row.name} style={{ fontSize: '0.85rem' }}>
                                                    {row.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}

                                {/* Show Hand Over Date ONLY if stage is Hold */}
                                {leadType === "Hold" && (
                                    <TextField
                                        id="handoverDate"
                                        name="handoverDate"
                                        label="Hand Over Date"
                                        type="date"
                                        variant="outlined"
                                        value={handoverDate}
                                        onChange={(e) => setHandoverDate(e.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                        margin="normal"
                                    />
                                )}



                                {
                                    (leadType !== 'To Be Called' && leadType === 'Real') &&
                                    (
                                        <FormControl fullWidth style={{ marginBottom: 20 }}>
                                            <TextField
                                                select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="assignToManager"
                                                value={assignToManager}
                                                label="Assign To Team"
                                                onChange={checkAssignDetail}
                                                variant="outlined"
                                                size="small"
                                            >
                                                {managerOfSalesTeam?.map((data) => (
                                                    <MenuItem key={data._id} value={data._id}>
                                                        {`${data?.teamId?.name} - ${data?.name}`}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </FormControl>
                                    )
                                }
                            </>
                        }
                        {/* {
                        userDetails.roles[0]['name'] === 'Admin' &&
                        <>
                        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20 }}>
                            <InputLabel id="demo-simple-select-label">Project Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={projectType}
                                label="Project Type"
                                name="projectType"
                                onChange={changeHandler}
                                variant="outlined"
                            >
                                <MenuItem value='1BHK'>1BHK</MenuItem>
                                <MenuItem value='2BHK'>2BHK</MenuItem>
                                <MenuItem value='3BHK'>3BHK</MenuItem>
                                <MenuItem value='Villa'>Villa</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20 }}>
                            <InputLabel id="demo-simple-select-label">Property Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={propertyType}
                                label="Property Type"
                                name="propertyType"
                                onChange={changeHandler}
                                variant="outlined"
                            >
                                <MenuItem value='Residential/New Apartment'>Residential/New Apartment</MenuItem>
                                <MenuItem value='Independent House'>Independent House</MenuItem>
                                <MenuItem value='Commercial'>Commercial</MenuItem>
                                <MenuItem value='Renovation'>Renovation</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20 }}>
                            <InputLabel id="demo-simple-select-label">Scope Of Work</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={scopeOfWork}
                                label="Scope Of Work"
                                name="scopeOfWork"
                                onChange={changeHandler}
                                variant="outlined"
                            >
                                <MenuItem value='Kitchens and Wardrobes'>Kitchens and Wardrobes</MenuItem>
                                <MenuItem value='Kitchens and Wardrobes + some other elements(movable+Fixed+Decorative'>Kitchens and Wardrobes + some other elements(movable+Fixed+Decorative</MenuItem>
                                <MenuItem value='End to End implementation(Entire Home)'>End to End implementation(Entire Home)</MenuItem>
                                <MenuItem value='Commercial Requirements'>Commercial Requirements</MenuItem>
                            </Select>
                        </FormControl>
                        {/* <TextField label="Description" size="small" value={description} style={{ marginBottom: 20 }} name="description" onChange={changeHandler} variant="outlined" /> */}
                        {/* <TextField label="Floor Plan" size="small" value={floorPlan} style={{ marginBottom: 20 }} name="floorPlan" onChange={changeHandler} variant="outlined" />
                        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20 }}>
                            <InputLabel id="demo-simple-select-label">Registration Done</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={isRegistered}
                                label="Registration Done"
                                name="isRegistered"
                                onChange={changeHandler}
                                variant="outlined"
                            >
                                <MenuItem value='Yes'>Yes</MenuItem>
                                <MenuItem value='No'>No</MenuItem>
                                <MenuItem value='Will get it in 15-20 days'>Will get it in 15-20 days</MenuItem>
                            </Select>
                        </FormControl> */}
                        {/* <TextField label="Sq.Ft Area" value={area} size="small" style={{ marginBottom: 20 }} name="area" onChange={sqFtAreaInputHandler} variant="outlined" />
                        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20 }}>
                            <InputLabel id="demo-simple-select-label">Lead Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={leadType}
                                label="Lead Type"
                                name="leadType"
                                onChange={changeHandler}
                                variant="outlined"
                            >
                                <MenuItem value='Real'>Real</MenuItem>
                                <MenuItem value='Junk'>Junk</MenuItem>
                                <MenuItem value='Hold'>Hold</MenuItem>
                            </Select>
                        </FormControl> */}
                        {/* </> } */}
                        {/* {
                            userDetails.roles[0]['name'] === 'Admin' &&
                            <FormControl fullWidth size="small" variant="outlined" style={{ marginBottom: 20 }}>
                                <InputLabel id="demo-simple-select-label">Apply Discount on All Scopes</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={discountOnAllScopes}
                                    label="Apply Discount on All Scopes"
                                    name="discountOnAllScopes"
                                    onChange={changeHandler}
                                    variant="outlined"
                                >
                                    <MenuItem value='true'>Yes</MenuItem>
                                    <MenuItem value='false'>No</MenuItem>
                                </Select>
                            </FormControl>
                        } */}
                        {/* {
                            (userDetails.roles[0]['name'] === 'Admin' && leadType === 'Real') &&
                            <FormControl fullWidth size="small" variant="outlined" style={{ marginBottom: 20 }}>
                                <InputLabel id="demo-simple-select-label">Assign To</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={assignToManager}
                                    label="Assign To Team"
                                    name="assignToManager"
                                    onChange={(e) => changeHandler(e)}
                                    variant="outlined"
                                >
                                    {salesManagerList.map((row, i) => {
                                        return (
                                            <MenuItem key={i + 1} value={row._id}>{`${row?.teamId?.name} - ${row?.name}`}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                        } */}
                        
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEditProjectModal(false)} variant="contained" color="secondary">
                        Cancel
                    </Button>

                    { 
                        userDetails.roles[0]['name'] !== "Assistant Sales Manager" &&
                            <>
                                <Button onClick={saveProjectDetail} disabled={contact_no.length > 10 || contact_no.length < 10 || isSubmitDisabled} variant="contained" color="primary">
                                    Save Project Details
                                </Button>
                            </>
                    }
                    { 
                        userDetails.roles[0]['name'] === "Assistant Sales Manager" &&
                            <>
                                <Button onClick={saveProjectDetailForAsm} variant="contained" color="primary" disabled={contact_no.length > 10 || contact_no.length < 10 || isSubmitDisabled}>
                                    Save Project Details
                                </Button>
                            </>
                    }
                
                </DialogActions>
            </Dialog>


            <Dialog open={openClientModel} onClose={() => setOpenClientModel(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">Extra days due to client dependency</DialogTitle>
                <Divider />
                <DialogContent>
                    <TextField label="Extra days due to client dependency" type="number" size="small" style={{ marginBottom: 20, textAlign: "center" }} name="extraDaysDueToClientDependency" onChange={(e) => setClientDelay({ [e.target.name]: e.target.value })} variant="outlined" />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenClientModel(false)} color="secondary" variant="outlined">
                        Cancel
                    </Button>
                    <Button onClick={clientDelayfunc} color="primary" variant="outlined">
                        Update
                    </Button>
                </DialogActions>
            </Dialog>

            {/* floor plan dialog box  */}
            {/* Floor Plan Dialogbox */}
            <Dialog open={fBtnShow} onClose={() => setfBtnShow(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">Floor Plan Button Dialog</DialogTitle>
                <Divider />
                <DialogContent>
                    <div style={{ paddingBottom: 15, paddingTop: 10 }} variant="outlined" size="small">
                        <input
                            accept=".pdf"
                            id="floorplan-document"
                            onChange={(e) => uploadWDFileDocument(e, 'FloorPlanFile')}
                            type="file"
                            style={{ display: 'none' }}
                        />
                        <label htmlFor="floorplan-document">
                            <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span">
                                Upload FloorPlan
                            </Button>
                        </label>
                        {checkForFloor && <CheckCircleIcon style={{ color: "green", marginTop: "2rem", marginLeft: "2rem", marginRight: "1rem" }} />}

                    </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setfBtnShow(false)} color="secondary" variant="outlined">
                        Cancel
                    </Button>
                    <Button onClick={floorPlanFunc} color="primary" variant="outlined">
                        Upload Floor Plan
                    </Button>
                </DialogActions>
            </Dialog>
            {/*Change CHM user */}
            {/* <Dialog open={openChmUser} onClose={() => setOpenChmUser(false)}>
                <DialogTitle>Change CHM User</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth>
                            <TextField
                                select
                                labelId="user-select-label"
                                id="user-select"
                                label="Select User"
                                variant="outlined"
                                value={chmUser}
                                onChange={(e) => handleChmUserChange(e)} // Update the selected CHM user
                            >
                                {chmList.map((user) => (
                                    <MenuItem key={user.id} value={user._id}>
                                        {user.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenChmUser(false)} color="primary" variant='outlined'>
                        Cancel
                    </Button>
                    <Button onClick={updateChmUser} color="primary" variant='contained'>
                        Change
                    </Button>
                </DialogActions>
            </Dialog> */}
            {/* Dialog for select the stage */}
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Change Stages</DialogTitle>
                <DialogContent>
                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <InputLabel id="select-stage">Select Stage</InputLabel>
                            <Select labelId="select-stage"
                                id="select-stage"
                                value={stage}
                                label="Select Stage"
                                variant="outlined"
                                // onChange={handleSelectedStageChange}
                                onChange={(e) => handleSelectedStageChange(e)}
                            >
                                {departmentStage?.map((row, i) => {
                                     let isActive = true;
                                     let mtmOption = false;
                                     const onlyLostOnInternalKickOff = projectDetails?.currentStage === 'Design Kick-Off : Internal' && row !== 'Lost';

                                     if ((projectDetails?.currentStage === 'Design Discussion' && (row === 'Design Discussion' || row === 'Lost')) 
                                        ||
                                        ((projectDetails?.currentStage === 'Internal Design Sign-Off' || projectDetails?.currentStage === 'Design Sign-off HOLD' || projectDetails.currentStage === 'Design Sign-off') && (row === 'Design Sign-off' || row === 'Design Sign-off HOLD' || row === 'Lost'))
                                        ||
                                        (i === currentStageIndex || row === 'Lost')) {
                                          isActive = false;
                                      }

                                      if (
                                        row === 'Move to Marketing'
                                        && (
                                            userDetails?.roles?.find(role => role.name === ROLENAME.SalesUser)
                                            || isMoveToMarketingBlockedByAssignmentAge(projectDetails?.leadAssignedDate)
                                        )
                                    ) {
                                            mtmOption=true;
                                        }
                                        else if( (['Quotation Sent', 'Site/Office visit', 'Negotiation', 'Won', 'Lost'].includes(projectDetails?.currentStage) && [ 'Requirements Not Collected', 'Requirements Collected', 'Move to Marketing'].includes(row))) {
                                          mtmOption = true;
                                      }
                                     else {
                                            mtmOption=false;
                                        }
                                     const isInternalSignOffDisabled = row === 'Internal Design Sign-Off' && projectDetails?.internalDesignSignOffDate;
                                     const isDisabledMoveThroughNaraci = row === 'Drawing QC' || row === 'Design Sign-off';
                                     const isDesignerBlockedFromInternalKickOff = row === 'Internal Kick-Off' && userDetails?.roles?.some(role => role.name === ROLENAME.DesignUser || role.name === ROLENAME.AssistantDesignManager);
                                     const isInitialMeasurementBlockedOnDkoCustomer = row === 'Initial Measurement'
                                        && projectDetails?.currentStage === 'Design Kick-Off : Customer';
                                     const isDesignerRole = userDetails?.roles?.some(
                                        (role) => role.name === ROLENAME.DesignUser || role.name === ROLENAME.AssistantDesignManager
                                     );
                                     const menuItemLabel = isDesignerBlockedFromInternalKickOff
                                        ? `${row} (Assigned by ODM)`
                                        : (isInitialMeasurementBlockedOnDkoCustomer && isDesignerRole)
                                            ? `${row} (Assigned by ODM)`
                                        : (isDisabledMoveThroughNaraci ? `${row} (Naraci - Push to DQC)` : row);
                                     const stageDisabled = projectDetails?.departmentId?.name === 'Design'
                                        ? (onlyLostOnInternalKickOff || isActive || isInternalSignOffDisabled || isDisabledMoveThroughNaraci || isDesignerBlockedFromInternalKickOff || isInitialMeasurementBlockedOnDkoCustomer)
                                        : (onlyLostOnInternalKickOff || mtmOption || isInternalSignOffDisabled || isDisabledMoveThroughNaraci || isInitialMeasurementBlockedOnDkoCustomer);
                                     const stageItem = (
                                        <MenuItem value={row} disabled={stageDisabled} style={(onlyLostOnInternalKickOff || isInitialMeasurementBlockedOnDkoCustomer) ? { pointerEvents: 'none' } : undefined}>{menuItemLabel}</MenuItem>
                                     );
                                     if (onlyLostOnInternalKickOff) {
                                        return (
                                            <Tooltip key={i + 1} title="To Move go to Design Kick off Sidebar" placement="right">
                                                <span style={{ display: 'block' }}>{stageItem}</span>
                                            </Tooltip>
                                        );
                                     }
                                     if (isInitialMeasurementBlockedOnDkoCustomer) {
                                        return (
                                            <Tooltip key={i + 1} title="Complete customer kick-off from Design Kick-off sidebar before moving to Initial Measurement" placement="right">
                                                <span style={{ display: 'block' }}>{stageItem}</span>
                                            </Tooltip>
                                        );
                                     }
                                     return React.cloneElement(stageItem, { key: i + 1 });
                                })}
                            </Select>
                            {
                                stage === "Final Quotation Approval" ?
                                 <Button style={{marginTop:"10px"}} variant="outlined" color="primary" onClick={handleClickOpenDialog}>Select Quotation Want to Share</Button>
                                 :""
                            }
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                <Button onClick={() => setOpen(false)} variant="outlined" color="primary">Cancel</Button>
                    {
                        userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser || role.name === ROLENAME.DesignManager || role.name === ROLENAME.DesignHead || role.name === ROLENAME.DGM_Design || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.OperationDesignManager) &&
                            stage === 'Internal Kick-Off' ?
                            <Button onClick={openDesignKickOffInternalDialog} variant="contained" color="primary">Change</Button> :
                            stage === 'Design Kick-Off : Customer' ?
                                <Button onClick={openDesignKickOffCustomerDialog} variant="contained" color="primary">Change</Button> :
                                stage !== 'Design Sign-off' && stage !== 'Design Kick-Off : Customer' ?
                                    stage === 'Final Quotation Approval' ?
                                        <Button onClick={openAnotherDialog} disabled={!showButton} variant="contained" color="primary">Change</Button> :
                                        <Button onClick={openAnotherDialog} disabled={stage === ""} variant="contained" color="primary">Change</Button>
                                    :
                                    <Button onClick={openAnotherDialog} variant="contained" color="primary">Change</Button>
                    }


                </DialogActions>
            </Dialog>
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                                            <DialogTitle>Quotation Details</DialogTitle>
                                            <DialogContent>
                                            <Table>
                                                <TableBody>
                                                <TableCell style={{ padding: '5px' }} component="th" scope="row">S.No</TableCell>
                                                <TableCell style={{ padding: '5px' }} component="th" scope="row">Version</TableCell>
                                                <TableCell style={{ padding: '5px' }} component="th" scope="row">Created Date</TableCell>
                                                <TableCell style={{ padding: '5px' }} component="th" scope="row">Created By</TableCell>
                                                <TableCell style={{ padding: '5px' }} component="th" scope="row">Total Customer OutFlow</TableCell>
                                                <TableCell style={{ padding: '5px' }} component="th" scope="row">Select Quotation </TableCell>

                                                {storeLatestQuotation.map((quotation, index) => (
                                                    <TableRow key={index}>
                                                    <TableCell style={{ padding: '5px' }} component="th" scope="row">{index+1}</TableCell>
                                                    <TableCell style={{ padding: '5px' }} component="th" scope="row">{quotation.version}</TableCell>
                                                    <TableCell style={{ padding: '5px' }} component="th" scope="row">{moment(quotation.createdAt).format('YYYY-MM-DD')}</TableCell>
                                                    <TableCell style={{ padding: '5px' }} component="th" scope="row">{quotation?.createdBy?.name}</TableCell>
                                                    <TableCell style={{ padding: '5px' }} component="th" scope="row">{quotation.totalCustomerOutflow}</TableCell>
                                                    <TableCell style={{ padding: '5px' }}>
                                                    <Checkbox checked={storeVersion == quotation.version ? storeVersion == quotation.version : projectDetails.designVersion == quotation.version } onChange={(event) => handleCheckboxChange(event, quotation)} />
                                                    </TableCell>
                                                    </TableRow>
                                                ))}
                                                </TableBody>
                                            </Table>
                                            </DialogContent>
                        </Dialog>

            {/* Dialog for capturing details during stage move to Design Kick-Off : Customer */}
            <Dialog open={designKickOffCustomerDialog} onClose={() => setDesignKickOffCustomerDialog(false)}>
                <DialogTitle>Required Details</DialogTitle>
                <DialogContent>

                    <Box sx={{ minWidth: 450 }}>
                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                            <TextField
                                id="salesOwnerMeetingDate"
                                name="salesOwnerMeetingDate"
                                value={designKickOffCustomerForm.salesOwnerMeetingDate}
                                onChange={(e, v) => captureDesignKickOffCustomerDetails(e, v)}
                                label="Meeting Date with Sales Owner"
                                type="date"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                variant="outlined"
                                size="small"
                            />
                        </FormControl>

                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                            <TextField
                            id="dateOfKickOffMeeting"
                            name="dateOfKickOffMeeting"
                            label="Design Kick-Off : Customer Date"
                            type="date"
                            value={designKickOffCustomerForm.dateOfKickOffMeeting}
                            onChange={(e, v) => captureDesignKickOffCustomerDetails(e, v)}
                            InputLabelProps={{
                            shrink: true,
                            }}
                            variant="outlined"
                            size="small"
                            />
                        </FormControl>
                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                            <TextField
                            id="timeOfKickOffMeeting"
                            name="timeOfKickOffMeeting"
                            label="Design Kick-Off : Customer Time"
                            type="time"
                            value={designKickOffCustomerForm.timeOfKickOffMeeting}
                            onChange={(e, v) => captureDesignKickOffCustomerDetails(e, v)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            size="small"
                            />
                        </FormControl>
                       
                        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20 }}>
                            <InputLabel id="floor-plan-received">Floor Plan Received ?</InputLabel>
                            <Select
                                labelId="floor-plan-received"
                                id="floor-plan-received"
                                value={designKickOffCustomerForm.floorPlanReceived}
                                label="Floor Plan Received ?"
                                name="floorPlanReceived"
                                onChange={(e, v) => captureDesignKickOffCustomerDetails(e, v)}
                                variant="outlined"
                            >
                                <MenuItem value='Yes'>Yes</MenuItem>
                                <MenuItem value='No'>No</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20 }}>
                            <InputLabel id="quotation-discussed">Quotation Discussed ?</InputLabel>
                            <Select
                                labelId="quotation-discussed"
                                id="quotation-discussed"
                                value={designKickOffCustomerForm.quotationDiscussed}
                                label="quotation discussed ?"
                                name="quotationDiscussed"
                                onChange={(e, v) => captureDesignKickOffCustomerDetails(e, v)}
                                variant="outlined"
                            >
                                <MenuItem value='Yes'>Yes</MenuItem>
                                <MenuItem value='No'>No</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20 }}>
                            <InputLabel id="requirement-discussed">Requirement Discussed ?</InputLabel>
                            <Select
                                labelId="requirement-discussed"
                                id="requirement-discussed"
                                value={designKickOffCustomerForm.requirementDiscussed}
                                label="Requirement Discussed ?"
                                name="requirementDiscussed"
                                onChange={(e, v) => captureDesignKickOffCustomerDetails(e, v)}
                                variant="outlined"
                            >
                                <MenuItem value='Yes'>Yes</MenuItem>
                                <MenuItem value='No'>No</MenuItem>
                            </Select>
                        </FormControl>

                    </Box>
                </DialogContent>
                <DialogActions>
                <Button onClick={assignProject} disabled={!designKickOffCustomerForm.salesOwnerMeetingDate || designKickOffCustomerForm.floorPlanReceived != 'Yes' || designKickOffCustomerForm.quotationDiscussed != 'Yes' || designKickOffCustomerForm.requirementDiscussed != 'Yes'} variant="contained" color="primary">Submit</Button>
                <Button onClick={() => setDesignKickOffCustomerDialog(false)} variant="outlined" color="primary">Cancel</Button>



                </DialogActions>
            </Dialog>

            {/* Dialog for select the details of previous dialog selected stage */}
            <>
                <Dialog open={anotherDialog} onClose={() => setOpenAnotherDialog(false)}>
                <DialogTitle>{stage === 'Move to Marketing' ? `Send Back For Move To Marketing Approval` : `Select Details`}</DialogTitle>
                    {stage === 'Move to Marketing' &&
                        userDetails.roles.some(role =>
                            role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager
                        ) && (
                            <FormControl
                                fullWidth
                                variant="outlined"
                                size="small"
                                style={{ marginBottom: 10 }}
                            >
                                <InputLabel id="select-reason-label" style={{ fontSize: '0.85rem' }}>
                                    Reason for Moving
                                </InputLabel>
                                <Select
                                    labelId="select-reason-label"
                                    id="select-reason"
                                    value={moveToMarketingReason}
                                    label="Reason for Moving"
                                    onChange={handleSelectReason}
                                    size="small"
                                    style={{ fontSize: '0.85rem', marginLeft: 10, marginRight: 30 }}
                                >
                                    {reasonOptions.map((row, i) => (
                                        <MenuItem key={i + 1} value={row._id} style={{ fontSize: '0.85rem' }}>
                                            {row.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                <DialogContent>
                        <Box sx={{ minWidth: 450 }}>
                            {stage === 'Move to Marketing' && (
                                <>
                                    {/* Upload Section */}
                                    <input
                                        accept="audio/*,image/*"
                                        className={classes.input}
                                        id="upload-file-input"
                                        multiple
                                        type="file"
                                        onChange={onFileUpload}
                                        style={{ display: 'none' }}
                                    />
                                    <label htmlFor="upload-file-input">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            component="span"
                                            startIcon={<CloudUploadIcon />}
                                        >
                                            Upload Audio/Image
                                        </Button>

                                        {audioUploaded && (
                                            <CheckCircleIcon
                                                style={{
                                                    verticalAlign: 'middle',
                                                    marginLeft: 10,
                                                    color: 'green',
                                                    fontSize: 30,
                                                }}
                                            />
                                        )}
                                    </label>

                                    {moveToMarketingReason === "project_timeline" && (
                                        <TextField
                                            id="handoverDate"
                                            name="handoverDate"
                                            label="Hand Over Date"
                                            type="date"
                                            variant="outlined"
                                            value={handoverDate}
                                            onChange={(e) => setHandoverDate(e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            fullWidth
                                            margin="normal"
                                        />
                                    )}

                                    {moveToMarketingReason === "others" && (
                                        <TextField
                                            id="others"
                                            name="others"
                                            label="others reason"
                                            value={otherReason}
                                            onChange={(e) => setOtherReason(e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            fullWidth
                                            margin="normal"
                                            required
                                        />
                                    )}
                                </>
                            )}
                        {/* {
                            // Pre sales call date
                            stage === 'Requirements Not Collected' &&
                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                <TextField
                                    id="preSalesCall-Date"
                                    name={preSalesCallDate}
                                    onChange={(e) => setHandlepreSalesCallDate(e.target.value)}
                                    label="Pre sales call date"
                                    type="date"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    variant="outlined"
                                    size="small"
                                />
                            </FormControl>
                        } */}
                        {
                            // Next Follow Update Date
                            (stage === 'Site/Office visit' || stage === 'Negotiation') &&
                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                <TextField
                                    id="nextFollowUp-Date"
                                    name={nextFollowUpDate}
                                    onChange={(e) => setHandleNextFollowUpDate(e.target.value)}
                                    label="Next Follow Update Date"
                                    type="date"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    variant="outlined"
                                    size="small"
                                />
                            </FormControl>
                        }
                            {
                                // Requirements Collected Data, Requirements, Estimate Budget, Requirements Collected comments
                                stage === 'Requirements Collected' &&
                                <>
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="salesCall-Date"
                                            name={salesCallDate}
                                            value={salesCallDate}
                                            onChange={(e) => setHandleSalesCallDate(e.target.value)}
                                            label="Requirement Collection Date"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            variant="outlined"
                                            size="small"
                                            required
                                        />
                                    </FormControl>
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="scope_of_work"
                                            label="Scope of work in detail"
                                            multiline
                                            rows={2}
                                            value={rcScopeOfWork}
                                            onChange={(e) => setRcScopeOfWork(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                            required
                                        />
                                    </FormControl>
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="design_preference"
                                            label="Design Preferences"
                                            multiline
                                            value={designPref}
                                            onChange={(e) => setDesignPref(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="estimate_budget"
                                            label="Budget"
                                            multiline
                                            value={estimatedBudget}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*$/.test(value)) { // Only allow digits (no decimal, no letters)
                                                    setEstimateBudget(value);
                                                }
                                            }}
                                            variant="outlined"
                                            size="small"
                                            required
                                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} // Mobile-friendly
                                        />
                                    </FormControl>
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="timeLineMoveHouseDate"
                                            name={timelineMoveHouseDate}
                                            value={timelineMoveHouseDate}
                                            onChange={(e) => setTimelineMoveHouseDate(e.target.value)}
                                            label="Timeline to move into the house"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            variant="outlined"
                                            size="small"
                                            required
                                        />
                                    </FormControl>

                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="possession_date"
                                            name={possDate}
                                            value={possDate}
                                            onChange={(e) => setPossDate(e.target.value)}
                                            label="Possession Date"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            variant="outlined"
                                            size="small"
                                            required
                                        />
                                    </FormControl>
                                    {/* attachement floor plan  */}
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <>
                                            <input
                                                accept=".pdf"
                                                className={classes.input}
                                                id="floorplan-document"
                                                onChange={(e) => uploadWDFileDocument(e, 'FloorPlanFile')}
                                                type="file"
                                                style={{ display: 'none' }}
                                            />
                                            <label htmlFor="floorplan-document">
                                                <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span">
                                                    Attach Floor Plan (if applicable)
                                                </Button>
                                                {floorPlanUploaded && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
                                            </label>
                                        </>
                                    </FormControl>
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="anyother_relevant"
                                            label="Any other specific details relevant to Decorpot"
                                            multiline
                                            rows={2}
                                            value={rcOtherDetails}
                                            onChange={(e) => setRcOtherDetails(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>
                                </>
                            }
                            {
                                // Quotation sent date, mom quotation stage
                                stage === 'Quotation Sent' &&
                                <div>
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            aria-label="type"
                                            name="type"
                                            value={qtSentMeetingOption}
                                            onChange={handleQtSentMeetingOption}
                                        >
                                            <>
                                                <FormControlLabel value="Quotation sent meeting not fixed" control={<Radio />} label="Quotation sent meeting not fixed" />
                                                <FormControlLabel value="Quotation sent meeting fixed" control={<Radio />} label="Quotation sent meeting fixed" />
                                                <br />
                                            </>
                                        </RadioGroup>
                                    </FormControl>
                                    {qtSentMeetingOption === "Quotation sent meeting fixed" &&
                                        <>

                                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                                <InputLabel id="propose_meeting_type">Propose Meeting Type *</InputLabel>
                                                <Select
                                                    labelId="propose_meeting_type"
                                                    id="propose_meeting_type"
                                                    value={meetingFixedDetail.proposeMeetingType}
                                                    label="Propose Meeting Type*"
                                                    name="proposeMeetingType"
                                                    onChange={(e) => setMeetingfixedDetail({ ...meetingFixedDetail, proposeMeetingType: e.target.value })}
                                                    variant="outlined"
                                                    required
                                                >
                                                    <MenuItem value="Office Meet">Office Meeting</MenuItem>
                                                    <MenuItem value="Residence Meeting">Residence Meeting</MenuItem>
                                                </Select>
                                            </FormControl>

                                            <TextField
                                                fullWidth
                                                name="proposeMeetingDate"
                                                id="proposeMeetingDate"
                                                value={meetingFixedDetail.proposeMeetingDate}
                                                onChange={(e) => setMeetingfixedDetail({ ...meetingFixedDetail, proposeMeetingDate: e.target.value })}
                                                label="Propose Meeting Date"
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                variant="outlined"
                                                required
                                                size="small"
                                                style={{ marginBottom: '15px' }}
                                            />

                                            <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                                <TextField
                                                    id="meetingParticipant"
                                                    label="Meeting Participant*"
                                                    multiline
                                                    name="meetingParticipant"
                                                    rows={2}
                                                    placeholder="Enter Meeting Participants"
                                                    value={meetingFixedDetail.meetingParticipant}
                                                    onChange={(e) => setMeetingfixedDetail({ ...meetingFixedDetail, meetingParticipant: e.target.value })}
                                                    variant="outlined"
                                                    size="small"
                                                />
                                            </FormControl>
                                             </>
                                        }

                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <InputLabel id="reason-deal-QtSent">Reason for deal to be in Quotation Sent *</InputLabel>
                                        <Select
                                            labelId="reason-deal-QtSent"
                                            id="reason-deal-QtSent"
                                            value={reasonToDealQt}
                                            label="Reason for deal to be in Quotation Sent *"
                                            onChange={(e) => setReasonToDealQt(e.target.value)}
                                            variant="outlined"
                                            required
                                            size="small"
                                        >
                                            {reasonForDealQtList.map((reasonName, i) => {
                                                return (
                                                    <MenuItem key={i + 1} value={reasonName}>{reasonName}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>

                                    {/* text fpr reson other */}
                                    {reasonToDealQt === 'Other' &&
                                        <TextField
                                            fullWidth
                                            label="Reason"
                                            name="reasonToDealOther"
                                            id="reasonToDealOther"
                                            variant="outlined"
                                            value={reasonToDealQtOther}
                                            onChange={(e) => setReasonToDealQtOther(e.target.value)}
                                            required
                                            size="small"
                                            style={{ marginBottom: '10px' }}
                                        />
                                    }
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend" style={{ color: "#000" }}>
                                            1. Is quotation fitting customer budget mentioned?
                                        </FormLabel>
                                        <RadioGroup
                                            aria-label="type"
                                            name="type"
                                            value={qtFittingBudget}
                                            onChange={(e) => setQtFittingBudget(e.target.value)}
                                        >
                                            <>
                                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="No" control={<Radio />} label="No" />
                                                <FormControlLabel value="Not Sure" control={<Radio />} label="Not Sure" />
                                            </>
                                        </RadioGroup>
                                    </FormControl>

                                    <FormControl component="fieldset">
                                        <FormLabel component="legend" style={{ color: "#000" }}>
                                            2. Is the customer planning to visit the Experience Zone?
                                        </FormLabel>
                                        <RadioGroup
                                            aria-label="type"
                                            name="type"
                                            value={cxPlanVisitExZone}
                                            onChange={(e) => setcxPlanVisitExZone(e.target.value)}
                                        >
                                            <>
                                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                {cxPlanVisitExZone === "Yes" &&
                                                    <TextField
                                                        fullWidth
                                                        name="cxPlanDate"
                                                        id="cxPlanDate"
                                                        value={planVisitDate}
                                                        onChange={(e) => setPlanVisitDate(e.target.value)}
                                                        label="Select Plan Date Visit"
                                                        type="date"
                                                        InputLabelProps={{
                                                            shrink: true
                                                        }}
                                                        variant="outlined"
                                                        size="small"
                                                        required
                                                        style={{ marginBottom: '5px' }}
                                                    />
                                                }
                                                <FormControlLabel value="No" control={<Radio />} label="No" />
                                                <FormControlLabel value="Not Sure" control={<Radio />} label="Not Sure" />
                                            </>
                                        </RadioGroup>
                                    </FormControl>
                                    <hr />
                                </div>
                            }
                        {
                            // site visit date, mom meeting stage, mom site visit stage
                            stage === 'Site/Office visit' &&
                            <div>
                                <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                    <TextField
                                        id="siteVisit-Date"
                                        name={siteVisitDate}
                                        onChange={(e) => setSiteVisitDate(e.target.value)}
                                        label="Site Visit date"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        variant="outlined"
                                        size="small"
                                    />
                                </FormControl>
                                <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                    <TextField
                                        id="standard-multiline-static"
                                        label="MOM Meeting Stage"
                                        multiline
                                        rows={4}
                                        placeholder="Enter MOM Meeting Stage"
                                        value={momMeetingStage}
                                        onChange={(e) => setMomMeetingStage(e.target.value)}
                                        variant="outlined"
                                        size="small"
                                    />
                                </FormControl>
                                <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                    <TextField
                                        id="standard-multiline-static"
                                        label="MOM Site visit Stage"
                                        multiline
                                        rows={4}
                                        placeholder="Enter MOM Site visit Stage"
                                        value={momSiteVisitStage}
                                        onChange={(e) => setMomSiteVisitStage(e.target.value)}
                                        variant="outlined"
                                        size="small"
                                    />
                                </FormControl>
                            </div>
                        }
                        {
                            // Negotiation date, mom negotiation stage
                            stage === 'Negotiation' &&
                            <div>
                                <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                    <TextField
                                        id="negotiation-Date"
                                        name={negotiationDate}
                                        onChange={(e) => setNegotiationDate(e.target.value)}
                                        label="Negotiation date"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        variant="outlined"
                                        size="small"
                                    />
                                </FormControl>
                                <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                    <TextField
                                        id="standard-multiline-static"
                                        label="MOM Negotiation Stage"
                                        multiline
                                        rows={4}
                                        placeholder="Enter MOM Negotiation Stage"
                                        value={momNegotiationStage}
                                        onChange={(e) => setMomNegotiationStage(e.target.value)}
                                        variant="outlined"
                                        size="small"
                                    />
                                </FormControl>
                            </div>
                        }
                        {
                            // Negotiation date, mom negotiation stage
                            ((stage === 'Negotiation' || stage === 'Won' || stage === 'Lost' || stage === 'Site/Office visit' || (stage === 'Lost' && (projectDetails.salesStage === "Negotiation" || projectDetails.salesStage === "Site/Office visit")))) &&
                            <div>
                                <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20 }}>
                                    <InputLabel id="demo-simple-select-label">Meet Done</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={meetingDone}
                                        label="Registration Done"
                                        name="isRegistered"
                                        onChange={(e) => setMeetingDone(e.target.value)}
                                        variant="outlined"
                                    >

                                        <MenuItem value="Yes">Yes</MenuItem>
                                        <MenuItem value="No">No</MenuItem>

                                    </Select>
                                </FormControl>
                                {meetingDone === "Yes" &&
                                    <div>
                                        <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 20 }}>
                                            <InputLabel id="demo-simple-select-label">Meet Type</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={meetingType}
                                                label="Registration Done"
                                                name="isRegistered"
                                                onChange={(e) => setMeetingType(e.target.value)}
                                                variant="outlined"
                                            >

                                                {/* <MenuItem value="Virtual Meeting">Virtual Meeting</MenuItem> */}
                                                <MenuItem value="Office Meet">Office Meet</MenuItem>
                                                <MenuItem value="Residence Meeting">Residence Meeting</MenuItem>

                                            </Select>
                                        </FormControl>
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="meetingDoneDate"
                                                name={meetingDate}
                                                onChange={(e) => {
                                                            const today = new Date().toISOString().split("T")[0];
                                                            if (e.target.value > today) return;
                                                            setMeetingDate(e.target.value);
                                                }}
                                                label="Meeting Done Date"
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                inputProps={{
                                                            max: new Date().toISOString().split("T")[0],
                                                }}
                                                variant="outlined"
                                                size="small"
                                            />
                                        </FormControl>

                                    </div>}
                            </div>
                        }
                        {
                            // Won date, Remark, client move in date
                            stage === 'Won' &&
                            <div>
                                <h2>Do you want to assign designer now</h2>
                            </div>
                        }
                        {
                            // Design Sign-off date, Project Completion date, WD Attachement
                            (stage === 'Design Sign-off' || stage === 'Design Sign-off HOLD') &&
                            <div>
                                {/* <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                    <TextField
                                        id="contractSigned-Date"
                                        name="designSignOffDate"
                                        value={contractSignStageForm.designSignOffDate}
                                        onChange={(e) => setContractSignStageForm({ ...contractSignStageForm, [e.target.name]: e.target.value })}
                                        label="Design Sign-off Date"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        variant="outlined"
                                        size="small"
                                        disabled="true"
                                    />
                                </FormControl>
                                <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                    <TextField
                                        id="projectCompletionDate-Date"
                                        name="projectCompletionDate"
                                        value={contractSignStageForm.projectCompletionDate}
                                        onChange={(e) => setContractSignStageForm({ ...contractSignStageForm, [e.target.name]: e.target.value })}
                                        label="Expected Project Completion Date"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        variant="outlined"
                                        size="small"
                                    />
                                </FormControl> */}

                                {/* upload pdf foramt */}

                               {/* <div style={{ paddingBottom: 15, paddingTop: 10 }} variant="outlined" size="small">
                                    <input
                                        accept=".pdf"
                                        className={classes.input}
                                        id="quotation-document"
                                        onChange={(e) => uploadWDFileDocument(e, 'quotationFile')}
                                        type="file"
                                        style={{ display: 'none' }}
                                        disabled={!checkIsUpload.scanQuotationFile && totalSize > 25}
                                    />
                                    <label htmlFor="quotation-document">
                                        <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span" disabled={!checkIsUpload.scanQuotationFile && totalSize > 25}>
                                            Upload Quotation PDF
                                        </Button>
                                    </label>
                                    {checkIsUpload.scanQuotationFile && (
                                        <>
                                            <CheckCircleIcon style={{ color: "green" }} />
                                            <h5 style={{ display: "inline-block", marginLeft: "5px" }}>
                                                File Size: {(uploadSize.scanQuotationFile / (1024 * 1024)).toFixed(2)} MB
                                            </h5>
                                        </>
                                    )}

                                    </div>   */}

                                <div style={{ paddingBottom: 15, paddingTop: 10 }} variant="outlined" size="small">
                                    <input
                                        accept=".pdf"
                                        className={classes.input}
                                        id="projectKickOffCheckList-document"
                                        onChange={(e) => uploadWDFileDocument(e, 'ProjectKickOffCheckList')}
                                        type="file"
                                        style={{ display: 'none' }}
                                        disabled={!checkIsUpload.scanProjectKickOffCheckListFile && totalSize > 25}
                                    />
                                    <label htmlFor="projectKickOffCheckList-document">
                                        <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span" disabled={!checkIsUpload.scanProjectKickOffCheckListFile && totalSize > 25}>
                                            Upload Project Kick Off Checklist
                                        </Button>
                                    </label>
                                    {/* {checkIsUpload.scanProjectKickOffCheckListFile && <CheckCircleIcon style={{ color: "green" }} />} */}
                                    {checkIsUpload.scanProjectKickOffCheckListFile && (
                                        <>
                                            <CheckCircleIcon style={{ color: "green" }} />
                                            <h5 style={{ display: "inline-block", marginLeft: "5px" }}>
                                                File Size: {(uploadSize.scanProjectKickOffCheckListFile / (1024 * 1024)).toFixed(2)} MB
                                            </h5>
                                        </>
                                    )}
                                </div>

                                <div style={{ paddingBottom: 15, paddingTop: 10 }} variant="outlined" size="small">
                                    <input
                                        accept=".pdf"
                                        className={classes.input}
                                        id="wdfile-document"
                                        onChange={(e) => uploadWDFileDocument(e, 'wdfile')}
                                        type="file"
                                        style={{ display: 'none' }}
                                        disabled={!checkIsUpload.workingDrawingFile && totalSize > 25}
                                    />
                                    <label htmlFor="wdfile-document">
                                        <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span" disabled={!checkIsUpload.workingDrawingFile && totalSize > 25}>
                                            Upload Working Drawing File
                                        </Button>
                                    </label>
                                    {/* {checkIsUpload.workingDrawingFile && <CheckCircleIcon style={{ color: "green" }} />} */}
                                    {checkIsUpload.workingDrawingFile && (
                                        <>
                                            <CheckCircleIcon style={{ color: "green" }} />
                                            <h5 style={{ display: "inline-block", marginLeft: "5px" }}>
                                                File Size: {(uploadSize.workingDrawingFile / (1024 * 1024)).toFixed(2)} MB
                                            </h5>
                                        </>
                                    )}
                                </div>

                                <div style={{ paddingBottom: 15, paddingTop: 10 }} variant="outlined" size="small">
                                    <input
                                        accept=".pdf"
                                        className={classes.input}
                                        id="3wdfile-document"
                                        onChange={(e) => uploadWDFileDocument(e, '3wdfile')}
                                        type="file"
                                        style={{ display: 'none' }}
                                        disabled={!checkIsUpload.threeworkingDrawingFile && totalSize > 25}
                                    />
                                    <label htmlFor="3wdfile-document">
                                        <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span" disabled={!checkIsUpload.threeworkingDrawingFile && totalSize > 25}>
                                            Upload 3D Working Drawing File
                                        </Button>
                                    </label>
                                    {/* {checkIsUpload.threeworkingDrawingFile && <CheckCircleIcon style={{ color: "green" }} />} */}
                                    {checkIsUpload.threeworkingDrawingFile && (
                                        <>
                                            <CheckCircleIcon style={{ color: "green" }} />
                                            <h5 style={{ display: "inline-block", marginLeft: "5px" }}>
                                                File Size: {(uploadSize.threeworkingDrawingFile / (1024 * 1024)).toFixed(2)} MB
                                            </h5>
                                        </>
                                    )}
                                </div>

                                {/* <div style={{ paddingBottom: 15, paddingTop: 10 }} variant="outlined" size="small">
                                    <input
                                            accept=".xlsx, .csv"
                                        className={classes.input}
                                        id="quotationcsv-document"
                                        onChange={(e) => uploadWDFileDocument(e, 'quotationcsv')}
                                        type="file"
                                        style={{ display: 'none' }}
                                        disabled={!checkIsUpload.quotationCsvFile && totalSize > 25}
                                    />
                                    <label htmlFor="quotationcsv-document">
                                        <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span" disabled={!checkIsUpload.quotationCsvFile && totalSize > 25}>
                                            Upload Quotation Excel/CSV
                                        </Button>
                                    </label>
                                    {checkIsUpload.quotationCsvFile && (
                                        <>
                                            <CheckCircleIcon style={{ color: "green" }} />
                                            <h5 style={{ display: "inline-block", marginLeft: "5px" }}>
                                                File Size: {(uploadSize.quotationCsvFile / (1024 * 1024)).toFixed(2)} MB
                                            </h5>
                                        </>
                                    )}
                                </div> */}

                                <div style={{ paddingBottom: 15, paddingTop: 10 }} variant="outlined" size="small">
                                    <input
                                        accept='.pdf'
                                        className={classes.input}
                                        id="siteqc-checklist"
                                        onChange={(e) => uploadWDFileDocument(e, 'siteqcchecklist')}
                                        type='file'
                                        style={{ display: 'none' }}
                                        disabled={!checkIsUpload.scanSiteQCCheckListFile && totalSize > 25}
                                    />
                                    <label htmlFor='siteqc-checklist'>
                                        <Button variant='contained' color='primary' style={{ background: "#716ACA", margin: 5 }} component="span" disabled={!checkIsUpload.scanSiteQCCheckListFile && totalSize > 25}>
                                            Upload SiteQC CheckList
                                        </Button>
                                    </label>
                                    {/* {checkIsUpload.scanSiteQCCheckListFile && <CheckCircleIcon style={{ color: "green" }} />} */}
                                    {checkIsUpload.scanSiteQCCheckListFile && (
                                        <>
                                            <CheckCircleIcon style={{ color: "green" }} />
                                            <h5 style={{ display: "inline-block", marginLeft: "5px" }}>
                                                File Size: {(uploadSize.scanSiteQCCheckListFile / (1024 * 1024)).toFixed(2)} MB
                                            </h5>
                                        </>
                                    )}
                                </div>

                                <div style={{ paddingBottom: 20, paddingTop: 10, display: "inline-fix" }} variant="outlined" size="small">
                                    {videos.map((video, index) => (
                                        <div key={index}>
                                        <input
                                            type="file"
                                            accept='video/*'
                                            id={`contained-button-video-${index}`}
                                            onChange={(event) => onVideoChangeCheck(event, index)}
                                            style={{ display: 'none' }}
                                        />
                                        <label htmlFor={`contained-button-video-${index}`}>
                                            <Button
                                            variant="contained"
                                            color="primary"
                                            component="span"
                                            style={{ background: "#716ACA", marginBottom: 15, marginLeft: 5 }}
                                            >
                                            UPLOAD SITE VIDEOS
                                            </Button>
                                        </label>
                                        {videos[index] !== "" && (
                                            <>
                                            <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: 'green', fontSize: 30 }} />
                                            </>
                                        )}
                                        <Button onClick={() => handleAddVideoInput(index)} startIcon={<AddCircleOutlineRoundedIcon />} style={{ marginLeft: 10 }} />
                                        {index !== 0 && (
                                            <Button onClick={() => handleRemoveVideoInput(index)} startIcon={<DeleteOutlineOutlinedIcon />} style={{ marginLeft: 10 }} />
                                        )}
                                        </div>
                                    ))}
                                    </div>

                                    <div style={{ paddingBottom: 20, paddingTop: 10, display: "inline-fix" }} variant="outlined" size="small">
                                        {pics.map((pic, index) => (
                                            <div key={index}>
                                                <input
                                                    type="file"
                                                    accept=".jpg,.png"
                                                    id={`contained-button-pic-${index}`}
                                                    onChange={(event) => onImageChange(event, index)}
                                                    style={{ display: 'none' }}
                                                    disabled={!uploadSize.siteQCPhotos[index] && totalSize>25}
                                                />
                                                <label htmlFor={`contained-button-pic-${index}`}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        component="span"
                                                        style={{ background: "#716ACA", marginBottom: 15, marginLeft: 5 }}
                                                        disabled={!uploadSize.siteQCPhotos[index] && totalSize>25}
                                                    >
                                                        UPLOAD SITE PHOTOS
                                                    </Button>
                                                </label>
                                                {pics[index] !== "" && (<>
                                                    <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: 'green', fontSize: 30 }} />
                                                    <h5 style={{ display: "inline-block", marginLeft: "5px" }}>
                                                        File Size: {(uploadSize.siteQCPhotos[index] / (1024 * 1024)).toFixed(2) || 0} MB
                                                    </h5>
                                                
                                                </>)}
                                                <Button onClick={() => handleAddFilesInput(index)} startIcon={<AddCircleOutlineRoundedIcon />} style={{ marginLeft: 10 }} disabled={!uploadSize.siteQCPhotos[index] && totalSize>25}/>
                                                {index !== 0 && (
                                                    <Button onClick={() => handleRemoveFilesInput(index)} startIcon={<DeleteOutlineOutlinedIcon />} style={{ marginLeft: 10 }} />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                 {/* Clone Quotation Changes for uplaod file pdf and excel of design sign off */}
                                { <>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ background: "#716ACA", margin: 5 }}
                                        component="span"
                                        disabled={!checkIsUpload.scanQuotationFile && totalSize>25}
                                        onClick={() => setOpenSelectQuotationVersion(true)}
                                    >
                                        Select Quotation Version
                                    </Button>
                                    {checkIsUpload?.quotationCsvFile && checkIsUpload?.scanQuotationFile && (
                                        <>
                                            <CheckCircleIcon style={{ color: "green" }} />
                                            {/* <h5 style={{ display: "inline-block", marginLeft: "5px" }}>
                                                File Size: {(uploadSize.scanQuotationFile / (1024 * 1024)).toFixed(2)} MB
                                            </h5> */}
                                        </>
                                    )}
                                </>
                                 }

                                    {stage === 'Design Sign-off HOLD' &&
                                        <FormControl fullWidth style={{ marginTop: "15px", marginBottom: "15px" }} variant="outlined" size="small">
                                            <TextField
                                                id="designSignOffRevokeDate"
                                                name="designSignOffRevokeDate"
                                                onChange={(e) => setContractSignStageForm({ ...contractSignStageForm, designSignOffRevokeDate: new Date(e.target.value) })}
                                                label="When Hold will be revoked"
                                                type="date"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                variant="outlined"
                                                size="small"
                                            />
                                        </FormControl>}
                                    
                                    {/* <FormControl fullWidth style={{ marginTop: "15px", marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="internalDesignSignOffDate"
                                            name="internalDesignSignOffDate"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setContractSignStageForm({
                                                    ...contractSignStageForm,
                                                    internalDesignSignOffDate: value ? new Date(value) : null
                                                });
                                            }}
                                            label="Internal Design Sign-Off Date"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                min: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString().split("T")[0],
                                                max: new Date().toISOString().split("T")[0],
                                            }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl> */}
                                <FormControl fullWidth style={{ marginBottom: "15px", marginTop: 15 }} variant="outlined" size="small">
                                    <TextField
                                        id="grandTotal"
                                        name="grandTotal"
                                        value={projectDetails.staticSalesWonAmount}
                                        label="Tentative Sales Quotation"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        variant="outlined"
                                        size="small"
                                        disabled="true"
                                    />
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: "15px", marginTop: 15 }} variant="outlined" size="small">
                                    <TextField
                                        id="grandTotal"
                                        name="grandTotal"
                                        // value={projectDetails.grandTotal}
                                        value={qtVersionGrandTotal}
                                        label="Design Sign Off Total Amount"
                                        type="text"
                                        InputLabelProps={{ shrink: true }}
                                        variant="outlined"
                                        size="small"
                                        disabled="true"
                                    />
                                </FormControl>

                                <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                    <TextField
                                        id="amountReceived"
                                        name="contractSignedValue"
                                        value={totalAmount}
                                        onChange={(e) => setContractSignStageForm({ ...contractSignStageForm, [e.target.name]: Number(e.target.value) })}
                                        label="Amount Received"
                                        type="number"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        variant="outlined"
                                        size="small"
                                        disabled = "true"
                                    />
                                </FormControl>
                                <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                    <TextField
                                        id="percentageReceived"
                                        name="tokenPercent"
                                        // value={((contractSignStageForm.contractSignedValue / projectDetails.grandTotal) * 100).toFixed(2)}
                                        value={qtVersionGrandTotal !== 0 ? ((parseInt(totalAmount) / parseInt(qtVersionGrandTotal)) * 100).toFixed(2) : "0.00"}
                                        onChange={(e) => setContractSignStageForm({ ...contractSignStageForm, [e.target.name]: e.target.value })}
                                        label="Percentage Received"
                                        type="text"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        variant="outlined"
                                        size="small"
                                        disabled="true"
                                    />
                                </FormControl>
                                {/* <FormControl fullWidth style={{ marginBottom: "15px", marginTop: 15 }} variant="outlined" size="small">
                                        <TextField
                                            id="standard-number"
                                            label="Days As Per Contract"
                                            name="daysAsPerContractSign"
                                            type="number"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={(e) => setContractSignStageForm({ ...contractSignStageForm, [e.target.name]: Number(e.target.value) })}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl> */}
                                {files?.map((file, index) => (
                                    <div style={{ display: 'flex', alignItems: 'center', margin: 10, padding: 2 }}>
                                        <FormControl style={{ width: 500 }}>
                                            <input
                                                key={`${index}`}
                                                accept="*"
                                                className={classes.input}
                                                id={`contained-button-file-${index}`}
                                                name="contractSignedPaymentReceviedAttachemnts"
                                                onChange={(e) => onImageChangeCheck(e, index)}
                                                type="file"
                                                style={{ display: 'none' }}
                                                disabled={!uploadSize.paymentRecievedAttachments[index] && totalSize > 25}
                                            />
                                            <label htmlFor={`contained-button-file-${index}`}>
                                                <Button variant="contained" color="primary" style={{ background: "#716ACA" }} component="span" disabled={!uploadSize.paymentRecievedAttachments[index] && totalSize > 25}>
                                                    Upload Payment Received Attachments
                                                </Button>
                                            </label>
                                        </FormControl>
                                        {files[index] !== "" && (<>
                                            <CheckCircleIcon
                                                style={{ verticalAlign: "middle", color: "green", fontSize: 30, marginLeft: 10 }}
                                            />
                                            <h5 style={{ display: "inline-block", marginLeft: "5px" }}>
                                                File Size: {(uploadSize.paymentRecievedAttachments[index] / (1024 * 1024)).toFixed(2) || 0} MB
                                            </h5>
                                        </>)}
                                        <Button onClick={() => handleAddFileInput(index)} startIcon={<AddCircleOutlineRoundedIcon />} style={{ marginLeft: 10 }} disabled={!uploadSize.paymentRecievedAttachments[index] && totalSize > 25} />
                                        {index !== 0 && (
                                            <Button onClick={() => handleRemoveFileInput(index)} startIcon={<DeleteOutlineOutlinedIcon />} style={{ marginLeft: 10 }} />
                                        )}
                                    </div>
                                ))}

                            </div>
                        }
                        {/* {

                            stage === 'Final Quotation Approval' &&
                            <div>
                                <FormControl fullWidth style={{ marginBottom: 20 }}>
                                    <TextField
                                        select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="Quotations"
                                        value={selectedQuote}
                                        label="Select Quotation"
                                        onChange={handleQuotations}
                                        variant="outlined"
                                        size="small"
                                    >
                                        {quotationsdata.map((row, i) => {
                                            return (
                                                <MenuItem key={i + 1} value={row._id}>{row.version} - {row.grandTotal}</MenuItem>
                                            )
                                        })}
                                    </TextField>
                                </FormControl>
                            </div>
                        } */}

                            {stage === "Lost" && (
                                <div>
                                    <FormControl
                                        fullWidth
                                        style={{ marginBottom: "15px" }}
                                        variant="outlined"
                                        size="small"
                                    >
                                        <InputLabel htmlFor="outlined-adornment-amount">
                                            Reason for Lost *
                                        </InputLabel>

                                        {(userDetails?.departmentId === salesDepartment) ? (
                                            <Select
                                                labelId="select-reason-label"
                                                id="select-reason"
                                                value={salesLostReason}
                                                label="Reason for Lost"
                                                onChange={handleSelectSalesLostReason}
                                                size="small"
                                                style={{ fontSize: "0.85rem", marginLeft: 10, marginRight: 30 }}
                                            >
                                                {salesLostReasonOptions.map((row, i) => (
                                                    <MenuItem key={i + 1} value={row.name} style={{ fontSize: "0.85rem" }}>
                                                        {row.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        ) : (
                                            <OutlinedInput
                                                id="outlined-adornment-amount"
                                                value={lostReason}
                                                onChange={handlelostReason}
                                                label="Reason for Lost"
                                                variant="outlined"
                                                size="small"
                                            />
                                        )}
                                    </FormControl>
                                    {/* Unified Lost + Refund choice */}
                                    <FormControl component="fieldset" style={{ marginBottom: 12 }}>
                                        <FormLabel component="legend" style={{ fontSize: '0.95rem' }}>
                                            Do you want to raise a refund request?
                                        </FormLabel>
                                        <RadioGroup
                                            row
                                            aria-label="refund-request"
                                            name="refund-request"
                                            value={unifiedWantsRefund}
                                            onChange={(e) => setUnifiedWantsRefund(e.target.value)}
                                        >
                                            <FormControlLabel 
                                                value="yes" 
                                                control={<Radio color="primary" />} 
                                                label="Yes" 
                                                disabled={totalAmount <= 0}
                                            />
                                            <FormControlLabel value="no" control={<Radio color="primary" />} label="No" />
                                        </RadioGroup>
                                        {totalAmount <= 0 && (
                                            <Typography variant="caption" style={{ color: 'red', marginTop: 4 }}>
                                                Refund option disabled: No payment received for this project
                                            </Typography>
                                        )}
                                    </FormControl>

                                    {unifiedWantsRefund === 'yes' && (
                                        <FormControl fullWidth style={{ marginBottom: 12 }} variant="outlined" size="small">
                                            <TextField
                                                label="Refund Amount"
                                                name="unifiedRefundAmount"
                                                type="number"
                                                value={unifiedRefundAmount}
                                                onChange={(e) => {
                                                    const value = parseFloat(e.target.value);
                                                    if (value > totalAmount) {
                                                        setUnifiedRefundAmount(totalAmount);
                                                    } else {
                                                        setUnifiedRefundAmount(value);
                                                    }
                                                }}
                                                variant="outlined"
                                                size="small"
                                                inputProps={{ min: 0, max: totalAmount, step: 0.01 }}
                                                InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }}
                                                required
                                            />
                                        </FormControl>
                                    )}
                                    
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <TextField
                                            label="Remarks"
                                            name="unifiedLostRemarks"
                                            value={unifiedLostRemarks}
                                            onChange={(e) => setUnifiedLostRemarks(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                            multiline
                                            rows={3}
                                        />
                                    </FormControl>
                                    {/* <Typography
                                        variant="body2"
                                        style={{
                                            color: "red",
                                            marginTop: "-10px",
                                            marginBottom: "15px",
                                        }}
                                    >
                                        This is a Lost request. Post which you will not be able to raise a refund
                                        request. To raise a refund, please move to Lost from the Raise Refund
                                        Request page.
                                    </Typography> */}
                                </div>
                            )}
                            {stage === 'Design Discussion' &&
                                <div>
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <InputLabel id="select-design-discussion">Select Discussion</InputLabel>
                                        <Select
                                            labelId="select-design-discussion"
                                            id="demo-simple-select1"
                                            value={discussionNo}
                                            label="Select Stage"
                                        onChange={(e)=> setDiscussionNo(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                        // disabled = {discussionNo !== ""}
                                        >
                                            {designDiscussion
                                                ?.filter((row) => !projectDetails?.designDiscussionDetails?.some((detail) => detail?.discussionNo === row))
                                                ?.map((row, i) => (
                                                    <MenuItem key={i + 1} value={row}>{row}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControl sx={{ marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                                    <Button onClick={()=>setOpenMomPage(true)} variant="contained" color="primary" disabled = {discussionNo === ''}>Fill MOM</Button>
                                        {
                                         momSubmit && <CheckCircleIcon style={{ marginLeft: '5px', color:"green" ,display: 'flex'}}  />
                                        }
                                    </FormControl>

                                    <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                        <>
                                            <input
                                                accept=".skp"
                                                className={classes.input}
                                                id="contained-button-file1"
                                                multiple
                                                type="file"
                                                onChange={addDwgSkpFile}
                                                style={{ display: 'none' }}
                                                name="skpFile"
                                            />
                                            <label htmlFor="contained-button-file1">
                                                <Button variant="contained" color="primary"
                                                    component="span" startIcon={<CloudUploadIcon />}>
                                                    Upload SKP File
                                                </Button>
                                                {
                                                    skpFile && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />
                                                }
                                            </label>
                                        </>
                                    </FormControl>
                                    <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                        <>
                                            <input
                                                accept=".dwg"
                                                className={classes.input}
                                                id="contained-button-file2"
                                                multiple
                                                type="file"
                                                onChange={addDwgSkpFile}
                                                style={{ display: 'none' }}
                                                name="dwgFile"
                                            />
                                            <label htmlFor="contained-button-file2">
                                                <Button variant="contained" color="primary"
                                                    component="span" startIcon={<CloudUploadIcon />}>
                                                    Upload AUTOCAD File
                                                </Button>
                                                {
                                                    dwgFile && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />
                                                }
                                            </label>
                                        </>
                                    </FormControl>


                                </div>
                            }

                        {stage !== 'Won' && stage !== 'Lost' && stage !== 'Move to Marketing' && stage !== 'Design Sign-off' && stage !== 'Design Sign-off HOLD' && stage !== 'Design Discussion' && <>
                                {/* Select Department */}
                                {
                                    stage == 'Initial Measurement' &&
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="intial_measurement_date"
                                            name="intial_measurement_date"
                                            label="Initial Measurement Date"
                                            type="date"
                                            value={initialMeasurementForm.intial_measurement_date}
                                            onChange={(e, v) => captureInitialMeasurementFormDetails(e, v)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    <br/>
                                        <TextField
                                            id="intial_measurement_time"
                                            name="intial_measurement_time"
                                            label="Initial Measurement Time"
                                            type="time"
                                            value={initialMeasurementForm.intial_measurement_time}
                                            onChange={(e, v) => captureInitialMeasurementFormDetails(e, v)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>

                                }
                                {
                                    stage == 'Finalization of Materials' &&
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="materialSelectionDate"
                                            name="materialSelectionDate"
                                            label="Finalzation of Materials Date"
                                            type="date"
                                            value={finalizationOfMaterialForm.materialSelectionDate}
                                            onChange={(e, v) => captureFinalizationOfMaterialsFormDetails(e, v)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    <br/>
                                        <TextField
                                            id="materialSelectionTime"
                                            name="materialSelectionTime"
                                            label="Finalzation of Materials Time"
                                            type="time"
                                            value={finalizationOfMaterialForm.materialSelectionTime}
                                            onChange={(e, v) => captureFinalizationOfMaterialsFormDetails(e, v)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>

                                }
                                {
                                    stage == 'Site QC/Project Kick-Off' &&
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <TextField
                                            id="siteQcDate"
                                            name="siteQcDate"
                                            label="Site QC/Project Kick-Off Date"
                                            type="date"
                                            value={siteQcDateForm.siteQcDate}
                                            onChange={(e, v) => captureSiteQcDateFormDetails(e, v)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    <br/>
                                        <TextField
                                            id="siteQcTime"
                                            name="siteQcTime"
                                            label="Site QC/Project Kick-Off Time"
                                            type="time"
                                            value={siteQcDateForm.siteQcTime}
                                            onChange={(e, v) => captureSiteQcDateFormDetails(e, v)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>

                                }
                                {/* Requirements Not Collected Reason */}
                                {
                                    stage === 'Requirements Not Collected' &&
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <InputLabel id="req-not-collected-reason">Reason to move to Requirements Not Collected *</InputLabel>
                                        <Select
                                            labelId="req-not-collected-reason"
                                            id="req-not-collected-reason"
                                            value={moveInRncReason}
                                            label="Reason to move to Requirements Not Collected *"
                                            onChange={(e) => setMoveInRncReason(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                        >
                                            {reqNotCollectedReasonList.map((reasonName, i) => {
                                                return (
                                                    <MenuItem key={i + 1} value={reasonName}>{reasonName}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                }

                                {/* text fpr reson other */}
                                {moveInRncReason === 'Other' &&
                                    <TextField
                                        fullWidth
                                        label="Reason"
                                        name="accountHolder"
                                        id="reasonForMove"
                                        variant="outlined"
                                        value={moveInRncOtherReason}
                                        onChange={(e) => setMoveInRncOtherReason(e.target.value)}
                                        required
                                        size="small"
                                        style={{ marginBottom: '10px' }}
                                    />
                                }

                                {/* verification Status */}
                                {
                                    stage === 'Requirements Not Collected' &&
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <InputLabel id="verfication-status">Lead verification status *</InputLabel>
                                        <Select
                                            labelId="req-not-collected-reason"
                                            id="verfication-status"
                                            value={verficationStatus}
                                            label="Lead verification status *"
                                            onChange={(e) => setVerficationStatus(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                        >
                                            {verificationStatusList.map((status, i) => {
                                                return (
                                                    <MenuItem key={i + 1} value={status}>{status}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                }

                                {/* text for verify other */}
                                {verficationStatus === 'Verified disqualified lead' &&
                                    <TextField
                                        fullWidth
                                        label="Reason"
                                        name="verifiyName"
                                        id="verifiyName"
                                        variant="outlined"
                                        value={verficationStatusOther}
                                        onChange={(e) => setVerficationStatusOther(e.target.value)}
                                        required
                                        size="small"
                                        style={{ marginBottom: '10px' }}
                                    />
                                }

                                {/* Requirement Collected - Reason for moving to Requirements Collected */}
                                {
                                    stage === 'Requirements Collected' &&
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <InputLabel id="req-collected-reason">Reason for moving to Requirements Collected *</InputLabel>
                                        <Select
                                            labelId="req-collected-reason"
                                            id="req-collected-reason"
                                            value={reasonMoveRcCollect}
                                            label="Reason for moving to Requirements Collected *"
                                            onChange={(e) => setReasonMoveRcCollect(e.target.value)}
                                            variant="outlined"
                                            size="small"
                                        >
                                            {reasonMoveRcCollectList.map((reasonName, i) => {
                                                return (
                                                    <MenuItem key={i + 1} value={reasonName}>{reasonName}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                }

                                {/* Other for - Reason for moving to Requirements Collected */}
                                {reasonMoveRcCollect === 'Other' &&
                                    <TextField
                                        fullWidth
                                        label="Reason"
                                        name="reasonCollect"
                                        id="reasonCollect"
                                        variant="outlined"
                                        value={reasonMoveRcCollectOther}
                                        onChange={(e) => setReasonMoveRcCollectOther(e.target.value)}
                                        required
                                        size="small"
                                        style={{ marginBottom: '10px' }}
                                    />
                                }

                            {/* Reassign to another user */}
                            {((stage === 'Requirements Not Collected' || stage === 'Requirements Collected' || stage === 'Quotation Sent'))&&
                                <FormControl style={{ marginRight: 20 }}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={reassignUser}
                                        onChange={handleReassign}
                                        name="reassignUser"
                                        color="primary"
                                    />
                                    }
                                    label="Reassign to another user"
                                />
                                </FormControl>
                            }

                            {(stage !== 'Requirements Not Collected' && stage !== 'Requirements Collected' && stage !== 'Quotation Sent')  && 
                                (stage === "Drawing QC") && (
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <InputLabel id="demo-simple-select-label_qc">Select QC Sub Stages</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label_qc"
                                            id="demo-simple-select_qc"
                                            // value={department}
                                            label="Select Sub Stages"
                                            onChange={handleSelectedQCStages}
                                            variant="outlined"
                                            size="small"
                                        >
                                            <MenuItem value="ADM In Progress" disabled={projectDetails?.drawingQcAdmApproved} >Drawing QC-1</MenuItem>
                                            <MenuItem value="QC2 In Progress" disabled={!(projectDetails?.drawingQCStage === "QC1 Completed" || projectDetails?.drawingQCStage === "QC2 Correction Needed")} >Drawing QC-2</MenuItem>
                                        </Select>
                                    </FormControl>
                                )
                            }

                                {(stage === "Drawing QC") && (
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <div>
                                        <TextField
                                                label="Remarks"
                                                multiline
                                                rows={4}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                value={qcRemarks}
                                                onChange={(e) => setQCRemarks(e.target.value)}
                                        />
                                    </div>
                                    </FormControl>
                                )}
                                
                                {!(stage === "Drawing QC" && projectDetails.drawingQcOneApproved) && (
                                    <>
                                     { ((stage !== 'Requirements Not Collected') && (stage !== 'Requirements Collected') && (stage !== 'Quotation Sent')) &&
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <InputLabel id="demo-simple-select-label">Select Department</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label1"
                                                id="demo-simple-select1"
                                                value={department}
                                                label="Select Stage"
                                                onChange={handleSelectedDepartmentChange}
                                                variant="outlined"
                                                size="small"
                                            >
                                                {departmentLists.map((row, i) => {
                                                    return (
                                                        <MenuItem key={i + 1} value={row._id}>{row.name}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                     }
                                {/* Select Team */}
                                { (((stage !== 'Requirements Not Collected') || (stage === 'Requirements Not Collected' && reassignUser)) && 
                                    ((stage !== 'Requirements Collected') || (stage === 'Requirements Collected' && reassignUser))  &&
                                    ((stage !== 'Quotation Sent') || (stage === 'Quotation Sent' && reassignUser))  
                                    ) &&
                                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                            <InputLabel id="demo-simple-select-label2">Select Team</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label2"
                                                id="demo-simple-select2"
                                                value={team}
                                                label="Select Team"
                                                onChange={handleSelectedTeamChange}
                                                variant="outlined"
                                                size="small"
                                            >
                                                {teamLists.map((row, i) => {
                                                    return (
                                                        <MenuItem key={i + 1} value={row._id}>{row.name}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                               }
                                 {/* Select Deal Owner User */}
                                {(((stage !== 'Requirements Not Collected') || (stage === 'Requirements Not Collected' && reassignUser)) &&
                                    ((stage !== 'Requirements Collected') || (stage === 'Requirements Collected' && reassignUser)) &&
                                    ((stage !== 'Quotation Sent') || (stage === 'Quotation Sent' && reassignUser))
                                ) &&
                                    <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                                        <InputLabel id="demo-simple-select-label3">Select User</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label3"
                                            id="demo-simple-select3"
                                            value={dealOwner}
                                            label="Select User"
                                            onChange={handleSelectedUserChange}
                                            variant="outlined"
                                            size="small"
                                        >
                                            {dealOwnerLists.map((row, i) => {
                                                return (
                                                    <MenuItem key={i + 1} value={row._id}>{row.name}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                }

                                </>
                                 )}

                                {(stage === "Finalization of Design" || stage === "Final Quote and Design" || stage === "Renders" || stage === "Finalization of Materials" || stage === "Site QC/Project Kick-Off") && (
                                    <>
                                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                            <>
                                                <input
                                                    accept=".skp"
                                                    className={classes.input}
                                                    id="contained-button-file1"
                                                    multiple
                                                    type="file"
                                                    onChange={addDwgSkpFile}
                                                    style={{ display: 'none' }}
                                                    name="skpFile"
                                                />
                                                <label htmlFor="contained-button-file1">
                                                    <Button variant="contained" color="primary"
                                                        component="span" startIcon={<CloudUploadIcon />}>
                                                        Upload SKP File
                                                    </Button>
                                                    {skpFile && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
                                                </label>
                                            </>
                                        </FormControl>
                                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                            <>
                                                <input
                                                    accept=".dwg"
                                                    className={classes.input}
                                                    id="contained-button-file2"
                                                    multiple
                                                    type="file"
                                                    onChange={addDwgSkpFile}
                                                    style={{ display: 'none' }}
                                                    name="dwgFile"
                                                />
                                                <label htmlFor="contained-button-file2">
                                                    <Button variant="contained" color="primary"
                                                        component="span" startIcon={<CloudUploadIcon />}>
                                                        Upload AUTOCAD File
                                                    </Button>
                                                    {dwgFile && <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 10, color: "green", fontSize: 30 }} />}
                                                </label>
                                            </>
                                        </FormControl>
                                    </>
                                )}
                                {(stage === "Internal Design Sign-Off") &&
                                    <div>
                                        <Box sx={{ minWidth: 450 }}>
                                            {/* Upload Payment Proof */}
                                            <FormControl fullWidth variant="outlined" size="small">
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <Button
                                                        variant="contained"
                                                        component="label"
                                                        color="primary"
                                                        style={{ marginBottom: 20, marginRight: '10px' }}
                                                    >
                                                        Upload Payment Proof
                                                        <input
                                                            type="file"
                                                            hidden
                                                            accept="image/*, application/pdf"
                                                            onChange={handleFileSelection}  // Directly handle file selection
                                                        />
                                                    </Button>
                                                    {/* Show green tick if upload is successful */}
                                                    {uploadSuccess && <CheckCircleIcon style={{ color: 'green' }} />}
                                                </Box>
                                            </FormControl>
                                        </Box>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            style={{ marginBottom: 20, marginRight: '10px' }}
                                            component="label"
                                            disabled={!checkIsUpload.scanQuotationFile && totalSize > 25}
                                            onClick={() => setOpenSelectQuotationVersion(true)}
                                        >
                                            Select Quotation Version
                                        </Button>
                                        {qtVersionGrandTotal > 0 &&
                                            requiresDsoPaymentApproval(
                                                projectDetails?.staticSalesWonAmount,
                                                qtVersionGrandTotal
                                            ) && (
                                                <div style={{ marginBottom: 16 }}>
                                                    <p style={{ color: '#c0392b', marginBottom: 8 }}>
                                                        Design sign-off amount is{' '}
                                                        {salesVsQuotationVariancePercent(
                                                            projectDetails?.staticSalesWonAmount,
                                                            qtVersionGrandTotal
                                                        ).toFixed(1)}
                                                        % below sales won (≥ 30% reduction). Naren approval is required.
                                                    </p>
                                                    {projectDetails?.dsoPaymentApprovalStatus === 'Sent for Approval' && (
                                                        <p style={{ color: '#856404', marginBottom: 8 }}>
                                                            Pending Naren approval. Stage stays Drawing QC until he approves.
                                                        </p>
                                                    )}
                                                    {isDsoPaymentApprovedForLead(projectDetails, qtVersionGrandTotal) && (
                                                        <p style={{ color: '#1e8449', marginBottom: 8 }}>
                                                            Naren approved this quotation amount
                                                        </p>
                                                    )}
                                                    {!isDsoPaymentApprovedForLead(projectDetails, qtVersionGrandTotal) &&
                                                        projectDetails?.dsoPaymentApprovalStatus !== 'Sent for Approval' && (
                                                            <p style={{ color: '#5f6b7a', marginBottom: 8 }}>
                                                                Upload documents and click Assign. This will go to Naren.
                                                                After he approves, stage becomes Internal Design Sign-Off.
                                                                If he rejects, it stays at Drawing QC and these files are cleared.
                                                            </p>
                                                        )}
                                                </div>
                                            )}
                                        {checkIsUpload?.quotationCsvFile && checkIsUpload?.scanQuotationFile && (
                                            <>
                                                <CheckCircleIcon style={{ color: "green" }} />
                                            </>
                                        )}
                                    </div>
                                }
                                {(stage === "Drawing QC") && (
                                  <>
                                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                            <>
                                                <input
                                                    className={classes.input}
                                                    id="contained-button-file1"
                                                    multiple
                                                    type="file"
                                                    onChange={addDwgSkpMultipleFile}
                                                    style={{ display: 'none' }}
                                                    name="siteMasking"
                                                />
                                                <label htmlFor="contained-button-file1" 
                                                style={{ 
                                                    display: "flex", 
                                                    alignItems: "center",  
                                                    gap: "10px",           
                                                    maxWidth: "fit-content" 
                                                }}
                                                >
                                                    <Button variant="contained" color="primary"
                                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }} 
                                                        component="span" startIcon={<CloudUploadIcon />}>
                                                        Site Masking Documents
                                                    </Button>
                                                    {siteMaskingDocuments && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                                    {Array.isArray(siteMaskingDocumentsLink) && siteMaskingDocumentsLink.length > 0 && (
                                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                                            <span>({siteMaskingDocumentsLink.length})</span>
                                                        </div>
                                                    )}
                                                </label>
                                            </>
                                        </FormControl>
                                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                            <>
                                                <input
                                                    className={classes.input}
                                                    id="contained-button-file2"
                                                    multiple
                                                    type="file"
                                                    onChange={addDwgSkpMultipleFile}
                                                    style={{ display: 'none' }}
                                                    name="2dDrawings"
                                                />
                                                <label htmlFor="contained-button-file2"
                                                 style={{ 
                                                    display: "flex", 
                                                    alignItems: "center",  
                                                    gap: "10px",           
                                                    maxWidth: "fit-content" 
                                                }}
                                                >
                                                    <Button variant="contained" color="primary"
                                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }}
                                                        component="span" startIcon={<CloudUploadIcon />}>
                                                        2D Drawings
                                                    </Button>
                                                    {twoDDrawingsFile && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                                    {Array.isArray(twoDDrawingsFileLink) && twoDDrawingsFileLink.length > 0 && (
                                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                                            <span>({twoDDrawingsFileLink.length})</span>
                                                        </div>
                                                    )}
                                                </label>
                                            </>
                                        </FormControl>
                                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                            <>
                                                <input
                                                    className={classes.input}
                                                    id="contained-button-file3"
                                                    multiple
                                                    type="file"
                                                    onChange={addDwgSkpMultipleFile}
                                                    style={{ display: 'none' }}
                                                    name="sitePhotosVideos"
                                                />
                                                <label htmlFor="contained-button-file3"
                                                style={{ 
                                                    display: "flex", 
                                                    alignItems: "center",  
                                                    gap: "10px",           
                                                    maxWidth: "fit-content" 
                                                }}
                                                >
                                                    <Button variant="contained" color="primary"
                                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }}
                                                        component="span" startIcon={<CloudUploadIcon />}>
                                                        Site Photos/Videos
                                                    </Button>
                                                    {sitePhotosVideosFile && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                                    {Array.isArray(sitePhotosVideosFileLink) && sitePhotosVideosFileLink.length > 0 && (
                                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                                            <span>({sitePhotosVideosFileLink.length})</span>
                                                        </div>
                                                    )}
                                                </label>
                                            </>
                                        </FormControl>
                                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                            <>
                                                <input
                                                    
                                                    className={classes.input}
                                                    id="contained-button-file4"
                                                    multiple
                                                    type="file"
                                                    onChange={addDwgSkpMultipleFile}
                                                    style={{ display: 'none' }}
                                                    name="appliancesChecklist"
                                                />
                                                <label htmlFor="contained-button-file4"
                                                style={{ 
                                                    display: "flex", 
                                                    alignItems: "center",  
                                                    gap: "10px",           
                                                    maxWidth: "fit-content" 
                                                }}
                                                >
                                                    <Button variant="contained" color="primary"
                                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }}
                                                        component="span" startIcon={<CloudUploadIcon />}>
                                                        Appliances Checklist
                                                    </Button>
                                                    {appliancesChecklistFile && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                                    {Array.isArray(appliancesChecklistFileLink) && appliancesChecklistFileLink.length > 0 && (
                                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                                            <span>({appliancesChecklistFileLink.length})</span>
                                                        </div>
                                                    )}
                                                </label>
                                            </>
                                        </FormControl>
                                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                            <>
                                                <input
                                                    
                                                    className={classes.input}
                                                    id="contained-button-file5"
                                                    multiple
                                                    type="file"
                                                    onChange={addDwgSkpMultipleFile}
                                                    style={{ display: 'none' }}
                                                    name="3dPPT"
                                                />
                                                <label htmlFor="contained-button-file5"
                                                style={{ 
                                                    display: "flex", 
                                                    alignItems: "center",  
                                                    gap: "10px",           
                                                    maxWidth: "fit-content" 
                                                }}
                                                >
                                                    <Button variant="contained" color="primary"
                                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }}
                                                        component="span" startIcon={<CloudUploadIcon />}>
                                                        3D PowerPoint (PPT)
                                                    </Button>
                                                    {powerPointFile && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                                    {Array.isArray(powerPointFileLink) && powerPointFileLink.length > 0 && (
                                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                                            <span>({powerPointFileLink.length})</span>
                                                        </div>
                                                    )}
                                                </label>
                                            </>
                                        </FormControl>
                                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                                            <>
                                                {/*<input
                                                    
                                                    className={classes.input}
                                                    id="contained-button-file6"
                                                    multiple
                                                    type="file"
                                                    onChange={addDwgSkpMultipleFile}
                                                    style={{ display: 'none' }}
                                                    name="Quotation"
                                                />*/}
                                                <label htmlFor="contained-button-file6"
                                                style={{ 
                                                    display: "flex", 
                                                    alignItems: "center",  
                                                    gap: "10px",           
                                                    maxWidth: "fit-content" 
                                                }}
                                                >
                                                <Button variant="contained" color="primary"
                                                    style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }}
                                                    disabled={!checkIsUpload.scanQuotationFile && totalSize > 25}
                                                    onClick={() => setOpenSelectQuotationVersion(true)}
                                                    component="span" startIcon={<CloudUploadIcon />}>
                                                    Quotation
                                                </Button>
                                                {quotationFile && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                                {Array.isArray(quotationFileLink) && quotationFileLink.length > 0 && (
                                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                                            <span>({quotationFileLink.length})</span>
                                                        </div>
                                                )}
                                                </label>
                                            </>
                                        </FormControl>
                                  </>
                                )}

                                {/* Give Project No.*/}
                                {(stage === "Assign to Designer" && !projectDetails.erpProjectNo) &&
                                    <div>
                                        <Box sx={{ minWidth: 450 }}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                                <TextField
                                                    label="ERP Project No."
                                                    size="small"
                                                    value={projectDetails?.uniqueLeadNumber || ""}
                                                    style={{ marginBottom: 20 }}
                                                    name="floorPlan"
                                                    InputProps={{ readOnly: true }}
                                                    helperText="Auto-generated from Unique Lead Number"
                                                    variant="outlined"
                                                />
                                            </FormControl>
                                        </Box>
                                        {erpProjectExists && (
                                            <p style={{ color: 'red' }}>The project no already exist please connect with the tech team</p>
                                        )}
                                    </div>
                                }
                            </>}
                    </Box>
                </DialogContent>
                <DialogActions>
                        {
                            stage === 'Won' && meetingDone === "Yes" ? <>
                                <Button onClick={() => updateClosureStatus("No")} variant="outlined" disabled={meetingType === "" || meetingDate === null}>No</Button>
                                <Button onClick={() => updateClosureStatus("Yes")} variant="contained" color="primary" disabled={meetingType === "" || meetingDate === null}>Yes</Button>
                            </> :
                                stage === 'Won' ? <>
                                    <Button onClick={() => updateClosureStatus("No")} variant="outlined">No</Button>
                                    <Button onClick={() => updateClosureStatus("Yes")} variant="contained" color="primary" >Yes</Button>
                                </> : stage === 'Move to Marketing' ? <>
                                    <Button onClick={() => setOpenAnotherDialog(false)} variant="outlined">Cancel</Button>
                                    <Button onClick={sentForMoveToMarketingApproval} variant="contained" color="primary" disabled={!isFormValid}>Send For Approval</Button>
                                </> : stage === 'Lost' && meetingDone === "Yes" ? <>
                                    <Button onClick={() => setOpenAnotherDialog(false)} variant="outlined">Cancel</Button>
                                    <Button 
                                        onClick={handleUnifiedLostFromMoveDeal} 
                                        variant="contained" 
                                        color="primary" 
                                        disabled={
                                            (lostReason === "" && salesLostReason === "") ||
                                            meetingType === "" ||
                                            meetingDate === null ||
                                            unifiedWantsRefund === null ||
                                            (unifiedWantsRefund === 'yes' && (!unifiedRefundAmount || parseFloat(unifiedRefundAmount) <= 0))
                                        }
                                    >
                                        Assign Project
                                    </Button>
                                </> : stage === 'Lost' ? <>
                                    <Button onClick={() => setOpenAnotherDialog(false)} variant="outlined">Cancel</Button>
                                    <Button 
                                        onClick={handleUnifiedLostFromMoveDeal} 
                                        variant="contained" 
                                        color="primary" 
                                        disabled={
                                            (lostReason === "" && salesLostReason === "") ||
                                            unifiedWantsRefund === null ||
                                            (unifiedWantsRefund === 'yes' && (!unifiedRefundAmount || parseFloat(unifiedRefundAmount) <= 0))
                                        }
                                    >
                                        Assign Project
                                    </Button>
                                </> : stage === 'Design Sign-off' ? <>
                                    <Button onClick={() => setOpenAnotherDialog(false)} variant="outlined">Cancel</Button>
                                    <Button onClick={checkProceedToD2E} variant="contained" color="primary"
                                        disabled={!hasAttachments || !hasPhotos || !hasVideos  ||
                                            !checkIsUpload.scanQuotationFile || !checkIsUpload.threeworkingDrawingFile || !checkIsUpload.quotationCsvFile || !checkIsUpload.scanQuotationFile
                                    || !checkIsUpload.workingDrawingFile || !checkIsUpload.scanProjectKickOffCheckListFile || !checkIsUpload.scanSiteQCCheckListFile || isDisabled || totalSize>=25}

                                    >Send Approval Request</Button>
                                </> : ((stage === 'Site/Office visit' || stage === 'Negotiation') && (meetingDone === 'Yes' || meetingDone === 'No')) ?
                                            <>
                                            <Button 
                                                onClick={()=> setOpenAnotherDialog(false)} 
                                                variant="contained"
                                                color="secondary"
                                            >
                                                Cancel
                                            </Button>
                                             <Button onClick={handleSiteVisitNegotiation}
                                                variant="contained"
                                                color="primary"
                                                disabled = {(stage === 'Site/Office visit' || stage === 'Negotiation') && meetingDone === ''}
                                                >
                                                    Assign Project
                                             </Button>
                                    </> : stage === 'Design Sign-off HOLD' ? <>
                                    <Button onClick={() => setOpenAnotherDialog(false)} variant="outlined">Cancel</Button>
                                    <Button onClick={checkProceedToD2E} variant="contained" color="primary"
                                        disabled={!hasAttachments || !hasPhotos || 
                                            !checkIsUpload.scanQuotationFile || !checkIsUpload.threeworkingDrawingFile || !checkIsUpload.quotationCsvFile
                                            || !checkIsUpload.workingDrawingFile || !checkIsUpload.scanProjectKickOffCheckListFile || !checkIsUpload.scanSiteQCCheckListFile || isDisabled || totalSize >= 25 || !contractSignStageForm.designSignOffRevokeDate }
                                    >MOVE TO HOLD</Button>
                                </> : meetingDone === "Yes" ? <>
                                    <Button onClick={() => setOpenAnotherDialog(false)} variant="outlined">Cancel</Button>
                                    <Button onClick={assignProject} variant="contained" color="primary"
                                        disabled={department === '' || team === '' || dealOwner === '' || meetingType === "" || meetingDate === "" || meetingDate === null}
                                    >Assign Project</Button>
                                </> : stage === 'Design Discussion' ? <>
                                    <Button onClick={() => setOpenAnotherDialog(false)} variant="outlined"> Cancel </Button>
                                    <Button variant="contained" color="primary" disabled = { discussionNo === '' || !momSubmit} onClick={handleDiscussionButton}>Submit</Button>
                                </> :
                                    stage === 'Requirements Not Collected' ? 
                                    <>
                                    <Button onClick={handleRncCancelButton} variant="contained" color='secondary'>Cancel</Button>
                                    <Button onClick={handleRncSubmitButton} disabled = {isRncSubmitDisabled} variant="contained" color='primary'>Submit</Button>
                                    </>
                                    :  stage === 'Requirements Collected' ? 
                                    <>
                                    <Button onClick={handleRcCancelButton} variant="contained" color='secondary'>Cancel</Button>
                                    <Button onClick={handleRcSubmitButton} disabled = {isRcSubmitDisabled} variant="contained" color='primary'>Submit</Button>
                                    </> : 
                                    stage === 'Quotation Sent' ? 
                                    <>
                                    <Button onClick={handleQtCancelButton} variant="contained" color='secondary'>Cancel</Button>
                                    <Button onClick={handleQtSubmitButton} disabled = {isQtSubmitDisabled} variant="contained" color='primary'>Submit</Button>
                                    </> : 
                                    <>
                                        {(stage === 'Drawing QC') ? (
                                            <>
                                                <Button onClick={() => setOpenAnotherDialog(false)} variant="outlined">Cancel</Button>
                                                    <Button
                                                        onClick={assignProject}
                                                        variant="contained"
                                                        color="primary"
                                                        disabled={
                                                            !siteMaskingDocuments ||
                                                            !twoDDrawingsFile ||
                                                            !sitePhotosVideosFile ||
                                                            !appliancesChecklistFile ||
                                                            !powerPointFile ||
                                                            !quotationFile ||
                                                            qcStages === '' ||
                                                            qcRemarks === '' ||
                                                            ( // Only check these if the condition is TRUE
                                                            !(stage === "Drawing QC" && projectDetails.drawingQcOneApproved) &&
                                                            (
                                                                department === '' ||
                                                                team === '' ||
                                                                dealOwner === ''
                                                            )
                                                            )
                                                        }
                                                    >
                                                    Assign Project
                                                </Button>
                                            </>
                                            )
                                            : 
                                            (
                                            <>
                                                <Button onClick={() => setOpenAnotherDialog(false)} variant="outlined">Cancel</Button>
                                                <Button
                                                    onClick={assignProject}
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={
                                                        department === '' || team === '' || dealOwner === '' ||
                                                        (stage === 'Internal Design Sign-Off' && (!uploadSuccess || !checkIsUpload.scanQuotationFile || !checkIsUpload.quotationCsvFile)) ||
                                                        (stage === 'Assign to Designer' && !projectDetails?.erpProjectNo && !projectDetails?.uniqueLeadNumber) ||
                                                        // (stage === 'Assign to Designer' && userDetails?.roles?.find(role => role.name === ROLENAME.DesignUser)) ||
                                                        ((stage === 'Site/Office visit' || stage === 'Negotiation') && meetingDone === '')
                                                    }
                                                >
                                                    Assign Project
                                                </Button>
                                            </>
                                        )}
                                    </>
                        }
                    </DialogActions>
                </Dialog>
                {loading && (
                    <Backdrop
                        open={true}
                        style={{
                            zIndex: 1400, // Higher than the Dialog's z-index
                            color: '#fff',
                        }}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                )}
            </>
            <Dialog open={designUserWarningDialog} onClose={() => setDesignUserWarningDialog(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
            <DialogTitle id="form-dialog-title">
                    The Payment amount is less than threshold conditions. Are you sure you want to proceed?
                </DialogTitle>
                <DialogActions>
                <Button onClick={() => setDesignUserWarningDialog(false)} variant="outlined" style={{ marginRight: '30px' }}>No</Button>
                <Button onClick={() => sendRequestToFinanceAndDesignManager()} disabled={ clicked} variant="contained" color="primary">Yes</Button>
                </DialogActions>
            </Dialog>
            {/* Upload Mom File Dialog */}
            <Dialog fullWidth={true} maxWidth={'xl'} open={openMomPage} onClose={() => setOpenMomPage(false)}>
                <div style={{ margin: '3% 18%' }}>
                    <br />
                    <Typography style={{ textAlign: 'center'}} variant="h5" component="h2"><strong>Design Discussion M.O.M</strong></Typography>
                    <br />

                    <Card className={classes.root} variant="outlined">
                        <CardContent>

                        {/* Additional minutes details */}
                            <div className="row" style={{ marginLeft: '5px', marginRight: '5px' }}>
                                <div style={{ marginTop: '1em' }}>
                                    <div className="row" style={{ marginLeft: '5px', marginRight: '5px' }}>
                                        <div style={{ marginTop: '1em' }}>
                                            <TableContainer component={Paper} style={{ width: '100%' }}>
                                                <Table stickyHeader aria-label="sticky table" style={{ width: "100%" }}>
                                                    <TableBody>
                                                    <TableRow>
                                                        <TableCell style={{textAlign:'center', background:'#DCDCDC', fontSize: '14px', fontWeight:'600'}} colSpan={4}>MINUTES OF MEETING</TableCell>
                                                    </TableRow>
                                                        <TableRow key='0'>
                                                            <TableCell component="th" scope="row">Project No</TableCell>
                                                            <TableCell component="th">
                                                                <FormControl style={{ width: 250 }}>
                                                                    <TextField size="small" id="outlined-basic" disabled value={projectDetails.erpProjectNo ? projectDetails.erpProjectNo : "-"} variant="outlined" name="projectNo" type='text' />
                                                                </FormControl>
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">Designer</TableCell>
                                                            <TableCell component="th">
                                                                <FormControl style={{ width: 250 }}>
                                                                    <TextField size="small" id="outlined-basic" disabled value={momDiscussionsDetails.designer} onChange={(e) => handleMomFormDetail(e)} variant="outlined" name="designer" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow key='1'>
                                                            <TableCell component="th" scope="row">Date</TableCell>
                                                            <TableCell component="th">
                                                                <FormControl style={{ width: 250 }}>
                                                                    <TextField size="small" id="outlined-basic" disabled value={momDiscussionsDetails.date} variant="outlined" name="date" type='text' />
                                                                </FormControl>
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">Time</TableCell>
                                                            <TableCell component="th">
                                                                <FormControl style={{ width: 250 }}>
                                                                    <TextField size="small" id="outlined-basic" disabled value={momDiscussionsDetails.time} variant="outlined" name="time" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow key='2'>
                                                            <TableCell component="th" scope="row">Type of Meeting</TableCell>
                                                            <TableCell component="th">
                                                                <FormControl style={{ width: 250 }}>
                                                                    <TextField size="small" id="outlined-basic" required value={momDiscussionsDetails.typeOfMeeting} onChange={(e) => handleMomFormDetail(e)} variant="outlined" name="typeOfMeeting" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">Quotation No.</TableCell>
                                                            <TableCell component="th">
                                                                <FormControl style={{ width: 250 }}>
                                                                    <TextField size="small" id="outlined-basic" required value={momDiscussionsDetails.quotationNo} onChange={(e) => handleMomFormDetail(e)} variant="outlined" name="quotationNo" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow key='3'>
                                                            <TableCell component="th" scope="row">Attendees</TableCell>
                                                            <TableCell component="th">
                                                                <FormControl style={{ width: 250 }}>
                                                                    <TextField size="small" id="outlined-basic" required value={momDiscussionsDetails.attendees} onChange={(e) => handleMomFormDetail(e)} variant="outlined" name="attendees" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">Minutes By</TableCell>
                                                            <TableCell component="th">
                                                                <FormControl style={{ width: 250 }}>
                                                                    <TextField size="small" id="outlined-basic" required value={momDiscussionsDetails.minutesBy} onChange={(e) => handleMomFormDetail(e)} variant="outlined" name="minutesBy" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow key='4'>
                                                            <TableCell component="th" scope="row">MOM No</TableCell>
                                                            <TableCell component="th">
                                                                <FormControl style={{ width: 250 }}>
                                                                    <TextField size="small" id="outlined-basic" required value={momDiscussionsDetails.momNo} onChange={(e) => handleMomFormDetail(e)} variant="outlined" name="momNo" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">Venue</TableCell>
                                                            <TableCell component="th">
                                                                <FormControl style={{ width: 250 }}>
                                                                    <TextField size="small" id="outlined-basic" required value={momDiscussionsDetails.venue} onChange={(e) => handleMomFormDetail(e)} variant="outlined" name="venue" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                        </TableRow>

                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />

                        {/* Additional Agenda Summary */}
                            <TableContainer component={Paper} style={{ width: '100%' }}>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell style={{textAlign:'center', background:'#DCDCDC', fontSize: '14px', fontWeight:'600'}}>AGENDA SUMMARY</TableCell>
                                        </TableRow>
                                        <TableRow key={0}>
                                            <TableCell colSpan={3}>
                                                <TextField
                                                    variant='outlined'
                                                    fullWidth
                                                    value={momDiscussionsDetails.agenda}
                                                    name='agenda'
                                                    required
                                                    size = "small"
                                                    onChange={(e) => handleMomFormDetail(e)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <br />

                        {/* Additional Discussion Summary */}
                            <div className="row" style={{ marginLeft: '5px', marginRight: '5px' }}>
                                <div style={{ marginTop: '1em' }}>
                                    <div className="row" style={{ marginLeft: '5px', marginRight: '5px' }}>
                                        <div style={{ marginTop: '1em' }}>
                                            <TableContainer component={Paper} style={{ width: '100%' }}>
                                                <Table stickyHeader aria-label="sticky table" style={{ width: "100%" }}>
                                                    <TableBody>

                                                        <TableRow key='0'>
                                                            <TableCell style={{ textAlign: 'center' }} component="th"><b>Sl No.</b></TableCell>
                                                            <TableCell style={{ textAlign: 'center' }} component="th"><b>Discussion</b></TableCell>
                                                            <TableCell style={{ textAlign: 'center' }} component="th"><b>Owners</b></TableCell>
                                                            <TableCell style={{ textAlign: 'center' }} component="th"><b>Customer remarks (To be filled only if there is change/disagreements on the points)</b></TableCell>
                                                        </TableRow>
                                                        <TableRow key='1'>
                                                            <TableCell style={{ textAlign: 'center' }} component="th">01</TableCell>
                                                            <TableCell style={{ textAlign: 'justify' }} component="th">
                                                            <ReactQuill
                                                            value={momDiscussionsDetails.discussion}  // Changed from discussionSummary to discussion
                                                            onChange={(content) => {
                                                                // Direct state update for ReactQuill
                                                                setMomDiscussionsDetails({
                                                                    ...momDiscussionsDetails,
                                                                    discussion: content  // Update the discussion field directly
                                                                });
                                                            }}
                                                            required
                                                            style={{ width: 400, height: 150, marginBottom: 40 }}
                                                        />
                                                            </TableCell>
                                                            <TableCell style={{ textAlign: 'center' }} component="th">
                                                                <FormControl style={{ width: 120 }}>
                                                                    <TextField size="small" id="outlined-basic" required value={momDiscussionsDetails.owners} onChange={(e) => handleMomFormDetail(e)} variant="outlined" name="owners" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                            <TableCell style={{ textAlign: 'center' }} component="th">
                                                                <FormControl style={{ width: 150 }}>
                                                                    <TextField size="small" id="outlined-basic" required value={momDiscussionsDetails.customerRemarks} onChange={(e) => handleMomFormDetail(e)} variant="outlined" name="customerRemarks" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow key='2'>
                                                            <TableCell colSpan={4}><b>Next Meeting: </b>
                                                            <FormControl style={{ width: 200, marginLeft:'5%' }}>
                                                                    <TextField size="small" id="outlined-basic" required value={momDiscussionsDetails.nextMeeting} onChange={(e) => handleMomFormDetail(e)} variant="standard" name="nextMeeting" type='date' />
                                                                </FormControl>
                                                            </TableCell>
                                                        </TableRow>

                                                        <TableRow key='3'>
                                                            <TableCell colSpan={4}><b>Remark: </b>
                                                            <FormControl style={{ width: 200 , marginLeft: '9%'}}>
                                                                    <TextField size="small" id="outlined-basic" required value={momDiscussionsDetails.remark} onChange={(e) => handleMomFormDetail(e)} variant="standard" name="remark" type='text' />
                                                                </FormControl>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </div>
                                        Note : If this is the last Discussion please submit with SKP and ACAD file.
                                        <h5 style={{ display: 'flex', alignItems: 'right', justifyContent: 'right', marginRight: '15%', marginTop: '3%' }}>Client Acknowledgement:</h5>
                                        <h5 style={{ display: 'flex', alignItems: 'right', justifyContent: 'right', marginRight: '15%' }}>Date:</h5>
                                    </div>
                                </div>
                            </div>
                            <br />
                        </CardContent>
                    </Card>
                    <DialogActions>

                        <Button
                            onClick={handleDiscussionDetailsSubmit}
                            disabled={!areAllFieldsFilled()}
                            variant="contained"
                            color="primary"
                            style={{ marginRight: 10 }}
                        >
                            Submit
                        </Button>
                        <Button
                            onClick={() => {
                                setOpenMomPage(false);
                                setDiscussionNo("");
                            }}
                            variant="outlined"
                            color="primary"
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                    <br />
                </div>
            </Dialog>

            <Dialog
            open={openNew}
            onClose={handleCloseNew}
            aria-labelledby="form-dialog-title"
            maxWidth="xl"
        >
            <DialogTitle id="form-dialog-title">Enter Details</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="amount"
                    label="Amount"
                    type="number"
                    fullWidth
                    value={amount}
                    onChange={handleAmountChange}
                    variant="outlined"
                    required
                    error={!isValidAmount}
                    helperText={!isValidAmount && 'Please enter a valid amount'}
                    InputProps={{
                        style: { fontSize: '20px', padding: '12px' }
                    }}
                    style={{ marginBottom: '20px' }}
                />
                <FormControlLabel
                    control={<Checkbox checked={payExtra} onChange={(e) => setPayExtra(e.target.checked)} />}
                    label="Customer is willing to pay extra 2.36%" // changing convenience fee to 2.36 to match cashfree..
                    //  label="Customer is willing to pay extra 1.6%"
                    disabled={isDisabledToken}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseNew} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained" disabled={!isValidAmount || isDisabledToken === false ? !payExtra : payExtra}>
                    Submit
                </Button>
            </DialogActions>
        </Dialog>


            {/* Change Lead Status Modal */}
            <Dialog open={openStatusModal} onClose={() => setOpenStatusModal(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">
                    {userDetails?.roles?.find(role => role.name === ROLENAME.MarketingUser || role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager || role.name === ROLENAME.MarketingManager) && `Change the Lead Status`}
                    {userDetails?.roles?.find(role => role.name === ROLENAME.DesignHead || role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser) && `Change the Design Status`}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <div style={{ paddingBottom: 15, marginTop: 15 }}>
                        {
                            userDetails?.roles?.find(role => role.name === ROLENAME.MarketingUser  || role.name === ROLENAME.TeleCallerUser || role.name === ROLENAME.TeleCallerManager || role.name === ROLENAME.MarketingManager) &&
                            <FormControl fullWidth variant="outlined" size="small">
                                <TextField
                                    id="outlined-select-currency"
                                    select
                                    label="Lead Status"
                                    name="status"
                                    value={leadStageStatus}
                                    // onChange={(e) => setLeadStageStatus({ [e.target.name]: e.target.value })}
                                    onChange={(e) => leadStageStatusChange(e)}
                                    variant="outlined"
                                    size="small"
                                >
                                    <MenuItem key={1} value='Lead Received'>Lead Received</MenuItem>
                                    <MenuItem key={2} value='To Be Called'>To Be Called</MenuItem>
                                    <MenuItem key={3} value='Hold'>Hold</MenuItem>
                                    {/* <MenuItem key={4} value='Lead Returned By Sales'>Lead Returned By Sales</MenuItem> */}
                                    <MenuItem key={5} value='Junk'>Junk</MenuItem>
                                </TextField>
                            </FormControl>
                        }
                        {
                            checkStageStatus === true &&
                            <FormControl fullWidth style={{ paddingTop: 20 }} size="small">
                                <TextField
                                    id="outlined-select-currency"
                                    select
                                    label="Select Sales Manager"
                                    name="salesManager"
                                    onChange={(e) => getSelectedSalesManagerDetail(e)}
                                    variant="outlined"
                                    size="small"
                                >
                                    {
                                        salesManagerList?.map((data, i) => (
                                            <MenuItem value={data._id} key={i + 1}> {`${data?.teamId?.name} - ${data?.name}`}</MenuItem>
                                        ))
                                    }
                                </TextField>
                            </FormControl>
                        }
                        {junkHold === true && (
                            <>
                                {/* Show Junk Reason ONLY if stage is Junk */}
                                {leadStageStatus === "Junk" && (
                                    <FormControl
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        style={{ margingTop: 50, marginBottom: 10 }}
                                    >
                                        <InputLabel id="select-reason-label" style={{ fontSize: '0.85rem' }}>
                                            Junk Reason
                                        </InputLabel>

                                        <Select
                                            labelId="select-reason-label"
                                            id="select-junk-reason"
                                            value={junkReason}
                                            label="Junk Reason"
                                            onChange={handleSelectJunkReason}
                                            size="small"
                                            style={{ fontSize: '0.85rem'}}
                                        >
                                            {junkReasonOptions.map((row, i) => (
                                                <MenuItem key={i} value={row.name} style={{ fontSize: '0.85rem' }}>
                                                    {row.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                )}

                                {/* Show Hand Over Date ONLY if stage is Hold */}
                                {leadStageStatus === "Hold" && (
                                    <TextField
                                        id="handoverDate"
                                        name="handoverDate"
                                        label="Hand Over Date"
                                        type="date"
                                        variant="outlined"
                                        value={handoverDate}
                                        onChange={(e) => setHandoverDate(e.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                        margin="normal"
                                    />
                                )}
                            </>
                        )}
                        {
                            userDetails?.roles?.find(role => role.name === ROLENAME.DesignHead || role.name === ROLENAME.DesignManager || role.name === ROLENAME.OperationDesignManager || role.name === ROLENAME.AssistantDesignManager || role.name === ROLENAME.DesignUser) &&

                            <FormControl fullWidth variant="outlined" size="small">
                                <TextField
                                    id="outlined-select-currency"
                                    select
                                    label="Design Status"
                                    name="status"
                                    value={selectedDesignStatus}
                                    onChange={(e) => designStageStatusChange(e)}
                                    variant="outlined"
                                    size="small"
                                    disabled = {againDesignHoldReq}
                                >
                                    <MenuItem key={1} value='Design'>Design</MenuItem>
                                    {canSelectDesignHold() && (
                                        <MenuItem key={2} value='Design-Hold'>Design Hold</MenuItem>
                                    )}
                                    {/* <MenuItem key={2} value='Design Hold - Possession more than 3 months'>Design Hold - Possession more than 3 months</MenuItem> */}
                                </TextField>
                            </FormControl>
                        }
                        {
                            (selectedDesignStatus === 'Design-Hold')  && <>

                                <FormControl fullWidth style={{ paddingTop: 20 }} size="small">
                                    <TextField
                                        select
                                        name="design-hold-select-reason"
                                        value={designHoldSelectedTypes}
                                        required="true"
                                        onChange={(e) => { setDesignHoldSelectedTypes(e.target.value); setLeadDesignHoldReason("") }}
                                        label="Design-Hold Reason"
                                        variant="outlined"
                                        size="small"
                                    >
                                        {availableDesignHoldOptions && availableDesignHoldOptions.map((option, index) => (
                                            <MenuItem key={index} value={option.name}>
                                                {option.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </FormControl>

                            <FormControl fullWidth style={{ paddingTop: 20 }} variant="outlined" size="small">
                                    <TextField
                                        id="design-hold-reason"
                                        label="Remarks"
                                        name="resonDesignHold"
                                        value={leadDesignHoldReason}
                                        required="true"
                                        onChange={(e) => setLeadDesignHoldReason(e.target.value)}
                                        variant="outlined"
                                        size="small"
                                    />
                                </FormControl>
                                <FormControl fullWidth style={{ paddingTop: 20 }} variant="outlined" size="small">
                                    <TextField
                                        style={{ margin: '5px' }}
                                        id="proposedDesignStart-Date"
                                        name="proposedDesignStartDate"
                                        value={moment(proposedDesignStartDate).format('YYYY-MM-DD')}
                                        onChange={(e) => setProposedDesignStartDate(e.target.value)}
                                        label="Probable Date for Restarting the Designing"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        inputProps={{
                                            min: moment().format('YYYY-MM-DD'), // Set the min attribute to today's date
                                        }}
                                        required = "true"
                                        variant="outlined"
                                        size="small"
                                    />
                                </FormControl>
                                 {/* Probable Date of Design Sign-Off  */}
                                 <FormControl fullWidth style={{ paddingTop: 20 }} variant="outlined" size="small">
                                    <TextField
                                        style={{ margin: '5px' }}
                                        id="probabaleDateDesignSignOff"
                                        name="probabaleDateDesignSignOff"
                                        value={moment(probableDesignSignOffDate).format('YYYY-MM-DD')}
                                        onChange={(e) => setProbableDesignSignOffDate(e.target.value)}
                                        label="Tentative Design Closure"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        inputProps={{
                                            min: proposedDesignStartDate ? moment(proposedDesignStartDate).add(1, 'month').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'), // Set the min attribute to proposedDesignStartDate
                                        }}
                                        variant="outlined"
                                        size="small"
                                        required = "true"
                                    />
                                    </FormControl>
                            </>
                        }
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenStatusModal(false)} variant="outlined" color="secondary">
                        Cancel
                    </Button>
                    <Button
                        disabled={(designStageStatus === 'Design-Hold') && (!probableDesignSignOffDate || !proposedDesignStartDate || !designHoldSelectedTypes)}
                        onClick={updateLeadStatus} variant="outlined" color="primary">
                        {checkStageStatus === true ? `Update Status and Assign Lead` : `Update Status`}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDesignerAssignmentDate} onClose={() => setOpenDesignerAssignmentDate(false)}>
                <DialogTitle>Set Designer Assignment Date</DialogTitle>
                <Divider />
                <DialogContent>
                    <FormControl fullWidth style={{ marginTop: 20, marginBottom: 20 }}>
                        <TextField
                            id="designerAssignement-Date"
                            name="designerAssignmentDate"
                            onChange={(e) => setDesignerAssignmentDate(e.target.value)}
                            label="Select Designer Assignment Date"
                            type="date"
                            InputLabelProps={{
                                shrink: true
                            }}
                            variant="outlined"
                            size="small"
                        />
                    </FormControl>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenDesignerAssignmentDate(false)} variant="outlined" color="primary">Cancel</Button>
                    <Button onClick={() => updateDesignerAssignmentDate()} variant="contained" color="primary">Update Designer Assignment Date</Button>
                </DialogActions>
            </Dialog>

            {/* clone button----------------------------- */}
            <Dialog open={openSelectQuotationVersion} onClose={() => setOpenSelectQuotationVersion(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">Select Quotation version to Upload CSV and Pdf</DialogTitle>
                <Divider />
                <DialogContent>
                    <div style={{ paddingBottom: 15, paddingTop: 20 }}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                <StyledTableCell align="center">Sl No</StyledTableCell>
                                <StyledTableCell align="center">Quotation Name</StyledTableCell>
                                <StyledTableCell align="center">Created By</StyledTableCell>
                                <StyledTableCell align="center">Created At</StyledTableCell>
                                <StyledTableCell align="center">Lead Amount</StyledTableCell>
                                <StyledTableCell align="center" >Action</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                    {/* ===================== Naraci Quotations ===================== */}
                    {naraciQuotationList?.length > 0 && (
                        <>
                        <TableRow>
                            <StyledTableCell colSpan={6} style={{ fontWeight: 600, backgroundColor: "#f0f0f0" }}>
                            Naraci Quotations
                            </StyledTableCell>
                        </TableRow>

                        {naraciQuotationList.map((data, index) => (
                            <StyledTableRow key={data._id}>
                            <StyledTableCell align="center">{index + 1}</StyledTableCell>
                            <StyledTableCell align="center">{data?.quotationVersion}</StyledTableCell>
                            <StyledTableCell align="center">{data?.quotationCreatedByDetails?.name}</StyledTableCell>
                            <StyledTableCell align="center">
                                {moment(data?.quotationCreatedDate).format("DD-MM-YYYY")}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                ₹ {commaSeparateAmount(data?.quotationAmount)}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                <Radio
                                aria-label="Quotation Version"
                                name="quotationVersion"
                                value={data._id}
                                checked={selectedQuotationVersion === data._id}
                                onChange={(e) => {
                                    const selectedQuotationId = e.target.value;
                                    setSelectedQuotationVersion(selectedQuotationId);
                                    setDrawingQcQtValue(data?.quotationAmount);
                                    setQtVersion(data?.quotationVersion);
                                    setQuotationPdf(data?.quotationPdfUrl);
                                    setQtVersionGrandTotal(data?.quotationAmount);
                                    setQuotationCsv(data?.quotationCsvUrl);
                                    setDisableUpload(false);
                                    if (data?.quotationPdfUrl) {
                                        setContractSignStageForm((prev) => ({
                                            ...prev,
                                            scanQuotationFile: data.quotationPdfUrl,
                                        }));
                                        setCheckIsUpload((prev) => ({
                                            ...prev,
                                            scanQuotationFile: true,
                                        }));
                                    }
                                    if (data?.quotationCsvUrl) {
                                        setContractSignStageForm((prev) => ({
                                            ...prev,
                                            quotationCsvFile: data.quotationCsvUrl,
                                        }));
                                        setCheckIsUpload((prev) => ({
                                            ...prev,
                                            quotationCsvFile: true,
                                        }));
                                    }
                                    props.setSnackInfo(
                                    "Click the Upload Quotation Excel/CSV and PDF Button",
                                    "warning"
                                    );
                                }}
                                />
                            </StyledTableCell>
                            </StyledTableRow>
                        ))}
                        </>
                    )}

                    {/* ===================== ERP Quotations ===================== */}
                    {quotationList?.filter(
                     (data) => data?.createdBy?.departmentId?._id === constantDepartmentId.design
                    ).length > 0 && (
                        <>
                        <TableRow>
                            <StyledTableCell colSpan={6} style={{ fontWeight: 600, backgroundColor: "#f0f0f0" }}>
                            ERP Quotations
                            </StyledTableCell>
                        </TableRow>

                        {quotationList
                            .filter((data) => data?.createdBy?.departmentId?._id === constantDepartmentId.design || constantDepartmentId.admin)
                            .map((data, index) => (
                            <StyledTableRow key={data._id}>
                                <StyledTableCell align="center">
                                { index + 1}
                                </StyledTableCell>
                                <StyledTableCell align="center">{data?.version}</StyledTableCell>
                                <StyledTableCell align="center">{data?.createdBy?.name}</StyledTableCell>
                                <StyledTableCell align="center">
                                {moment(data?.createdAt).format("DD-MM-YYYY")}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                ₹ {commaSeparateAmount(data?.grandTotal)}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                <Radio
                                    aria-label="Quotation Version"
                                    name="quotationVersion"
                                    value={data._id}
                                    checked={selectedQuotationVersion === data._id}
                                    onChange={(e) => {
                                    const selectedQuotationId = e.target.value;
                                    const selectedQuotation = quotationList.find(
                                        (quotation) => quotation._id === selectedQuotationId
                                    );
                                    if (!selectedQuotation) return;

                                    setDrawingQcQtValue(selectedQuotation?.grandTotal);
                                    const required50Percent = selectedQuotation?.grandTotal * 0.5;

                                    if (totalAmount < required50Percent && stage === "Internal Design Sign-Off") {
                                        props.setSnackInfo(
                                            "Payment received is less than 50% of the quote value. Please collect the minimum 50% payment to proceed.",
                                            "error"
                                        );
                                        setDisableUpload(true);
                                        return;
                                    }
                                    setDisableUpload(false);
                                    setSelectedQuotationVersion(selectedQuotationId);
                                    setQtVersion(selectedQuotation.version);
                                    const quotationPdfUrl = selectedQuotation.s3Location || selectedQuotation.maskedQuotationS3 || '';
                                    setQuotationPdf(quotationPdfUrl);
                                    setQtVersionGrandTotal(selectedQuotation.grandTotal);

                                    // Same as earlier: on radio click, always build CSV
                                    // (ERP and Naraci-synced ERP rows). Scope is optional
                                    // so missing scopeId no longer blocks the file.
                                    generateQuotationExcel(selectedQuotationId);
                                    if (quotationPdfUrl) {
                                        uploadWDFileDocument(quotationPdfUrl, "quotationFile");
                                    }

                                    props.setSnackInfo(
                                        "Click the Upload Quotation Excel/CSV and PDF Button",
                                        "warning"
                                    );
                                    }}
                                />
                                </StyledTableCell>
                            </StyledTableRow>
                            ))}
                        </>
                    )}
                    </TableBody>
                         </Table>
                    </TableContainer>
                </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    {/* <Button onClick={() => setOpenSelectQuotationVersion(false)} variant="outlined" color="secondary">
                        Cancel
                    </Button> */}
                     {userDetails?.roles?.some(
                        (role) =>
                            role.name === ROLENAME.OperationDesignManager ||
                            role.name === ROLENAME.DesignManager ||
                            role.name === ROLENAME.AssistantDesignManager ||
                            role.name === ROLENAME.DesignUser ||
                            role.name === ROLENAME.DesignHead ||
                            role.name === ROLENAME.DGM_Design ||
                            role.name === ROLENAME.AGM_Design ||
                            role.name === ROLENAME.AssistanceDesignManager
                        ) ? (
                        <Button
                            onClick={() => updateDesignQuotation()}
                            variant="contained"
                            color="primary"
                            disabled={
                                !qtVersion ||
                                !qtVersionGrandTotal ||
                                !quotationCsv ||
                                disableUpload
                            }
                            >
                            Upload Quotation Excel/CSV and Pdf
                        </Button>
                        ) : (
                        <Button
                            onClick={() => cloneSelectedVersion()}
                            variant="contained"
                            color="primary"
                            disabled={!checkIsUpload.scanQuotationFile}
                        >
                            Upload Quotation Excel/CSV and Pdf
                        </Button>
                    )}      
                </DialogActions>
            </Dialog>
            <Dialog open={openUpdatePaymentModel} onClose={() => setOpenUpdatePaymentModel(false)}>
                <DialogTitle>Update customer payment</DialogTitle>
                <Divider />
                <DialogContent>
                    <FormControl fullWidth style={{ marginTop: 20 }}>
                        <TextField
                            style={{ margin: '5px' }}
                            id="paymentAmount-design"
                            name="paymentAmount"
                            onChange={(e) => setPaymentUpdateForm({ ...paymentUpdateForm, [e.target.name]: e.target.value })}
                            label="Payment Amount"
                            InputLabelProps={{
                                shrink: true
                            }}
                            type="number"
                            variant="outlined"
                            size="small"
                        />
                    </FormControl>
                    <FormControl fullWidth style={{ marginTop: 20, display: 'inline-block' }}>
                        <input
                            accept="*"
                            className={classes.input}
                            id="designerPaymentAttachement-document"
                            onChange={(e) => uploadWDFileDocument(e, 'designerPayment')}
                            type="file"
                            style={{ display: 'none' }}
                        />
                        <label htmlFor="designerPaymentAttachement-document">
                            <Button variant="contained" color="primary" style={{ background: "#716ACA", margin: 5 }} component="span">
                                Upload Payment Attachment
                            </Button>
                        </label>
                        {checkIsUpload.designerPaymentAttachement && <CheckCircleIcon style={{ color: "green" }} />}

                    </FormControl>
                    <FormControl fullWidth style={{ marginTop: 20 }}>
                        <TextField
                            style={{ margin: '5px' }}
                            id="note-payment"
                            name="note"
                            onChange={(e) => setPaymentUpdateForm({ ...paymentUpdateForm, [e.target.name]: e.target.value })}
                            label="Enter note"
                            InputLabelProps={{
                                shrink: true
                            }}
                            variant="outlined"
                            size="small"
                        />
                    </FormControl>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenUpdatePaymentModel(false)} variant="outlined" color="primary">Cancel</Button>
                    <Button onClick={() => updateCustomerPayment()} disabled={paymentUpdateForm.paymentAmount === "" || paymentUpdateForm.paymentAttachement === ""} variant="contained" color="primary">Update Payment</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openNoDialog} onClose={() => setOpenNoDialog(false)}>
                <DialogTitle>Lead Details</DialogTitle>
                <Divider />
                <DialogContent>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th" scope="row">Sales Won Date</TableCell>
                                <TableCell>
                                    <FormControl fullWidth style={{ marginTop: 20 }}>
                                        <TextField
                                            id="SalesWon-Date"
                                            name="SalesWonDate"
                                            onChange={(e) => setNewsalesWonDate(e.target.value)}
                                            label="Select Sales Won Date"
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            inputProps={{
                                                min: moment(new Date()).format('YYYY-MM-DD'),
                                                max: moment().endOf('month').format('YYYY-MM-DD'),
                                                onKeyDown: (e) => e.preventDefault()
                        }}
                                            variant="outlined"
                                            size="small"
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Payment Received</TableCell>
                                <TableCell>
                                    <FormControl fullWidth>
                                        <TextField
                                            style={{ margin: '1.1rem' }}
                                            id="paymentAmount-design"
                                            name="paymentAmount"
                                            value={totalAmount}
                                            label="Payment Received"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            disabled
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Quotation</TableCell>
                                <TableCell>
                                    <Button
                                        onClick={handleClickSalesOpenDialog}
                                        variant="contained"
                                        color="primary"
                                        disabled={
                                            projectDetails.salesLeadOwnRole === 'SalesUser' ||
                                            projectDetails.salesLeadOwnRole === 'SalesManager' ||
                                            userDetails.roles.some(role => role.name === ROLENAME.CenterHead)
                                        }
                                    >
                                        Select Quotation
                                    </Button>
                                    {" "}
                                    <span>{projectDetails?.version}</span>

                                    <Dialog open={openSalesDialog} onClose={handleSalesCloseDialog}>
                                        <DialogTitle>Quotation Details</DialogTitle>
                                        <DialogContent>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Version</TableCell>
                                                        <TableCell>Created Date</TableCell>
                                                        <TableCell>Created By</TableCell>
                                                        <TableCell>Total Customer OutFlow</TableCell>
                                                        <TableCell>Select Quotation</TableCell>
                                                    </TableRow>

                                                    {storeSalesQuotation.map((quotation, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{quotation.version}</TableCell>
                                                            <TableCell>{moment(quotation.createdAt).format('YYYY-MM-DD')}</TableCell>
                                                            <TableCell>{quotation?.createdBy?.name}</TableCell>
                                                            <TableCell>{quotation.totalCustomerOutflow}</TableCell>
                                                            <TableCell>
                                                                <Checkbox
                                                                    checked={projectDetails.version === quotation.version}
                                                                    onChange={(event) => handleCheckboxChangeSales(event, quotation)}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleSalesCloseDialog}>Close</Button>
                                        </DialogActions>
                                    </Dialog>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">% Amount Paid</TableCell>
                                <TableCell>
                                    <FormControl fullWidth>
                                        <TextField
                                            style={{ margin: '1.1rem' }}
                                            id="percent-amount-paid"
                                            name="percentAmountPaid"
                                            value={((totalAmount / projectDetails?.grandTotal) * 100).toFixed(2)} // Calculate the percentage
                                            label="% Amount Paid"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            type="number"
                                            variant="outlined"
                                            size="small"
                                            disabled
                                        />
                                    </FormControl>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell component="th" scope="row">Payment Attachment</TableCell>
                                <TableCell>
                                    <FormControl fullWidth>
                                        <Box display="flex" alignItems="center">
                                            <input
                                                accept="*"
                                                className={classes.input}
                                                id="PaymentAttachement-document"
                                                onChange={(e) => uploadWDFileDocument(e, 'salesPaymentSlip')}
                                                type="file"
                                                style={{ display: 'none' }}
                                            />
                                            <label htmlFor="PaymentAttachement-document">
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    style={{ background: "#716ACA", marginBottom: "1rem", marginRight: "1rem" }}
                                                    component="span"
                                                >
                                                    Upload Payment Attachment
                                                </Button>
                                            </label>
                                            {checkForSales && (
                                                <CheckCircleIcon
                                                    style={{ color: "green", marginLeft: "0.5rem" }}
                                                />
                                            )}
                                        </Box>
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        onClick={() => setSalesWonDate()}
                        variant="contained"
                        color="primary"
                        disabled={clicked || newsalesWonDate === "" || newPaymentSlip === "" || projectDetails.version === ""}
                    >
                        Update
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={newModals} onClose={() => setNewModal(false)} aria-labelledby="form-dialog-title" maxWidth='lg'>
                <DialogTitle id="form-dialog-title">Approved Payments By Finance Manager</DialogTitle>
                <Divider />
                <DialogContent>
                    {paymentProof.map((el, i) => {
                        return (
                            <>
                                <TableCell >Proof {i + 1}<DownloadOutlined onClick={() => window.open(el?.paymentImageUrl)} /></TableCell>
                            </>)
                    })
                    }
                </DialogContent>
                <Divider />
                <DialogActions>
                </DialogActions>
            </Dialog>
            {/* Assign Lead To Sales Manager Modal */}
            {/* <Dialog open={openSalesManagerModal} onClose={() => setOpenSalesManagerModal(false)} aria-labelledby="form-dialog-title" maxWidth='sm'>
                <DialogTitle id="form-dialog-title">Assign Lead to Sales Manager</DialogTitle>
                <Divider />
                <DialogContent>
                    <div style={{ paddingBottom: 15, paddingTop: 20 }}>
                        <FormControl fullWidth >
                            <TextField
                                id="outlined-select-currency"
                                select
                                label="Select Sales Manager"
                                name="salesManager"
                                onChange={(e) => getSelectedSalesManagerDetail(e)}
                                variant="outlined"
                            >
                                {
                                    salesManagerList?.map((data, i) => (
                                        <MenuItem value={data._id} key={i + 1}>{data.name}</MenuItem>
                                    ))
                                }
                            </TextField>
                        </FormControl>
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => setOpenSalesManagerModal(false)} variant="outlined" color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={assignLeadToSalesManager} variant="contained" color="primary">
                        Assign Manager
                    </Button>
                </DialogActions>
            </Dialog> */}

            {/* <Dialog open={openCheckListModal} onClose={() => setOpenCheckListModal(false)} aria-labelledby="form-dialog-title" maxWidth='lg'>
                <DialogTitle id="form-dialog-title">Fill the Checklist</DialogTitle>
                <Divider />
                <DialogContent>
                    <div style={{ paddingBottom: 15 }}>
                        <FormControl fullWidth style={{ marginBottom: "15px" }}>
                            <TextField
                                id="standard-multiline-static"
                                label="Remark"
                                multiline
                                rows={4}
                                placeholder="Enter Remark"
                                value={remark}
                                onChange={(e) => setRemark(e.target.value)}
                                variant="outlined"
                                size="small"
                            />
                        </FormControl>
                        <FormControl fullWidth style={{ marginBottom: "15px" }}>
                            <TextField
                                id="closure-Date"
                                name={closureDate}
                                onChange={(e) => setClosureDate(e.target.value)}
                                label="Closure date"
                                type="date"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                variant="outlined"
                                size="small"
                            />
                        </FormControl>

                        <FormControl fullWidth style={{ marginBottom: "15px" }}>
                            <TextField
                                id="clientMovein-Date"
                                name={clientMoveinDate}
                                onChange={(e) => setClientMoveinDate(e.target.value)}
                                label="Client Move in Date"
                                type="date"
                                InputLabelProps={{
                                    shrink: true
                                }}
                                variant="outlined"
                                size="small"
                            />
                        </FormControl>
                    </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={() => { setOpenCheckListModal(false); setOpenAnotherDialog(true) }} variant="outlined" color="error">
                        Cancel
                    </Button>
                    <Button onClick={updateLeadCheckList} variant="outlined" color="primary">
                        Update Lead
                    </Button>
                </DialogActions>
            </Dialog> */}

            <Dialog open={cdrModal} onClose={() => { setCDRModal(false); setCDRLogs([]); }} aria-labelledby="form-dialog-title" fullWidth maxWidth='lg' style={{ padding: "10rem" }}>
                <DialogTitle id="form-dialog-title" style={{ textAlign: "center", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {`CDR for Lead No - ${projectDetails?.lead_no}`}
                    <Button
                        onClick={handleDownloadExcel}
                        color="primary"
                        variant="contained"
                        startIcon={<CloudDownloadIcon />}
                        style={{ marginLeft: "10px" }}
                    >
                        Excel
                    </Button>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Table className={classes.table} size="small" aria-label="customized table">
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: "center" }}>Sl. No.</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }}>ERP User</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }}>Role</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }}>Call Type</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }}>Caller Number</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }}>Destination Number</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }}>Call Duration</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }}>Overall Call Status</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }}>Recordings</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }}>Date</StyledTableCell>
                            </StyledTableRow>
                            <TableBody>
                                {cdrLogs?.map((row, i) => (
                                    <StyledTableRow key={i + 1}>
                                        <StyledTableCell style={{ textAlign: "center" }}>{i + 1}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: "center" }}>{row?.user?.name}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: "center" }}>{row?.user?.roles[0].name}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: "center" }}>{callTypeMap[row?.callType]}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: "center" }}>{row?.callerNumber}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: "center" }}>{row?.destinationNumber}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: "center" }}>{row?.conversationDuration ? row.conversationDuration : "NaN"} sec</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: "center" }}>{row?.overallCallStatus}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: "center" }}>
                                            {row.recordingURL ?
                                                <a href={row.recordingURL} target="_blank" rel="noopener noreferrer">🎧 Listen to Recording</a>
                                                : 'No Recordings'}
                                        </StyledTableCell>
                                        <StyledTableCell style={{ textAlign: "center" }}>{row.createdAt ? moment(row.createdAt).format("DD-MM-YYYY") : ''}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </DialogContentText>
                </DialogContent>
            </Dialog>

<Dialog open={callLogsModal} onClose={() => { setCallLogsModal(false); setCallLogs([]) }} aria-labelledby="form-dialog-title" fullWidth maxWidth='lg' style={{ padding: "10rem 10rem 10rem 10rem" }}>
                <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
                    List of Call Logs
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Table className={classes.table} size="small" aria-label="customized table">
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row">S.No.</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row">Call Recording</StyledTableCell>
                                <StyledTableCell style={{ textAlign: "center" }} component="th" scope="row">Date</StyledTableCell>
                            </StyledTableRow>
                            <TableBody>
                                {callLogs.map((row, i) => {
                                    return (
                                        <StyledTableRow key={i + 1}>
                                            <StyledTableCell style={{ textAlign: "center" }}>{i + 1}</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "center" }} component="td" scope="row">
                                                {row.recording_url ? 
                                                    <a href={row.recording_url} target="_blank" rel="noopener noreferrer">Click to Download</a> 
                                                    : 'NA'}
                                            </StyledTableCell>
                                            <StyledTableCell style={{ textAlign: "center" }} component="td" scope="row">{row.createdAt ? moment(row.createdAt).format("DD-MM-YYYY") : ''}</StyledTableCell>  
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </DialogContentText>
                </DialogContent>
            </Dialog>

            <Dialog fullWidth={true} maxWidth={'xl'} open={designKickOffInternalDialog} onClose={() => setDesignKickOffInternalDialog(false)}>
                <div style={{ margin: 'auto' }}>
                    <br />
                    <Typography style={{ textAlign: 'center' }} variant="h5" component="h2"><strong>Internal Design Kickoff Checklist</strong></Typography>
                    <br />
                    {/* Common Details Section */}
                    <Paper>
                        <Card className={classes.root} variant="outlined">
                            <CardContent>
                                <TableContainer component={Paper} style={{ width: '100%' }}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableBody>
                                            <TableRow key='0'>
                                                <TableCell component="th" scope="row">Date of Internal Kick-off </TableCell>
                                                <TableCell>
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            // style={{ margin: '10px' }}
                                                            id="dateOfInternalKickOffMeeting"
                                                            name="dateOfInternalKickOffMeeting"
                                                            value={checklistDateValue('dateOfInternalKickOffMeeting', projectDetails?.dateOfInternalKickOffMeeting)}
                                                            onChange={(e) => handleDesignerMomChanges(e)}
                                                            // label="Possesion Date"
                                                            type="date"
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true
                                                            }}
                                                            size="small"
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='1'>
                                                <TableCell component="th" scope="row">Client Name </TableCell>
                                                <TableCell>
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            // style={{ margin: '10px' }}
                                                            id="clientName"
                                                            name="clientName"
                                                            value={designerMomChecklistData?.clientName || projectDetails?.customerId?.name}
                                                            onChange={(e) => handleDesignerMomChanges(e)}
                                                            // label="Possesion Date"
                                                            type="text"
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true
                                                            }}
                                                            size="small"
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='2'>
                                                <TableCell component="th" scope="row">Apartment Name</TableCell>
                                                <TableCell>
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField onChange={e => handleDesignerMomChanges(e)} size="small" id="outlined-basic" value={designerMomChecklistData?.apartmentName || projectDetails?.customerId?.address} variant="outlined" name="apartmentName" type='text' />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='2a'>
                                                <TableCell component="th" scope="row">Designer Name</TableCell>
                                                <TableCell component="th" scope="row">{projectDetails?.designUser?.name}</TableCell>
                                            </TableRow>
                                            <TableRow key='3'>
                                                <TableCell component="th" scope="row">Sales Owner Name</TableCell>
                                                <TableCell component="th" scope="row">{projectDetails?.salesWonUserName}</TableCell>
                                            </TableRow>
                                            <TableRow key='4'>
                                                <TableCell component="th" scope="row">Date of Designer Assigned</TableCell>
                                                <TableCell component="th" scope="row">{moment(projectDetails?.designerAssignedDate).format('DD-MM-YYYY')}</TableCell>
                                            </TableRow>
                                            {/* <TableRow key='7'>
                                            <TableCell component="th" scope="row">Date of kick off meeting</TableCell>
                                            <TableCell component="th" scope="row">
                                              <FormControl style={{ width: 300 }}>
                                                    <TextField
                                                        // style={{ margin: '10px' }}
                                                        id="dateOfKickOffMeeting"
                                                        name="dateOfKickOffMeeting"
                                                        value={designerMomChecklistData.dateOfKickOffMeeting}
                                                        onChange={(e) => handleDesignerMomChanges(e)}
                                                        // label="Date of kick off meeting"
                                                        type="date"
                                                        variant="outlined"
                                                        InputLabelProps={{
                                                          shrink: true
                                                      }}
                                                      size="small"
                                                        
                                                    />
                                              </FormControl>
                                              </TableCell>
                                        </TableRow> */}
                                            <TableRow key='5'>
                                                <TableCell component="th" scope="row">Possesion Date</TableCell>
                                                <TableCell>{moment(projectDetails?.possessionDate).format('DD-MM-YYYY')}</TableCell>
                                            </TableRow>
                                            <TableRow key='6'>
                                                <TableCell component="th" scope="row"> Move - in Date</TableCell>
                                                <TableCell>{moment(projectDetails?.designerAssignedDate).format('YYYY-MM-DD')}</TableCell>
                                            </TableRow>
                                            <TableRow key='7'>
                                                <TableCell component="th" scope="row">Internal Design Kick-Off Meeting Date </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            // style={{ margin: '10px' }}
                                                            id="dateOfKickOffMeeting"
                                                            name="dateOfKickOffMeeting"
                                                            value={checklistDateValue('dateOfKickOffMeeting', projectDetails?.dateOfKickOffMeeting)}
                                                            onChange={(e) => handleDesignerMomChanges(e)}
                                                            // label="Date of kick off meeting"
                                                            type="date"
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true
                                                            }}
                                                            size="small"
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='8'>
                                                <TableCell component="th" scope="row">
                                                    If possession date is more than 3 months from the designer assign date,
                                                    design meetings will be taken for an hour in a week. Has this been informed
                                                    to the client?
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="informedClient"
                                                            name="informedClient"
                                                            value={designerMomChecklistData?.informedClient}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                             {/* <TextField
                                                id="internalKickOffRemarks"
                                                name="internalKickOffRemarks"
                                                label="Remarks"
                                                value={designerMomChecklistData?.internalKickOffRemarks}
                                                onChange={handleDesignerMomChanges}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                size="small"
                                            /> */}
                                         </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    </Paper>
                    <br />
                    {/* Client Informations Section */}
                    <br />
                    <Paper>
                        <Card className={classes.root} variant="outlined">
                            <CardContent>
                                <TableContainer component={Paper} className={classes.container}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ textAlign: 'left', fontWeight: 700, fontSize: 20, width: 1000 }}>Client Informations</TableCell>
                                                <TableCell colSpan={2} style={{ textAlign: 'center', fontWeight: 700 }}></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow key='0'>
                                                <TableCell component="th" scope="row">
                                                   Floor Plan Uploaded on ERP Is acknowledged by the customer
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="floorPlanShared"
                                                            name="floorPlanShared"
                                                            value={designerMomChecklistData?.floorPlanShared}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='1'>
                                                <TableCell component="th" scope="row">
                                                    Reference Images Received from Sales team
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="refImg"
                                                            name="refImg"
                                                            value={designerMomChecklistData?.refImg}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                             <TableRow key='1a'>
                                                <TableCell component="th" scope="row">
                                                    Any Deviation in the Quote based on the Reference Images
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="quoteDeviation"
                                                            name="quoteDeviation"
                                                            value={designerMomChecklistData?.quoteDeviation}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TextField
                                                id="clientInformationsRemarks"
                                                name="clientInformationsRemarks"
                                                label="Remarks"
                                                value={designerMomChecklistData?.clientInformationsRemarks}
                                                onChange={handleDesignerMomChanges}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                size="small"
                                            />
                                            <TableRow key='2'>
                                                <TableCell component="th" scope="row">
                                                   Percentage of the Payment Recorded in ERP
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="paymentScreenshot"
                                                            name="paymentScreenshot"
                                                            value={designerMomChecklistData?.paymentScreenshot}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="5%" control={<Radio />} label="5%" />
                                                            <FormControlLabel value="10%" control={<Radio />} label="10%" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                             <TableRow key='3'>
                                                <TableCell component="th" scope="row">
                                                    Any Discrepancy on Discount Agreed v/s Present in Quotation
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="quoteDiscount"
                                                            name="quoteDiscount"
                                                            value={designerMomChecklistData?.quoteDiscount}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            {/* <TableRow key='3'>
                                                <TableCell component="th" scope="row">Checklist Remarks</TableCell>
                                                <TableCell component="th" scope="row">{projectDetails?.checkListRemarkBySalesUser ? projectDetails.checkListRemarkBySalesUser : "NA"} </TableCell>
                                            </TableRow> */}
                                            <TableRow key='5'>
                                                <TableCell component="th" scope="row">Family details - Decision makers </TableCell>
                                                <TableCell>
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            id="familyDetails"
                                                            name="familyDetails"
                                                        value={designerMomChecklistData?.familyDetails}
                                                        onChange={e => handleDesignerMomChanges(e)} size="small" variant="outlined" type='text' />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='5a'>
                                                <TableCell component="th" scope="row">Deviation in Quotation Percentage Conveyed to Customer by Sales Team </TableCell>
                                                <TableCell>
                                                    <FormControl style={{ width: 300 }}>
                                                        <TextField
                                                            value={designerMomChecklistData?.deviationSalesTeam}
                                                        onChange={e => handleDesignerMomChanges(e)} size="small" id="deviationSalesTeam" variant="outlined" name="deviationSalesTeam" type='text' />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='5b'>
                                                <TableCell component="th" scope="row">
                                                    Sales Team Conveyed - Design Final Quote to be lesser Than Sales Quotation Min of 5-10% Deviation : Okay to increase the quotation as per design : 
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="salesDesignDeviation"
                                                            name="salesDesignDeviation"
                                                            value={designerMomChecklistData?.salesDesignDeviation}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            {/* <TableRow key='6'>
                                                <TableCell component="th" scope="row">
                                                    Is Client
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="budgetInfo"
                                                            name="budgetInfo"
                                                            value={designerMomChecklistData?.budgetInfo}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Budget constraint" control={<Radio />} label="Budget constraint " />
                                                            <FormControlLabel value="Flexible" control={<Radio />} label="Flexible" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow> */}
                                            
                                            <TableRow key='7'>
                                                <TableCell component="th" scope="row">
                                                    Client Availability
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="clientAvailability"
                                                            name="clientAvailability"
                                                            value={designerMomChecklistData?.clientAvailability}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Virtual" control={<Radio />} label="Virtual" />
                                                            <FormControlLabel value="Face 2 Face" control={<Radio />} label="Face 2 Face" />
                                                            <FormControlLabel value="Weekends Specific" control={<Radio />} label="Weekends Specific" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='8'>
                                                <TableCell component="th" scope="row">
                                                    Any specific design/ material has been liked by the client from EC/ others?
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="specification"
                                                            name="specification"
                                                            value={designerMomChecklistData?.specification}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>

                                             <TextField
                                                id="ECspecificationRemarks"
                                                name="ECspecificationRemarks"
                                                label="Remarks"
                                                value={designerMomChecklistData?.ECspecificationRemarks}
                                                onChange={handleDesignerMomChanges}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                size="small"
                                            />

                                            <TableRow key='8a'>
                                                <TableCell component="th" scope="row">
                                                    Any specific commitment made to client w.r.t scheduling design meeting's post 8pm or on Sunday's ? 
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="scheduleCommitment"
                                                            name="scheduleCommitment"
                                                            value={designerMomChecklistData?.scheduleCommitment}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TextField
                                                id="specificationRemarks"
                                                name="specificationRemarks"
                                                label="Remarks"
                                                value={designerMomChecklistData?.specificationRemarks}
                                                onChange={handleDesignerMomChanges}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                size="small"
                                            />
                                            <TableRow key='9'>
                                                <TableCell component="th" scope="row">Any specific requirment on design/ finishes/ materials that a client is looking forward for  </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="requirementSpecification"
                                                            name="requirementSpecification"
                                                            value={designerMomChecklistData?.requirementSpecification}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TextField
                                                id="requirementSpecificRemarks"
                                                name="requirementSpecificRemarks"
                                                label="Remarks"
                                                value={designerMomChecklistData?.requirementSpecificRemarks}
                                                onChange={handleDesignerMomChanges}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                size="small"
                                            />
                                            <TextField
                                                id="notesClientInformation"
                                                name="notesClientInformation"
                                                label="Notes/Remarks If Any"
                                                value={designerMomChecklistData?.notesClientInformation}
                                                onChange={handleDesignerMomChanges}
                                                variant="outlined"
                                                fullWidth
                                                margin="normal"
                                                size="small"
                                            />
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    </Paper>
                    <br />
                    {/* Standards Section */}
                    <Paper>
                        <Card className={classes.root} variant="outlined">
                            <CardContent component={Paper}>
                                <Table className={classes.table} stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ textAlign: 'left', fontWeight: 700, fontSize: 20, width: 1000 }}>Sales Team Informations</TableCell>
                                            <TableCell colSpan={2} style={{ textAlign: 'center', fontWeight: 700 }}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow key='0'>
                                            <TableCell component="th" scope="row">
                                                Site visit done by the team
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="siteVisitInfo"
                                                        name="siteVisitInfo"
                                                        value={designerMomChecklistData?.siteVisitInfo}
                                                        onChange={handleDesignerMomChanges}
                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key='1'>
                                            <TableCell component="th" scope="row">
                                                Furniture Placement Discussed During Sales Closure
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="furnitureboolean"
                                                        name="furnitureboolean"
                                                        value={designerMomChecklistData?.furnitureboolean}
                                                        onChange={handleDesignerMomChanges}
                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                         <TableRow key='1a'>
                                            <TableCell component="th" scope="row">
                                                If DP Scope. Room Wise False Ceiling Calculation in Quotation(View Quotation Tab on ERP & Not PDF File) 
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="quoteFalseCeiling"
                                                        name="quoteFalseCeiling"
                                                        value={designerMomChecklistData?.quoteFalseCeiling}
                                                        onChange={handleDesignerMomChanges}
                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key='1b'>
                                            <TableCell component="th" scope="row">
                                                Room Wise Soft Close Hinge and Channels in Quotation (If DP Scope)
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="hingeScope"
                                                        name="hingeScope"
                                                        value={designerMomChecklistData?.hingeScope}
                                                        onChange={handleDesignerMomChanges}
                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                           <TableRow key='1c'>
                                            <TableCell component="th" scope="row">
                                                Painting Calculation as per Formula (ie, Built-Up Area x 2)
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="paintFormula"
                                                        name="paintFormula"
                                                        value={designerMomChecklistData?.paintFormula}
                                                        onChange={handleDesignerMomChanges}
                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow key='2'>
                                            <TableCell component="th" scope="row">
                                                Project timelines post Design Sign-off as per ERP agreed by CRM
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <FormControl component="fieldset" style={{ marginBottom: '20px' }}>
                                                            <RadioGroup
                                                                aria-label="timelineBoolean"
                                                                name="timelineBoolean"
                                                                value={designerMomChecklistData?.timelineBoolean}
                                                                onChange={handleDesignerMomChanges}
                                                                style={{ display: 'flex', flexDirection: 'row' }} // Align Yes/No horizontally
                                                            >
                                                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                                <FormControlLabel value="No" control={<Radio />} label="No" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                        <FormControl component="fieldset">
                                                            <RadioGroup
                                                                aria-label="timelineDays"
                                                                name="timelineDays"
                                                                value={designerMomChecklistData?.timelineDays}
                                                                onChange={handleDesignerMomChanges}
                                                                style={{ display: 'flex', flexDirection: 'row' }} // Align 45/60 Days horizontally
                                                            >
                                                                <FormControlLabel value="45 Days" control={<Radio />} label="45 Days" />
                                                                <FormControlLabel value="60 Days" control={<Radio />} label="60 Days" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </div>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>

                                        <TableRow key='3'>
                                            <TableCell component="th" scope="row">
                                                Any external vendor or Services provided
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="vendorinfo"
                                                        name="vendorinfo"
                                                        value={designerMomChecklistData?.vendorinfo}
                                                        onChange={handleDesignerMomChanges}
                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TextField
                                            id="vendorRemarks"
                                            name="vendorRemarks"
                                            label="Remarks"
                                            value={designerMomChecklistData?.vendorRemarks}
                                            onChange={handleDesignerMomChanges}
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                        />
                                        <TableRow key='4'>
                                            <TableCell component="th" scope="row">
                                              Any Complimentary Items apart from items mentioned on ERP
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="complimentaryBoolean"
                                                        name="complimentaryBoolean"
                                                        value={designerMomChecklistData?.complimentaryBoolean}
                                                        onChange={handleDesignerMomChanges}
                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TextField
                                            id="complimentoryRemarks"
                                            name="complimentoryRemarks"
                                            label="Remarks"
                                            value={designerMomChecklistData?.complimentoryRemarks}
                                            onChange={handleDesignerMomChanges}
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                        />
                                        <TableRow key='5'>
                                            <TableCell component="th" scope="row">
                                                Any Approvals from Sales Manager/Center Head
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="approvalInfo"
                                                        name="approvalInfo"
                                                        value={designerMomChecklistData?.approvalInfo}
                                                        onChange={handleDesignerMomChanges}
                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TextField
                                            id="approvalRemarks"
                                            name="approvalRemarks"
                                            label="Remarks"
                                            value={designerMomChecklistData?.approvalRemarks}
                                            onChange={handleDesignerMomChanges}
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                        />
                                        <TableRow key='6'>
                                            <TableCell component="th" scope="row">
                                                Any Approvals In term for Designs (Non-Standard)
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="designapprovalInfo"
                                                        name="designapprovalInfo"
                                                        value={designerMomChecklistData?.designapprovalInfo}
                                                        onChange={handleDesignerMomChanges}
                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TextField
                                            id="designApprovalRemarks"
                                            name="designApprovalRemarks"
                                            label="Remarks"
                                            value={designerMomChecklistData?.designApprovalRemarks}
                                            onChange={handleDesignerMomChanges}
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                        />
                                        <TableRow key='7'>
                                            <TableCell component="th" scope="row">
                                                Any approvals on mail, has design team been looped?
                                            </TableCell>
                                            <TableCell component="th" scope="row">
                                                <FormControl component="fieldset">
                                                    <FormLabel component="legend"></FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="mailApprovalInfo"
                                                        name="mailApprovalInfo"
                                                        value={designerMomChecklistData?.mailApprovalInfo}
                                                        onChange={handleDesignerMomChanges}
                                                    >
                                                        <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                        <FormControlLabel value="No" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </TableCell>
                                        </TableRow>
                                        <TextField
                                            id="mailApprovalRemarks"
                                            name="mailApprovalRemarks"
                                            label="Remarks"
                                            value={designerMomChecklistData?.mailApprovalRemarks}
                                            onChange={handleDesignerMomChanges}
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                        />
                                        
                                        {/* <TextField
                                            id="cashApprovalRemarks"
                                            name="cashApprovalRemarks"
                                            label="Remarks"
                                            value={designerMomChecklistData?.cashApprovalRemarks}
                                            onChange={handleDesignerMomChanges}
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                        /> */}
                                        <TextField
                                            id="salesTeamInfoNotes"
                                            name="salesTeamInfoNotes"
                                            label="Notes/Remarks If Any"
                                            value={designerMomChecklistData?.salesTeamInfoNotes}
                                            onChange={handleDesignerMomChanges}
                                            variant="outlined"
                                            fullWidth
                                            margin="normal"
                                            size="small"
                                        />
                                    </TableBody>
                                </Table>
                            </CardContent>
                        </Card>
                    </Paper>
                    <br />

                       <Paper>
                        <Card className={classes.root} variant="outlined">
                            <CardContent>
                                <TableContainer component={Paper} className={classes.container}></TableContainer>

                            <TableRow key='1ps'>
                                <TableCell component="th" scope="row">
                                    Internal Kick Off Meeting along with 3D Sketchup Model as per the Sales Quote(View Quotation Tab on ERP & Not PDF File) :      </TableCell>
                                <TableCell component="th" scope="row">
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend"></FormLabel>
                                        <RadioGroup
                                            row
                                            aria-label="cashApprovalInfo"
                                            name="cashApprovalInfo"
                                            value={designerMomChecklistData?.cashApprovalInfo}
                                            onChange={handleDesignerMomChanges}
                                        >
                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                        </RadioGroup>
                                    </FormControl>
                                </TableCell>
                            </TableRow>
                                            </CardContent>
                    </Card>
            </Paper>
                      
                    {/* False-ceiling Section */}
                    <br />
                    <Paper>
                        <Card className={classes.root} variant="outlined">
                            <CardContent>
                                <TableContainer component={Paper} className={classes.container}>
                                    <Table className={classes.table} stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ textAlign: 'left', fontWeight: 700, fontSize: 20, width: 1000 }}>Decorpot Offerings</TableCell>
                                                <TableCell colSpan={2} style={{ textAlign: 'center', fontWeight: 700 }}></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow key='0'>
                                                <TableCell component="th" scope="row">
                                                     Offering in term for Plywood/Materials Finishes
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="stdOfferingInfo"
                                                            name="stdOfferingInfo"
                                                            value={designerMomChecklistData?.stdOfferingInfo}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='1'>
                                                <TableCell component="th" scope="row">
                                                     Offering in term for Handles/Hardwares
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="stdHandles"
                                                            name="stdHandles"
                                                            value={designerMomChecklistData?.stdHandles}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                             <TableRow key='1a'>
                                                <TableCell component="th" scope="row">
                                                    Is loft included in quotation? If yes, has the difference been clearly communicated ?
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="loftCheck"
                                                            name="loftCheck"
                                                            value={designerMomChecklistData?.loftCheck}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                             <TableRow key='1a'>
                                                <TableCell component="th" scope="row">
                                                    Is extended loft / loft as box included in quotation? If yes, has the difference been clearly communicated ?
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="extendedLoftCheck"
                                                            name="extendedLoftCheck"
                                                            value={designerMomChecklistData?.extendedLoftCheck}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            
                                            <TableRow key='2'>
                                                <TableCell component="th" scope="row">
                                                    Services are Mandatory to Avail/ Any Approvals
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="servicesApproval"
                                                            name="servicesApproval"
                                                            value={designerMomChecklistData?.servicesApproval}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key='3'>
                                                <TableCell component="th" scope="row">
                                                    Payment terms & Mode explained
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <FormControl component="fieldset">
                                                        <FormLabel component="legend"></FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-label="paymentTermsBoolean"
                                                            name="paymentTermsBoolean"
                                                            value={designerMomChecklistData?.paymentTermsBoolean}
                                                            onChange={handleDesignerMomChanges}
                                                        >
                                                            <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                                            <FormControlLabel value="No" control={<Radio />} label="No" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>

                                            <TextField id="standardOfferingsNotes" name="standardOfferingsNotes" label="Notes/Remarks If Any" value={designerMomChecklistData?.standardOfferingsNotes} onChange={handleDesignerMomChanges} variant="outlined" fullWidth margin="normal" size="small" />


                                            <TableRow>
                                                <TableCell colSpan={2}>
                                                    <Typography variant="body2">
                                                        1. Signing off this document is an agreement between SE & Designer to
                                                        be aligned on customer requirements and understanding of the sales
                                                        quotation.
                                                    </Typography>
                                                    <Typography variant="body2" mt={1}>
                                                        2. All necessary approvals and documentation have been received to
                                                        proceed before signing below.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>

                                            <TableRow>
                                                <TableCell>
                                                    <Box display="flex" justifyContent="space-between">
                                                        <Typography variant="body2">
                                                            Designer Signature
                                                        </Typography>
                                                        <Typography variant="body2">
                                                            Sales CRM Signature
                                                        </Typography>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>


                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    </Paper>
                    <br />
                    <DialogActions>
                    
                        <Button
                            onClick={(e) => handleDesignKickOffInternalDesignMomSubmit(e)}
                            variant="contained"
                            color="primary"
                            //    disabled={designerMomChecklistData.}
                            style={{ marginRight: 10 }}
                        >
                            Submit
                        </Button>
                        <Button
                            onClick={(e) => setDesignKickOffInternalDialog(false)}
                            variant="outlined"
                            color="primary"
                            disabled={false}
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                    <br />         
                </div>
            </Dialog>


            <Dialog open={cancelLinkIsModalOpen} onClose={()=>{
                setCancelLinkIsModalOpen(false)
            }} maxWidth="sm" fullWidth>
            <DialogContent>
            {
                allPaymentLink && allPaymentLink?.extractedLinks?.length > 0 ? (
                    allPaymentLink.extractedLinks.map((ele, index) => (
                        <Box
                        key={index}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center", // keeps button aligned
                            borderBottom: "2px solid #F47E46",
                            paddingBottom: "5px",
                            marginBottom: "5px",
                            gap: 2, // adds some space between text and button
                        }}
                        >
                        {/* URL Box */}
                        <Box
                            sx={{
                            flex: 1,                 // take up remaining space
                            maxWidth: "calc(100% - 120px)", // leave space for button
                            whiteSpace: "normal",    // allow wrapping
                            wordBreak: "break-all",  // break long URLs if needed
                            }}
                        >
                            {ele?.link_url}
                        </Box>

                        {/* Cancel Button */}
                        <Button
                            onClick={() => cancelPaymentLinkHandle(ele?.link_id, ele?.link_url,ele?.merchantOrderId)}
                            sx={{ fontSize: "12px", width: "100px", height: "36px" }}
                            color="secondary"
                            variant="contained"
                        >
                            Cancel
                        </Button>
                        </Box>

                    ))
                ) : (
                    <Box>Not found</Box>
                )
            }


            </DialogContent>
            <DialogActions>
                <Button style={{fontSize:"12px"}} onClick={()=>{
                    setCancelLinkIsModalOpen(false)
                }} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
        
        {/* This is for move stages. */}
            <Dialog open={openDwgDialog} onClose={handleCloseDwgDialog} maxWidth="sm" fullWidth>
                <DialogTitle>Move the Drawing QC Stages QC-1 and QC-2</DialogTitle>
                
                <FormControl   style={{ margin: "10px", width: "50%", marginBottom: "15px", minWidth: 150 }} variant="outlined" size="small">
                    <InputLabel id="demo-simple-select-label_qc_dwg">Select QC Sub Stages</InputLabel>
                    <Select
                        labelId="demo-simple-select-label_qc_dwg"
                        id="demo-simple-select_qc_dwg"
                        // value={department}
                        label="Select Drawing QC Stages"
                        onChange={handleSelectedQCStages}
                        variant="outlined"
                        size="small"
                    >
                        <MenuItem
                        value="QC1 Completed"
                        disabled={!(projectDetails?.drawingQcAdmApproved && !projectDetails?.drawingQcOneApproved)}
                        >
                        QC1 Completed
                        </MenuItem>
                        <MenuItem
                        value="QC2 Correction Needed"
                        disabled={!(projectDetails?.drawingQcOneApproved && !projectDetails?.drawingQcTwoApproved)}
                        >
                        QC2 Correction Needed
                        </MenuItem>
                        <MenuItem
                        value="QC2 Completed"
                        disabled={!(projectDetails?.drawingQcOneApproved && !projectDetails?.drawingQcTwoApproved)}
                        >
                        QC2 Completed
                        </MenuItem>
                    </Select>
                </FormControl>
                <TextField
                    label="Remarks"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    style={{ margin: "10px", width: "90%", marginBottom: "20px" }}
                    onChange={(e) => setDwgRemarks(e.target.value)} 
                    value={dwgRemarks} 
                />
                <DialogContent dividers>
                    <>
                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                            <>
                                <input
                                    className={classes.input}
                                    id="contained-button-file1"
                                    multiple
                                    type="file"
                                    onChange={addDwgSkpMultipleFile}
                                    style={{ display: 'none' }}
                                    name="siteMasking"
                                />
                                <label htmlFor="contained-button-file1" 
                                style={{ 
                                    display: "flex", 
                                    alignItems: "center",  
                                    gap: "10px",           
                                    maxWidth: "fit-content" 
                                }}
                                >
                                    <Button variant="contained" color="primary"
                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }} 
                                        component="span" startIcon={<CloudUploadIcon />}>
                                        Site Masking Documents
                                    </Button>
                                    {siteMaskingDocuments && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                    {Array.isArray(siteMaskingDocumentsLink) && siteMaskingDocumentsLink.length > 0 && (
                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                            <span>({siteMaskingDocumentsLink.length})</span>
                                        </div>
                                    )}
                                </label>
                            </>
                        </FormControl>
                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                            <>
                                <input
                                    className={classes.input}
                                    id="contained-button-file2"
                                    multiple
                                    type="file"
                                    onChange={addDwgSkpMultipleFile}
                                    style={{ display: 'none' }}
                                    name="2dDrawings"
                                />
                                <label htmlFor="contained-button-file2"
                                    style={{ 
                                    display: "flex", 
                                    alignItems: "center",  
                                    gap: "10px",           
                                    maxWidth: "fit-content" 
                                }}
                                >
                                    <Button variant="contained" color="primary"
                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }}
                                        component="span" startIcon={<CloudUploadIcon />}>
                                        2D Drawings
                                    </Button>
                                    {twoDDrawingsFile && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                    {Array.isArray(twoDDrawingsFileLink) && twoDDrawingsFileLink.length > 0 && (
                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                            <span>({twoDDrawingsFileLink.length})</span>
                                        </div>
                                    )}
                                </label>
                            </>
                        </FormControl>
                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                            <>
                                <input
                                    className={classes.input}
                                    id="contained-button-file3"
                                    multiple
                                    type="file"
                                    onChange={addDwgSkpMultipleFile}
                                    style={{ display: 'none' }}
                                    name="sitePhotosVideos"
                                />
                                <label htmlFor="contained-button-file3"
                                style={{ 
                                    display: "flex", 
                                    alignItems: "center",  
                                    gap: "10px",           
                                    maxWidth: "fit-content" 
                                }}
                                >
                                    <Button variant="contained" color="primary"
                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }}
                                        component="span" startIcon={<CloudUploadIcon />}>
                                        Site Photos/Videos
                                    </Button>
                                    {sitePhotosVideosFile && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                    {Array.isArray(sitePhotosVideosFileLink) && sitePhotosVideosFileLink.length > 0 && (
                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                            <span>({sitePhotosVideosFileLink.length})</span>
                                        </div>
                                    )}
                                </label>
                            </>
                        </FormControl>
                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                            <>
                                <input
                                    className={classes.input}
                                    id="contained-button-file4"
                                    multiple
                                    type="file"
                                    onChange={addDwgSkpMultipleFile}
                                    style={{ display: 'none' }}
                                    name="appliancesChecklist"
                                />
                                <label htmlFor="contained-button-file4"
                                style={{ 
                                    display: "flex", 
                                    alignItems: "center",  
                                    gap: "10px",           
                                    maxWidth: "fit-content" 
                                }}
                                >
                                    <Button variant="contained" color="primary"
                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }}
                                        component="span" startIcon={<CloudUploadIcon />}>
                                        Appliances Checklist
                                    </Button>
                                    {appliancesChecklistFile && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                    {Array.isArray(appliancesChecklistFileLink) && appliancesChecklistFileLink.length > 0 && (
                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                            <span>({appliancesChecklistFileLink.length})</span>
                                        </div>
                                    )}
                                </label>
                            </>
                        </FormControl>
                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                            <>
                                <input
                                    className={classes.input}
                                    id="contained-button-file5"
                                    multiple
                                    type="file"
                                    onChange={addDwgSkpMultipleFile}
                                    style={{ display: 'none' }}
                                    name="3dPPT"
                                />
                                <label htmlFor="contained-button-file5"
                                style={{ 
                                    display: "flex", 
                                    alignItems: "center",  
                                    gap: "10px",           
                                    maxWidth: "fit-content" 
                                }}
                                >
                                    <Button variant="contained" color="primary"
                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }}
                                        component="span" startIcon={<CloudUploadIcon />}>
                                        3D PowerPoint (PPT)
                                    </Button>
                                    {powerPointFile && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                    {Array.isArray(powerPointFileLink) && powerPointFileLink.length > 0 && (
                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                            <span>({powerPointFileLink.length})</span>
                                        </div>
                                    )}
                                </label>
                            </>
                        </FormControl>
                        <FormControl style={{ marginLeft: 10, marginRight: 10, marginTop: 20, marginBottom: 10, display: 'block' }}>
                            <>
                                <input
                                    className={classes.input}
                                    id="contained-button-file6"
                                    multiple
                                    type="file"
                                    onChange={addDwgSkpMultipleFile}
                                    style={{ display: 'none' }}
                                    name="Quotation"
                                />
                                <label htmlFor="contained-button-file6"
                                style={{ 
                                    display: "flex", 
                                    alignItems: "center",  
                                    gap: "10px",           
                                    maxWidth: "fit-content" 
                                }}
                                >
                                    <Button variant="contained" color="primary"
                                        style={{ display: "flex", justifyContent: "space-between", minWidth: "250px" }}
                                        component="span" startIcon={<CloudUploadIcon />}>
                                        Quotation
                                    </Button>
                                    {quotationFile && <CheckCircleIcon style={{ color: "green", fontSize: 30 }} />}
                                    {Array.isArray(quotationFileLink) && quotationFileLink.length > 0 && (
                                            <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "bold", }}>
                                                <span>({quotationFileLink.length})</span>
                                            </div>
                                    )}
                                </label>
                            </>
                        </FormControl>
                    </>
                </DialogContent>
                <DialogActions style={{ justifyContent: "flex-end", padding: "16px" }}>
                    <Button onClick={handleCloseDwgDialog} color="secondary" variant="outlined">
                        Cancel
                    </Button>
                    <Button color="primary" variant="contained" style={{ marginLeft: "10px" }}
                    disabled={
                        (
                            !siteMaskingDocuments ||
                            !twoDDrawingsFile ||
                            !sitePhotosVideosFile ||
                            !appliancesChecklistFile ||
                            !powerPointFile ||
                            !quotationFile ||
                            qcStages === '' ||
                            dwgRemarks === ''
                        )
                    }
                    onClick={approvalOrRejctDrawingQc}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
            {/* ADM Modal to display the AdmCheckListPdf */}
            <Dialog open={aDMModalOpen} onClose={handleCloseADMModal} maxWidth="lg" fullWidth>
                <DialogContent>
                    {projectDetails && <DrawingQCLogs projectDetails={projectDetails} />}
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseADMModal} color="primary">
                    Close
                </Button>
                </DialogActions>
            </Dialog>

            {/* This is for Assign Drawing QC Project To Others. */}
            <Dialog open={assignQCModel} onClose={handleCloseAssign} maxWidth="sm" fullWidth>
            <DialogContent>
                <FormControl style={{ width: '100%', marginTop: '0.30rem' }}>
                    <Autocomplete
                        value={selectedUsers}
                        options={usersData}
                        getOptionLabel={(option) => option.name}
                        onChange={(e, val) => setSelectedUsers(val)}
                        renderInput={(params) => <TextField {...params} label="Select QC Users" variant="outlined" />}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseAssign} color="primary">
                    Close
                </Button>
                <Button onClick={assignQcPerson} color="secondary" variant="contained">
                    Assign Project
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog open={openDialogRoleChange} onClose={() => setOpenDialogRoleChange(false)} fullWidth maxWidth="sm">
            <DialogTitle>Reallocate Lead Ownership</DialogTitle>
            <DialogContent dividers>            

                {/* Team Dropdown */}
                {/* <FormControl fullWidth margin="dense">
                    <InputLabel>Select Team</InputLabel>
                    <Select value={selectedTeamForHierarchySet} onChange={(e) => handleTeamSelect(e.target.value)}>
                        {teams.map((t) => (
                            <MenuItem key={t._id} value={t._id}>{t.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl> */}

                {/* Role Dropdowns (only show if team selected) */}
                { (
                   <>
                            {Object.keys(hierarchyOptions).map((roleKey) => (
                                <FormControl fullWidth margin="dense" key={roleKey}>
                                    <InputLabel>
                                        {roleKey === "designManager"
                                            ? "designODM"
                                            : roleKey.replace("sales", "Sales ")
                                        }
                                    </InputLabel>
                                    <Select
                                        value={selectedValues[roleKey]?._id || ""}
                                       
                                        onChange={(e) => {
                                            const user = hierarchyOptions[roleKey].find((u) => u._id === e.target.value);
                                        
                                            const updatedValues = {
                                                ...selectedValues,
                                                [roleKey]: { _id: user._id, name: user.name },
                                            };
                                        
                                            setSelectedValues(updatedValues);
                                        
                                            // If manager changed — filter users
                                            if (
                                                roleKey.endsWith("Manager") &&           
                                                !roleKey.includes("AssistantManager")      
                                              ) {
                                                filterUsersByManager(user._id);
                                              }
                                        }}
                                    >
                                        {(Array.isArray(hierarchyOptions[roleKey]) ? hierarchyOptions[roleKey] : [])
                                            .filter((u) => u && u._id && u.name)
                                            .map((u) => (
                                                <MenuItem key={u._id} value={u._id}>
                                                    {u.name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            ))}
                        </>
                 
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setOpenDialogRoleChange(false)}>Cancel</Button>
                <Button variant="contained" color="primary" onClick={handleSaveOwnership}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>


        {/* Modal for raise the discrepencies */}
        <Dialog
        open={isOpenFlaggedModal}
        onClose={closeHandle}
        maxWidth="sm"
        fullWidth
        >
        <DialogContent>
            <Box style={{ width: "100%", marginTop: "0.5rem" }}>
            <Autocomplete
                value={selectDiscrepancies}
                options={discrepanciesList || []}
                getOptionLabel={(option) => option?.name || ""}
                onChange={(e, val) => setSelectDiscrepancies(val)}
                renderInput={(params) => (
                <TextField
                    {...params}
                    label="Select Discrepancy"
                    variant="outlined"
                    fullWidth
                    size="small"
                />
                )}
            />

           <Box style={{marginTop: "1rem"}}>
            <Autocomplete
            value={selectFlagAssign}
            options={assignToForFlag || []}
            getOptionLabel={(option) => option || ""}
            onChange={(event, newValue) => setSelectFlagAssign(newValue)}
            renderInput={(params) => (
                <TextField
                {...params}
                label="Assign To"
                variant="outlined"
                fullWidth
                size="small"
                />
            )}
            />
           </Box>

            <TextField
                label="Enter Description"
                value={discrepancyDescription}
                onChange={(e) => setDiscrepancyDescription(e.target.value)}
                variant="outlined"
                fullWidth
                margin="normal"
                size="small"
            />
            </Box>

            <Button
            variant="contained"
            component="label"
            fullWidth
            style={{
                backgroundColor: "#355025",
                color: "#FFF2EB",
                marginTop: "10px",
            }}
            >
            <div>
                Upload Attachment
                {flagAttachment?.name && <span>, {flagAttachment.name}</span>}
            </div>
            <input
                type="file"
                hidden
                accept=".png, .jpg, .jpeg, .webp"
                onChange={handleAttachmentImageChange}
            />
            <FormGroup style={{ marginLeft: "10px" }}>
                <FormControlLabel
                control={
                    <Checkbox checked={!!flagAttachment} color="primary" />
                }
                />
            </FormGroup>
            </Button>
        </DialogContent>

        <DialogActions>
            <Button
            onClick={closeHandle}
            color="primary"
            variant="outlined"
            >
            Close
            </Button>
            <Button
            color="secondary"
            variant="contained"
            onClick={createFlaggedproject}
            >
            Submit
            </Button>
        </DialogActions>
        </Dialog>

         <Dialog open={editQtSentMeetingDialog} onClose={handleQtSentMeetingCancel}>
                <DialogTitle>Quotation Sent Meeting Details</DialogTitle>
                <DialogContent>
                    <>
                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                            <InputLabel id="propose_meeting_type">Propose Meeting Type *</InputLabel>
                            <Select
                                labelId="propose_meeting_type"
                                id="propose_meeting_type"
                                value={meetingFixedDetail.proposeMeetingType}
                                label="Propose Meeting Type*"
                                name="proposeMeetingType"
                                onChange={(e) => setMeetingfixedDetail({ ...meetingFixedDetail, proposeMeetingType: e.target.value })}
                                variant="outlined"
                                required
                            >
                                <MenuItem value="Office Meet">Office Meeting</MenuItem>
                                <MenuItem value="Residence Meeting">Residence Meeting</MenuItem>
                            </Select>
                        </FormControl>

                        <TextField
                            fullWidth
                            name="proposeMeetingDate"
                            id="proposeMeetingDate"
                            value={meetingFixedDetail.proposeMeetingDate}
                            onChange={(e) => setMeetingfixedDetail({ ...meetingFixedDetail, proposeMeetingDate: e.target.value })}
                            label="Propose Meeting Date"
                            type="date"
                            InputLabelProps={{
                                shrink: true
                            }}
                            variant="outlined"
                            required
                            size="small"
                            style={{ marginBottom: '15px' }}
                        />

                        <FormControl fullWidth style={{ marginBottom: "15px" }} variant="outlined" size="small">
                            <TextField
                                id="meetingParticipant"
                                label="Meeting Participant*"
                                multiline
                                name="meetingParticipant"
                                rows={2}
                                placeholder="Enter Meeting Participants"
                                value={meetingFixedDetail.meetingParticipant}
                                onChange={(e) => setMeetingfixedDetail({ ...meetingFixedDetail, meetingParticipant: e.target.value })}
                                variant="outlined"
                                size="small"
                            />
                        </FormControl>
                    </>

                </DialogContent>
                <DialogActions>
                    <>
                        <Button onClick={handleQtSentMeetingCancel} variant="contained" color='secondary'>Cancel</Button>
                        <Button onClick={handleQtSentMeetingSubmit} disabled={proposeMeetingType || proposeMeetingDate || meetingParticipant} variant="contained" color='primary'>Submit</Button>
                    </>
                </DialogActions>
            </Dialog>

            <Dialog open={viewQtSentData} onClose={() => setViewQtSentData(false)}>
                <DialogTitle>Quotation Sent Meeting Details</DialogTitle>
                <DialogContent>
                    <TableContainer>
                        <Table className={classes.table} size="small" aria-label="custom pagination table">
                            <TableBody>
                                <TableRow>
                                    <TableCell style={{ textAlign: 'center' }}>Propose Meeting Type</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>{qtSentMeetingData?.proposeMeetingType? qtSentMeetingData?.proposeMeetingType: '-'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ textAlign: 'center' }}>Propose Meeting Date</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>{ qtSentMeetingData?.proposeMeetingDate ? moment(qtSentMeetingData?.proposeMeetingDate).format('DD-MM-YYYY'): '-'}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{ textAlign: 'center' }}>Meeting Participants</TableCell>
                                    <TableCell style={{ textAlign: 'center' }}>{qtSentMeetingData?.meetingParticipant? qtSentMeetingData?.meetingParticipant: '-'}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <>
                        <Button onClick={()=>setViewQtSentData(false)} variant="outlined" size="small" color='secondary'>Cancel</Button>
                    </>
                </DialogActions>
            </Dialog>

            {/* Refund Request Confirmation Dialog */}
            <Dialog
                open={showRefundConfirmDialog}
                onClose={handleRefundConfirmCancel}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    Refund Request Confirmation
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{ textAlign: 'center', fontSize: '16px', marginBottom: '20px' }}>
                        Do you want to raise a refund request?
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center', gap: '10px', paddingBottom: '20px' }}>
                    <Button
                        onClick={handleRefundConfirmYes}
                        variant="contained"
                        color="primary"
                        size="large"
                        style={{ minWidth: '80px' }}
                    >
                        YES
                    </Button>
                    <Button
                        onClick={handleRefundConfirmNo}
                        variant="contained"
                        color="secondary"
                        size="large"
                        style={{ minWidth: '80px' }}
                    >
                        NO
                    </Button>
                    <Button
                        onClick={handleRefundConfirmCancel}
                        variant="outlined"
                        color="default"
                        size="large"
                        style={{ minWidth: '80px' }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Upload Tax Invoices - Finance only */}
        <Dialog
          open={taxInvoiceModalOpen}
          onClose={closeTaxInvoiceModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Upload Tax Invoices</DialogTitle>
          <DialogContent>
            <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 16, marginTop: 6 }}>
              <InputLabel id="tax-invoice-type-label">Tax Invoice Type</InputLabel>
              <Select
                labelId="tax-invoice-type-label"
                label="Tax Invoice Type"
                value={taxInvoiceType}
                onChange={handleTaxInvoiceTypeChange}
                disabled={taxInvoiceTypesLoading}
              >
                {TAX_INVOICE_TYPES.map((option) => (
                  <MenuItem
                    key={option.code}
                    value={option.code}
                    disabled={taxInvoiceUsedTypes.includes(option.code)}
                  >
                    {option.label}{taxInvoiceUsedTypes.includes(option.code) ? ' (already uploaded)' : ''}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={taxInvoiceSendVia.email}
                    onChange={handleTaxInvoiceSendViaChange('email')}
                  />
                }
                label="Share via Email"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={taxInvoiceSendVia.whatsapp}
                    onChange={handleTaxInvoiceSendViaChange('whatsapp')}
                  />
                }
                label="Share via WhatsApp"
                style={{ marginLeft: 16 }}
              />
            </FormGroup>

            {taxInvoiceType && (
              <div style={{ marginTop: 16 }}>
                <input
                  type="file"
                  accept=".pdf"
                  id="tax-invoice-file"
                  style={{ display: 'none' }}
                  onChange={handleTaxInvoiceFileChange}
                />
                <label htmlFor="tax-invoice-file">
                  <Button variant="contained" component="span" color="primary" size="small">
                    Upload PDF
                  </Button>
                </label>
                {taxInvoiceFile && (
                  <span style={{ marginLeft: 10 }}>
                    {taxInvoiceFile.name}
                    <CheckCircleIcon style={{ verticalAlign: 'middle', marginLeft: 6, color: 'green', fontSize: 20 }} />
                  </span>
                )}
                <div style={{ marginTop: 6, fontSize: 12, color: 'gray' }}>Only PDF files up to 5 MB are allowed.</div>

                <TextField
                  label="Remark (optional)"
                  helperText={`Shown in the Email/WhatsApp to the customer only if filled. ${taxInvoiceRemark.length}/500`}
                  fullWidth
                  multiline
                  minRows={2}
                  variant="outlined"
                  size="small"
                  style={{ marginTop: 16 }}
                  value={taxInvoiceRemark}
                  onChange={(e) => setTaxInvoiceRemark(e.target.value)}
                  inputProps={{ maxLength: 500 }}
                />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={submitTaxInvoice}
              color="primary"
              variant="contained"
              disabled={taxInvoiceSubmitting || !taxInvoiceType || !taxInvoiceFile || (!taxInvoiceSendVia.email && !taxInvoiceSendVia.whatsapp)}
            >
              {taxInvoiceSubmitting ? 'Uploading...' : 'Submit'}
            </Button>
            <Button onClick={closeTaxInvoiceModal} color="primary" disabled={taxInvoiceSubmitting}>
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Resend checklist button */}
        <Dialog
          open={checklistResendModal}
          onClose={() => {
            setChecklistResendModal(false); // ✅ close modal properly
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogContent style={{}}>
            Do you want to Resend Hold Approval link to customer?
          </DialogContent>

          <DialogActions>
          <Button
              onClick={() => {
                resendDesignHoldButton()
              }}
              color="primary"
            >
              Yes
            </Button>
            <Button
              onClick={() => {
                setChecklistResendModal(false); // ✅ close on button click
              }}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* AI Design Sign-off Date — Two-phase dialog */}
        <Dialog
            open={aiSignoffState.dialogOpen}
            onClose={() => !aiSignoffState.loading && setAiSignoffState(prev => ({ ...prev, dialogOpen: false }))}
            maxWidth="sm"
            fullWidth
            className={classes.aiDialogOverlay}
            disableEnforceFocus
        >
            <DialogTitle style={{ backgroundColor: '#1C375D', color: '#fff', display: 'flex', alignItems: 'center', gap: 10 }}>
                <EventIcon style={{ fontSize: 24 }} /> AI Design Sign-off Date Extraction
            </DialogTitle>
            <Divider />
            <DialogContent style={{ paddingTop: 20, paddingBottom: 20 }}>
                {/* Loading spinner — same for both phases */}
                {aiSignoffState.loading && (
                    <div style={{ textAlign: 'center', padding: 30 }}>
                        <CircularProgress size={40} />
                        <Typography variant="body1" style={{ marginTop: 15, color: '#555' }}>
                            {aiSignoffState.phase === 'preCheck'
                                ? 'Checking the latest conversation on this lead (Runo calls and Notes)...'
                                : 'Analysing the latest conversation...'}
                        </Typography>
                        <Typography variant="caption" style={{ color: '#999' }}>
                            This may take a few seconds
                        </Typography>
                    </div>
                )}

                {/* ===== PHASE 1: Pre-Check — the latest conversation (Runo call, or a newer note audio) ===== */}
                {!aiSignoffState.loading && aiSignoffState.phase === 'preCheck' && (
                    <AiConversationPreCheckBody
                        state={aiSignoffState}
                        question="Do you want to send this latest conversation for AI analysis to extract the expected design sign-off date?"
                        infoText="We analyse the latest conversation using AI. If it has a discussion related to design sign-off, the date will be extracted automatically."
                    />
                )}

                {/* ===== PHASE 2: Analysis Results ===== */}
                {!aiSignoffState.loading && aiSignoffState.phase === 'analysis' && (
                    <>
                        {/* No conversation found during analysis */}
                        {aiSignoffState.noConversation && (
                            <div style={{
                                padding: 15, borderRadius: 8,
                                backgroundColor: '#fff3e0', border: '1px solid #ffb74d',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <WarningIcon style={{ color: '#e65100', fontSize: 22 }} />
                                    <Typography variant="subtitle1" style={{ color: '#e65100', fontWeight: 700 }}>
                                        No Conversation Found
                                    </Typography>
                                </div>
                                <Typography variant="body2" style={{ marginTop: 8, fontWeight: 600 }}>
                                    <PersonIcon style={{ fontSize: 16, verticalAlign: 'middle', marginRight: 4 }} />
                                    Designer: {aiSignoffState.designerName}
                                </Typography>
                                <Typography variant="body2" style={{ marginTop: 12, color: '#666' }}>
                                    {AI_NO_LEAD_CONVERSATION_MSG}
                                </Typography>
                            </div>
                        )}

                        {/* Error during analysis */}
                        {aiSignoffState.error && (
                            <div style={{
                                padding: 15, borderRadius: 8,
                                backgroundColor: '#ffebee', border: '1px solid #ef9a9a',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <ErrorOutlineIcon style={{ color: '#b71c1c', fontSize: 22 }} />
                                    <Typography variant="subtitle1" style={{ color: '#b71c1c', fontWeight: 700 }}>
                                        {aiSignoffState.analysisFailed ? 'Analysis Failed' : 'Extraction Failed'}
                                    </Typography>
                                </div>
                                <Typography variant="body2" style={{ marginTop: 8 }}>
                                    {aiSignoffState.error}
                                </Typography>
                            </div>
                        )}

                        {/* Analysis result */}
                        {aiSignoffState.result && (
                            <div style={{ padding: 10 }}>
                                {aiSignoffState.result.date_found ? (
                                    <>
                                        <div style={{
                                            padding: 15, borderRadius: 8,
                                            backgroundColor: '#e8f5e9', border: '1px solid #a5d6a7',
                                            marginBottom: 15
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                                                <CheckCircleIcon style={{ color: '#2e7d32', fontSize: 22 }} />
                                                <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                                                    Design Sign-Off Date found from conversation:
                                                </Typography>
                                            </div>
                                            <TextField
                                                type="date"
                                                variant="outlined"
                                                size="small"
                                                value={OCRState.approvalDate || ''}
                                                onChange={(e) => {
                                                    setOCRState(prev => ({ ...prev, approvalDate: e.target.value }));
                                                    setIsEditingDate(true);
                                                }}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                            <Typography variant="caption" style={{ display: 'block', marginTop: 6, color: '#e21111ff', fontWeight: 600 }}>
                                                You can modify the detected date if needed
                                            </Typography>
                                        </div>
                                        <Typography variant="body2" style={{ color: '#444', marginBottom: 8 }}>
                                            <strong>AI Reasoning:</strong> {aiSignoffState.result.reason}
                                        </Typography>
                                        {aiSignoffState.result.source_quote && (
                                            <Typography variant="body2" style={{ color: '#666', fontStyle: 'italic', borderLeft: '3px solid #1C375D', paddingLeft: 10 }}>
                                                "{aiSignoffState.result.source_quote}"
                                            </Typography>
                                        )}
                                        <Typography variant="caption" style={{ display: 'block', marginTop: 10, color: '#999' }}>
                                            Confidence: {Math.round((aiSignoffState.result.confidence || 0) * 100)}%
                                        </Typography>
                                    </>
                                ) : (
                                    <div style={{
                                        padding: 15, borderRadius: 8,
                                        backgroundColor: '#fff8e1', border: '1px solid #ffe082',
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <WarningIcon style={{ color: '#e65100', fontSize: 22 }} />
                                            <Typography variant="subtitle1" style={{ color: '#e65100', fontWeight: 700 }}>
                                                No Date Found
                                            </Typography>
                                        </div>
                                        <Typography variant="body2" style={{ marginTop: 8 }}>
                                            {aiSignoffState.result.reason || 'No date discussion was found in the call transcripts or notes.'}
                                        </Typography>
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}
            </DialogContent>
            <Divider />
            <DialogActions style={{ padding: '12px 20px' }}>
                {/* Pre-check phase: Send for Analysis (only if the latest conversation exists) */}
                {!aiSignoffState.loading && aiSignoffState.phase === 'preCheck' && !aiSignoffState.noConversation && aiSignoffState.hasConversation && !aiSignoffState.preCheckError && (
                    <Button
                        onClick={handleConfirmSignoffAnalysis}
                        variant="contained"
                        color="primary"
                        startIcon={<SendIcon />}
                    >
                        Send for Analysis
                    </Button>
                )}

                {/* Analysis phase: Proceed button (only when date found) */}
                {!aiSignoffState.loading && aiSignoffState.phase === 'analysis' && !aiSignoffState.analysisFailed && aiSignoffState.result?.date_found && (
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<CheckCircleIcon />}
                        onClick={() => {
                            setAiSignoffState(prev => ({ ...prev, dialogOpen: false }));
                            handleDesignSignOffDate();
                        }}
                    >
                        Proceed
                    </Button>
                )}

                {/* Close / Cancel button — always visible */}
                <Button
                    onClick={() => setAiSignoffState(prev => ({ ...prev, dialogOpen: false }))}
                    variant="outlined"
                    color="secondary"
                    disabled={aiSignoffState.loading}
                    startIcon={<CloseIcon />}
                >
                    {aiSignoffState.phase === 'preCheck' && !aiSignoffState.noConversation && aiSignoffState.hasConversation && !aiSignoffState.preCheckError ? 'Cancel' : 'Close'}
                </Button>
            </DialogActions>
        </Dialog>
        {/* ...<<< OCR MODAL HERE...=>>... */}

        {/* AI Design Hold — Pre-check dialog (same pattern as signoff) */}
        <Dialog
            open={designHoldPreCheck.dialogOpen}
            onClose={() => !designHoldPreCheck.loading && handleDesignHoldPreCheckClose()}
            maxWidth="sm"
            fullWidth
            className={classes.aiDialogOverlay}
            disableEnforceFocus
        >
            <DialogTitle style={{ backgroundColor: '#1C375D', color: '#fff', display: 'flex', alignItems: 'center', gap: 10 }}>
                <PauseCircleFilledIcon style={{ fontSize: 24 }} /> Design Hold — AI Verification
            </DialogTitle>
            <Divider />
            <DialogContent style={{ paddingTop: 20, paddingBottom: 20 }}>
                {/* Loading spinner */}
                {designHoldPreCheck.loading && (
                    <div style={{ textAlign: 'center', padding: 30 }}>
                        <CircularProgress size={40} />
                        <Typography variant="body1" style={{ marginTop: 15, color: '#555' }}>
                            {designHoldPreCheck.phase === 'preCheck'
                                ? 'Checking the latest conversation on this lead (Runo calls and Notes)...'
                                : 'Analysing the latest conversation...'}
                        </Typography>
                        <Typography variant="caption" style={{ color: '#999' }}>
                            This may take a few seconds
                        </Typography>
                    </div>
                )}

                {/* ===== PHASE 1: Pre-Check — the latest conversation (Runo call, or a newer note audio) ===== */}
                {!designHoldPreCheck.loading && designHoldPreCheck.phase === 'preCheck' && (
                    <AiConversationPreCheckBody
                        state={designHoldPreCheck}
                        question="Do you want to send this latest conversation for AI analysis before applying Design Hold?"
                        infoText="We analyse the latest conversation using AI. If the AI approves the hold, it is sent directly to the customer for approval."
                    />
                )}

                {/* ===== PHASE 2: Analysis in progress (shown briefly during loading) ===== */}

                {/* ===== PHASE 3: Result ===== */}
                {!designHoldPreCheck.loading && designHoldPreCheck.phase === 'result' && (
                    <>
                        {/* AI Approved */}
                        {designHoldPreCheck.result && designHoldPreCheck.result.approved && (
                            <div style={{
                                padding: 15, borderRadius: 8,
                                backgroundColor: '#e8f5e9', border: '1px solid #a5d6a7',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <CheckCircleIcon style={{ color: '#2e7d32', fontSize: 22 }} />
                                    <Typography variant="subtitle1" style={{ color: '#2e7d32', fontWeight: 700 }}>
                                        Design Hold Approved
                                    </Typography>
                                </div>
                                <Typography variant="body2" style={{ marginTop: 8 }}>
                                    {designHoldPreCheck.result.reason || 'The AI analysis has approved this design hold request.'}
                                </Typography>
                                {designHoldPreCheck.result.suggestion && (
                                    <Typography variant="body2" style={{ marginTop: 8, color: '#666', fontStyle: 'italic', borderLeft: '3px solid #2e7d32', paddingLeft: 10 }}>
                                        <strong>Suggestion:</strong> {designHoldPreCheck.result.suggestion}
                                    </Typography>
                                )}
                                <Typography variant="body2" style={{ marginTop: 12, color: '#444', fontWeight: 600 }}>
                                    Click "Proceed" to send the design hold to the customer for approval.
                                </Typography>
                            </div>
                        )}

                        {/* AI Rejected */}
                        {designHoldPreCheck.result && !designHoldPreCheck.result.approved && (
                            <div style={{
                                padding: 15, borderRadius: 8,
                                backgroundColor: '#ffebee', border: '1px solid #ef9a9a',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <ErrorOutlineIcon style={{ color: '#b71c1c', fontSize: 22 }} />
                                    <Typography variant="subtitle1" style={{ color: '#b71c1c', fontWeight: 700 }}>
                                        Design Hold Rejected
                                    </Typography>
                                </div>
                                <Typography variant="body2" style={{ marginTop: 8 }}>
                                    {designHoldPreCheck.result.reason || 'The AI analysis did not approve this design hold request.'}
                                </Typography>
                                {designHoldPreCheck.result.suggestion && (
                                    <Typography variant="body2" style={{ marginTop: 8, color: '#666', fontStyle: 'italic', borderLeft: '3px solid #b71c1c', paddingLeft: 10 }}>
                                        <strong>Suggestion:</strong> {designHoldPreCheck.result.suggestion}
                                    </Typography>
                                )}
                            </div>
                        )}

                        {/* Error */}
                        {designHoldPreCheck.error && !designHoldPreCheck.result && (
                            <div style={{
                                padding: 15, borderRadius: 8,
                                backgroundColor: '#ffebee', border: '1px solid #ef9a9a',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <ErrorOutlineIcon style={{ color: '#b71c1c', fontSize: 22 }} />
                                    <Typography variant="subtitle1" style={{ color: '#b71c1c', fontWeight: 700 }}>
                                        {designHoldPreCheck.analysisFailed ? 'Analysis Failed' : 'Verification Failed'}
                                    </Typography>
                                </div>
                                <Typography variant="body2" style={{ marginTop: 8 }}>
                                    {designHoldPreCheck.error}
                                </Typography>
                            </div>
                        )}
                    </>
                )}
            </DialogContent>
            <Divider />
            <DialogActions style={{ padding: '12px 20px' }}>
                {/* Pre-check phase: Send for Analysis — only if the latest conversation exists */}
                {!designHoldPreCheck.loading && designHoldPreCheck.phase === 'preCheck' && !designHoldPreCheck.noConversation && designHoldPreCheck.hasConversation && !designHoldPreCheck.preCheckError && (
                    <Button
                        onClick={handleDesignHoldConfirmAndSubmit}
                        variant="contained"
                        color="primary"
                        startIcon={<SendIcon />}
                    >
                        Send for Analysis
                    </Button>
                )}

                {/* Result phase: Proceed — only if approved */}
                {!designHoldPreCheck.loading && designHoldPreCheck.phase === 'result' && !designHoldPreCheck.analysisFailed && designHoldPreCheck.result?.approved && (
                    <Button
                        onClick={handleDesignHoldProceedAfterApproval}
                        variant="contained"
                        color="primary"
                        startIcon={<CheckCircleIcon />}
                    >
                        Proceed
                    </Button>
                )}

                {/* Close / Cancel */}
                <Button
                    onClick={handleDesignHoldPreCheckClose}
                    variant="outlined"
                    color="secondary"
                    disabled={designHoldPreCheck.loading}
                    startIcon={<CloseIcon />}
                >
                    {designHoldPreCheck.phase === 'preCheck' && !designHoldPreCheck.noConversation && designHoldPreCheck.hasConversation && !designHoldPreCheck.preCheckError ? 'Cancel' : 'Close'}
                </Button>
            </DialogActions>
        </Dialog>

        {OCRState.OCRModalOpen && (
            <Dialog
                open={OCRState.OCRModalOpen}
                onClose={() => setOCRState((prevState) => ({ ...prevState, OCRModalOpen: false }))}
                maxWidth="md"
                fullWidth
                scroll="paper"
            >
                <DialogContent 
                    dividers
                    style={{
                        maxHeight: "75vh",
                        overflowY: "auto"
                    }}
                >
                <Card className={classes.card}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            📑 Please upload confirmation screenshot from Customer (only image accepted).
                        </Typography>

                        <Divider />

                        <Box mt={3}>
                            <label>
                                <input
                                    type="file"
                                    accept="image/png,image/jpeg,image/jpg"
                                    hidden
                                    onChange={handleFileChange}
                                />
                                <Box className={classes.uploadBox}>
                                    <CloudUploadIcon color="primary" fontSize="large" />
                                    <Typography variant="body1">
                                        Click to upload image
                                    </Typography>
                                </Box>
                            </label>

                            {OCRState.preview && ( 
                                <img src={OCRState.preview} alt="Preview" className={classes.preview} />
                            )}

                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                startIcon={<DescriptionIcon />}
                                className={classes.uploadBtn}
                                onClick={handleUploadAndExtract}
                                disabled={OCRState.processing || !OCRState?.image || OCRState?.ocrText}
                            >
                                {OCRState.processing ? <CircularProgress size={22} /> : "Upload & Extract Text"}
                            </Button>
                                {OCRState.approved && OCRState.approvalDate && (
                                        <Box
                                            mt={2}
                                            p={2}
                                            borderRadius={2}
                                            bgcolor="#f5faff"
                                            border="1px solid #c3d5ff"
                                        >
                                            <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2 }}>
                                                Design Sign-Off Date detected from the screenshot:(DD-MM-YYYY)
                                            </Typography>
                                            {canEditDate ? (
                                                <Box>
                                                    <TextField
                                                        type="date"
                                                        variant="outlined"
                                                        size="small"
                                                        value={OCRState.approvalDate || ""}
                                                        onChange={(e) => {
                                                            if (OCRState.approvalDate !== e.target.value) {
                                                                setIsEditingDate(true);
                                                            }
                                                            setOCRState((prev) => ({
                                                                ...prev,
                                                                approvalDate: e.target.value
                                                            }))
                                                        }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />

                                                    <Typography
                                                        variant="caption"
                                                        style={{
                                                            display: "block",
                                                            marginTop: 6,
                                                            color: "#e21111ff",
                                                            fontWeight: 600
                                                        }}
                                                    >
                                                        You can modify the detected date if needed
                                                    </Typography>
                                                </Box>
                                            ) : (
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>
                                                    {formatDateForDisplay(
                                                        normalizeOcrDate(OCRState?.approvalDate)?.value
                                                    )}
                                                </Typography>
                                            )}
                                        </Box>
                                    )}

                                {OCRState.ocrText && !OCRState.approved && (
                                    <Box
                                        mt={2}
                                        p={2}
                                        border="1px solid #d32f2f"
                                        borderRadius={2}
                                        bgcolor="#ffebee"
                                    >
                                        <Typography variant="subtitle1" style={{ color: "#b71c1c", fontWeight: 700 }}>
                                            ❌ OCR Validation Failed
                                        </Typography>

                                        <Typography variant="body2" style={{ marginTop: 8 }}>
                                            Please upload a screenshot containing
                                            <strong> customer confirmation messages for Design-SignOff Date</strong>.
                                        </Typography>

                                        {OCRState?.reason && (
                                            <Typography
                                                variant="body2"
                                                style={{ marginTop: 12, fontWeight: 700, color: "#c62828" }}
                                            >
                                                Reason: {OCRState?.reason}
                                            </Typography>
                                        )}
                                    </Box>
                                )}
                        </Box>
                    </CardContent>
                </Card>
                </DialogContent>
                <DialogActions>
                        <Button
                            onClick={handleRetryOCR}
                            variant="outlined"
                            color="primary"
                            disabled={OCRState.processing || !OCRState?.s3Url || OCRState.approved || OCRState.retryCount >= 3}
                        >
                            Retry
                        </Button>
                    <Button
                        onClick={handleCloseOCRModal}
                        variant="outlined"
                        color="primary"
                    >
                        Close
                    </Button>

                    {OCRState.approved && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                handleCloseOCRModal();
                                handleDesignSignOffDate();
                            }}
                        >
                            Proceed
                        </Button>
                    )}
                </DialogActions>

                
            </Dialog>
        )}

        {/* Resend kick-off approval email button */}
        <Dialog
          open={kickOffApprovalResendModal}
          onClose={() => {
            setKickOffApprovalResendModal(false);
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogContent style={{}}>
            Do you want to Resend Kick-off Approval email to customer?
          </DialogContent>

          <DialogActions>
          <Button
              onClick={() => {
                resendKickOffApprovalEmail()
              }}
              color="primary"
            >
              Yes
            </Button>
            <Button
              onClick={() => {
                setKickOffApprovalResendModal(false);
              }}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

            {/* BotWot WhatsApp conversation - shared with the WhatsApp funnel
                dashboard (components/BotWotChatDrawer). It fetches its own
                messages from the leadId, so this page holds no chat state. */}
            <BotWotChatDrawer
                open={openChat}
                onClose={() => setOpenChat(false)}
                leadId={projectId}
                leadNo={projectDetails?.lead_no || projectDetails?.uniqueLeadNumber}
                customerName={projectDetails?.customerId?.name}
            />
            {callingDeskOpen && (
                <CallingDeskDialog
                    onClose={() => setCallingDeskOpen(false)}
                    leadIds={[projectId]}
                    source="project-logs"
                    subtitle={[
                        (projectDetails?.lead_no || projectDetails?.uniqueLeadNumber) && `Lead ${projectDetails?.lead_no || projectDetails?.uniqueLeadNumber}`,
                        maskedCustomerName,
                    ].filter(Boolean).join(' - ')}
                />
            )}
            {/* HOOMANLABS TRANSCRIPTS DRAWER */}
            <Drawer
                anchor="right"
                open={hoomanTranscriptsOpen}
                onClose={() => { setHoomanTranscriptsOpen(false); setSelectedHoomanCall(null); }}
                classes={{ paper: classes.drawerPaper }}
            >
                <div className={classes.container} style={{ background: "#f5f3ff" }}>

                    {/* HEADER */}
                    <div
                        className={classes.header}
                        style={{
                            background: "#6c5ce7",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            {selectedHoomanCall && (
                                <IconButton size="small" style={{ color: "#fff" }} onClick={() => setSelectedHoomanCall(null)}>
                                    <ArrowBackIcon />
                                </IconButton>
                            )}
                            <div>
                                <Typography style={{ fontWeight: 600 }}>
                                    AI-Karan Transcripts
                                </Typography>
                                <Typography style={{ fontSize: 12, opacity: 0.85 }}>
                                    {selectedHoomanCall
                                        ? moment(selectedHoomanCall.beginTimestamp || selectedHoomanCall.createdAt).format("DD MMM YYYY, hh:mm A")
                                        : `${hoomanTranscripts.length} call${hoomanTranscripts.length === 1 ? "" : "s"}`}
                                </Typography>
                            </div>
                        </div>

                        <IconButton
                            onClick={() => { setHoomanTranscriptsOpen(false); setSelectedHoomanCall(null); }}
                            style={{ color: "#fff" }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>

                    {/* BODY */}
                    <div className={classes.chatBody}>

                        {hoomanTranscriptsLoading ? (
                            /* Placeholder cards at the real card's height, so the
                               list doesn't collapse and then jump when it loads. */
                            Array.from({ length: 4 }).map((_, i) => (
                                <Paper key={i} className={classes.hoomanCallCard} style={{ cursor: "default" }} elevation={0}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                        <Skeleton variant="rect" width={34} height={34} style={{ borderRadius: 10 }} />
                                        <div style={{ flex: 1 }}>
                                            <Skeleton variant="text" width="45%" />
                                            <Skeleton variant="text" width="65%" height={12} />
                                        </div>
                                        <Skeleton variant="rect" width={82} height={22} style={{ borderRadius: 7 }} />
                                    </div>
                                    <Skeleton variant="text" width="92%" style={{ marginTop: 12 }} />
                                    <Skeleton variant="text" width="70%" />
                                </Paper>
                            ))

                        ) : !selectedHoomanCall ? (

                            hoomanTranscripts.length === 0 ? (
                                <div className={classes.emptyState}>
                                    <MicIcon style={{ fontSize: 40, opacity: 0.3 }} />
                                    <Typography style={{ marginTop: 10, fontWeight: 500 }}>
                                        No transcripts yet
                                    </Typography>
                                    <Typography style={{ fontSize: 12, opacity: 0.7 }}>
                                        AI Bot voice calls for this lead will appear here
                                    </Typography>
                                </div>
                            ) : (
                                /* CALL LIST */
                                hoomanTranscripts.map((call, i) => {
                                    const isInbound = call.callInfo?.type === "inbound";
                                    const summary = call.analysis?.results?.summary;

                                    return (
                                        <Paper
                                            key={call._id || i}
                                            className={classes.hoomanCallCard}
                                            onClick={() => setSelectedHoomanCall(call)}
                                        >
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}>
                                                <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
                                                    <span
                                                        className={classes.hoomanCallIconWrap}
                                                        style={{ background: isInbound ? "#e6f4ea" : "#e8f0fb" }}
                                                    >
                                                        {isInbound
                                                            ? <CallReceivedIcon style={{ color: "#2e7d32", fontSize: 18 }} />
                                                            : <CallMadeIcon style={{ color: "#1565c0", fontSize: 18 }} />}
                                                    </span>
                                                    <div style={{ minWidth: 0 }}>
                                                        <Typography style={{ fontWeight: 700, fontSize: 13, color: "#2b3648" }}>
                                                            {isInbound ? "Inbound" : "Outbound"} call
                                                        </Typography>
                                                        <Typography style={{ fontSize: 11.5, color: "#8b93a6", marginTop: 1 }}>
                                                            {moment(call.beginTimestamp || call.createdAt).format("DD MMM YYYY, hh:mm A")}
                                                            {call.callInfo?.duration
                                                                ? ` · ${Math.round(call.callInfo.duration)}s`
                                                                : ""}
                                                        </Typography>
                                                    </div>
                                                </div>

                                                <Chip
                                                    size="small"
                                                    label={call.outcome || (call.connected ? "Connected" : "Not connected")}
                                                    style={{
                                                        flexShrink: 0,
                                                        height: 22,
                                                        fontSize: 11,
                                                        borderRadius: 7,
                                                        background: call.connected ? "#e6f4ea" : "#fdecea",
                                                        color: call.connected ? "#1e7e34" : "#c62828",
                                                        border: `1px solid ${call.connected ? "#bfe3c9" : "#f6c9c5"}`,
                                                        fontWeight: 700
                                                    }}
                                                />
                                            </div>

                                            {summary ? (
                                                <Typography className={classes.hoomanCallSummary}>
                                                    {summary.length > 150 ? `${summary.slice(0, 150)}…` : summary}
                                                </Typography>
                                            ) : null}

                                            <div className={classes.hoomanCallCta}>
                                                View transcript
                                                <ArrowForwardIcon style={{ fontSize: 13 }} />
                                            </div>
                                        </Paper>
                                    );
                                })
                            )

                        ) : (
                            /* SELECTED CALL DETAIL */
                            <>
                                {selectedHoomanCall.analysis?.results?.summary && (
                                    <div
                                        className={classes.resultBox}
                                        style={{
                                            marginBottom: 18,
                                            padding: "13px 15px",
                                            borderRadius: 12,
                                            background: "#fff",
                                            border: "1px solid #e6e1fb",
                                            borderLeft: "3px solid #6c5ce7",
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                fontSize: 10.5,
                                                fontWeight: 700,
                                                letterSpacing: 0.4,
                                                textTransform: "uppercase",
                                                color: "#6c5ce7",
                                                marginBottom: 6,
                                            }}
                                        >
                                            Call Summary
                                        </Typography>
                                        <Typography style={{ fontSize: 13, lineHeight: 1.55, color: "#37445c" }}>
                                            {selectedHoomanCall.analysis.results.summary}
                                        </Typography>
                                    </div>
                                )}

                                {(selectedHoomanCall.callInfo?.recording || selectedHoomanCall.callInfo?.recordingSrc) && (
                                    <audio controls style={{ width: "100%", marginBottom: 18, display: "block" }}>
                                        <source src={selectedHoomanCall.callInfo.recording || selectedHoomanCall.callInfo.recordingSrc} />
                                        Your browser does not support audio
                                    </audio>
                                )}

                                {/* Separates the conversation from the summary and
                                    recording above it. */}
                                {(selectedHoomanCall.transcript || []).length > 0 && (
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 9,
                                            margin: "0 0 12px",
                                            fontSize: 10.5,
                                            fontWeight: 700,
                                            letterSpacing: 0.4,
                                            textTransform: "uppercase",
                                            color: "#8b93a6",
                                        }}
                                    >
                                        Conversation
                                        <span style={{ flex: 1, height: 1, background: "#e6e1fb" }} />
                                    </div>
                                )}

                                {(selectedHoomanCall.transcript || []).length === 0 ? (
                                    <div className={classes.emptyState}>
                                        <Typography>No transcript available for this call</Typography>
                                    </div>
                                ) : (
                                    selectedHoomanCall.transcript.map((msg, i) => (
                                        <div
                                            key={i}
                                            className={`${classes.messageRow} ${msg.role === "assistant" ? classes.right : classes.left}`}
                                        >
                                            <div
                                                className={`${classes.bubble} ${msg.role === "assistant" ? classes.rightBubble : classes.leftBubble}`}
                                            >
                                                <Typography
                                                    style={{
                                                        fontSize: 10.5,
                                                        fontWeight: 700,
                                                        letterSpacing: 0.3,
                                                        textTransform: "uppercase",
                                                        marginBottom: 3,
                                                        color: msg.role === "assistant" ? "#4c3cbe" : "#1f7a4d",
                                                    }}
                                                >
                                                    {msg.role === "assistant" ? "AI Bot" : "Customer"}
                                                </Typography>
                                                <Typography style={{ fontSize: 13, lineHeight: 1.5, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                                                    {msg.content}
                                                </Typography>
                                                {msg.timestamp && (
                                                    <Typography style={{ fontSize: 10, marginTop: 5, textAlign: "right", color: "rgba(0,0,0,0.45)" }}>
                                                        {moment(msg.timestamp).format("hh:mm A")}
                                                    </Typography>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </>
                        )}
                    </div>
                </div>
            </Drawer>
        </div>
    )
}


export default connect(null, { setLoading, setSnackInfo })(ManageProjectLogs)